let ufs = {
    "AC": {
        "nome": "Acre",
        "municipios": [
            {
                "codigo_ibge": 1200013,
                "nome": "Acrelândia"
            },
            {
                "codigo_ibge": 1200054,
                "nome": "Assis Brasil"
            },
            {
                "codigo_ibge": 1200104,
                "nome": "Brasiléia"
            },
            {
                "codigo_ibge": 1200138,
                "nome": "Bujari"
            },
            {
                "codigo_ibge": 1200179,
                "nome": "Capixaba"
            },
            {
                "codigo_ibge": 1200203,
                "nome": "Cruzeiro do Sul"
            },
            {
                "codigo_ibge": 1200252,
                "nome": "Epitaciolândia"
            },
            {
                "codigo_ibge": 1200302,
                "nome": "Feijó"
            },
            {
                "codigo_ibge": 1200328,
                "nome": "Jordão"
            },
            {
                "codigo_ibge": 1200336,
                "nome": "Mâncio Lima"
            },
            {
                "codigo_ibge": 1200344,
                "nome": "Manoel Urbano"
            },
            {
                "codigo_ibge": 1200351,
                "nome": "Marechal Thaumaturgo"
            },
            {
                "codigo_ibge": 1200385,
                "nome": "Plácido de Castro"
            },
            {
                "codigo_ibge": 1200807,
                "nome": "Porto Acre"
            },
            {
                "codigo_ibge": 1200393,
                "nome": "Porto Walter"
            },
            {
                "codigo_ibge": 1200401,
                "nome": "Rio Branco"
            },
            {
                "codigo_ibge": 1200427,
                "nome": "Rodrigues Alves"
            },
            {
                "codigo_ibge": 1200435,
                "nome": "Santa Rosa do Purus"
            },
            {
                "codigo_ibge": 1200500,
                "nome": "Sena Madureira"
            },
            {
                "codigo_ibge": 1200450,
                "nome": "Senador Guiomard"
            },
            {
                "codigo_ibge": 1200609,
                "nome": "Tarauacá"
            },
            {
                "codigo_ibge": 1200708,
                "nome": "Xapuri"
            }
        ]
    },
    "AL": {
        "nome": "Alagoas",
        "municipios": [
            {
                "codigo_ibge": 2700102,
                "nome": "Água Branca"
            },
            {
                "codigo_ibge": 2700201,
                "nome": "Anadia"
            },
            {
                "codigo_ibge": 2700300,
                "nome": "Arapiraca"
            },
            {
                "codigo_ibge": 2700409,
                "nome": "Atalaia"
            },
            {
                "codigo_ibge": 2700508,
                "nome": "Barra de Santo Antônio"
            },
            {
                "codigo_ibge": 2700607,
                "nome": "Barra de São Miguel"
            },
            {
                "codigo_ibge": 2700706,
                "nome": "Batalha"
            },
            {
                "codigo_ibge": 2700805,
                "nome": "Belém"
            },
            {
                "codigo_ibge": 2700904,
                "nome": "Belo Monte"
            },
            {
                "codigo_ibge": 2701001,
                "nome": "Boca da Mata"
            },
            {
                "codigo_ibge": 2701100,
                "nome": "Branquinha"
            },
            {
                "codigo_ibge": 2701209,
                "nome": "Cacimbinhas"
            },
            {
                "codigo_ibge": 2701308,
                "nome": "Cajueiro"
            },
            {
                "codigo_ibge": 2701357,
                "nome": "Campestre"
            },
            {
                "codigo_ibge": 2701407,
                "nome": "Campo Alegre"
            },
            {
                "codigo_ibge": 2701506,
                "nome": "Campo Grande"
            },
            {
                "codigo_ibge": 2701605,
                "nome": "Canapi"
            },
            {
                "codigo_ibge": 2701704,
                "nome": "Capela"
            },
            {
                "codigo_ibge": 2701803,
                "nome": "Carneiros"
            },
            {
                "codigo_ibge": 2701902,
                "nome": "Chã Preta"
            },
            {
                "codigo_ibge": 2702009,
                "nome": "Coité do Nóia"
            },
            {
                "codigo_ibge": 2702108,
                "nome": "Colônia Leopoldina"
            },
            {
                "codigo_ibge": 2702207,
                "nome": "Coqueiro Seco"
            },
            {
                "codigo_ibge": 2702306,
                "nome": "Coruripe"
            },
            {
                "codigo_ibge": 2702355,
                "nome": "Craíbas"
            },
            {
                "codigo_ibge": 2702405,
                "nome": "Delmiro Gouveia"
            },
            {
                "codigo_ibge": 2702504,
                "nome": "Dois Riachos"
            },
            {
                "codigo_ibge": 2702553,
                "nome": "Estrela de Alagoas"
            },
            {
                "codigo_ibge": 2702603,
                "nome": "Feira Grande"
            },
            {
                "codigo_ibge": 2702702,
                "nome": "Feliz Deserto"
            },
            {
                "codigo_ibge": 2702801,
                "nome": "Flexeiras"
            },
            {
                "codigo_ibge": 2702900,
                "nome": "Girau do Ponciano"
            },
            {
                "codigo_ibge": 2703007,
                "nome": "Ibateguara"
            },
            {
                "codigo_ibge": 2703106,
                "nome": "Igaci"
            },
            {
                "codigo_ibge": 2703205,
                "nome": "Igreja Nova"
            },
            {
                "codigo_ibge": 2703304,
                "nome": "Inhapi"
            },
            {
                "codigo_ibge": 2703403,
                "nome": "Jacaré dos Homens"
            },
            {
                "codigo_ibge": 2703502,
                "nome": "Jacuípe"
            },
            {
                "codigo_ibge": 2703601,
                "nome": "Japaratinga"
            },
            {
                "codigo_ibge": 2703700,
                "nome": "Jaramataia"
            },
            {
                "codigo_ibge": 2703759,
                "nome": "Jequiá da Praia"
            },
            {
                "codigo_ibge": 2703809,
                "nome": "Joaquim Gomes"
            },
            {
                "codigo_ibge": 2703908,
                "nome": "Jundiá"
            },
            {
                "codigo_ibge": 2704005,
                "nome": "Junqueiro"
            },
            {
                "codigo_ibge": 2704104,
                "nome": "Lagoa da Canoa"
            },
            {
                "codigo_ibge": 2704203,
                "nome": "Limoeiro de Anadia"
            },
            {
                "codigo_ibge": 2704302,
                "nome": "Maceió"
            },
            {
                "codigo_ibge": 2704401,
                "nome": "Major Isidoro"
            },
            {
                "codigo_ibge": 2704906,
                "nome": "Mar Vermelho"
            },
            {
                "codigo_ibge": 2704500,
                "nome": "Maragogi"
            },
            {
                "codigo_ibge": 2704609,
                "nome": "Maravilha"
            },
            {
                "codigo_ibge": 2704708,
                "nome": "Marechal Deodoro"
            },
            {
                "codigo_ibge": 2704807,
                "nome": "Maribondo"
            },
            {
                "codigo_ibge": 2705002,
                "nome": "Mata Grande"
            },
            {
                "codigo_ibge": 2705101,
                "nome": "Matriz de Camaragibe"
            },
            {
                "codigo_ibge": 2705200,
                "nome": "Messias"
            },
            {
                "codigo_ibge": 2705309,
                "nome": "Minador do Negrão"
            },
            {
                "codigo_ibge": 2705408,
                "nome": "Monteirópolis"
            },
            {
                "codigo_ibge": 2705507,
                "nome": "Murici"
            },
            {
                "codigo_ibge": 2705606,
                "nome": "Novo Lino"
            },
            {
                "codigo_ibge": 2705705,
                "nome": "Olho d'Água das Flores"
            },
            {
                "codigo_ibge": 2705804,
                "nome": "Olho d'Água do Casado"
            },
            {
                "codigo_ibge": 2705903,
                "nome": "Olho d'Água Grande"
            },
            {
                "codigo_ibge": 2706000,
                "nome": "Olivença"
            },
            {
                "codigo_ibge": 2706109,
                "nome": "Ouro Branco"
            },
            {
                "codigo_ibge": 2706208,
                "nome": "Palestina"
            },
            {
                "codigo_ibge": 2706307,
                "nome": "Palmeira dos Índios"
            },
            {
                "codigo_ibge": 2706406,
                "nome": "Pão de Açúcar"
            },
            {
                "codigo_ibge": 2706422,
                "nome": "Pariconha"
            },
            {
                "codigo_ibge": 2706448,
                "nome": "Paripueira"
            },
            {
                "codigo_ibge": 2706505,
                "nome": "Passo de Camaragibe"
            },
            {
                "codigo_ibge": 2706604,
                "nome": "Paulo Jacinto"
            },
            {
                "codigo_ibge": 2706703,
                "nome": "Penedo"
            },
            {
                "codigo_ibge": 2706802,
                "nome": "Piaçabuçu"
            },
            {
                "codigo_ibge": 2706901,
                "nome": "Pilar"
            },
            {
                "codigo_ibge": 2707008,
                "nome": "Pindoba"
            },
            {
                "codigo_ibge": 2707107,
                "nome": "Piranhas"
            },
            {
                "codigo_ibge": 2707206,
                "nome": "Poço das Trincheiras"
            },
            {
                "codigo_ibge": 2707305,
                "nome": "Porto Calvo"
            },
            {
                "codigo_ibge": 2707404,
                "nome": "Porto de Pedras"
            },
            {
                "codigo_ibge": 2707503,
                "nome": "Porto Real do Colégio"
            },
            {
                "codigo_ibge": 2707602,
                "nome": "Quebrangulo"
            },
            {
                "codigo_ibge": 2707701,
                "nome": "Rio Largo"
            },
            {
                "codigo_ibge": 2707800,
                "nome": "Roteiro"
            },
            {
                "codigo_ibge": 2707909,
                "nome": "Santa Luzia do Norte"
            },
            {
                "codigo_ibge": 2708006,
                "nome": "Santana do Ipanema"
            },
            {
                "codigo_ibge": 2708105,
                "nome": "Santana do Mundaú"
            },
            {
                "codigo_ibge": 2708204,
                "nome": "São Brás"
            },
            {
                "codigo_ibge": 2708303,
                "nome": "São José da Laje"
            },
            {
                "codigo_ibge": 2708402,
                "nome": "São José da Tapera"
            },
            {
                "codigo_ibge": 2708501,
                "nome": "São Luís do Quitunde"
            },
            {
                "codigo_ibge": 2708600,
                "nome": "São Miguel dos Campos"
            },
            {
                "codigo_ibge": 2708709,
                "nome": "São Miguel dos Milagres"
            },
            {
                "codigo_ibge": 2708808,
                "nome": "São Sebastião"
            },
            {
                "codigo_ibge": 2708907,
                "nome": "Satuba"
            },
            {
                "codigo_ibge": 2708956,
                "nome": "Senador Rui Palmeira"
            },
            {
                "codigo_ibge": 2709004,
                "nome": "Tanque d'Arca"
            },
            {
                "codigo_ibge": 2709103,
                "nome": "Taquarana"
            },
            {
                "codigo_ibge": 2709152,
                "nome": "Teotônio Vilela"
            },
            {
                "codigo_ibge": 2709202,
                "nome": "Traipu"
            },
            {
                "codigo_ibge": 2709301,
                "nome": "União dos Palmares"
            },
            {
                "codigo_ibge": 2709400,
                "nome": "Viçosa"
            }
        ]
    },
    "AM": {
        "nome": "Amazonas",
        "municipios": [
            {
                "codigo_ibge": 1300029,
                "nome": "Alvarães"
            },
            {
                "codigo_ibge": 1300060,
                "nome": "Amaturá"
            },
            {
                "codigo_ibge": 1300086,
                "nome": "Anamã"
            },
            {
                "codigo_ibge": 1300102,
                "nome": "Anori"
            },
            {
                "codigo_ibge": 1300144,
                "nome": "Apuí"
            },
            {
                "codigo_ibge": 1300201,
                "nome": "Atalaia do Norte"
            },
            {
                "codigo_ibge": 1300300,
                "nome": "Autazes"
            },
            {
                "codigo_ibge": 1300409,
                "nome": "Barcelos"
            },
            {
                "codigo_ibge": 1300508,
                "nome": "Barreirinha"
            },
            {
                "codigo_ibge": 1300607,
                "nome": "Benjamin Constant"
            },
            {
                "codigo_ibge": 1300631,
                "nome": "Beruri"
            },
            {
                "codigo_ibge": 1300680,
                "nome": "Boa Vista do Ramos"
            },
            {
                "codigo_ibge": 1300706,
                "nome": "Boca do Acre"
            },
            {
                "codigo_ibge": 1300805,
                "nome": "Borba"
            },
            {
                "codigo_ibge": 1300839,
                "nome": "Caapiranga"
            },
            {
                "codigo_ibge": 1300904,
                "nome": "Canutama"
            },
            {
                "codigo_ibge": 1301001,
                "nome": "Carauari"
            },
            {
                "codigo_ibge": 1301100,
                "nome": "Careiro"
            },
            {
                "codigo_ibge": 1301159,
                "nome": "Careiro da Várzea"
            },
            {
                "codigo_ibge": 1301209,
                "nome": "Coari"
            },
            {
                "codigo_ibge": 1301308,
                "nome": "Codajás"
            },
            {
                "codigo_ibge": 1301407,
                "nome": "Eirunepé"
            },
            {
                "codigo_ibge": 1301506,
                "nome": "Envira"
            },
            {
                "codigo_ibge": 1301605,
                "nome": "Fonte Boa"
            },
            {
                "codigo_ibge": 1301654,
                "nome": "Guajará"
            },
            {
                "codigo_ibge": 1301704,
                "nome": "Humaitá"
            },
            {
                "codigo_ibge": 1301803,
                "nome": "Ipixuna"
            },
            {
                "codigo_ibge": 1301852,
                "nome": "Iranduba"
            },
            {
                "codigo_ibge": 1301902,
                "nome": "Itacoatiara"
            },
            {
                "codigo_ibge": 1301951,
                "nome": "Itamarati"
            },
            {
                "codigo_ibge": 1302009,
                "nome": "Itapiranga"
            },
            {
                "codigo_ibge": 1302108,
                "nome": "Japurá"
            },
            {
                "codigo_ibge": 1302207,
                "nome": "Juruá"
            },
            {
                "codigo_ibge": 1302306,
                "nome": "Jutaí"
            },
            {
                "codigo_ibge": 1302405,
                "nome": "Lábrea"
            },
            {
                "codigo_ibge": 1302504,
                "nome": "Manacapuru"
            },
            {
                "codigo_ibge": 1302553,
                "nome": "Manaquiri"
            },
            {
                "codigo_ibge": 1302603,
                "nome": "Manaus"
            },
            {
                "codigo_ibge": 1302702,
                "nome": "Manicoré"
            },
            {
                "codigo_ibge": 1302801,
                "nome": "Maraã"
            },
            {
                "codigo_ibge": 1302900,
                "nome": "Maués"
            },
            {
                "codigo_ibge": 1303007,
                "nome": "Nhamundá"
            },
            {
                "codigo_ibge": 1303106,
                "nome": "Nova Olinda do Norte"
            },
            {
                "codigo_ibge": 1303205,
                "nome": "Novo Airão"
            },
            {
                "codigo_ibge": 1303304,
                "nome": "Novo Aripuanã"
            },
            {
                "codigo_ibge": 1303403,
                "nome": "Parintins"
            },
            {
                "codigo_ibge": 1303502,
                "nome": "Pauini"
            },
            {
                "codigo_ibge": 1303536,
                "nome": "Presidente Figueiredo"
            },
            {
                "codigo_ibge": 1303569,
                "nome": "Rio Preto da Eva"
            },
            {
                "codigo_ibge": 1303601,
                "nome": "Santa Isabel do Rio Negro"
            },
            {
                "codigo_ibge": 1303700,
                "nome": "Santo Antônio do Içá"
            },
            {
                "codigo_ibge": 1303809,
                "nome": "São Gabriel da Cachoeira"
            },
            {
                "codigo_ibge": 1303908,
                "nome": "São Paulo de Olivença"
            },
            {
                "codigo_ibge": 1303957,
                "nome": "São Sebastião do Uatumã"
            },
            {
                "codigo_ibge": 1304005,
                "nome": "Silves"
            },
            {
                "codigo_ibge": 1304062,
                "nome": "Tabatinga"
            },
            {
                "codigo_ibge": 1304104,
                "nome": "Tapauá"
            },
            {
                "codigo_ibge": 1304203,
                "nome": "Tefé"
            },
            {
                "codigo_ibge": 1304237,
                "nome": "Tonantins"
            },
            {
                "codigo_ibge": 1304260,
                "nome": "Uarini"
            },
            {
                "codigo_ibge": 1304302,
                "nome": "Urucará"
            },
            {
                "codigo_ibge": 1304401,
                "nome": "Urucurituba"
            }
        ]
    },
    "AP": {
        "nome": "Amapá",
        "municipios": [
            {
                "codigo_ibge": 1600105,
                "nome": "Amapá"
            },
            {
                "codigo_ibge": 1600204,
                "nome": "Calçoene"
            },
            {
                "codigo_ibge": 1600212,
                "nome": "Cutias"
            },
            {
                "codigo_ibge": 1600238,
                "nome": "Ferreira Gomes"
            },
            {
                "codigo_ibge": 1600253,
                "nome": "Itaubal"
            },
            {
                "codigo_ibge": 1600279,
                "nome": "Laranjal do Jari"
            },
            {
                "codigo_ibge": 1600303,
                "nome": "Macapá"
            },
            {
                "codigo_ibge": 1600402,
                "nome": "Mazagão"
            },
            {
                "codigo_ibge": 1600501,
                "nome": "Oiapoque"
            },
            {
                "codigo_ibge": 1600154,
                "nome": "Pedra Branca do Amapari"
            },
            {
                "codigo_ibge": 1600535,
                "nome": "Porto Grande"
            },
            {
                "codigo_ibge": 1600550,
                "nome": "Pracuúba"
            },
            {
                "codigo_ibge": 1600600,
                "nome": "Santana"
            },
            {
                "codigo_ibge": 1600055,
                "nome": "Serra do Navio"
            },
            {
                "codigo_ibge": 1600709,
                "nome": "Tartarugalzinho"
            },
            {
                "codigo_ibge": 1600808,
                "nome": "Vitória do Jari"
            }
        ]
    },
    "BA": {
        "nome": "Bahia",
        "municipios": [
            {
                "codigo_ibge": 2900108,
                "nome": "Abaíra"
            },
            {
                "codigo_ibge": 2900207,
                "nome": "Abaré"
            },
            {
                "codigo_ibge": 2900306,
                "nome": "Acajutiba"
            },
            {
                "codigo_ibge": 2900355,
                "nome": "Adustina"
            },
            {
                "codigo_ibge": 2900405,
                "nome": "Água Fria"
            },
            {
                "codigo_ibge": 2900603,
                "nome": "Aiquara"
            },
            {
                "codigo_ibge": 2900702,
                "nome": "Alagoinhas"
            },
            {
                "codigo_ibge": 2900801,
                "nome": "Alcobaça"
            },
            {
                "codigo_ibge": 2900900,
                "nome": "Almadina"
            },
            {
                "codigo_ibge": 2901007,
                "nome": "Amargosa"
            },
            {
                "codigo_ibge": 2901106,
                "nome": "Amélia Rodrigues"
            },
            {
                "codigo_ibge": 2901155,
                "nome": "América Dourada"
            },
            {
                "codigo_ibge": 2901205,
                "nome": "Anagé"
            },
            {
                "codigo_ibge": 2901304,
                "nome": "Andaraí"
            },
            {
                "codigo_ibge": 2901353,
                "nome": "Andorinha"
            },
            {
                "codigo_ibge": 2901403,
                "nome": "Angical"
            },
            {
                "codigo_ibge": 2901502,
                "nome": "Anguera"
            },
            {
                "codigo_ibge": 2901601,
                "nome": "Antas"
            },
            {
                "codigo_ibge": 2901700,
                "nome": "Antônio Cardoso"
            },
            {
                "codigo_ibge": 2901809,
                "nome": "Antônio Gonçalves"
            },
            {
                "codigo_ibge": 2901908,
                "nome": "Aporá"
            },
            {
                "codigo_ibge": 2901957,
                "nome": "Apuarema"
            },
            {
                "codigo_ibge": 2902054,
                "nome": "Araças"
            },
            {
                "codigo_ibge": 2902005,
                "nome": "Aracatu"
            },
            {
                "codigo_ibge": 2902104,
                "nome": "Araci"
            },
            {
                "codigo_ibge": 2902203,
                "nome": "Aramari"
            },
            {
                "codigo_ibge": 2902252,
                "nome": "Arataca"
            },
            {
                "codigo_ibge": 2902302,
                "nome": "Aratuípe"
            },
            {
                "codigo_ibge": 2902401,
                "nome": "Aurelino Leal"
            },
            {
                "codigo_ibge": 2902500,
                "nome": "Baianópolis"
            },
            {
                "codigo_ibge": 2902609,
                "nome": "Baixa Grande"
            },
            {
                "codigo_ibge": 2902658,
                "nome": "Banzaê"
            },
            {
                "codigo_ibge": 2902708,
                "nome": "Barra"
            },
            {
                "codigo_ibge": 2902807,
                "nome": "Barra da Estiva"
            },
            {
                "codigo_ibge": 2902906,
                "nome": "Barra do Choça"
            },
            {
                "codigo_ibge": 2903003,
                "nome": "Barra do Mendes"
            },
            {
                "codigo_ibge": 2903102,
                "nome": "Barra do Rocha"
            },
            {
                "codigo_ibge": 2903201,
                "nome": "Barreiras"
            },
            {
                "codigo_ibge": 2903235,
                "nome": "Barro Alto"
            },
            {
                "codigo_ibge": 2903300,
                "nome": "Barro Preto"
            },
            {
                "codigo_ibge": 2903276,
                "nome": "Barrocas"
            },
            {
                "codigo_ibge": 2903409,
                "nome": "Belmonte"
            },
            {
                "codigo_ibge": 2903508,
                "nome": "Belo Campo"
            },
            {
                "codigo_ibge": 2903607,
                "nome": "Biritinga"
            },
            {
                "codigo_ibge": 2903706,
                "nome": "Boa Nova"
            },
            {
                "codigo_ibge": 2903805,
                "nome": "Boa Vista do Tupim"
            },
            {
                "codigo_ibge": 2903904,
                "nome": "Bom Jesus da Lapa"
            },
            {
                "codigo_ibge": 2903953,
                "nome": "Bom Jesus da Serra"
            },
            {
                "codigo_ibge": 2904001,
                "nome": "Boninal"
            },
            {
                "codigo_ibge": 2904050,
                "nome": "Bonito"
            },
            {
                "codigo_ibge": 2904100,
                "nome": "Boquira"
            },
            {
                "codigo_ibge": 2904209,
                "nome": "Botuporã"
            },
            {
                "codigo_ibge": 2904308,
                "nome": "Brejões"
            },
            {
                "codigo_ibge": 2904407,
                "nome": "Brejolândia"
            },
            {
                "codigo_ibge": 2904506,
                "nome": "Brotas de Macaúbas"
            },
            {
                "codigo_ibge": 2904605,
                "nome": "Brumado"
            },
            {
                "codigo_ibge": 2904704,
                "nome": "Buerarema"
            },
            {
                "codigo_ibge": 2904753,
                "nome": "Buritirama"
            },
            {
                "codigo_ibge": 2904803,
                "nome": "Caatiba"
            },
            {
                "codigo_ibge": 2904852,
                "nome": "Cabaceiras do Paraguaçu"
            },
            {
                "codigo_ibge": 2904902,
                "nome": "Cachoeira"
            },
            {
                "codigo_ibge": 2905008,
                "nome": "Caculé"
            },
            {
                "codigo_ibge": 2905107,
                "nome": "Caém"
            },
            {
                "codigo_ibge": 2905156,
                "nome": "Caetanos"
            },
            {
                "codigo_ibge": 2905206,
                "nome": "Caetité"
            },
            {
                "codigo_ibge": 2905305,
                "nome": "Cafarnaum"
            },
            {
                "codigo_ibge": 2905404,
                "nome": "Cairu"
            },
            {
                "codigo_ibge": 2905503,
                "nome": "Caldeirão Grande"
            },
            {
                "codigo_ibge": 2905602,
                "nome": "Camacan"
            },
            {
                "codigo_ibge": 2905701,
                "nome": "Camaçari"
            },
            {
                "codigo_ibge": 2905800,
                "nome": "Camamu"
            },
            {
                "codigo_ibge": 2905909,
                "nome": "Campo Alegre de Lourdes"
            },
            {
                "codigo_ibge": 2906006,
                "nome": "Campo Formoso"
            },
            {
                "codigo_ibge": 2906105,
                "nome": "Canápolis"
            },
            {
                "codigo_ibge": 2906204,
                "nome": "Canarana"
            },
            {
                "codigo_ibge": 2906303,
                "nome": "Canavieiras"
            },
            {
                "codigo_ibge": 2906402,
                "nome": "Candeal"
            },
            {
                "codigo_ibge": 2906501,
                "nome": "Candeias"
            },
            {
                "codigo_ibge": 2906600,
                "nome": "Candiba"
            },
            {
                "codigo_ibge": 2906709,
                "nome": "Cândido Sales"
            },
            {
                "codigo_ibge": 2906808,
                "nome": "Cansanção"
            },
            {
                "codigo_ibge": 2906824,
                "nome": "Canudos"
            },
            {
                "codigo_ibge": 2906857,
                "nome": "Capela do Alto Alegre"
            },
            {
                "codigo_ibge": 2906873,
                "nome": "Capim Grosso"
            },
            {
                "codigo_ibge": 2906899,
                "nome": "Caraíbas"
            },
            {
                "codigo_ibge": 2906907,
                "nome": "Caravelas"
            },
            {
                "codigo_ibge": 2907004,
                "nome": "Cardeal da Silva"
            },
            {
                "codigo_ibge": 2907103,
                "nome": "Carinhanha"
            },
            {
                "codigo_ibge": 2907202,
                "nome": "Casa Nova"
            },
            {
                "codigo_ibge": 2907301,
                "nome": "Castro Alves"
            },
            {
                "codigo_ibge": 2907400,
                "nome": "Catolândia"
            },
            {
                "codigo_ibge": 2907509,
                "nome": "Catu"
            },
            {
                "codigo_ibge": 2907558,
                "nome": "Caturama"
            },
            {
                "codigo_ibge": 2907608,
                "nome": "Central"
            },
            {
                "codigo_ibge": 2907707,
                "nome": "Chorrochó"
            },
            {
                "codigo_ibge": 2907806,
                "nome": "Cícero Dantas"
            },
            {
                "codigo_ibge": 2907905,
                "nome": "Cipó"
            },
            {
                "codigo_ibge": 2908002,
                "nome": "Coaraci"
            },
            {
                "codigo_ibge": 2908101,
                "nome": "Cocos"
            },
            {
                "codigo_ibge": 2908200,
                "nome": "Conceição da Feira"
            },
            {
                "codigo_ibge": 2908309,
                "nome": "Conceição do Almeida"
            },
            {
                "codigo_ibge": 2908408,
                "nome": "Conceição do Coité"
            },
            {
                "codigo_ibge": 2908507,
                "nome": "Conceição do Jacuípe"
            },
            {
                "codigo_ibge": 2908606,
                "nome": "Conde"
            },
            {
                "codigo_ibge": 2908705,
                "nome": "Condeúba"
            },
            {
                "codigo_ibge": 2908804,
                "nome": "Contendas do Sincorá"
            },
            {
                "codigo_ibge": 2908903,
                "nome": "Coração de Maria"
            },
            {
                "codigo_ibge": 2909000,
                "nome": "Cordeiros"
            },
            {
                "codigo_ibge": 2909109,
                "nome": "Coribe"
            },
            {
                "codigo_ibge": 2909208,
                "nome": "Coronel João Sá"
            },
            {
                "codigo_ibge": 2909307,
                "nome": "Correntina"
            },
            {
                "codigo_ibge": 2909406,
                "nome": "Cotegipe"
            },
            {
                "codigo_ibge": 2909505,
                "nome": "Cravolândia"
            },
            {
                "codigo_ibge": 2909604,
                "nome": "Crisópolis"
            },
            {
                "codigo_ibge": 2909703,
                "nome": "Cristópolis"
            },
            {
                "codigo_ibge": 2909802,
                "nome": "Cruz das Almas"
            },
            {
                "codigo_ibge": 2909901,
                "nome": "Curaçá"
            },
            {
                "codigo_ibge": 2910008,
                "nome": "Dário Meira"
            },
            {
                "codigo_ibge": 2910057,
                "nome": "Dias d'Ávila"
            },
            {
                "codigo_ibge": 2910107,
                "nome": "Dom Basílio"
            },
            {
                "codigo_ibge": 2910206,
                "nome": "Dom Macedo Costa"
            },
            {
                "codigo_ibge": 2910305,
                "nome": "Elísio Medrado"
            },
            {
                "codigo_ibge": 2910404,
                "nome": "Encruzilhada"
            },
            {
                "codigo_ibge": 2910503,
                "nome": "Entre Rios"
            },
            {
                "codigo_ibge": 2900504,
                "nome": "Érico Cardoso"
            },
            {
                "codigo_ibge": 2910602,
                "nome": "Esplanada"
            },
            {
                "codigo_ibge": 2910701,
                "nome": "Euclides da Cunha"
            },
            {
                "codigo_ibge": 2910727,
                "nome": "Eunápolis"
            },
            {
                "codigo_ibge": 2910750,
                "nome": "Fátima"
            },
            {
                "codigo_ibge": 2910776,
                "nome": "Feira da Mata"
            },
            {
                "codigo_ibge": 2910800,
                "nome": "Feira de Santana"
            },
            {
                "codigo_ibge": 2910859,
                "nome": "Filadélfia"
            },
            {
                "codigo_ibge": 2910909,
                "nome": "Firmino Alves"
            },
            {
                "codigo_ibge": 2911006,
                "nome": "Floresta Azul"
            },
            {
                "codigo_ibge": 2911105,
                "nome": "Formosa do Rio Preto"
            },
            {
                "codigo_ibge": 2911204,
                "nome": "Gandu"
            },
            {
                "codigo_ibge": 2911253,
                "nome": "Gavião"
            },
            {
                "codigo_ibge": 2911303,
                "nome": "Gentio do Ouro"
            },
            {
                "codigo_ibge": 2911402,
                "nome": "Glória"
            },
            {
                "codigo_ibge": 2911501,
                "nome": "Gongogi"
            },
            {
                "codigo_ibge": 2911600,
                "nome": "Governador Mangabeira"
            },
            {
                "codigo_ibge": 2911659,
                "nome": "Guajeru"
            },
            {
                "codigo_ibge": 2911709,
                "nome": "Guanambi"
            },
            {
                "codigo_ibge": 2911808,
                "nome": "Guaratinga"
            },
            {
                "codigo_ibge": 2911857,
                "nome": "Heliópolis"
            },
            {
                "codigo_ibge": 2911907,
                "nome": "Iaçu"
            },
            {
                "codigo_ibge": 2912004,
                "nome": "Ibiassucê"
            },
            {
                "codigo_ibge": 2912103,
                "nome": "Ibicaraí"
            },
            {
                "codigo_ibge": 2912202,
                "nome": "Ibicoara"
            },
            {
                "codigo_ibge": 2912301,
                "nome": "Ibicuí"
            },
            {
                "codigo_ibge": 2912400,
                "nome": "Ibipeba"
            },
            {
                "codigo_ibge": 2912509,
                "nome": "Ibipitanga"
            },
            {
                "codigo_ibge": 2912608,
                "nome": "Ibiquera"
            },
            {
                "codigo_ibge": 2912707,
                "nome": "Ibirapitanga"
            },
            {
                "codigo_ibge": 2912806,
                "nome": "Ibirapuã"
            },
            {
                "codigo_ibge": 2912905,
                "nome": "Ibirataia"
            },
            {
                "codigo_ibge": 2913002,
                "nome": "Ibitiara"
            },
            {
                "codigo_ibge": 2913101,
                "nome": "Ibititá"
            },
            {
                "codigo_ibge": 2913200,
                "nome": "Ibotirama"
            },
            {
                "codigo_ibge": 2913309,
                "nome": "Ichu"
            },
            {
                "codigo_ibge": 2913408,
                "nome": "Igaporã"
            },
            {
                "codigo_ibge": 2913457,
                "nome": "Igrapiúna"
            },
            {
                "codigo_ibge": 2913507,
                "nome": "Iguaí"
            },
            {
                "codigo_ibge": 2913606,
                "nome": "Ilhéus"
            },
            {
                "codigo_ibge": 2913705,
                "nome": "Inhambupe"
            },
            {
                "codigo_ibge": 2913804,
                "nome": "Ipecaetá"
            },
            {
                "codigo_ibge": 2913903,
                "nome": "Ipiaú"
            },
            {
                "codigo_ibge": 2914000,
                "nome": "Ipirá"
            },
            {
                "codigo_ibge": 2914109,
                "nome": "Ipupiara"
            },
            {
                "codigo_ibge": 2914208,
                "nome": "Irajuba"
            },
            {
                "codigo_ibge": 2914307,
                "nome": "Iramaia"
            },
            {
                "codigo_ibge": 2914406,
                "nome": "Iraquara"
            },
            {
                "codigo_ibge": 2914505,
                "nome": "Irará"
            },
            {
                "codigo_ibge": 2914604,
                "nome": "Irecê"
            },
            {
                "codigo_ibge": 2914653,
                "nome": "Itabela"
            },
            {
                "codigo_ibge": 2914703,
                "nome": "Itaberaba"
            },
            {
                "codigo_ibge": 2914802,
                "nome": "Itabuna"
            },
            {
                "codigo_ibge": 2914901,
                "nome": "Itacaré"
            },
            {
                "codigo_ibge": 2915007,
                "nome": "Itaeté"
            },
            {
                "codigo_ibge": 2915106,
                "nome": "Itagi"
            },
            {
                "codigo_ibge": 2915205,
                "nome": "Itagibá"
            },
            {
                "codigo_ibge": 2915304,
                "nome": "Itagimirim"
            },
            {
                "codigo_ibge": 2915353,
                "nome": "Itaguaçu da Bahia"
            },
            {
                "codigo_ibge": 2915403,
                "nome": "Itaju do Colônia"
            },
            {
                "codigo_ibge": 2915502,
                "nome": "Itajuípe"
            },
            {
                "codigo_ibge": 2915601,
                "nome": "Itamaraju"
            },
            {
                "codigo_ibge": 2915700,
                "nome": "Itamari"
            },
            {
                "codigo_ibge": 2915809,
                "nome": "Itambé"
            },
            {
                "codigo_ibge": 2915908,
                "nome": "Itanagra"
            },
            {
                "codigo_ibge": 2916005,
                "nome": "Itanhém"
            },
            {
                "codigo_ibge": 2916104,
                "nome": "Itaparica"
            },
            {
                "codigo_ibge": 2916203,
                "nome": "Itapé"
            },
            {
                "codigo_ibge": 2916302,
                "nome": "Itapebi"
            },
            {
                "codigo_ibge": 2916401,
                "nome": "Itapetinga"
            },
            {
                "codigo_ibge": 2916500,
                "nome": "Itapicuru"
            },
            {
                "codigo_ibge": 2916609,
                "nome": "Itapitanga"
            },
            {
                "codigo_ibge": 2916708,
                "nome": "Itaquara"
            },
            {
                "codigo_ibge": 2916807,
                "nome": "Itarantim"
            },
            {
                "codigo_ibge": 2916856,
                "nome": "Itatim"
            },
            {
                "codigo_ibge": 2916906,
                "nome": "Itiruçu"
            },
            {
                "codigo_ibge": 2917003,
                "nome": "Itiúba"
            },
            {
                "codigo_ibge": 2917102,
                "nome": "Itororó"
            },
            {
                "codigo_ibge": 2917201,
                "nome": "Ituaçu"
            },
            {
                "codigo_ibge": 2917300,
                "nome": "Ituberá"
            },
            {
                "codigo_ibge": 2917334,
                "nome": "Iuiú"
            },
            {
                "codigo_ibge": 2917359,
                "nome": "Jaborandi"
            },
            {
                "codigo_ibge": 2917409,
                "nome": "Jacaraci"
            },
            {
                "codigo_ibge": 2917508,
                "nome": "Jacobina"
            },
            {
                "codigo_ibge": 2917607,
                "nome": "Jaguaquara"
            },
            {
                "codigo_ibge": 2917706,
                "nome": "Jaguarari"
            },
            {
                "codigo_ibge": 2917805,
                "nome": "Jaguaripe"
            },
            {
                "codigo_ibge": 2917904,
                "nome": "Jandaíra"
            },
            {
                "codigo_ibge": 2918001,
                "nome": "Jequié"
            },
            {
                "codigo_ibge": 2918100,
                "nome": "Jeremoabo"
            },
            {
                "codigo_ibge": 2918209,
                "nome": "Jiquiriçá"
            },
            {
                "codigo_ibge": 2918308,
                "nome": "Jitaúna"
            },
            {
                "codigo_ibge": 2918357,
                "nome": "João Dourado"
            },
            {
                "codigo_ibge": 2918407,
                "nome": "Juazeiro"
            },
            {
                "codigo_ibge": 2918456,
                "nome": "Jucuruçu"
            },
            {
                "codigo_ibge": 2918506,
                "nome": "Jussara"
            },
            {
                "codigo_ibge": 2918555,
                "nome": "Jussari"
            },
            {
                "codigo_ibge": 2918605,
                "nome": "Jussiape"
            },
            {
                "codigo_ibge": 2918704,
                "nome": "Lafaiete Coutinho"
            },
            {
                "codigo_ibge": 2918753,
                "nome": "Lagoa Real"
            },
            {
                "codigo_ibge": 2918803,
                "nome": "Laje"
            },
            {
                "codigo_ibge": 2918902,
                "nome": "Lajedão"
            },
            {
                "codigo_ibge": 2919009,
                "nome": "Lajedinho"
            },
            {
                "codigo_ibge": 2919058,
                "nome": "Lajedo do Tabocal"
            },
            {
                "codigo_ibge": 2919108,
                "nome": "Lamarão"
            },
            {
                "codigo_ibge": 2919157,
                "nome": "Lapão"
            },
            {
                "codigo_ibge": 2919207,
                "nome": "Lauro de Freitas"
            },
            {
                "codigo_ibge": 2919306,
                "nome": "Lençóis"
            },
            {
                "codigo_ibge": 2919405,
                "nome": "Licínio de Almeida"
            },
            {
                "codigo_ibge": 2919504,
                "nome": "Livramento de Nossa Senhora"
            },
            {
                "codigo_ibge": 2919553,
                "nome": "Luís Eduardo Magalhães"
            },
            {
                "codigo_ibge": 2919603,
                "nome": "Macajuba"
            },
            {
                "codigo_ibge": 2919702,
                "nome": "Macarani"
            },
            {
                "codigo_ibge": 2919801,
                "nome": "Macaúbas"
            },
            {
                "codigo_ibge": 2919900,
                "nome": "Macururé"
            },
            {
                "codigo_ibge": 2919926,
                "nome": "Madre de Deus"
            },
            {
                "codigo_ibge": 2919959,
                "nome": "Maetinga"
            },
            {
                "codigo_ibge": 2920007,
                "nome": "Maiquinique"
            },
            {
                "codigo_ibge": 2920106,
                "nome": "Mairi"
            },
            {
                "codigo_ibge": 2920205,
                "nome": "Malhada"
            },
            {
                "codigo_ibge": 2920304,
                "nome": "Malhada de Pedras"
            },
            {
                "codigo_ibge": 2920403,
                "nome": "Manoel Vitorino"
            },
            {
                "codigo_ibge": 2920452,
                "nome": "Mansidão"
            },
            {
                "codigo_ibge": 2920502,
                "nome": "Maracás"
            },
            {
                "codigo_ibge": 2920601,
                "nome": "Maragogipe"
            },
            {
                "codigo_ibge": 2920700,
                "nome": "Maraú"
            },
            {
                "codigo_ibge": 2920809,
                "nome": "Marcionílio Souza"
            },
            {
                "codigo_ibge": 2920908,
                "nome": "Mascote"
            },
            {
                "codigo_ibge": 2921005,
                "nome": "Mata de São João"
            },
            {
                "codigo_ibge": 2921054,
                "nome": "Matina"
            },
            {
                "codigo_ibge": 2921104,
                "nome": "Medeiros Neto"
            },
            {
                "codigo_ibge": 2921203,
                "nome": "Miguel Calmon"
            },
            {
                "codigo_ibge": 2921302,
                "nome": "Milagres"
            },
            {
                "codigo_ibge": 2921401,
                "nome": "Mirangaba"
            },
            {
                "codigo_ibge": 2921450,
                "nome": "Mirante"
            },
            {
                "codigo_ibge": 2921500,
                "nome": "Monte Santo"
            },
            {
                "codigo_ibge": 2921609,
                "nome": "Morpará"
            },
            {
                "codigo_ibge": 2921708,
                "nome": "Morro do Chapéu"
            },
            {
                "codigo_ibge": 2921807,
                "nome": "Mortugaba"
            },
            {
                "codigo_ibge": 2921906,
                "nome": "Mucugê"
            },
            {
                "codigo_ibge": 2922003,
                "nome": "Mucuri"
            },
            {
                "codigo_ibge": 2922052,
                "nome": "Mulungu do Morro"
            },
            {
                "codigo_ibge": 2922102,
                "nome": "Mundo Novo"
            },
            {
                "codigo_ibge": 2922201,
                "nome": "Muniz Ferreira"
            },
            {
                "codigo_ibge": 2922250,
                "nome": "Muquém de São Francisco"
            },
            {
                "codigo_ibge": 2922300,
                "nome": "Muritiba"
            },
            {
                "codigo_ibge": 2922409,
                "nome": "Mutuípe"
            },
            {
                "codigo_ibge": 2922508,
                "nome": "Nazaré"
            },
            {
                "codigo_ibge": 2922607,
                "nome": "Nilo Peçanha"
            },
            {
                "codigo_ibge": 2922656,
                "nome": "Nordestina"
            },
            {
                "codigo_ibge": 2922706,
                "nome": "Nova Canaã"
            },
            {
                "codigo_ibge": 2922730,
                "nome": "Nova Fátima"
            },
            {
                "codigo_ibge": 2922755,
                "nome": "Nova Ibiá"
            },
            {
                "codigo_ibge": 2922805,
                "nome": "Nova Itarana"
            },
            {
                "codigo_ibge": 2922854,
                "nome": "Nova Redenção"
            },
            {
                "codigo_ibge": 2922904,
                "nome": "Nova Soure"
            },
            {
                "codigo_ibge": 2923001,
                "nome": "Nova Viçosa"
            },
            {
                "codigo_ibge": 2923035,
                "nome": "Novo Horizonte"
            },
            {
                "codigo_ibge": 2923050,
                "nome": "Novo Triunfo"
            },
            {
                "codigo_ibge": 2923100,
                "nome": "Olindina"
            },
            {
                "codigo_ibge": 2923209,
                "nome": "Oliveira dos Brejinhos"
            },
            {
                "codigo_ibge": 2923308,
                "nome": "Ouriçangas"
            },
            {
                "codigo_ibge": 2923357,
                "nome": "Ourolândia"
            },
            {
                "codigo_ibge": 2923407,
                "nome": "Palmas de Monte Alto"
            },
            {
                "codigo_ibge": 2923506,
                "nome": "Palmeiras"
            },
            {
                "codigo_ibge": 2923605,
                "nome": "Paramirim"
            },
            {
                "codigo_ibge": 2923704,
                "nome": "Paratinga"
            },
            {
                "codigo_ibge": 2923803,
                "nome": "Paripiranga"
            },
            {
                "codigo_ibge": 2923902,
                "nome": "Pau Brasil"
            },
            {
                "codigo_ibge": 2924009,
                "nome": "Paulo Afonso"
            },
            {
                "codigo_ibge": 2924058,
                "nome": "Pé de Serra"
            },
            {
                "codigo_ibge": 2924108,
                "nome": "Pedrão"
            },
            {
                "codigo_ibge": 2924207,
                "nome": "Pedro Alexandre"
            },
            {
                "codigo_ibge": 2924306,
                "nome": "Piatã"
            },
            {
                "codigo_ibge": 2924405,
                "nome": "Pilão Arcado"
            },
            {
                "codigo_ibge": 2924504,
                "nome": "Pindaí"
            },
            {
                "codigo_ibge": 2924603,
                "nome": "Pindobaçu"
            },
            {
                "codigo_ibge": 2924652,
                "nome": "Pintadas"
            },
            {
                "codigo_ibge": 2924678,
                "nome": "Piraí do Norte"
            },
            {
                "codigo_ibge": 2924702,
                "nome": "Piripá"
            },
            {
                "codigo_ibge": 2924801,
                "nome": "Piritiba"
            },
            {
                "codigo_ibge": 2924900,
                "nome": "Planaltino"
            },
            {
                "codigo_ibge": 2925006,
                "nome": "Planalto"
            },
            {
                "codigo_ibge": 2925105,
                "nome": "Poções"
            },
            {
                "codigo_ibge": 2925204,
                "nome": "Pojuca"
            },
            {
                "codigo_ibge": 2925253,
                "nome": "Ponto Novo"
            },
            {
                "codigo_ibge": 2925303,
                "nome": "Porto Seguro"
            },
            {
                "codigo_ibge": 2925402,
                "nome": "Potiraguá"
            },
            {
                "codigo_ibge": 2925501,
                "nome": "Prado"
            },
            {
                "codigo_ibge": 2925600,
                "nome": "Presidente Dutra"
            },
            {
                "codigo_ibge": 2925709,
                "nome": "Presidente Jânio Quadros"
            },
            {
                "codigo_ibge": 2925758,
                "nome": "Presidente Tancredo Neves"
            },
            {
                "codigo_ibge": 2925808,
                "nome": "Queimadas"
            },
            {
                "codigo_ibge": 2925907,
                "nome": "Quijingue"
            },
            {
                "codigo_ibge": 2925931,
                "nome": "Quixabeira"
            },
            {
                "codigo_ibge": 2925956,
                "nome": "Rafael Jambeiro"
            },
            {
                "codigo_ibge": 2926004,
                "nome": "Remanso"
            },
            {
                "codigo_ibge": 2926103,
                "nome": "Retirolândia"
            },
            {
                "codigo_ibge": 2926202,
                "nome": "Riachão das Neves"
            },
            {
                "codigo_ibge": 2926301,
                "nome": "Riachão do Jacuípe"
            },
            {
                "codigo_ibge": 2926400,
                "nome": "Riacho de Santana"
            },
            {
                "codigo_ibge": 2926509,
                "nome": "Ribeira do Amparo"
            },
            {
                "codigo_ibge": 2926608,
                "nome": "Ribeira do Pombal"
            },
            {
                "codigo_ibge": 2926657,
                "nome": "Ribeirão do Largo"
            },
            {
                "codigo_ibge": 2926707,
                "nome": "Rio de Contas"
            },
            {
                "codigo_ibge": 2926806,
                "nome": "Rio do Antônio"
            },
            {
                "codigo_ibge": 2926905,
                "nome": "Rio do Pires"
            },
            {
                "codigo_ibge": 2927002,
                "nome": "Rio Real"
            },
            {
                "codigo_ibge": 2927101,
                "nome": "Rodelas"
            },
            {
                "codigo_ibge": 2927200,
                "nome": "Ruy Barbosa"
            },
            {
                "codigo_ibge": 2927309,
                "nome": "Salinas da Margarida"
            },
            {
                "codigo_ibge": 2927408,
                "nome": "Salvador"
            },
            {
                "codigo_ibge": 2927507,
                "nome": "Santa Bárbara"
            },
            {
                "codigo_ibge": 2927606,
                "nome": "Santa Brígida"
            },
            {
                "codigo_ibge": 2927705,
                "nome": "Santa Cruz Cabrália"
            },
            {
                "codigo_ibge": 2927804,
                "nome": "Santa Cruz da Vitória"
            },
            {
                "codigo_ibge": 2927903,
                "nome": "Santa Inês"
            },
            {
                "codigo_ibge": 2928059,
                "nome": "Santa Luzia"
            },
            {
                "codigo_ibge": 2928109,
                "nome": "Santa Maria da Vitória"
            },
            {
                "codigo_ibge": 2928406,
                "nome": "Santa Rita de Cássia"
            },
            {
                "codigo_ibge": 2928505,
                "nome": "Santa Teresinha"
            },
            {
                "codigo_ibge": 2928000,
                "nome": "Santaluz"
            },
            {
                "codigo_ibge": 2928208,
                "nome": "Santana"
            },
            {
                "codigo_ibge": 2928307,
                "nome": "Santanópolis"
            },
            {
                "codigo_ibge": 2928604,
                "nome": "Santo Amaro"
            },
            {
                "codigo_ibge": 2928703,
                "nome": "Santo Antônio de Jesus"
            },
            {
                "codigo_ibge": 2928802,
                "nome": "Santo Estêvão"
            },
            {
                "codigo_ibge": 2928901,
                "nome": "São Desidério"
            },
            {
                "codigo_ibge": 2928950,
                "nome": "São Domingos"
            },
            {
                "codigo_ibge": 2929107,
                "nome": "São Felipe"
            },
            {
                "codigo_ibge": 2929008,
                "nome": "São Félix"
            },
            {
                "codigo_ibge": 2929057,
                "nome": "São Félix do Coribe"
            },
            {
                "codigo_ibge": 2929206,
                "nome": "São Francisco do Conde"
            },
            {
                "codigo_ibge": 2929255,
                "nome": "São Gabriel"
            },
            {
                "codigo_ibge": 2929305,
                "nome": "São Gonçalo dos Campos"
            },
            {
                "codigo_ibge": 2929354,
                "nome": "São José da Vitória"
            },
            {
                "codigo_ibge": 2929370,
                "nome": "São José do Jacuípe"
            },
            {
                "codigo_ibge": 2929404,
                "nome": "São Miguel das Matas"
            },
            {
                "codigo_ibge": 2929503,
                "nome": "São Sebastião do Passé"
            },
            {
                "codigo_ibge": 2929602,
                "nome": "Sapeaçu"
            },
            {
                "codigo_ibge": 2929701,
                "nome": "Sátiro Dias"
            },
            {
                "codigo_ibge": 2929750,
                "nome": "Saubara"
            },
            {
                "codigo_ibge": 2929800,
                "nome": "Saúde"
            },
            {
                "codigo_ibge": 2929909,
                "nome": "Seabra"
            },
            {
                "codigo_ibge": 2930006,
                "nome": "Sebastião Laranjeiras"
            },
            {
                "codigo_ibge": 2930105,
                "nome": "Senhor do Bonfim"
            },
            {
                "codigo_ibge": 2930204,
                "nome": "Sento Sé"
            },
            {
                "codigo_ibge": 2930154,
                "nome": "Serra do Ramalho"
            },
            {
                "codigo_ibge": 2930303,
                "nome": "Serra Dourada"
            },
            {
                "codigo_ibge": 2930402,
                "nome": "Serra Preta"
            },
            {
                "codigo_ibge": 2930501,
                "nome": "Serrinha"
            },
            {
                "codigo_ibge": 2930600,
                "nome": "Serrolândia"
            },
            {
                "codigo_ibge": 2930709,
                "nome": "Simões Filho"
            },
            {
                "codigo_ibge": 2930758,
                "nome": "Sítio do Mato"
            },
            {
                "codigo_ibge": 2930766,
                "nome": "Sítio do Quinto"
            },
            {
                "codigo_ibge": 2930774,
                "nome": "Sobradinho"
            },
            {
                "codigo_ibge": 2930808,
                "nome": "Souto Soares"
            },
            {
                "codigo_ibge": 2930907,
                "nome": "Tabocas do Brejo Velho"
            },
            {
                "codigo_ibge": 2931004,
                "nome": "Tanhaçu"
            },
            {
                "codigo_ibge": 2931053,
                "nome": "Tanque Novo"
            },
            {
                "codigo_ibge": 2931103,
                "nome": "Tanquinho"
            },
            {
                "codigo_ibge": 2931202,
                "nome": "Taperoá"
            },
            {
                "codigo_ibge": 2931301,
                "nome": "Tapiramutá"
            },
            {
                "codigo_ibge": 2931350,
                "nome": "Teixeira de Freitas"
            },
            {
                "codigo_ibge": 2931400,
                "nome": "Teodoro Sampaio"
            },
            {
                "codigo_ibge": 2931509,
                "nome": "Teofilândia"
            },
            {
                "codigo_ibge": 2931608,
                "nome": "Teolândia"
            },
            {
                "codigo_ibge": 2931707,
                "nome": "Terra Nova"
            },
            {
                "codigo_ibge": 2931806,
                "nome": "Tremedal"
            },
            {
                "codigo_ibge": 2931905,
                "nome": "Tucano"
            },
            {
                "codigo_ibge": 2932002,
                "nome": "Uauá"
            },
            {
                "codigo_ibge": 2932101,
                "nome": "Ubaíra"
            },
            {
                "codigo_ibge": 2932200,
                "nome": "Ubaitaba"
            },
            {
                "codigo_ibge": 2932309,
                "nome": "Ubatã"
            },
            {
                "codigo_ibge": 2932408,
                "nome": "Uibaí"
            },
            {
                "codigo_ibge": 2932457,
                "nome": "Umburanas"
            },
            {
                "codigo_ibge": 2932507,
                "nome": "Una"
            },
            {
                "codigo_ibge": 2932606,
                "nome": "Urandi"
            },
            {
                "codigo_ibge": 2932705,
                "nome": "Uruçuca"
            },
            {
                "codigo_ibge": 2932804,
                "nome": "Utinga"
            },
            {
                "codigo_ibge": 2932903,
                "nome": "Valença"
            },
            {
                "codigo_ibge": 2933000,
                "nome": "Valente"
            },
            {
                "codigo_ibge": 2933059,
                "nome": "Várzea da Roça"
            },
            {
                "codigo_ibge": 2933109,
                "nome": "Várzea do Poço"
            },
            {
                "codigo_ibge": 2933158,
                "nome": "Várzea Nova"
            },
            {
                "codigo_ibge": 2933174,
                "nome": "Varzedo"
            },
            {
                "codigo_ibge": 2933208,
                "nome": "Vera Cruz"
            },
            {
                "codigo_ibge": 2933257,
                "nome": "Vereda"
            },
            {
                "codigo_ibge": 2933307,
                "nome": "Vitória da Conquista"
            },
            {
                "codigo_ibge": 2933406,
                "nome": "Wagner"
            },
            {
                "codigo_ibge": 2933455,
                "nome": "Wanderley"
            },
            {
                "codigo_ibge": 2933505,
                "nome": "Wenceslau Guimarães"
            },
            {
                "codigo_ibge": 2933604,
                "nome": "Xique-Xique"
            }
        ]
    },
    "CE": {
        "nome": "Ceará",
        "municipios": [
            {
                "codigo_ibge": 2300101,
                "nome": "Abaiara"
            },
            {
                "codigo_ibge": 2300150,
                "nome": "Acarape"
            },
            {
                "codigo_ibge": 2300200,
                "nome": "Acaraú"
            },
            {
                "codigo_ibge": 2300309,
                "nome": "Acopiara"
            },
            {
                "codigo_ibge": 2300408,
                "nome": "Aiuaba"
            },
            {
                "codigo_ibge": 2300507,
                "nome": "Alcântaras"
            },
            {
                "codigo_ibge": 2300606,
                "nome": "Altaneira"
            },
            {
                "codigo_ibge": 2300705,
                "nome": "Alto Santo"
            },
            {
                "codigo_ibge": 2300754,
                "nome": "Amontada"
            },
            {
                "codigo_ibge": 2300804,
                "nome": "Antonina do Norte"
            },
            {
                "codigo_ibge": 2300903,
                "nome": "Apuiarés"
            },
            {
                "codigo_ibge": 2301000,
                "nome": "Aquiraz"
            },
            {
                "codigo_ibge": 2301109,
                "nome": "Aracati"
            },
            {
                "codigo_ibge": 2301208,
                "nome": "Aracoiaba"
            },
            {
                "codigo_ibge": 2301257,
                "nome": "Ararendá"
            },
            {
                "codigo_ibge": 2301307,
                "nome": "Araripe"
            },
            {
                "codigo_ibge": 2301406,
                "nome": "Aratuba"
            },
            {
                "codigo_ibge": 2301505,
                "nome": "Arneiroz"
            },
            {
                "codigo_ibge": 2301604,
                "nome": "Assaré"
            },
            {
                "codigo_ibge": 2301703,
                "nome": "Aurora"
            },
            {
                "codigo_ibge": 2301802,
                "nome": "Baixio"
            },
            {
                "codigo_ibge": 2301851,
                "nome": "Banabuiú"
            },
            {
                "codigo_ibge": 2301901,
                "nome": "Barbalha"
            },
            {
                "codigo_ibge": 2301950,
                "nome": "Barreira"
            },
            {
                "codigo_ibge": 2302008,
                "nome": "Barro"
            },
            {
                "codigo_ibge": 2302057,
                "nome": "Barroquinha"
            },
            {
                "codigo_ibge": 2302107,
                "nome": "Baturité"
            },
            {
                "codigo_ibge": 2302206,
                "nome": "Beberibe"
            },
            {
                "codigo_ibge": 2302305,
                "nome": "Bela Cruz"
            },
            {
                "codigo_ibge": 2302404,
                "nome": "Boa Viagem"
            },
            {
                "codigo_ibge": 2302503,
                "nome": "Brejo Santo"
            },
            {
                "codigo_ibge": 2302602,
                "nome": "Camocim"
            },
            {
                "codigo_ibge": 2302701,
                "nome": "Campos Sales"
            },
            {
                "codigo_ibge": 2302800,
                "nome": "Canindé"
            },
            {
                "codigo_ibge": 2302909,
                "nome": "Capistrano"
            },
            {
                "codigo_ibge": 2303006,
                "nome": "Caridade"
            },
            {
                "codigo_ibge": 2303105,
                "nome": "Cariré"
            },
            {
                "codigo_ibge": 2303204,
                "nome": "Caririaçu"
            },
            {
                "codigo_ibge": 2303303,
                "nome": "Cariús"
            },
            {
                "codigo_ibge": 2303402,
                "nome": "Carnaubal"
            },
            {
                "codigo_ibge": 2303501,
                "nome": "Cascavel"
            },
            {
                "codigo_ibge": 2303600,
                "nome": "Catarina"
            },
            {
                "codigo_ibge": 2303659,
                "nome": "Catunda"
            },
            {
                "codigo_ibge": 2303709,
                "nome": "Caucaia"
            },
            {
                "codigo_ibge": 2303808,
                "nome": "Cedro"
            },
            {
                "codigo_ibge": 2303907,
                "nome": "Chaval"
            },
            {
                "codigo_ibge": 2303931,
                "nome": "Choró"
            },
            {
                "codigo_ibge": 2303956,
                "nome": "Chorozinho"
            },
            {
                "codigo_ibge": 2304004,
                "nome": "Coreaú"
            },
            {
                "codigo_ibge": 2304103,
                "nome": "Crateús"
            },
            {
                "codigo_ibge": 2304202,
                "nome": "Crato"
            },
            {
                "codigo_ibge": 2304236,
                "nome": "Croatá"
            },
            {
                "codigo_ibge": 2304251,
                "nome": "Cruz"
            },
            {
                "codigo_ibge": 2304269,
                "nome": "Deputado Irapuan Pinheiro"
            },
            {
                "codigo_ibge": 2304277,
                "nome": "Ererê"
            },
            {
                "codigo_ibge": 2304285,
                "nome": "Eusébio"
            },
            {
                "codigo_ibge": 2304301,
                "nome": "Farias Brito"
            },
            {
                "codigo_ibge": 2304350,
                "nome": "Forquilha"
            },
            {
                "codigo_ibge": 2304400,
                "nome": "Fortaleza"
            },
            {
                "codigo_ibge": 2304459,
                "nome": "Fortim"
            },
            {
                "codigo_ibge": 2304509,
                "nome": "Frecheirinha"
            },
            {
                "codigo_ibge": 2304608,
                "nome": "General Sampaio"
            },
            {
                "codigo_ibge": 2304657,
                "nome": "Graça"
            },
            {
                "codigo_ibge": 2304707,
                "nome": "Granja"
            },
            {
                "codigo_ibge": 2304806,
                "nome": "Granjeiro"
            },
            {
                "codigo_ibge": 2304905,
                "nome": "Groaíras"
            },
            {
                "codigo_ibge": 2304954,
                "nome": "Guaiúba"
            },
            {
                "codigo_ibge": 2305001,
                "nome": "Guaraciaba do Norte"
            },
            {
                "codigo_ibge": 2305100,
                "nome": "Guaramiranga"
            },
            {
                "codigo_ibge": 2305209,
                "nome": "Hidrolândia"
            },
            {
                "codigo_ibge": 2305233,
                "nome": "Horizonte"
            },
            {
                "codigo_ibge": 2305266,
                "nome": "Ibaretama"
            },
            {
                "codigo_ibge": 2305308,
                "nome": "Ibiapina"
            },
            {
                "codigo_ibge": 2305332,
                "nome": "Ibicuitinga"
            },
            {
                "codigo_ibge": 2305357,
                "nome": "Icapuí"
            },
            {
                "codigo_ibge": 2305407,
                "nome": "Icó"
            },
            {
                "codigo_ibge": 2305506,
                "nome": "Iguatu"
            },
            {
                "codigo_ibge": 2305605,
                "nome": "Independência"
            },
            {
                "codigo_ibge": 2305654,
                "nome": "Ipaporanga"
            },
            {
                "codigo_ibge": 2305704,
                "nome": "Ipaumirim"
            },
            {
                "codigo_ibge": 2305803,
                "nome": "Ipu"
            },
            {
                "codigo_ibge": 2305902,
                "nome": "Ipueiras"
            },
            {
                "codigo_ibge": 2306009,
                "nome": "Iracema"
            },
            {
                "codigo_ibge": 2306108,
                "nome": "Irauçuba"
            },
            {
                "codigo_ibge": 2306207,
                "nome": "Itaiçaba"
            },
            {
                "codigo_ibge": 2306256,
                "nome": "Itaitinga"
            },
            {
                "codigo_ibge": 2306306,
                "nome": "Itapajé"
            },
            {
                "codigo_ibge": 2306405,
                "nome": "Itapipoca"
            },
            {
                "codigo_ibge": 2306504,
                "nome": "Itapiúna"
            },
            {
                "codigo_ibge": 2306553,
                "nome": "Itarema"
            },
            {
                "codigo_ibge": 2306603,
                "nome": "Itatira"
            },
            {
                "codigo_ibge": 2306702,
                "nome": "Jaguaretama"
            },
            {
                "codigo_ibge": 2306801,
                "nome": "Jaguaribara"
            },
            {
                "codigo_ibge": 2306900,
                "nome": "Jaguaribe"
            },
            {
                "codigo_ibge": 2307007,
                "nome": "Jaguaruana"
            },
            {
                "codigo_ibge": 2307106,
                "nome": "Jardim"
            },
            {
                "codigo_ibge": 2307205,
                "nome": "Jati"
            },
            {
                "codigo_ibge": 2307254,
                "nome": "Jijoca de Jericoacoara"
            },
            {
                "codigo_ibge": 2307304,
                "nome": "Juazeiro do Norte"
            },
            {
                "codigo_ibge": 2307403,
                "nome": "Jucás"
            },
            {
                "codigo_ibge": 2307502,
                "nome": "Lavras da Mangabeira"
            },
            {
                "codigo_ibge": 2307601,
                "nome": "Limoeiro do Norte"
            },
            {
                "codigo_ibge": 2307635,
                "nome": "Madalena"
            },
            {
                "codigo_ibge": 2307650,
                "nome": "Maracanaú"
            },
            {
                "codigo_ibge": 2307700,
                "nome": "Maranguape"
            },
            {
                "codigo_ibge": 2307809,
                "nome": "Marco"
            },
            {
                "codigo_ibge": 2307908,
                "nome": "Martinópole"
            },
            {
                "codigo_ibge": 2308005,
                "nome": "Massapê"
            },
            {
                "codigo_ibge": 2308104,
                "nome": "Mauriti"
            },
            {
                "codigo_ibge": 2308203,
                "nome": "Meruoca"
            },
            {
                "codigo_ibge": 2308302,
                "nome": "Milagres"
            },
            {
                "codigo_ibge": 2308351,
                "nome": "Milhã"
            },
            {
                "codigo_ibge": 2308377,
                "nome": "Miraíma"
            },
            {
                "codigo_ibge": 2308401,
                "nome": "Missão Velha"
            },
            {
                "codigo_ibge": 2308500,
                "nome": "Mombaça"
            },
            {
                "codigo_ibge": 2308609,
                "nome": "Monsenhor Tabosa"
            },
            {
                "codigo_ibge": 2308708,
                "nome": "Morada Nova"
            },
            {
                "codigo_ibge": 2308807,
                "nome": "Moraújo"
            },
            {
                "codigo_ibge": 2308906,
                "nome": "Morrinhos"
            },
            {
                "codigo_ibge": 2309003,
                "nome": "Mucambo"
            },
            {
                "codigo_ibge": 2309102,
                "nome": "Mulungu"
            },
            {
                "codigo_ibge": 2309201,
                "nome": "Nova Olinda"
            },
            {
                "codigo_ibge": 2309300,
                "nome": "Nova Russas"
            },
            {
                "codigo_ibge": 2309409,
                "nome": "Novo Oriente"
            },
            {
                "codigo_ibge": 2309458,
                "nome": "Ocara"
            },
            {
                "codigo_ibge": 2309508,
                "nome": "Orós"
            },
            {
                "codigo_ibge": 2309607,
                "nome": "Pacajus"
            },
            {
                "codigo_ibge": 2309706,
                "nome": "Pacatuba"
            },
            {
                "codigo_ibge": 2309805,
                "nome": "Pacoti"
            },
            {
                "codigo_ibge": 2309904,
                "nome": "Pacujá"
            },
            {
                "codigo_ibge": 2310001,
                "nome": "Palhano"
            },
            {
                "codigo_ibge": 2310100,
                "nome": "Palmácia"
            },
            {
                "codigo_ibge": 2310209,
                "nome": "Paracuru"
            },
            {
                "codigo_ibge": 2310258,
                "nome": "Paraipaba"
            },
            {
                "codigo_ibge": 2310308,
                "nome": "Parambu"
            },
            {
                "codigo_ibge": 2310407,
                "nome": "Paramoti"
            },
            {
                "codigo_ibge": 2310506,
                "nome": "Pedra Branca"
            },
            {
                "codigo_ibge": 2310605,
                "nome": "Penaforte"
            },
            {
                "codigo_ibge": 2310704,
                "nome": "Pentecoste"
            },
            {
                "codigo_ibge": 2310803,
                "nome": "Pereiro"
            },
            {
                "codigo_ibge": 2310852,
                "nome": "Pindoretama"
            },
            {
                "codigo_ibge": 2310902,
                "nome": "Piquet Carneiro"
            },
            {
                "codigo_ibge": 2310951,
                "nome": "Pires Ferreira"
            },
            {
                "codigo_ibge": 2311009,
                "nome": "Poranga"
            },
            {
                "codigo_ibge": 2311108,
                "nome": "Porteiras"
            },
            {
                "codigo_ibge": 2311207,
                "nome": "Potengi"
            },
            {
                "codigo_ibge": 2311231,
                "nome": "Potiretama"
            },
            {
                "codigo_ibge": 2311264,
                "nome": "Quiterianópolis"
            },
            {
                "codigo_ibge": 2311306,
                "nome": "Quixadá"
            },
            {
                "codigo_ibge": 2311355,
                "nome": "Quixelô"
            },
            {
                "codigo_ibge": 2311405,
                "nome": "Quixeramobim"
            },
            {
                "codigo_ibge": 2311504,
                "nome": "Quixeré"
            },
            {
                "codigo_ibge": 2311603,
                "nome": "Redenção"
            },
            {
                "codigo_ibge": 2311702,
                "nome": "Reriutaba"
            },
            {
                "codigo_ibge": 2311801,
                "nome": "Russas"
            },
            {
                "codigo_ibge": 2311900,
                "nome": "Saboeiro"
            },
            {
                "codigo_ibge": 2311959,
                "nome": "Salitre"
            },
            {
                "codigo_ibge": 2312205,
                "nome": "Santa Quitéria"
            },
            {
                "codigo_ibge": 2312007,
                "nome": "Santana do Acaraú"
            },
            {
                "codigo_ibge": 2312106,
                "nome": "Santana do Cariri"
            },
            {
                "codigo_ibge": 2312304,
                "nome": "São Benedito"
            },
            {
                "codigo_ibge": 2312403,
                "nome": "São Gonçalo do Amarante"
            },
            {
                "codigo_ibge": 2312502,
                "nome": "São João do Jaguaribe"
            },
            {
                "codigo_ibge": 2312601,
                "nome": "São Luís do Curu"
            },
            {
                "codigo_ibge": 2312700,
                "nome": "Senador Pompeu"
            },
            {
                "codigo_ibge": 2312809,
                "nome": "Senador Sá"
            },
            {
                "codigo_ibge": 2312908,
                "nome": "Sobral"
            },
            {
                "codigo_ibge": 2313005,
                "nome": "Solonópole"
            },
            {
                "codigo_ibge": 2313104,
                "nome": "Tabuleiro do Norte"
            },
            {
                "codigo_ibge": 2313203,
                "nome": "Tamboril"
            },
            {
                "codigo_ibge": 2313252,
                "nome": "Tarrafas"
            },
            {
                "codigo_ibge": 2313302,
                "nome": "Tauá"
            },
            {
                "codigo_ibge": 2313351,
                "nome": "Tejuçuoca"
            },
            {
                "codigo_ibge": 2313401,
                "nome": "Tianguá"
            },
            {
                "codigo_ibge": 2313500,
                "nome": "Trairi"
            },
            {
                "codigo_ibge": 2313559,
                "nome": "Tururu"
            },
            {
                "codigo_ibge": 2313609,
                "nome": "Ubajara"
            },
            {
                "codigo_ibge": 2313708,
                "nome": "Umari"
            },
            {
                "codigo_ibge": 2313757,
                "nome": "Umirim"
            },
            {
                "codigo_ibge": 2313807,
                "nome": "Uruburetama"
            },
            {
                "codigo_ibge": 2313906,
                "nome": "Uruoca"
            },
            {
                "codigo_ibge": 2313955,
                "nome": "Varjota"
            },
            {
                "codigo_ibge": 2314003,
                "nome": "Várzea Alegre"
            },
            {
                "codigo_ibge": 2314102,
                "nome": "Viçosa do Ceará"
            }
        ]
    },
    "DF": {
        "nome": "Distrito Federal",
        "municipios": [
            {
                "codigo_ibge": 5300108,
                "nome": "Brasília"
            }
        ]
    },
    "ES": {
        "nome": "Espírito Santo",
        "municipios": [
            {
                "codigo_ibge": 3200102,
                "nome": "Afonso Cláudio"
            },
            {
                "codigo_ibge": 3200169,
                "nome": "Água Doce do Norte"
            },
            {
                "codigo_ibge": 3200136,
                "nome": "Águia Branca"
            },
            {
                "codigo_ibge": 3200201,
                "nome": "Alegre"
            },
            {
                "codigo_ibge": 3200300,
                "nome": "Alfredo Chaves"
            },
            {
                "codigo_ibge": 3200359,
                "nome": "Alto Rio Novo"
            },
            {
                "codigo_ibge": 3200409,
                "nome": "Anchieta"
            },
            {
                "codigo_ibge": 3200508,
                "nome": "Apiacá"
            },
            {
                "codigo_ibge": 3200607,
                "nome": "Aracruz"
            },
            {
                "codigo_ibge": 3200706,
                "nome": "Atilio Vivacqua"
            },
            {
                "codigo_ibge": 3200805,
                "nome": "Baixo Guandu"
            },
            {
                "codigo_ibge": 3200904,
                "nome": "Barra de São Francisco"
            },
            {
                "codigo_ibge": 3201001,
                "nome": "Boa Esperança"
            },
            {
                "codigo_ibge": 3201100,
                "nome": "Bom Jesus do Norte"
            },
            {
                "codigo_ibge": 3201159,
                "nome": "Brejetuba"
            },
            {
                "codigo_ibge": 3201209,
                "nome": "Cachoeiro de Itapemirim"
            },
            {
                "codigo_ibge": 3201308,
                "nome": "Cariacica"
            },
            {
                "codigo_ibge": 3201407,
                "nome": "Castelo"
            },
            {
                "codigo_ibge": 3201506,
                "nome": "Colatina"
            },
            {
                "codigo_ibge": 3201605,
                "nome": "Conceição da Barra"
            },
            {
                "codigo_ibge": 3201704,
                "nome": "Conceição do Castelo"
            },
            {
                "codigo_ibge": 3201803,
                "nome": "Divino de São Lourenço"
            },
            {
                "codigo_ibge": 3201902,
                "nome": "Domingos Martins"
            },
            {
                "codigo_ibge": 3202009,
                "nome": "Dores do Rio Preto"
            },
            {
                "codigo_ibge": 3202108,
                "nome": "Ecoporanga"
            },
            {
                "codigo_ibge": 3202207,
                "nome": "Fundão"
            },
            {
                "codigo_ibge": 3202256,
                "nome": "Governador Lindenberg"
            },
            {
                "codigo_ibge": 3202306,
                "nome": "Guaçuí"
            },
            {
                "codigo_ibge": 3202405,
                "nome": "Guarapari"
            },
            {
                "codigo_ibge": 3202454,
                "nome": "Ibatiba"
            },
            {
                "codigo_ibge": 3202504,
                "nome": "Ibiraçu"
            },
            {
                "codigo_ibge": 3202553,
                "nome": "Ibitirama"
            },
            {
                "codigo_ibge": 3202603,
                "nome": "Iconha"
            },
            {
                "codigo_ibge": 3202652,
                "nome": "Irupi"
            },
            {
                "codigo_ibge": 3202702,
                "nome": "Itaguaçu"
            },
            {
                "codigo_ibge": 3202801,
                "nome": "Itapemirim"
            },
            {
                "codigo_ibge": 3202900,
                "nome": "Itarana"
            },
            {
                "codigo_ibge": 3203007,
                "nome": "Iúna"
            },
            {
                "codigo_ibge": 3203056,
                "nome": "Jaguaré"
            },
            {
                "codigo_ibge": 3203106,
                "nome": "Jerônimo Monteiro"
            },
            {
                "codigo_ibge": 3203130,
                "nome": "João Neiva"
            },
            {
                "codigo_ibge": 3203163,
                "nome": "Laranja da Terra"
            },
            {
                "codigo_ibge": 3203205,
                "nome": "Linhares"
            },
            {
                "codigo_ibge": 3203304,
                "nome": "Mantenópolis"
            },
            {
                "codigo_ibge": 3203320,
                "nome": "Marataízes"
            },
            {
                "codigo_ibge": 3203346,
                "nome": "Marechal Floriano"
            },
            {
                "codigo_ibge": 3203353,
                "nome": "Marilândia"
            },
            {
                "codigo_ibge": 3203403,
                "nome": "Mimoso do Sul"
            },
            {
                "codigo_ibge": 3203502,
                "nome": "Montanha"
            },
            {
                "codigo_ibge": 3203601,
                "nome": "Mucurici"
            },
            {
                "codigo_ibge": 3203700,
                "nome": "Muniz Freire"
            },
            {
                "codigo_ibge": 3203809,
                "nome": "Muqui"
            },
            {
                "codigo_ibge": 3203908,
                "nome": "Nova Venécia"
            },
            {
                "codigo_ibge": 3204005,
                "nome": "Pancas"
            },
            {
                "codigo_ibge": 3204054,
                "nome": "Pedro Canário"
            },
            {
                "codigo_ibge": 3204104,
                "nome": "Pinheiros"
            },
            {
                "codigo_ibge": 3204203,
                "nome": "Piúma"
            },
            {
                "codigo_ibge": 3204252,
                "nome": "Ponto Belo"
            },
            {
                "codigo_ibge": 3204302,
                "nome": "Presidente Kennedy"
            },
            {
                "codigo_ibge": 3204351,
                "nome": "Rio Bananal"
            },
            {
                "codigo_ibge": 3204401,
                "nome": "Rio Novo do Sul"
            },
            {
                "codigo_ibge": 3204500,
                "nome": "Santa Leopoldina"
            },
            {
                "codigo_ibge": 3204559,
                "nome": "Santa Maria de Jetibá"
            },
            {
                "codigo_ibge": 3204609,
                "nome": "Santa Teresa"
            },
            {
                "codigo_ibge": 3204658,
                "nome": "São Domingos do Norte"
            },
            {
                "codigo_ibge": 3204708,
                "nome": "São Gabriel da Palha"
            },
            {
                "codigo_ibge": 3204807,
                "nome": "São José do Calçado"
            },
            {
                "codigo_ibge": 3204906,
                "nome": "São Mateus"
            },
            {
                "codigo_ibge": 3204955,
                "nome": "São Roque do Canaã"
            },
            {
                "codigo_ibge": 3205002,
                "nome": "Serra"
            },
            {
                "codigo_ibge": 3205010,
                "nome": "Sooretama"
            },
            {
                "codigo_ibge": 3205036,
                "nome": "Vargem Alta"
            },
            {
                "codigo_ibge": 3205069,
                "nome": "Venda Nova do Imigrante"
            },
            {
                "codigo_ibge": 3205101,
                "nome": "Viana"
            },
            {
                "codigo_ibge": 3205150,
                "nome": "Vila Pavão"
            },
            {
                "codigo_ibge": 3205176,
                "nome": "Vila Valério"
            },
            {
                "codigo_ibge": 3205200,
                "nome": "Vila Velha"
            },
            {
                "codigo_ibge": 3205309,
                "nome": "Vitória"
            }
        ]
    },
    "GO": {
        "nome": "Goiás",
        "municipios": [
            {
                "codigo_ibge": 5200050,
                "nome": "Abadia de Goiás"
            },
            {
                "codigo_ibge": 5200100,
                "nome": "Abadiânia"
            },
            {
                "codigo_ibge": 5200134,
                "nome": "Acreúna"
            },
            {
                "codigo_ibge": 5200159,
                "nome": "Adelândia"
            },
            {
                "codigo_ibge": 5200175,
                "nome": "Água Fria de Goiás"
            },
            {
                "codigo_ibge": 5200209,
                "nome": "Água Limpa"
            },
            {
                "codigo_ibge": 5200258,
                "nome": "Águas Lindas de Goiás"
            },
            {
                "codigo_ibge": 5200308,
                "nome": "Alexânia"
            },
            {
                "codigo_ibge": 5200506,
                "nome": "Aloândia"
            },
            {
                "codigo_ibge": 5200555,
                "nome": "Alto Horizonte"
            },
            {
                "codigo_ibge": 5200605,
                "nome": "Alto Paraíso de Goiás"
            },
            {
                "codigo_ibge": 5200803,
                "nome": "Alvorada do Norte"
            },
            {
                "codigo_ibge": 5200829,
                "nome": "Amaralina"
            },
            {
                "codigo_ibge": 5200852,
                "nome": "Americano do Brasil"
            },
            {
                "codigo_ibge": 5200902,
                "nome": "Amorinópolis"
            },
            {
                "codigo_ibge": 5201108,
                "nome": "Anápolis"
            },
            {
                "codigo_ibge": 5201207,
                "nome": "Anhanguera"
            },
            {
                "codigo_ibge": 5201306,
                "nome": "Anicuns"
            },
            {
                "codigo_ibge": 5201405,
                "nome": "Aparecida de Goiânia"
            },
            {
                "codigo_ibge": 5201454,
                "nome": "Aparecida do Rio Doce"
            },
            {
                "codigo_ibge": 5201504,
                "nome": "Aporé"
            },
            {
                "codigo_ibge": 5201603,
                "nome": "Araçu"
            },
            {
                "codigo_ibge": 5201702,
                "nome": "Aragarças"
            },
            {
                "codigo_ibge": 5201801,
                "nome": "Aragoiânia"
            },
            {
                "codigo_ibge": 5202155,
                "nome": "Araguapaz"
            },
            {
                "codigo_ibge": 5202353,
                "nome": "Arenópolis"
            },
            {
                "codigo_ibge": 5202502,
                "nome": "Aruanã"
            },
            {
                "codigo_ibge": 5202601,
                "nome": "Aurilândia"
            },
            {
                "codigo_ibge": 5202809,
                "nome": "Avelinópolis"
            },
            {
                "codigo_ibge": 5203104,
                "nome": "Baliza"
            },
            {
                "codigo_ibge": 5203203,
                "nome": "Barro Alto"
            },
            {
                "codigo_ibge": 5203302,
                "nome": "Bela Vista de Goiás"
            },
            {
                "codigo_ibge": 5203401,
                "nome": "Bom Jardim de Goiás"
            },
            {
                "codigo_ibge": 5203500,
                "nome": "Bom Jesus de Goiás"
            },
            {
                "codigo_ibge": 5203559,
                "nome": "Bonfinópolis"
            },
            {
                "codigo_ibge": 5203575,
                "nome": "Bonópolis"
            },
            {
                "codigo_ibge": 5203609,
                "nome": "Brazabrantes"
            },
            {
                "codigo_ibge": 5203807,
                "nome": "Britânia"
            },
            {
                "codigo_ibge": 5203906,
                "nome": "Buriti Alegre"
            },
            {
                "codigo_ibge": 5203939,
                "nome": "Buriti de Goiás"
            },
            {
                "codigo_ibge": 5203962,
                "nome": "Buritinópolis"
            },
            {
                "codigo_ibge": 5204003,
                "nome": "Cabeceiras"
            },
            {
                "codigo_ibge": 5204102,
                "nome": "Cachoeira Alta"
            },
            {
                "codigo_ibge": 5204201,
                "nome": "Cachoeira de Goiás"
            },
            {
                "codigo_ibge": 5204250,
                "nome": "Cachoeira Dourada"
            },
            {
                "codigo_ibge": 5204300,
                "nome": "Caçu"
            },
            {
                "codigo_ibge": 5204409,
                "nome": "Caiapônia"
            },
            {
                "codigo_ibge": 5204508,
                "nome": "Caldas Novas"
            },
            {
                "codigo_ibge": 5204557,
                "nome": "Caldazinha"
            },
            {
                "codigo_ibge": 5204607,
                "nome": "Campestre de Goiás"
            },
            {
                "codigo_ibge": 5204656,
                "nome": "Campinaçu"
            },
            {
                "codigo_ibge": 5204706,
                "nome": "Campinorte"
            },
            {
                "codigo_ibge": 5204805,
                "nome": "Campo Alegre de Goiás"
            },
            {
                "codigo_ibge": 5204854,
                "nome": "Campo Limpo de Goiás"
            },
            {
                "codigo_ibge": 5204904,
                "nome": "Campos Belos"
            },
            {
                "codigo_ibge": 5204953,
                "nome": "Campos Verdes"
            },
            {
                "codigo_ibge": 5205000,
                "nome": "Carmo do Rio Verde"
            },
            {
                "codigo_ibge": 5205059,
                "nome": "Castelândia"
            },
            {
                "codigo_ibge": 5205109,
                "nome": "Catalão"
            },
            {
                "codigo_ibge": 5205208,
                "nome": "Caturaí"
            },
            {
                "codigo_ibge": 5205307,
                "nome": "Cavalcante"
            },
            {
                "codigo_ibge": 5205406,
                "nome": "Ceres"
            },
            {
                "codigo_ibge": 5205455,
                "nome": "Cezarina"
            },
            {
                "codigo_ibge": 5205471,
                "nome": "Chapadão do Céu"
            },
            {
                "codigo_ibge": 5205497,
                "nome": "Cidade Ocidental"
            },
            {
                "codigo_ibge": 5205513,
                "nome": "Cocalzinho de Goiás"
            },
            {
                "codigo_ibge": 5205521,
                "nome": "Colinas do Sul"
            },
            {
                "codigo_ibge": 5205703,
                "nome": "Córrego do Ouro"
            },
            {
                "codigo_ibge": 5205802,
                "nome": "Corumbá de Goiás"
            },
            {
                "codigo_ibge": 5205901,
                "nome": "Corumbaíba"
            },
            {
                "codigo_ibge": 5206206,
                "nome": "Cristalina"
            },
            {
                "codigo_ibge": 5206305,
                "nome": "Cristianópolis"
            },
            {
                "codigo_ibge": 5206404,
                "nome": "Crixás"
            },
            {
                "codigo_ibge": 5206503,
                "nome": "Cromínia"
            },
            {
                "codigo_ibge": 5206602,
                "nome": "Cumari"
            },
            {
                "codigo_ibge": 5206701,
                "nome": "Damianópolis"
            },
            {
                "codigo_ibge": 5206800,
                "nome": "Damolândia"
            },
            {
                "codigo_ibge": 5206909,
                "nome": "Davinópolis"
            },
            {
                "codigo_ibge": 5207105,
                "nome": "Diorama"
            },
            {
                "codigo_ibge": 5208301,
                "nome": "Divinópolis de Goiás"
            },
            {
                "codigo_ibge": 5207253,
                "nome": "Doverlândia"
            },
            {
                "codigo_ibge": 5207352,
                "nome": "Edealina"
            },
            {
                "codigo_ibge": 5207402,
                "nome": "Edéia"
            },
            {
                "codigo_ibge": 5207501,
                "nome": "Estrela do Norte"
            },
            {
                "codigo_ibge": 5207535,
                "nome": "Faina"
            },
            {
                "codigo_ibge": 5207600,
                "nome": "Fazenda Nova"
            },
            {
                "codigo_ibge": 5207808,
                "nome": "Firminópolis"
            },
            {
                "codigo_ibge": 5207907,
                "nome": "Flores de Goiás"
            },
            {
                "codigo_ibge": 5208004,
                "nome": "Formosa"
            },
            {
                "codigo_ibge": 5208103,
                "nome": "Formoso"
            },
            {
                "codigo_ibge": 5208152,
                "nome": "Gameleira de Goiás"
            },
            {
                "codigo_ibge": 5208400,
                "nome": "Goianápolis"
            },
            {
                "codigo_ibge": 5208509,
                "nome": "Goiandira"
            },
            {
                "codigo_ibge": 5208608,
                "nome": "Goianésia"
            },
            {
                "codigo_ibge": 5208707,
                "nome": "Goiânia"
            },
            {
                "codigo_ibge": 5208806,
                "nome": "Goianira"
            },
            {
                "codigo_ibge": 5208905,
                "nome": "Goiás"
            },
            {
                "codigo_ibge": 5209101,
                "nome": "Goiatuba"
            },
            {
                "codigo_ibge": 5209150,
                "nome": "Gouvelândia"
            },
            {
                "codigo_ibge": 5209200,
                "nome": "Guapó"
            },
            {
                "codigo_ibge": 5209291,
                "nome": "Guaraíta"
            },
            {
                "codigo_ibge": 5209408,
                "nome": "Guarani de Goiás"
            },
            {
                "codigo_ibge": 5209457,
                "nome": "Guarinos"
            },
            {
                "codigo_ibge": 5209606,
                "nome": "Heitoraí"
            },
            {
                "codigo_ibge": 5209705,
                "nome": "Hidrolândia"
            },
            {
                "codigo_ibge": 5209804,
                "nome": "Hidrolina"
            },
            {
                "codigo_ibge": 5209903,
                "nome": "Iaciara"
            },
            {
                "codigo_ibge": 5209937,
                "nome": "Inaciolândia"
            },
            {
                "codigo_ibge": 5209952,
                "nome": "Indiara"
            },
            {
                "codigo_ibge": 5210000,
                "nome": "Inhumas"
            },
            {
                "codigo_ibge": 5210109,
                "nome": "Ipameri"
            },
            {
                "codigo_ibge": 5210158,
                "nome": "Ipiranga de Goiás"
            },
            {
                "codigo_ibge": 5210208,
                "nome": "Iporá"
            },
            {
                "codigo_ibge": 5210307,
                "nome": "Israelândia"
            },
            {
                "codigo_ibge": 5210406,
                "nome": "Itaberaí"
            },
            {
                "codigo_ibge": 5210562,
                "nome": "Itaguari"
            },
            {
                "codigo_ibge": 5210604,
                "nome": "Itaguaru"
            },
            {
                "codigo_ibge": 5210802,
                "nome": "Itajá"
            },
            {
                "codigo_ibge": 5210901,
                "nome": "Itapaci"
            },
            {
                "codigo_ibge": 5211008,
                "nome": "Itapirapuã"
            },
            {
                "codigo_ibge": 5211206,
                "nome": "Itapuranga"
            },
            {
                "codigo_ibge": 5211305,
                "nome": "Itarumã"
            },
            {
                "codigo_ibge": 5211404,
                "nome": "Itauçu"
            },
            {
                "codigo_ibge": 5211503,
                "nome": "Itumbiara"
            },
            {
                "codigo_ibge": 5211602,
                "nome": "Ivolândia"
            },
            {
                "codigo_ibge": 5211701,
                "nome": "Jandaia"
            },
            {
                "codigo_ibge": 5211800,
                "nome": "Jaraguá"
            },
            {
                "codigo_ibge": 5211909,
                "nome": "Jataí"
            },
            {
                "codigo_ibge": 5212006,
                "nome": "Jaupaci"
            },
            {
                "codigo_ibge": 5212055,
                "nome": "Jesúpolis"
            },
            {
                "codigo_ibge": 5212105,
                "nome": "Joviânia"
            },
            {
                "codigo_ibge": 5212204,
                "nome": "Jussara"
            },
            {
                "codigo_ibge": 5212253,
                "nome": "Lagoa Santa"
            },
            {
                "codigo_ibge": 5212303,
                "nome": "Leopoldo de Bulhões"
            },
            {
                "codigo_ibge": 5212501,
                "nome": "Luziânia"
            },
            {
                "codigo_ibge": 5212600,
                "nome": "Mairipotaba"
            },
            {
                "codigo_ibge": 5212709,
                "nome": "Mambaí"
            },
            {
                "codigo_ibge": 5212808,
                "nome": "Mara Rosa"
            },
            {
                "codigo_ibge": 5212907,
                "nome": "Marzagão"
            },
            {
                "codigo_ibge": 5212956,
                "nome": "Matrinchã"
            },
            {
                "codigo_ibge": 5213004,
                "nome": "Maurilândia"
            },
            {
                "codigo_ibge": 5213053,
                "nome": "Mimoso de Goiás"
            },
            {
                "codigo_ibge": 5213087,
                "nome": "Minaçu"
            },
            {
                "codigo_ibge": 5213103,
                "nome": "Mineiros"
            },
            {
                "codigo_ibge": 5213400,
                "nome": "Moiporá"
            },
            {
                "codigo_ibge": 5213509,
                "nome": "Monte Alegre de Goiás"
            },
            {
                "codigo_ibge": 5213707,
                "nome": "Montes Claros de Goiás"
            },
            {
                "codigo_ibge": 5213756,
                "nome": "Montividiu"
            },
            {
                "codigo_ibge": 5213772,
                "nome": "Montividiu do Norte"
            },
            {
                "codigo_ibge": 5213806,
                "nome": "Morrinhos"
            },
            {
                "codigo_ibge": 5213855,
                "nome": "Morro Agudo de Goiás"
            },
            {
                "codigo_ibge": 5213905,
                "nome": "Mossâmedes"
            },
            {
                "codigo_ibge": 5214002,
                "nome": "Mozarlândia"
            },
            {
                "codigo_ibge": 5214051,
                "nome": "Mundo Novo"
            },
            {
                "codigo_ibge": 5214101,
                "nome": "Mutunópolis"
            },
            {
                "codigo_ibge": 5214408,
                "nome": "Nazário"
            },
            {
                "codigo_ibge": 5214507,
                "nome": "Nerópolis"
            },
            {
                "codigo_ibge": 5214606,
                "nome": "Niquelândia"
            },
            {
                "codigo_ibge": 5214705,
                "nome": "Nova América"
            },
            {
                "codigo_ibge": 5214804,
                "nome": "Nova Aurora"
            },
            {
                "codigo_ibge": 5214838,
                "nome": "Nova Crixás"
            },
            {
                "codigo_ibge": 5214861,
                "nome": "Nova Glória"
            },
            {
                "codigo_ibge": 5214879,
                "nome": "Nova Iguaçu de Goiás"
            },
            {
                "codigo_ibge": 5214903,
                "nome": "Nova Roma"
            },
            {
                "codigo_ibge": 5215009,
                "nome": "Nova Veneza"
            },
            {
                "codigo_ibge": 5215207,
                "nome": "Novo Brasil"
            },
            {
                "codigo_ibge": 5215231,
                "nome": "Novo Gama"
            },
            {
                "codigo_ibge": 5215256,
                "nome": "Novo Planalto"
            },
            {
                "codigo_ibge": 5215306,
                "nome": "Orizona"
            },
            {
                "codigo_ibge": 5215405,
                "nome": "Ouro Verde de Goiás"
            },
            {
                "codigo_ibge": 5215504,
                "nome": "Ouvidor"
            },
            {
                "codigo_ibge": 5215603,
                "nome": "Padre Bernardo"
            },
            {
                "codigo_ibge": 5215652,
                "nome": "Palestina de Goiás"
            },
            {
                "codigo_ibge": 5215702,
                "nome": "Palmeiras de Goiás"
            },
            {
                "codigo_ibge": 5215801,
                "nome": "Palmelo"
            },
            {
                "codigo_ibge": 5215900,
                "nome": "Palminópolis"
            },
            {
                "codigo_ibge": 5216007,
                "nome": "Panamá"
            },
            {
                "codigo_ibge": 5216304,
                "nome": "Paranaiguara"
            },
            {
                "codigo_ibge": 5216403,
                "nome": "Paraúna"
            },
            {
                "codigo_ibge": 5216452,
                "nome": "Perolândia"
            },
            {
                "codigo_ibge": 5216809,
                "nome": "Petrolina de Goiás"
            },
            {
                "codigo_ibge": 5216908,
                "nome": "Pilar de Goiás"
            },
            {
                "codigo_ibge": 5217104,
                "nome": "Piracanjuba"
            },
            {
                "codigo_ibge": 5217203,
                "nome": "Piranhas"
            },
            {
                "codigo_ibge": 5217302,
                "nome": "Pirenópolis"
            },
            {
                "codigo_ibge": 5217401,
                "nome": "Pires do Rio"
            },
            {
                "codigo_ibge": 5217609,
                "nome": "Planaltina"
            },
            {
                "codigo_ibge": 5217708,
                "nome": "Pontalina"
            },
            {
                "codigo_ibge": 5218003,
                "nome": "Porangatu"
            },
            {
                "codigo_ibge": 5218052,
                "nome": "Porteirão"
            },
            {
                "codigo_ibge": 5218102,
                "nome": "Portelândia"
            },
            {
                "codigo_ibge": 5218300,
                "nome": "Posse"
            },
            {
                "codigo_ibge": 5218391,
                "nome": "Professor Jamil"
            },
            {
                "codigo_ibge": 5218508,
                "nome": "Quirinópolis"
            },
            {
                "codigo_ibge": 5218607,
                "nome": "Rialma"
            },
            {
                "codigo_ibge": 5218706,
                "nome": "Rianápolis"
            },
            {
                "codigo_ibge": 5218789,
                "nome": "Rio Quente"
            },
            {
                "codigo_ibge": 5218805,
                "nome": "Rio Verde"
            },
            {
                "codigo_ibge": 5218904,
                "nome": "Rubiataba"
            },
            {
                "codigo_ibge": 5219001,
                "nome": "Sanclerlândia"
            },
            {
                "codigo_ibge": 5219100,
                "nome": "Santa Bárbara de Goiás"
            },
            {
                "codigo_ibge": 5219209,
                "nome": "Santa Cruz de Goiás"
            },
            {
                "codigo_ibge": 5219258,
                "nome": "Santa Fé de Goiás"
            },
            {
                "codigo_ibge": 5219308,
                "nome": "Santa Helena de Goiás"
            },
            {
                "codigo_ibge": 5219357,
                "nome": "Santa Isabel"
            },
            {
                "codigo_ibge": 5219407,
                "nome": "Santa Rita do Araguaia"
            },
            {
                "codigo_ibge": 5219456,
                "nome": "Santa Rita do Novo Destino"
            },
            {
                "codigo_ibge": 5219506,
                "nome": "Santa Rosa de Goiás"
            },
            {
                "codigo_ibge": 5219605,
                "nome": "Santa Tereza de Goiás"
            },
            {
                "codigo_ibge": 5219704,
                "nome": "Santa Terezinha de Goiás"
            },
            {
                "codigo_ibge": 5219712,
                "nome": "Santo Antônio da Barra"
            },
            {
                "codigo_ibge": 5219738,
                "nome": "Santo Antônio de Goiás"
            },
            {
                "codigo_ibge": 5219753,
                "nome": "Santo Antônio do Descoberto"
            },
            {
                "codigo_ibge": 5219803,
                "nome": "São Domingos"
            },
            {
                "codigo_ibge": 5219902,
                "nome": "São Francisco de Goiás"
            },
            {
                "codigo_ibge": 5220009,
                "nome": "São João d'Aliança"
            },
            {
                "codigo_ibge": 5220058,
                "nome": "São João da Paraúna"
            },
            {
                "codigo_ibge": 5220108,
                "nome": "São Luís de Montes Belos"
            },
            {
                "codigo_ibge": 5220157,
                "nome": "São Luiz do Norte"
            },
            {
                "codigo_ibge": 5220207,
                "nome": "São Miguel do Araguaia"
            },
            {
                "codigo_ibge": 5220264,
                "nome": "São Miguel do Passa Quatro"
            },
            {
                "codigo_ibge": 5220280,
                "nome": "São Patrício"
            },
            {
                "codigo_ibge": 5220405,
                "nome": "São Simão"
            },
            {
                "codigo_ibge": 5220454,
                "nome": "Senador Canedo"
            },
            {
                "codigo_ibge": 5220504,
                "nome": "Serranópolis"
            },
            {
                "codigo_ibge": 5220603,
                "nome": "Silvânia"
            },
            {
                "codigo_ibge": 5220686,
                "nome": "Simolândia"
            },
            {
                "codigo_ibge": 5220702,
                "nome": "Sítio d'Abadia"
            },
            {
                "codigo_ibge": 5221007,
                "nome": "Taquaral de Goiás"
            },
            {
                "codigo_ibge": 5221080,
                "nome": "Teresina de Goiás"
            },
            {
                "codigo_ibge": 5221197,
                "nome": "Terezópolis de Goiás"
            },
            {
                "codigo_ibge": 5221304,
                "nome": "Três Ranchos"
            },
            {
                "codigo_ibge": 5221403,
                "nome": "Trindade"
            },
            {
                "codigo_ibge": 5221452,
                "nome": "Trombas"
            },
            {
                "codigo_ibge": 5221502,
                "nome": "Turvânia"
            },
            {
                "codigo_ibge": 5221551,
                "nome": "Turvelândia"
            },
            {
                "codigo_ibge": 5221577,
                "nome": "Uirapuru"
            },
            {
                "codigo_ibge": 5221601,
                "nome": "Uruaçu"
            },
            {
                "codigo_ibge": 5221700,
                "nome": "Uruana"
            },
            {
                "codigo_ibge": 5221809,
                "nome": "Urutaí"
            },
            {
                "codigo_ibge": 5221858,
                "nome": "Valparaíso de Goiás"
            },
            {
                "codigo_ibge": 5221908,
                "nome": "Varjão"
            },
            {
                "codigo_ibge": 5222005,
                "nome": "Vianópolis"
            },
            {
                "codigo_ibge": 5222054,
                "nome": "Vicentinópolis"
            },
            {
                "codigo_ibge": 5222203,
                "nome": "Vila Boa"
            },
            {
                "codigo_ibge": 5222302,
                "nome": "Vila Propício"
            }
        ]
    },
    "MA": {
        "nome": "Maranhão",
        "municipios": [
            {
                "codigo_ibge": 2100055,
                "nome": "Açailândia"
            },
            {
                "codigo_ibge": 2100105,
                "nome": "Afonso Cunha"
            },
            {
                "codigo_ibge": 2100154,
                "nome": "Água Doce do Maranhão"
            },
            {
                "codigo_ibge": 2100204,
                "nome": "Alcântara"
            },
            {
                "codigo_ibge": 2100303,
                "nome": "Aldeias Altas"
            },
            {
                "codigo_ibge": 2100402,
                "nome": "Altamira do Maranhão"
            },
            {
                "codigo_ibge": 2100436,
                "nome": "Alto Alegre do Maranhão"
            },
            {
                "codigo_ibge": 2100477,
                "nome": "Alto Alegre do Pindaré"
            },
            {
                "codigo_ibge": 2100501,
                "nome": "Alto Parnaíba"
            },
            {
                "codigo_ibge": 2100550,
                "nome": "Amapá do Maranhão"
            },
            {
                "codigo_ibge": 2100600,
                "nome": "Amarante do Maranhão"
            },
            {
                "codigo_ibge": 2100709,
                "nome": "Anajatuba"
            },
            {
                "codigo_ibge": 2100808,
                "nome": "Anapurus"
            },
            {
                "codigo_ibge": 2100832,
                "nome": "Apicum-Açu"
            },
            {
                "codigo_ibge": 2100873,
                "nome": "Araguanã"
            },
            {
                "codigo_ibge": 2100907,
                "nome": "Araioses"
            },
            {
                "codigo_ibge": 2100956,
                "nome": "Arame"
            },
            {
                "codigo_ibge": 2101004,
                "nome": "Arari"
            },
            {
                "codigo_ibge": 2101103,
                "nome": "Axixá"
            },
            {
                "codigo_ibge": 2101202,
                "nome": "Bacabal"
            },
            {
                "codigo_ibge": 2101251,
                "nome": "Bacabeira"
            },
            {
                "codigo_ibge": 2101301,
                "nome": "Bacuri"
            },
            {
                "codigo_ibge": 2101350,
                "nome": "Bacurituba"
            },
            {
                "codigo_ibge": 2101400,
                "nome": "Balsas"
            },
            {
                "codigo_ibge": 2101509,
                "nome": "Barão de Grajaú"
            },
            {
                "codigo_ibge": 2101608,
                "nome": "Barra do Corda"
            },
            {
                "codigo_ibge": 2101707,
                "nome": "Barreirinhas"
            },
            {
                "codigo_ibge": 2101772,
                "nome": "Bela Vista do Maranhão"
            },
            {
                "codigo_ibge": 2101731,
                "nome": "Belágua"
            },
            {
                "codigo_ibge": 2101806,
                "nome": "Benedito Leite"
            },
            {
                "codigo_ibge": 2101905,
                "nome": "Bequimão"
            },
            {
                "codigo_ibge": 2101939,
                "nome": "Bernardo do Mearim"
            },
            {
                "codigo_ibge": 2101970,
                "nome": "Boa Vista do Gurupi"
            },
            {
                "codigo_ibge": 2102002,
                "nome": "Bom Jardim"
            },
            {
                "codigo_ibge": 2102036,
                "nome": "Bom Jesus das Selvas"
            },
            {
                "codigo_ibge": 2102077,
                "nome": "Bom Lugar"
            },
            {
                "codigo_ibge": 2102101,
                "nome": "Brejo"
            },
            {
                "codigo_ibge": 2102150,
                "nome": "Brejo de Areia"
            },
            {
                "codigo_ibge": 2102200,
                "nome": "Buriti"
            },
            {
                "codigo_ibge": 2102309,
                "nome": "Buriti Bravo"
            },
            {
                "codigo_ibge": 2102325,
                "nome": "Buriticupu"
            },
            {
                "codigo_ibge": 2102358,
                "nome": "Buritirana"
            },
            {
                "codigo_ibge": 2102374,
                "nome": "Cachoeira Grande"
            },
            {
                "codigo_ibge": 2102408,
                "nome": "Cajapió"
            },
            {
                "codigo_ibge": 2102507,
                "nome": "Cajari"
            },
            {
                "codigo_ibge": 2102556,
                "nome": "Campestre do Maranhão"
            },
            {
                "codigo_ibge": 2102606,
                "nome": "Cândido Mendes"
            },
            {
                "codigo_ibge": 2102705,
                "nome": "Cantanhede"
            },
            {
                "codigo_ibge": 2102754,
                "nome": "Capinzal do Norte"
            },
            {
                "codigo_ibge": 2102804,
                "nome": "Carolina"
            },
            {
                "codigo_ibge": 2102903,
                "nome": "Carutapera"
            },
            {
                "codigo_ibge": 2103000,
                "nome": "Caxias"
            },
            {
                "codigo_ibge": 2103109,
                "nome": "Cedral"
            },
            {
                "codigo_ibge": 2103125,
                "nome": "Central do Maranhão"
            },
            {
                "codigo_ibge": 2103158,
                "nome": "Centro do Guilherme"
            },
            {
                "codigo_ibge": 2103174,
                "nome": "Centro Novo do Maranhão"
            },
            {
                "codigo_ibge": 2103208,
                "nome": "Chapadinha"
            },
            {
                "codigo_ibge": 2103257,
                "nome": "Cidelândia"
            },
            {
                "codigo_ibge": 2103307,
                "nome": "Codó"
            },
            {
                "codigo_ibge": 2103406,
                "nome": "Coelho Neto"
            },
            {
                "codigo_ibge": 2103505,
                "nome": "Colinas"
            },
            {
                "codigo_ibge": 2103554,
                "nome": "Conceição do Lago-Açu"
            },
            {
                "codigo_ibge": 2103604,
                "nome": "Coroatá"
            },
            {
                "codigo_ibge": 2103703,
                "nome": "Cururupu"
            },
            {
                "codigo_ibge": 2103752,
                "nome": "Davinópolis"
            },
            {
                "codigo_ibge": 2103802,
                "nome": "Dom Pedro"
            },
            {
                "codigo_ibge": 2103901,
                "nome": "Duque Bacelar"
            },
            {
                "codigo_ibge": 2104008,
                "nome": "Esperantinópolis"
            },
            {
                "codigo_ibge": 2104057,
                "nome": "Estreito"
            },
            {
                "codigo_ibge": 2104073,
                "nome": "Feira Nova do Maranhão"
            },
            {
                "codigo_ibge": 2104081,
                "nome": "Fernando Falcão"
            },
            {
                "codigo_ibge": 2104099,
                "nome": "Formosa da Serra Negra"
            },
            {
                "codigo_ibge": 2104107,
                "nome": "Fortaleza dos Nogueiras"
            },
            {
                "codigo_ibge": 2104206,
                "nome": "Fortuna"
            },
            {
                "codigo_ibge": 2104305,
                "nome": "Godofredo Viana"
            },
            {
                "codigo_ibge": 2104404,
                "nome": "Gonçalves Dias"
            },
            {
                "codigo_ibge": 2104503,
                "nome": "Governador Archer"
            },
            {
                "codigo_ibge": 2104552,
                "nome": "Governador Edison Lobão"
            },
            {
                "codigo_ibge": 2104602,
                "nome": "Governador Eugênio Barros"
            },
            {
                "codigo_ibge": 2104628,
                "nome": "Governador Luiz Rocha"
            },
            {
                "codigo_ibge": 2104651,
                "nome": "Governador Newton Bello"
            },
            {
                "codigo_ibge": 2104677,
                "nome": "Governador Nunes Freire"
            },
            {
                "codigo_ibge": 2104701,
                "nome": "Graça Aranha"
            },
            {
                "codigo_ibge": 2104800,
                "nome": "Grajaú"
            },
            {
                "codigo_ibge": 2104909,
                "nome": "Guimarães"
            },
            {
                "codigo_ibge": 2105005,
                "nome": "Humberto de Campos"
            },
            {
                "codigo_ibge": 2105104,
                "nome": "Icatu"
            },
            {
                "codigo_ibge": 2105153,
                "nome": "Igarapé do Meio"
            },
            {
                "codigo_ibge": 2105203,
                "nome": "Igarapé Grande"
            },
            {
                "codigo_ibge": 2105302,
                "nome": "Imperatriz"
            },
            {
                "codigo_ibge": 2105351,
                "nome": "Itaipava do Grajaú"
            },
            {
                "codigo_ibge": 2105401,
                "nome": "Itapecuru Mirim"
            },
            {
                "codigo_ibge": 2105427,
                "nome": "Itinga do Maranhão"
            },
            {
                "codigo_ibge": 2105450,
                "nome": "Jatobá"
            },
            {
                "codigo_ibge": 2105476,
                "nome": "Jenipapo dos Vieiras"
            },
            {
                "codigo_ibge": 2105500,
                "nome": "João Lisboa"
            },
            {
                "codigo_ibge": 2105609,
                "nome": "Joselândia"
            },
            {
                "codigo_ibge": 2105658,
                "nome": "Junco do Maranhão"
            },
            {
                "codigo_ibge": 2105708,
                "nome": "Lago da Pedra"
            },
            {
                "codigo_ibge": 2105807,
                "nome": "Lago do Junco"
            },
            {
                "codigo_ibge": 2105948,
                "nome": "Lago dos Rodrigues"
            },
            {
                "codigo_ibge": 2105906,
                "nome": "Lago Verde"
            },
            {
                "codigo_ibge": 2105922,
                "nome": "Lagoa do Mato"
            },
            {
                "codigo_ibge": 2105963,
                "nome": "Lagoa Grande do Maranhão"
            },
            {
                "codigo_ibge": 2105989,
                "nome": "Lajeado Novo"
            },
            {
                "codigo_ibge": 2106003,
                "nome": "Lima Campos"
            },
            {
                "codigo_ibge": 2106102,
                "nome": "Loreto"
            },
            {
                "codigo_ibge": 2106201,
                "nome": "Luís Domingues"
            },
            {
                "codigo_ibge": 2106300,
                "nome": "Magalhães de Almeida"
            },
            {
                "codigo_ibge": 2106326,
                "nome": "Maracaçumé"
            },
            {
                "codigo_ibge": 2106359,
                "nome": "Marajá do Sena"
            },
            {
                "codigo_ibge": 2106375,
                "nome": "Maranhãozinho"
            },
            {
                "codigo_ibge": 2106409,
                "nome": "Mata Roma"
            },
            {
                "codigo_ibge": 2106508,
                "nome": "Matinha"
            },
            {
                "codigo_ibge": 2106607,
                "nome": "Matões"
            },
            {
                "codigo_ibge": 2106631,
                "nome": "Matões do Norte"
            },
            {
                "codigo_ibge": 2106672,
                "nome": "Milagres do Maranhão"
            },
            {
                "codigo_ibge": 2106706,
                "nome": "Mirador"
            },
            {
                "codigo_ibge": 2106755,
                "nome": "Miranda do Norte"
            },
            {
                "codigo_ibge": 2106805,
                "nome": "Mirinzal"
            },
            {
                "codigo_ibge": 2106904,
                "nome": "Monção"
            },
            {
                "codigo_ibge": 2107001,
                "nome": "Montes Altos"
            },
            {
                "codigo_ibge": 2107100,
                "nome": "Morros"
            },
            {
                "codigo_ibge": 2107209,
                "nome": "Nina Rodrigues"
            },
            {
                "codigo_ibge": 2107258,
                "nome": "Nova Colinas"
            },
            {
                "codigo_ibge": 2107308,
                "nome": "Nova Iorque"
            },
            {
                "codigo_ibge": 2107357,
                "nome": "Nova Olinda do Maranhão"
            },
            {
                "codigo_ibge": 2107407,
                "nome": "Olho d'Água das Cunhãs"
            },
            {
                "codigo_ibge": 2107456,
                "nome": "Olinda Nova do Maranhão"
            },
            {
                "codigo_ibge": 2107506,
                "nome": "Paço do Lumiar"
            },
            {
                "codigo_ibge": 2107605,
                "nome": "Palmeirândia"
            },
            {
                "codigo_ibge": 2107704,
                "nome": "Paraibano"
            },
            {
                "codigo_ibge": 2107803,
                "nome": "Parnarama"
            },
            {
                "codigo_ibge": 2107902,
                "nome": "Passagem Franca"
            },
            {
                "codigo_ibge": 2108009,
                "nome": "Pastos Bons"
            },
            {
                "codigo_ibge": 2108058,
                "nome": "Paulino Neves"
            },
            {
                "codigo_ibge": 2108108,
                "nome": "Paulo Ramos"
            },
            {
                "codigo_ibge": 2108207,
                "nome": "Pedreiras"
            },
            {
                "codigo_ibge": 2108256,
                "nome": "Pedro do Rosário"
            },
            {
                "codigo_ibge": 2108306,
                "nome": "Penalva"
            },
            {
                "codigo_ibge": 2108405,
                "nome": "Peri Mirim"
            },
            {
                "codigo_ibge": 2108454,
                "nome": "Peritoró"
            },
            {
                "codigo_ibge": 2108504,
                "nome": "Pindaré-Mirim"
            },
            {
                "codigo_ibge": 2108603,
                "nome": "Pinheiro"
            },
            {
                "codigo_ibge": 2108702,
                "nome": "Pio XII"
            },
            {
                "codigo_ibge": 2108801,
                "nome": "Pirapemas"
            },
            {
                "codigo_ibge": 2108900,
                "nome": "Poção de Pedras"
            },
            {
                "codigo_ibge": 2109007,
                "nome": "Porto Franco"
            },
            {
                "codigo_ibge": 2109056,
                "nome": "Porto Rico do Maranhão"
            },
            {
                "codigo_ibge": 2109106,
                "nome": "Presidente Dutra"
            },
            {
                "codigo_ibge": 2109205,
                "nome": "Presidente Juscelino"
            },
            {
                "codigo_ibge": 2109239,
                "nome": "Presidente Médici"
            },
            {
                "codigo_ibge": 2109270,
                "nome": "Presidente Sarney"
            },
            {
                "codigo_ibge": 2109304,
                "nome": "Presidente Vargas"
            },
            {
                "codigo_ibge": 2109403,
                "nome": "Primeira Cruz"
            },
            {
                "codigo_ibge": 2109452,
                "nome": "Raposa"
            },
            {
                "codigo_ibge": 2109502,
                "nome": "Riachão"
            },
            {
                "codigo_ibge": 2109551,
                "nome": "Ribamar Fiquene"
            },
            {
                "codigo_ibge": 2109601,
                "nome": "Rosário"
            },
            {
                "codigo_ibge": 2109700,
                "nome": "Sambaíba"
            },
            {
                "codigo_ibge": 2109759,
                "nome": "Santa Filomena do Maranhão"
            },
            {
                "codigo_ibge": 2109809,
                "nome": "Santa Helena"
            },
            {
                "codigo_ibge": 2109908,
                "nome": "Santa Inês"
            },
            {
                "codigo_ibge": 2110005,
                "nome": "Santa Luzia"
            },
            {
                "codigo_ibge": 2110039,
                "nome": "Santa Luzia do Paruá"
            },
            {
                "codigo_ibge": 2110104,
                "nome": "Santa Quitéria do Maranhão"
            },
            {
                "codigo_ibge": 2110203,
                "nome": "Santa Rita"
            },
            {
                "codigo_ibge": 2110237,
                "nome": "Santana do Maranhão"
            },
            {
                "codigo_ibge": 2110278,
                "nome": "Santo Amaro do Maranhão"
            },
            {
                "codigo_ibge": 2110302,
                "nome": "Santo Antônio dos Lopes"
            },
            {
                "codigo_ibge": 2110401,
                "nome": "São Benedito do Rio Preto"
            },
            {
                "codigo_ibge": 2110500,
                "nome": "São Bento"
            },
            {
                "codigo_ibge": 2110609,
                "nome": "São Bernardo"
            },
            {
                "codigo_ibge": 2110658,
                "nome": "São Domingos do Azeitão"
            },
            {
                "codigo_ibge": 2110708,
                "nome": "São Domingos do Maranhão"
            },
            {
                "codigo_ibge": 2110807,
                "nome": "São Félix de Balsas"
            },
            {
                "codigo_ibge": 2110856,
                "nome": "São Francisco do Brejão"
            },
            {
                "codigo_ibge": 2110906,
                "nome": "São Francisco do Maranhão"
            },
            {
                "codigo_ibge": 2111003,
                "nome": "São João Batista"
            },
            {
                "codigo_ibge": 2111029,
                "nome": "São João do Carú"
            },
            {
                "codigo_ibge": 2111052,
                "nome": "São João do Paraíso"
            },
            {
                "codigo_ibge": 2111078,
                "nome": "São João do Soter"
            },
            {
                "codigo_ibge": 2111102,
                "nome": "São João dos Patos"
            },
            {
                "codigo_ibge": 2111201,
                "nome": "São José de Ribamar"
            },
            {
                "codigo_ibge": 2111250,
                "nome": "São José dos Basílios"
            },
            {
                "codigo_ibge": 2111300,
                "nome": "São Luís"
            },
            {
                "codigo_ibge": 2111409,
                "nome": "São Luís Gonzaga do Maranhão"
            },
            {
                "codigo_ibge": 2111508,
                "nome": "São Mateus do Maranhão"
            },
            {
                "codigo_ibge": 2111532,
                "nome": "São Pedro da Água Branca"
            },
            {
                "codigo_ibge": 2111573,
                "nome": "São Pedro dos Crentes"
            },
            {
                "codigo_ibge": 2111607,
                "nome": "São Raimundo das Mangabeiras"
            },
            {
                "codigo_ibge": 2111631,
                "nome": "São Raimundo do Doca Bezerra"
            },
            {
                "codigo_ibge": 2111672,
                "nome": "São Roberto"
            },
            {
                "codigo_ibge": 2111706,
                "nome": "São Vicente Ferrer"
            },
            {
                "codigo_ibge": 2111722,
                "nome": "Satubinha"
            },
            {
                "codigo_ibge": 2111748,
                "nome": "Senador Alexandre Costa"
            },
            {
                "codigo_ibge": 2111763,
                "nome": "Senador La Rocque"
            },
            {
                "codigo_ibge": 2111789,
                "nome": "Serrano do Maranhão"
            },
            {
                "codigo_ibge": 2111805,
                "nome": "Sítio Novo"
            },
            {
                "codigo_ibge": 2111904,
                "nome": "Sucupira do Norte"
            },
            {
                "codigo_ibge": 2111953,
                "nome": "Sucupira do Riachão"
            },
            {
                "codigo_ibge": 2112001,
                "nome": "Tasso Fragoso"
            },
            {
                "codigo_ibge": 2112100,
                "nome": "Timbiras"
            },
            {
                "codigo_ibge": 2112209,
                "nome": "Timon"
            },
            {
                "codigo_ibge": 2112233,
                "nome": "Trizidela do Vale"
            },
            {
                "codigo_ibge": 2112274,
                "nome": "Tufilândia"
            },
            {
                "codigo_ibge": 2112308,
                "nome": "Tuntum"
            },
            {
                "codigo_ibge": 2112407,
                "nome": "Turiaçu"
            },
            {
                "codigo_ibge": 2112456,
                "nome": "Turilândia"
            },
            {
                "codigo_ibge": 2112506,
                "nome": "Tutóia"
            },
            {
                "codigo_ibge": 2112605,
                "nome": "Urbano Santos"
            },
            {
                "codigo_ibge": 2112704,
                "nome": "Vargem Grande"
            },
            {
                "codigo_ibge": 2112803,
                "nome": "Viana"
            },
            {
                "codigo_ibge": 2112852,
                "nome": "Vila Nova dos Martírios"
            },
            {
                "codigo_ibge": 2112902,
                "nome": "Vitória do Mearim"
            },
            {
                "codigo_ibge": 2113009,
                "nome": "Vitorino Freire"
            },
            {
                "codigo_ibge": 2114007,
                "nome": "Zé Doca"
            }
        ]
    },
    "MG": {
        "nome": "Minas Gerais",
        "municipios": [
            {
                "codigo_ibge": 3100104,
                "nome": "Abadia dos Dourados"
            },
            {
                "codigo_ibge": 3100203,
                "nome": "Abaeté"
            },
            {
                "codigo_ibge": 3100302,
                "nome": "Abre Campo"
            },
            {
                "codigo_ibge": 3100401,
                "nome": "Acaiaca"
            },
            {
                "codigo_ibge": 3100500,
                "nome": "Açucena"
            },
            {
                "codigo_ibge": 3100609,
                "nome": "Água Boa"
            },
            {
                "codigo_ibge": 3100708,
                "nome": "Água Comprida"
            },
            {
                "codigo_ibge": 3100807,
                "nome": "Aguanil"
            },
            {
                "codigo_ibge": 3100906,
                "nome": "Águas Formosas"
            },
            {
                "codigo_ibge": 3101003,
                "nome": "Águas Vermelhas"
            },
            {
                "codigo_ibge": 3101102,
                "nome": "Aimorés"
            },
            {
                "codigo_ibge": 3101201,
                "nome": "Aiuruoca"
            },
            {
                "codigo_ibge": 3101300,
                "nome": "Alagoa"
            },
            {
                "codigo_ibge": 3101409,
                "nome": "Albertina"
            },
            {
                "codigo_ibge": 3101508,
                "nome": "Além Paraíba"
            },
            {
                "codigo_ibge": 3101607,
                "nome": "Alfenas"
            },
            {
                "codigo_ibge": 3101631,
                "nome": "Alfredo Vasconcelos"
            },
            {
                "codigo_ibge": 3101706,
                "nome": "Almenara"
            },
            {
                "codigo_ibge": 3101805,
                "nome": "Alpercata"
            },
            {
                "codigo_ibge": 3101904,
                "nome": "Alpinópolis"
            },
            {
                "codigo_ibge": 3102001,
                "nome": "Alterosa"
            },
            {
                "codigo_ibge": 3102050,
                "nome": "Alto Caparaó"
            },
            {
                "codigo_ibge": 3153509,
                "nome": "Alto Jequitibá"
            },
            {
                "codigo_ibge": 3102100,
                "nome": "Alto Rio Doce"
            },
            {
                "codigo_ibge": 3102209,
                "nome": "Alvarenga"
            },
            {
                "codigo_ibge": 3102308,
                "nome": "Alvinópolis"
            },
            {
                "codigo_ibge": 3102407,
                "nome": "Alvorada de Minas"
            },
            {
                "codigo_ibge": 3102506,
                "nome": "Amparo do Serra"
            },
            {
                "codigo_ibge": 3102605,
                "nome": "Andradas"
            },
            {
                "codigo_ibge": 3102803,
                "nome": "Andrelândia"
            },
            {
                "codigo_ibge": 3102852,
                "nome": "Angelândia"
            },
            {
                "codigo_ibge": 3102902,
                "nome": "Antônio Carlos"
            },
            {
                "codigo_ibge": 3103009,
                "nome": "Antônio Dias"
            },
            {
                "codigo_ibge": 3103108,
                "nome": "Antônio Prado de Minas"
            },
            {
                "codigo_ibge": 3103207,
                "nome": "Araçaí"
            },
            {
                "codigo_ibge": 3103306,
                "nome": "Aracitaba"
            },
            {
                "codigo_ibge": 3103405,
                "nome": "Araçuaí"
            },
            {
                "codigo_ibge": 3103504,
                "nome": "Araguari"
            },
            {
                "codigo_ibge": 3103603,
                "nome": "Arantina"
            },
            {
                "codigo_ibge": 3103702,
                "nome": "Araponga"
            },
            {
                "codigo_ibge": 3103751,
                "nome": "Araporã"
            },
            {
                "codigo_ibge": 3103801,
                "nome": "Arapuá"
            },
            {
                "codigo_ibge": 3103900,
                "nome": "Araújos"
            },
            {
                "codigo_ibge": 3104007,
                "nome": "Araxá"
            },
            {
                "codigo_ibge": 3104106,
                "nome": "Arceburgo"
            },
            {
                "codigo_ibge": 3104205,
                "nome": "Arcos"
            },
            {
                "codigo_ibge": 3104304,
                "nome": "Areado"
            },
            {
                "codigo_ibge": 3104403,
                "nome": "Argirita"
            },
            {
                "codigo_ibge": 3104452,
                "nome": "Aricanduva"
            },
            {
                "codigo_ibge": 3104502,
                "nome": "Arinos"
            },
            {
                "codigo_ibge": 3104601,
                "nome": "Astolfo Dutra"
            },
            {
                "codigo_ibge": 3104700,
                "nome": "Ataléia"
            },
            {
                "codigo_ibge": 3104809,
                "nome": "Augusto de Lima"
            },
            {
                "codigo_ibge": 3104908,
                "nome": "Baependi"
            },
            {
                "codigo_ibge": 3105004,
                "nome": "Baldim"
            },
            {
                "codigo_ibge": 3105103,
                "nome": "Bambuí"
            },
            {
                "codigo_ibge": 3105202,
                "nome": "Bandeira"
            },
            {
                "codigo_ibge": 3105301,
                "nome": "Bandeira do Sul"
            },
            {
                "codigo_ibge": 3105400,
                "nome": "Barão de Cocais"
            },
            {
                "codigo_ibge": 3105509,
                "nome": "Barão de Monte Alto"
            },
            {
                "codigo_ibge": 3105608,
                "nome": "Barbacena"
            },
            {
                "codigo_ibge": 3105707,
                "nome": "Barra Longa"
            },
            {
                "codigo_ibge": 3105905,
                "nome": "Barroso"
            },
            {
                "codigo_ibge": 3106002,
                "nome": "Bela Vista de Minas"
            },
            {
                "codigo_ibge": 3106101,
                "nome": "Belmiro Braga"
            },
            {
                "codigo_ibge": 3106200,
                "nome": "Belo Horizonte"
            },
            {
                "codigo_ibge": 3106309,
                "nome": "Belo Oriente"
            },
            {
                "codigo_ibge": 3106408,
                "nome": "Belo Vale"
            },
            {
                "codigo_ibge": 3106507,
                "nome": "Berilo"
            },
            {
                "codigo_ibge": 3106655,
                "nome": "Berizal"
            },
            {
                "codigo_ibge": 3106606,
                "nome": "Bertópolis"
            },
            {
                "codigo_ibge": 3106705,
                "nome": "Betim"
            },
            {
                "codigo_ibge": 3106804,
                "nome": "Bias Fortes"
            },
            {
                "codigo_ibge": 3106903,
                "nome": "Bicas"
            },
            {
                "codigo_ibge": 3107000,
                "nome": "Biquinhas"
            },
            {
                "codigo_ibge": 3107109,
                "nome": "Boa Esperança"
            },
            {
                "codigo_ibge": 3107208,
                "nome": "Bocaina de Minas"
            },
            {
                "codigo_ibge": 3107307,
                "nome": "Bocaiúva"
            },
            {
                "codigo_ibge": 3107406,
                "nome": "Bom Despacho"
            },
            {
                "codigo_ibge": 3107505,
                "nome": "Bom Jardim de Minas"
            },
            {
                "codigo_ibge": 3107604,
                "nome": "Bom Jesus da Penha"
            },
            {
                "codigo_ibge": 3107703,
                "nome": "Bom Jesus do Amparo"
            },
            {
                "codigo_ibge": 3107802,
                "nome": "Bom Jesus do Galho"
            },
            {
                "codigo_ibge": 3107901,
                "nome": "Bom Repouso"
            },
            {
                "codigo_ibge": 3108008,
                "nome": "Bom Sucesso"
            },
            {
                "codigo_ibge": 3108107,
                "nome": "Bonfim"
            },
            {
                "codigo_ibge": 3108206,
                "nome": "Bonfinópolis de Minas"
            },
            {
                "codigo_ibge": 3108255,
                "nome": "Bonito de Minas"
            },
            {
                "codigo_ibge": 3108305,
                "nome": "Borda da Mata"
            },
            {
                "codigo_ibge": 3108404,
                "nome": "Botelhos"
            },
            {
                "codigo_ibge": 3108503,
                "nome": "Botumirim"
            },
            {
                "codigo_ibge": 3108701,
                "nome": "Brás Pires"
            },
            {
                "codigo_ibge": 3108552,
                "nome": "Brasilândia de Minas"
            },
            {
                "codigo_ibge": 3108602,
                "nome": "Brasília de Minas"
            },
            {
                "codigo_ibge": 3108800,
                "nome": "Braúnas"
            },
            {
                "codigo_ibge": 3108909,
                "nome": "Brazópolis"
            },
            {
                "codigo_ibge": 3109006,
                "nome": "Brumadinho"
            },
            {
                "codigo_ibge": 3109105,
                "nome": "Bueno Brandão"
            },
            {
                "codigo_ibge": 3109204,
                "nome": "Buenópolis"
            },
            {
                "codigo_ibge": 3109253,
                "nome": "Bugre"
            },
            {
                "codigo_ibge": 3109303,
                "nome": "Buritis"
            },
            {
                "codigo_ibge": 3109402,
                "nome": "Buritizeiro"
            },
            {
                "codigo_ibge": 3109451,
                "nome": "Cabeceira Grande"
            },
            {
                "codigo_ibge": 3109501,
                "nome": "Cabo Verde"
            },
            {
                "codigo_ibge": 3109600,
                "nome": "Cachoeira da Prata"
            },
            {
                "codigo_ibge": 3109709,
                "nome": "Cachoeira de Minas"
            },
            {
                "codigo_ibge": 3102704,
                "nome": "Cachoeira de Pajeú"
            },
            {
                "codigo_ibge": 3109808,
                "nome": "Cachoeira Dourada"
            },
            {
                "codigo_ibge": 3109907,
                "nome": "Caetanópolis"
            },
            {
                "codigo_ibge": 3110004,
                "nome": "Caeté"
            },
            {
                "codigo_ibge": 3110103,
                "nome": "Caiana"
            },
            {
                "codigo_ibge": 3110202,
                "nome": "Cajuri"
            },
            {
                "codigo_ibge": 3110301,
                "nome": "Caldas"
            },
            {
                "codigo_ibge": 3110400,
                "nome": "Camacho"
            },
            {
                "codigo_ibge": 3110509,
                "nome": "Camanducaia"
            },
            {
                "codigo_ibge": 3110608,
                "nome": "Cambuí"
            },
            {
                "codigo_ibge": 3110707,
                "nome": "Cambuquira"
            },
            {
                "codigo_ibge": 3110806,
                "nome": "Campanário"
            },
            {
                "codigo_ibge": 3110905,
                "nome": "Campanha"
            },
            {
                "codigo_ibge": 3111002,
                "nome": "Campestre"
            },
            {
                "codigo_ibge": 3111101,
                "nome": "Campina Verde"
            },
            {
                "codigo_ibge": 3111150,
                "nome": "Campo Azul"
            },
            {
                "codigo_ibge": 3111200,
                "nome": "Campo Belo"
            },
            {
                "codigo_ibge": 3111309,
                "nome": "Campo do Meio"
            },
            {
                "codigo_ibge": 3111408,
                "nome": "Campo Florido"
            },
            {
                "codigo_ibge": 3111507,
                "nome": "Campos Altos"
            },
            {
                "codigo_ibge": 3111606,
                "nome": "Campos Gerais"
            },
            {
                "codigo_ibge": 3111903,
                "nome": "Cana Verde"
            },
            {
                "codigo_ibge": 3111705,
                "nome": "Canaã"
            },
            {
                "codigo_ibge": 3111804,
                "nome": "Canápolis"
            },
            {
                "codigo_ibge": 3112000,
                "nome": "Candeias"
            },
            {
                "codigo_ibge": 3112059,
                "nome": "Cantagalo"
            },
            {
                "codigo_ibge": 3112109,
                "nome": "Caparaó"
            },
            {
                "codigo_ibge": 3112208,
                "nome": "Capela Nova"
            },
            {
                "codigo_ibge": 3112307,
                "nome": "Capelinha"
            },
            {
                "codigo_ibge": 3112406,
                "nome": "Capetinga"
            },
            {
                "codigo_ibge": 3112505,
                "nome": "Capim Branco"
            },
            {
                "codigo_ibge": 3112604,
                "nome": "Capinópolis"
            },
            {
                "codigo_ibge": 3112653,
                "nome": "Capitão Andrade"
            },
            {
                "codigo_ibge": 3112703,
                "nome": "Capitão Enéas"
            },
            {
                "codigo_ibge": 3112802,
                "nome": "Capitólio"
            },
            {
                "codigo_ibge": 3112901,
                "nome": "Caputira"
            },
            {
                "codigo_ibge": 3113008,
                "nome": "Caraí"
            },
            {
                "codigo_ibge": 3113107,
                "nome": "Caranaíba"
            },
            {
                "codigo_ibge": 3113206,
                "nome": "Carandaí"
            },
            {
                "codigo_ibge": 3113305,
                "nome": "Carangola"
            },
            {
                "codigo_ibge": 3113404,
                "nome": "Caratinga"
            },
            {
                "codigo_ibge": 3113503,
                "nome": "Carbonita"
            },
            {
                "codigo_ibge": 3113602,
                "nome": "Careaçu"
            },
            {
                "codigo_ibge": 3113701,
                "nome": "Carlos Chagas"
            },
            {
                "codigo_ibge": 3113800,
                "nome": "Carmésia"
            },
            {
                "codigo_ibge": 3113909,
                "nome": "Carmo da Cachoeira"
            },
            {
                "codigo_ibge": 3114006,
                "nome": "Carmo da Mata"
            },
            {
                "codigo_ibge": 3114105,
                "nome": "Carmo de Minas"
            },
            {
                "codigo_ibge": 3114204,
                "nome": "Carmo do Cajuru"
            },
            {
                "codigo_ibge": 3114303,
                "nome": "Carmo do Paranaíba"
            },
            {
                "codigo_ibge": 3114402,
                "nome": "Carmo do Rio Claro"
            },
            {
                "codigo_ibge": 3114501,
                "nome": "Carmópolis de Minas"
            },
            {
                "codigo_ibge": 3114550,
                "nome": "Carneirinho"
            },
            {
                "codigo_ibge": 3114600,
                "nome": "Carrancas"
            },
            {
                "codigo_ibge": 3114709,
                "nome": "Carvalhópolis"
            },
            {
                "codigo_ibge": 3114808,
                "nome": "Carvalhos"
            },
            {
                "codigo_ibge": 3114907,
                "nome": "Casa Grande"
            },
            {
                "codigo_ibge": 3115003,
                "nome": "Cascalho Rico"
            },
            {
                "codigo_ibge": 3115102,
                "nome": "Cássia"
            },
            {
                "codigo_ibge": 3115300,
                "nome": "Cataguases"
            },
            {
                "codigo_ibge": 3115359,
                "nome": "Catas Altas"
            },
            {
                "codigo_ibge": 3115409,
                "nome": "Catas Altas da Noruega"
            },
            {
                "codigo_ibge": 3115458,
                "nome": "Catuji"
            },
            {
                "codigo_ibge": 3115474,
                "nome": "Catuti"
            },
            {
                "codigo_ibge": 3115508,
                "nome": "Caxambu"
            },
            {
                "codigo_ibge": 3115607,
                "nome": "Cedro do Abaeté"
            },
            {
                "codigo_ibge": 3115706,
                "nome": "Central de Minas"
            },
            {
                "codigo_ibge": 3115805,
                "nome": "Centralina"
            },
            {
                "codigo_ibge": 3115904,
                "nome": "Chácara"
            },
            {
                "codigo_ibge": 3116001,
                "nome": "Chalé"
            },
            {
                "codigo_ibge": 3116100,
                "nome": "Chapada do Norte"
            },
            {
                "codigo_ibge": 3116159,
                "nome": "Chapada Gaúcha"
            },
            {
                "codigo_ibge": 3116209,
                "nome": "Chiador"
            },
            {
                "codigo_ibge": 3116308,
                "nome": "Cipotânea"
            },
            {
                "codigo_ibge": 3116407,
                "nome": "Claraval"
            },
            {
                "codigo_ibge": 3116506,
                "nome": "Claro dos Poções"
            },
            {
                "codigo_ibge": 3116605,
                "nome": "Cláudio"
            },
            {
                "codigo_ibge": 3116704,
                "nome": "Coimbra"
            },
            {
                "codigo_ibge": 3116803,
                "nome": "Coluna"
            },
            {
                "codigo_ibge": 3116902,
                "nome": "Comendador Gomes"
            },
            {
                "codigo_ibge": 3117009,
                "nome": "Comercinho"
            },
            {
                "codigo_ibge": 3117108,
                "nome": "Conceição da Aparecida"
            },
            {
                "codigo_ibge": 3115201,
                "nome": "Conceição da Barra de Minas"
            },
            {
                "codigo_ibge": 3117306,
                "nome": "Conceição das Alagoas"
            },
            {
                "codigo_ibge": 3117207,
                "nome": "Conceição das Pedras"
            },
            {
                "codigo_ibge": 3117405,
                "nome": "Conceição de Ipanema"
            },
            {
                "codigo_ibge": 3117504,
                "nome": "Conceição do Mato Dentro"
            },
            {
                "codigo_ibge": 3117603,
                "nome": "Conceição do Pará"
            },
            {
                "codigo_ibge": 3117702,
                "nome": "Conceição do Rio Verde"
            },
            {
                "codigo_ibge": 3117801,
                "nome": "Conceição dos Ouros"
            },
            {
                "codigo_ibge": 3117836,
                "nome": "Cônego Marinho"
            },
            {
                "codigo_ibge": 3117876,
                "nome": "Confins"
            },
            {
                "codigo_ibge": 3117900,
                "nome": "Congonhal"
            },
            {
                "codigo_ibge": 3118007,
                "nome": "Congonhas"
            },
            {
                "codigo_ibge": 3118106,
                "nome": "Congonhas do Norte"
            },
            {
                "codigo_ibge": 3118205,
                "nome": "Conquista"
            },
            {
                "codigo_ibge": 3118304,
                "nome": "Conselheiro Lafaiete"
            },
            {
                "codigo_ibge": 3118403,
                "nome": "Conselheiro Pena"
            },
            {
                "codigo_ibge": 3118502,
                "nome": "Consolação"
            },
            {
                "codigo_ibge": 3118601,
                "nome": "Contagem"
            },
            {
                "codigo_ibge": 3118700,
                "nome": "Coqueiral"
            },
            {
                "codigo_ibge": 3118809,
                "nome": "Coração de Jesus"
            },
            {
                "codigo_ibge": 3118908,
                "nome": "Cordisburgo"
            },
            {
                "codigo_ibge": 3119005,
                "nome": "Cordislândia"
            },
            {
                "codigo_ibge": 3119104,
                "nome": "Corinto"
            },
            {
                "codigo_ibge": 3119203,
                "nome": "Coroaci"
            },
            {
                "codigo_ibge": 3119302,
                "nome": "Coromandel"
            },
            {
                "codigo_ibge": 3119401,
                "nome": "Coronel Fabriciano"
            },
            {
                "codigo_ibge": 3119500,
                "nome": "Coronel Murta"
            },
            {
                "codigo_ibge": 3119609,
                "nome": "Coronel Pacheco"
            },
            {
                "codigo_ibge": 3119708,
                "nome": "Coronel Xavier Chaves"
            },
            {
                "codigo_ibge": 3119807,
                "nome": "Córrego Danta"
            },
            {
                "codigo_ibge": 3119906,
                "nome": "Córrego do Bom Jesus"
            },
            {
                "codigo_ibge": 3119955,
                "nome": "Córrego Fundo"
            },
            {
                "codigo_ibge": 3120003,
                "nome": "Córrego Novo"
            },
            {
                "codigo_ibge": 3120102,
                "nome": "Couto de Magalhães de Minas"
            },
            {
                "codigo_ibge": 3120151,
                "nome": "Crisólita"
            },
            {
                "codigo_ibge": 3120201,
                "nome": "Cristais"
            },
            {
                "codigo_ibge": 3120300,
                "nome": "Cristália"
            },
            {
                "codigo_ibge": 3120409,
                "nome": "Cristiano Otoni"
            },
            {
                "codigo_ibge": 3120508,
                "nome": "Cristina"
            },
            {
                "codigo_ibge": 3120607,
                "nome": "Crucilândia"
            },
            {
                "codigo_ibge": 3120706,
                "nome": "Cruzeiro da Fortaleza"
            },
            {
                "codigo_ibge": 3120805,
                "nome": "Cruzília"
            },
            {
                "codigo_ibge": 3120839,
                "nome": "Cuparaque"
            },
            {
                "codigo_ibge": 3120870,
                "nome": "Curral de Dentro"
            },
            {
                "codigo_ibge": 3120904,
                "nome": "Curvelo"
            },
            {
                "codigo_ibge": 3121001,
                "nome": "Datas"
            },
            {
                "codigo_ibge": 3121100,
                "nome": "Delfim Moreira"
            },
            {
                "codigo_ibge": 3121209,
                "nome": "Delfinópolis"
            },
            {
                "codigo_ibge": 3121258,
                "nome": "Delta"
            },
            {
                "codigo_ibge": 3121308,
                "nome": "Descoberto"
            },
            {
                "codigo_ibge": 3121407,
                "nome": "Desterro de Entre Rios"
            },
            {
                "codigo_ibge": 3121506,
                "nome": "Desterro do Melo"
            },
            {
                "codigo_ibge": 3121605,
                "nome": "Diamantina"
            },
            {
                "codigo_ibge": 3121704,
                "nome": "Diogo de Vasconcelos"
            },
            {
                "codigo_ibge": 3121803,
                "nome": "Dionísio"
            },
            {
                "codigo_ibge": 3121902,
                "nome": "Divinésia"
            },
            {
                "codigo_ibge": 3122009,
                "nome": "Divino"
            },
            {
                "codigo_ibge": 3122108,
                "nome": "Divino das Laranjeiras"
            },
            {
                "codigo_ibge": 3122207,
                "nome": "Divinolândia de Minas"
            },
            {
                "codigo_ibge": 3122306,
                "nome": "Divinópolis"
            },
            {
                "codigo_ibge": 3122355,
                "nome": "Divisa Alegre"
            },
            {
                "codigo_ibge": 3122405,
                "nome": "Divisa Nova"
            },
            {
                "codigo_ibge": 3122454,
                "nome": "Divisópolis"
            },
            {
                "codigo_ibge": 3122470,
                "nome": "Dom Bosco"
            },
            {
                "codigo_ibge": 3122504,
                "nome": "Dom Cavati"
            },
            {
                "codigo_ibge": 3122603,
                "nome": "Dom Joaquim"
            },
            {
                "codigo_ibge": 3122702,
                "nome": "Dom Silvério"
            },
            {
                "codigo_ibge": 3122801,
                "nome": "Dom Viçoso"
            },
            {
                "codigo_ibge": 3122900,
                "nome": "Dona Eusébia"
            },
            {
                "codigo_ibge": 3123007,
                "nome": "Dores de Campos"
            },
            {
                "codigo_ibge": 3123106,
                "nome": "Dores de Guanhães"
            },
            {
                "codigo_ibge": 3123205,
                "nome": "Dores do Indaiá"
            },
            {
                "codigo_ibge": 3123304,
                "nome": "Dores do Turvo"
            },
            {
                "codigo_ibge": 3123403,
                "nome": "Doresópolis"
            },
            {
                "codigo_ibge": 3123502,
                "nome": "Douradoquara"
            },
            {
                "codigo_ibge": 3123528,
                "nome": "Durandé"
            },
            {
                "codigo_ibge": 3123601,
                "nome": "Elói Mendes"
            },
            {
                "codigo_ibge": 3123700,
                "nome": "Engenheiro Caldas"
            },
            {
                "codigo_ibge": 3123809,
                "nome": "Engenheiro Navarro"
            },
            {
                "codigo_ibge": 3123858,
                "nome": "Entre Folhas"
            },
            {
                "codigo_ibge": 3123908,
                "nome": "Entre Rios de Minas"
            },
            {
                "codigo_ibge": 3124005,
                "nome": "Ervália"
            },
            {
                "codigo_ibge": 3124104,
                "nome": "Esmeraldas"
            },
            {
                "codigo_ibge": 3124203,
                "nome": "Espera Feliz"
            },
            {
                "codigo_ibge": 3124302,
                "nome": "Espinosa"
            },
            {
                "codigo_ibge": 3124401,
                "nome": "Espírito Santo do Dourado"
            },
            {
                "codigo_ibge": 3124500,
                "nome": "Estiva"
            },
            {
                "codigo_ibge": 3124609,
                "nome": "Estrela Dalva"
            },
            {
                "codigo_ibge": 3124708,
                "nome": "Estrela do Indaiá"
            },
            {
                "codigo_ibge": 3124807,
                "nome": "Estrela do Sul"
            },
            {
                "codigo_ibge": 3124906,
                "nome": "Eugenópolis"
            },
            {
                "codigo_ibge": 3125002,
                "nome": "Ewbank da Câmara"
            },
            {
                "codigo_ibge": 3125101,
                "nome": "Extrema"
            },
            {
                "codigo_ibge": 3125200,
                "nome": "Fama"
            },
            {
                "codigo_ibge": 3125309,
                "nome": "Faria Lemos"
            },
            {
                "codigo_ibge": 3125408,
                "nome": "Felício dos Santos"
            },
            {
                "codigo_ibge": 3125606,
                "nome": "Felisburgo"
            },
            {
                "codigo_ibge": 3125705,
                "nome": "Felixlândia"
            },
            {
                "codigo_ibge": 3125804,
                "nome": "Fernandes Tourinho"
            },
            {
                "codigo_ibge": 3125903,
                "nome": "Ferros"
            },
            {
                "codigo_ibge": 3125952,
                "nome": "Fervedouro"
            },
            {
                "codigo_ibge": 3126000,
                "nome": "Florestal"
            },
            {
                "codigo_ibge": 3126109,
                "nome": "Formiga"
            },
            {
                "codigo_ibge": 3126208,
                "nome": "Formoso"
            },
            {
                "codigo_ibge": 3126307,
                "nome": "Fortaleza de Minas"
            },
            {
                "codigo_ibge": 3126406,
                "nome": "Fortuna de Minas"
            },
            {
                "codigo_ibge": 3126505,
                "nome": "Francisco Badaró"
            },
            {
                "codigo_ibge": 3126604,
                "nome": "Francisco Dumont"
            },
            {
                "codigo_ibge": 3126703,
                "nome": "Francisco Sá"
            },
            {
                "codigo_ibge": 3126752,
                "nome": "Franciscópolis"
            },
            {
                "codigo_ibge": 3126802,
                "nome": "Frei Gaspar"
            },
            {
                "codigo_ibge": 3126901,
                "nome": "Frei Inocêncio"
            },
            {
                "codigo_ibge": 3126950,
                "nome": "Frei Lagonegro"
            },
            {
                "codigo_ibge": 3127008,
                "nome": "Fronteira"
            },
            {
                "codigo_ibge": 3127057,
                "nome": "Fronteira dos Vales"
            },
            {
                "codigo_ibge": 3127073,
                "nome": "Fruta de Leite"
            },
            {
                "codigo_ibge": 3127107,
                "nome": "Frutal"
            },
            {
                "codigo_ibge": 3127206,
                "nome": "Funilândia"
            },
            {
                "codigo_ibge": 3127305,
                "nome": "Galiléia"
            },
            {
                "codigo_ibge": 3127339,
                "nome": "Gameleiras"
            },
            {
                "codigo_ibge": 3127354,
                "nome": "Glaucilândia"
            },
            {
                "codigo_ibge": 3127370,
                "nome": "Goiabeira"
            },
            {
                "codigo_ibge": 3127388,
                "nome": "Goianá"
            },
            {
                "codigo_ibge": 3127404,
                "nome": "Gonçalves"
            },
            {
                "codigo_ibge": 3127503,
                "nome": "Gonzaga"
            },
            {
                "codigo_ibge": 3127602,
                "nome": "Gouveia"
            },
            {
                "codigo_ibge": 3127701,
                "nome": "Governador Valadares"
            },
            {
                "codigo_ibge": 3127800,
                "nome": "Grão Mogol"
            },
            {
                "codigo_ibge": 3127909,
                "nome": "Grupiara"
            },
            {
                "codigo_ibge": 3128006,
                "nome": "Guanhães"
            },
            {
                "codigo_ibge": 3128105,
                "nome": "Guapé"
            },
            {
                "codigo_ibge": 3128204,
                "nome": "Guaraciaba"
            },
            {
                "codigo_ibge": 3128253,
                "nome": "Guaraciama"
            },
            {
                "codigo_ibge": 3128303,
                "nome": "Guaranésia"
            },
            {
                "codigo_ibge": 3128402,
                "nome": "Guarani"
            },
            {
                "codigo_ibge": 3128501,
                "nome": "Guarará"
            },
            {
                "codigo_ibge": 3128600,
                "nome": "Guarda-Mor"
            },
            {
                "codigo_ibge": 3128709,
                "nome": "Guaxupé"
            },
            {
                "codigo_ibge": 3128808,
                "nome": "Guidoval"
            },
            {
                "codigo_ibge": 3128907,
                "nome": "Guimarânia"
            },
            {
                "codigo_ibge": 3129004,
                "nome": "Guiricema"
            },
            {
                "codigo_ibge": 3129103,
                "nome": "Gurinhatã"
            },
            {
                "codigo_ibge": 3129202,
                "nome": "Heliodora"
            },
            {
                "codigo_ibge": 3129301,
                "nome": "Iapu"
            },
            {
                "codigo_ibge": 3129400,
                "nome": "Ibertioga"
            },
            {
                "codigo_ibge": 3129509,
                "nome": "Ibiá"
            },
            {
                "codigo_ibge": 3129608,
                "nome": "Ibiaí"
            },
            {
                "codigo_ibge": 3129657,
                "nome": "Ibiracatu"
            },
            {
                "codigo_ibge": 3129707,
                "nome": "Ibiraci"
            },
            {
                "codigo_ibge": 3129806,
                "nome": "Ibirité"
            },
            {
                "codigo_ibge": 3129905,
                "nome": "Ibitiúra de Minas"
            },
            {
                "codigo_ibge": 3130002,
                "nome": "Ibituruna"
            },
            {
                "codigo_ibge": 3130051,
                "nome": "Icaraí de Minas"
            },
            {
                "codigo_ibge": 3130101,
                "nome": "Igarapé"
            },
            {
                "codigo_ibge": 3130200,
                "nome": "Igaratinga"
            },
            {
                "codigo_ibge": 3130309,
                "nome": "Iguatama"
            },
            {
                "codigo_ibge": 3130408,
                "nome": "Ijaci"
            },
            {
                "codigo_ibge": 3130507,
                "nome": "Ilicínea"
            },
            {
                "codigo_ibge": 3130556,
                "nome": "Imbé de Minas"
            },
            {
                "codigo_ibge": 3130606,
                "nome": "Inconfidentes"
            },
            {
                "codigo_ibge": 3130655,
                "nome": "Indaiabira"
            },
            {
                "codigo_ibge": 3130705,
                "nome": "Indianópolis"
            },
            {
                "codigo_ibge": 3130804,
                "nome": "Ingaí"
            },
            {
                "codigo_ibge": 3130903,
                "nome": "Inhapim"
            },
            {
                "codigo_ibge": 3131000,
                "nome": "Inhaúma"
            },
            {
                "codigo_ibge": 3131109,
                "nome": "Inimutaba"
            },
            {
                "codigo_ibge": 3131158,
                "nome": "Ipaba"
            },
            {
                "codigo_ibge": 3131208,
                "nome": "Ipanema"
            },
            {
                "codigo_ibge": 3131307,
                "nome": "Ipatinga"
            },
            {
                "codigo_ibge": 3131406,
                "nome": "Ipiaçu"
            },
            {
                "codigo_ibge": 3131505,
                "nome": "Ipuiúna"
            },
            {
                "codigo_ibge": 3131604,
                "nome": "Iraí de Minas"
            },
            {
                "codigo_ibge": 3131703,
                "nome": "Itabira"
            },
            {
                "codigo_ibge": 3131802,
                "nome": "Itabirinha"
            },
            {
                "codigo_ibge": 3131901,
                "nome": "Itabirito"
            },
            {
                "codigo_ibge": 3132008,
                "nome": "Itacambira"
            },
            {
                "codigo_ibge": 3132107,
                "nome": "Itacarambi"
            },
            {
                "codigo_ibge": 3132206,
                "nome": "Itaguara"
            },
            {
                "codigo_ibge": 3132305,
                "nome": "Itaipé"
            },
            {
                "codigo_ibge": 3132404,
                "nome": "Itajubá"
            },
            {
                "codigo_ibge": 3132503,
                "nome": "Itamarandiba"
            },
            {
                "codigo_ibge": 3132602,
                "nome": "Itamarati de Minas"
            },
            {
                "codigo_ibge": 3132701,
                "nome": "Itambacuri"
            },
            {
                "codigo_ibge": 3132800,
                "nome": "Itambé do Mato Dentro"
            },
            {
                "codigo_ibge": 3132909,
                "nome": "Itamogi"
            },
            {
                "codigo_ibge": 3133006,
                "nome": "Itamonte"
            },
            {
                "codigo_ibge": 3133105,
                "nome": "Itanhandu"
            },
            {
                "codigo_ibge": 3133204,
                "nome": "Itanhomi"
            },
            {
                "codigo_ibge": 3133303,
                "nome": "Itaobim"
            },
            {
                "codigo_ibge": 3133402,
                "nome": "Itapagipe"
            },
            {
                "codigo_ibge": 3133501,
                "nome": "Itapecerica"
            },
            {
                "codigo_ibge": 3133600,
                "nome": "Itapeva"
            },
            {
                "codigo_ibge": 3133709,
                "nome": "Itatiaiuçu"
            },
            {
                "codigo_ibge": 3133758,
                "nome": "Itaú de Minas"
            },
            {
                "codigo_ibge": 3133808,
                "nome": "Itaúna"
            },
            {
                "codigo_ibge": 3133907,
                "nome": "Itaverava"
            },
            {
                "codigo_ibge": 3134004,
                "nome": "Itinga"
            },
            {
                "codigo_ibge": 3134103,
                "nome": "Itueta"
            },
            {
                "codigo_ibge": 3134202,
                "nome": "Ituiutaba"
            },
            {
                "codigo_ibge": 3134301,
                "nome": "Itumirim"
            },
            {
                "codigo_ibge": 3134400,
                "nome": "Iturama"
            },
            {
                "codigo_ibge": 3134509,
                "nome": "Itutinga"
            },
            {
                "codigo_ibge": 3134608,
                "nome": "Jaboticatubas"
            },
            {
                "codigo_ibge": 3134707,
                "nome": "Jacinto"
            },
            {
                "codigo_ibge": 3134806,
                "nome": "Jacuí"
            },
            {
                "codigo_ibge": 3134905,
                "nome": "Jacutinga"
            },
            {
                "codigo_ibge": 3135001,
                "nome": "Jaguaraçu"
            },
            {
                "codigo_ibge": 3135050,
                "nome": "Jaíba"
            },
            {
                "codigo_ibge": 3135076,
                "nome": "Jampruca"
            },
            {
                "codigo_ibge": 3135100,
                "nome": "Janaúba"
            },
            {
                "codigo_ibge": 3135209,
                "nome": "Januária"
            },
            {
                "codigo_ibge": 3135308,
                "nome": "Japaraíba"
            },
            {
                "codigo_ibge": 3135357,
                "nome": "Japonvar"
            },
            {
                "codigo_ibge": 3135407,
                "nome": "Jeceaba"
            },
            {
                "codigo_ibge": 3135456,
                "nome": "Jenipapo de Minas"
            },
            {
                "codigo_ibge": 3135506,
                "nome": "Jequeri"
            },
            {
                "codigo_ibge": 3135605,
                "nome": "Jequitaí"
            },
            {
                "codigo_ibge": 3135704,
                "nome": "Jequitibá"
            },
            {
                "codigo_ibge": 3135803,
                "nome": "Jequitinhonha"
            },
            {
                "codigo_ibge": 3135902,
                "nome": "Jesuânia"
            },
            {
                "codigo_ibge": 3136009,
                "nome": "Joaíma"
            },
            {
                "codigo_ibge": 3136108,
                "nome": "Joanésia"
            },
            {
                "codigo_ibge": 3136207,
                "nome": "João Monlevade"
            },
            {
                "codigo_ibge": 3136306,
                "nome": "João Pinheiro"
            },
            {
                "codigo_ibge": 3136405,
                "nome": "Joaquim Felício"
            },
            {
                "codigo_ibge": 3136504,
                "nome": "Jordânia"
            },
            {
                "codigo_ibge": 3136520,
                "nome": "José Gonçalves de Minas"
            },
            {
                "codigo_ibge": 3136553,
                "nome": "José Raydan"
            },
            {
                "codigo_ibge": 3136579,
                "nome": "Josenópolis"
            },
            {
                "codigo_ibge": 3136652,
                "nome": "Juatuba"
            },
            {
                "codigo_ibge": 3136702,
                "nome": "Juiz de Fora"
            },
            {
                "codigo_ibge": 3136801,
                "nome": "Juramento"
            },
            {
                "codigo_ibge": 3136900,
                "nome": "Juruaia"
            },
            {
                "codigo_ibge": 3136959,
                "nome": "Juvenília"
            },
            {
                "codigo_ibge": 3137007,
                "nome": "Ladainha"
            },
            {
                "codigo_ibge": 3137106,
                "nome": "Lagamar"
            },
            {
                "codigo_ibge": 3137205,
                "nome": "Lagoa da Prata"
            },
            {
                "codigo_ibge": 3137304,
                "nome": "Lagoa dos Patos"
            },
            {
                "codigo_ibge": 3137403,
                "nome": "Lagoa Dourada"
            },
            {
                "codigo_ibge": 3137502,
                "nome": "Lagoa Formosa"
            },
            {
                "codigo_ibge": 3137536,
                "nome": "Lagoa Grande"
            },
            {
                "codigo_ibge": 3137601,
                "nome": "Lagoa Santa"
            },
            {
                "codigo_ibge": 3137700,
                "nome": "Lajinha"
            },
            {
                "codigo_ibge": 3137809,
                "nome": "Lambari"
            },
            {
                "codigo_ibge": 3137908,
                "nome": "Lamim"
            },
            {
                "codigo_ibge": 3138005,
                "nome": "Laranjal"
            },
            {
                "codigo_ibge": 3138104,
                "nome": "Lassance"
            },
            {
                "codigo_ibge": 3138203,
                "nome": "Lavras"
            },
            {
                "codigo_ibge": 3138302,
                "nome": "Leandro Ferreira"
            },
            {
                "codigo_ibge": 3138351,
                "nome": "Leme do Prado"
            },
            {
                "codigo_ibge": 3138401,
                "nome": "Leopoldina"
            },
            {
                "codigo_ibge": 3138500,
                "nome": "Liberdade"
            },
            {
                "codigo_ibge": 3138609,
                "nome": "Lima Duarte"
            },
            {
                "codigo_ibge": 3138625,
                "nome": "Limeira do Oeste"
            },
            {
                "codigo_ibge": 3138658,
                "nome": "Lontra"
            },
            {
                "codigo_ibge": 3138674,
                "nome": "Luisburgo"
            },
            {
                "codigo_ibge": 3138682,
                "nome": "Luislândia"
            },
            {
                "codigo_ibge": 3138708,
                "nome": "Luminárias"
            },
            {
                "codigo_ibge": 3138807,
                "nome": "Luz"
            },
            {
                "codigo_ibge": 3138906,
                "nome": "Machacalis"
            },
            {
                "codigo_ibge": 3139003,
                "nome": "Machado"
            },
            {
                "codigo_ibge": 3139102,
                "nome": "Madre de Deus de Minas"
            },
            {
                "codigo_ibge": 3139201,
                "nome": "Malacacheta"
            },
            {
                "codigo_ibge": 3139250,
                "nome": "Mamonas"
            },
            {
                "codigo_ibge": 3139300,
                "nome": "Manga"
            },
            {
                "codigo_ibge": 3139409,
                "nome": "Manhuaçu"
            },
            {
                "codigo_ibge": 3139508,
                "nome": "Manhumirim"
            },
            {
                "codigo_ibge": 3139607,
                "nome": "Mantena"
            },
            {
                "codigo_ibge": 3139805,
                "nome": "Mar de Espanha"
            },
            {
                "codigo_ibge": 3139706,
                "nome": "Maravilhas"
            },
            {
                "codigo_ibge": 3139904,
                "nome": "Maria da Fé"
            },
            {
                "codigo_ibge": 3140001,
                "nome": "Mariana"
            },
            {
                "codigo_ibge": 3140100,
                "nome": "Marilac"
            },
            {
                "codigo_ibge": 3140159,
                "nome": "Mário Campos"
            },
            {
                "codigo_ibge": 3140209,
                "nome": "Maripá de Minas"
            },
            {
                "codigo_ibge": 3140308,
                "nome": "Marliéria"
            },
            {
                "codigo_ibge": 3140407,
                "nome": "Marmelópolis"
            },
            {
                "codigo_ibge": 3140506,
                "nome": "Martinho Campos"
            },
            {
                "codigo_ibge": 3140530,
                "nome": "Martins Soares"
            },
            {
                "codigo_ibge": 3140555,
                "nome": "Mata Verde"
            },
            {
                "codigo_ibge": 3140605,
                "nome": "Materlândia"
            },
            {
                "codigo_ibge": 3140704,
                "nome": "Mateus Leme"
            },
            {
                "codigo_ibge": 3171501,
                "nome": "Mathias Lobato"
            },
            {
                "codigo_ibge": 3140803,
                "nome": "Matias Barbosa"
            },
            {
                "codigo_ibge": 3140852,
                "nome": "Matias Cardoso"
            },
            {
                "codigo_ibge": 3140902,
                "nome": "Matipó"
            },
            {
                "codigo_ibge": 3141009,
                "nome": "Mato Verde"
            },
            {
                "codigo_ibge": 3141108,
                "nome": "Matozinhos"
            },
            {
                "codigo_ibge": 3141207,
                "nome": "Matutina"
            },
            {
                "codigo_ibge": 3141306,
                "nome": "Medeiros"
            },
            {
                "codigo_ibge": 3141405,
                "nome": "Medina"
            },
            {
                "codigo_ibge": 3141504,
                "nome": "Mendes Pimentel"
            },
            {
                "codigo_ibge": 3141603,
                "nome": "Mercês"
            },
            {
                "codigo_ibge": 3141702,
                "nome": "Mesquita"
            },
            {
                "codigo_ibge": 3141801,
                "nome": "Minas Novas"
            },
            {
                "codigo_ibge": 3141900,
                "nome": "Minduri"
            },
            {
                "codigo_ibge": 3142007,
                "nome": "Mirabela"
            },
            {
                "codigo_ibge": 3142106,
                "nome": "Miradouro"
            },
            {
                "codigo_ibge": 3142205,
                "nome": "Miraí"
            },
            {
                "codigo_ibge": 3142254,
                "nome": "Miravânia"
            },
            {
                "codigo_ibge": 3142304,
                "nome": "Moeda"
            },
            {
                "codigo_ibge": 3142403,
                "nome": "Moema"
            },
            {
                "codigo_ibge": 3142502,
                "nome": "Monjolos"
            },
            {
                "codigo_ibge": 3142601,
                "nome": "Monsenhor Paulo"
            },
            {
                "codigo_ibge": 3142700,
                "nome": "Montalvânia"
            },
            {
                "codigo_ibge": 3142809,
                "nome": "Monte Alegre de Minas"
            },
            {
                "codigo_ibge": 3142908,
                "nome": "Monte Azul"
            },
            {
                "codigo_ibge": 3143005,
                "nome": "Monte Belo"
            },
            {
                "codigo_ibge": 3143104,
                "nome": "Monte Carmelo"
            },
            {
                "codigo_ibge": 3143153,
                "nome": "Monte Formoso"
            },
            {
                "codigo_ibge": 3143203,
                "nome": "Monte Santo de Minas"
            },
            {
                "codigo_ibge": 3143401,
                "nome": "Monte Sião"
            },
            {
                "codigo_ibge": 3143302,
                "nome": "Montes Claros"
            },
            {
                "codigo_ibge": 3143450,
                "nome": "Montezuma"
            },
            {
                "codigo_ibge": 3143500,
                "nome": "Morada Nova de Minas"
            },
            {
                "codigo_ibge": 3143609,
                "nome": "Morro da Garça"
            },
            {
                "codigo_ibge": 3143708,
                "nome": "Morro do Pilar"
            },
            {
                "codigo_ibge": 3143807,
                "nome": "Munhoz"
            },
            {
                "codigo_ibge": 3143906,
                "nome": "Muriaé"
            },
            {
                "codigo_ibge": 3144003,
                "nome": "Mutum"
            },
            {
                "codigo_ibge": 3144102,
                "nome": "Muzambinho"
            },
            {
                "codigo_ibge": 3144201,
                "nome": "Nacip Raydan"
            },
            {
                "codigo_ibge": 3144300,
                "nome": "Nanuque"
            },
            {
                "codigo_ibge": 3144359,
                "nome": "Naque"
            },
            {
                "codigo_ibge": 3144375,
                "nome": "Natalândia"
            },
            {
                "codigo_ibge": 3144409,
                "nome": "Natércia"
            },
            {
                "codigo_ibge": 3144508,
                "nome": "Nazareno"
            },
            {
                "codigo_ibge": 3144607,
                "nome": "Nepomuceno"
            },
            {
                "codigo_ibge": 3144656,
                "nome": "Ninheira"
            },
            {
                "codigo_ibge": 3144672,
                "nome": "Nova Belém"
            },
            {
                "codigo_ibge": 3144706,
                "nome": "Nova Era"
            },
            {
                "codigo_ibge": 3144805,
                "nome": "Nova Lima"
            },
            {
                "codigo_ibge": 3144904,
                "nome": "Nova Módica"
            },
            {
                "codigo_ibge": 3145000,
                "nome": "Nova Ponte"
            },
            {
                "codigo_ibge": 3145059,
                "nome": "Nova Porteirinha"
            },
            {
                "codigo_ibge": 3145109,
                "nome": "Nova Resende"
            },
            {
                "codigo_ibge": 3145208,
                "nome": "Nova Serrana"
            },
            {
                "codigo_ibge": 3136603,
                "nome": "Nova União"
            },
            {
                "codigo_ibge": 3145307,
                "nome": "Novo Cruzeiro"
            },
            {
                "codigo_ibge": 3145356,
                "nome": "Novo Oriente de Minas"
            },
            {
                "codigo_ibge": 3145372,
                "nome": "Novorizonte"
            },
            {
                "codigo_ibge": 3145406,
                "nome": "Olaria"
            },
            {
                "codigo_ibge": 3145455,
                "nome": "Olhos d'Água"
            },
            {
                "codigo_ibge": 3145505,
                "nome": "Olímpio Noronha"
            },
            {
                "codigo_ibge": 3145604,
                "nome": "Oliveira"
            },
            {
                "codigo_ibge": 3145703,
                "nome": "Oliveira Fortes"
            },
            {
                "codigo_ibge": 3145802,
                "nome": "Onça de Pitangui"
            },
            {
                "codigo_ibge": 3145851,
                "nome": "Oratórios"
            },
            {
                "codigo_ibge": 3145877,
                "nome": "Orizânia"
            },
            {
                "codigo_ibge": 3145901,
                "nome": "Ouro Branco"
            },
            {
                "codigo_ibge": 3146008,
                "nome": "Ouro Fino"
            },
            {
                "codigo_ibge": 3146107,
                "nome": "Ouro Preto"
            },
            {
                "codigo_ibge": 3146206,
                "nome": "Ouro Verde de Minas"
            },
            {
                "codigo_ibge": 3146255,
                "nome": "Padre Carvalho"
            },
            {
                "codigo_ibge": 3146305,
                "nome": "Padre Paraíso"
            },
            {
                "codigo_ibge": 3146552,
                "nome": "Pai Pedro"
            },
            {
                "codigo_ibge": 3146404,
                "nome": "Paineiras"
            },
            {
                "codigo_ibge": 3146503,
                "nome": "Pains"
            },
            {
                "codigo_ibge": 3146602,
                "nome": "Paiva"
            },
            {
                "codigo_ibge": 3146701,
                "nome": "Palma"
            },
            {
                "codigo_ibge": 3146750,
                "nome": "Palmópolis"
            },
            {
                "codigo_ibge": 3146909,
                "nome": "Papagaios"
            },
            {
                "codigo_ibge": 3147105,
                "nome": "Pará de Minas"
            },
            {
                "codigo_ibge": 3147006,
                "nome": "Paracatu"
            },
            {
                "codigo_ibge": 3147204,
                "nome": "Paraguaçu"
            },
            {
                "codigo_ibge": 3147303,
                "nome": "Paraisópolis"
            },
            {
                "codigo_ibge": 3147402,
                "nome": "Paraopeba"
            },
            {
                "codigo_ibge": 3147600,
                "nome": "Passa Quatro"
            },
            {
                "codigo_ibge": 3147709,
                "nome": "Passa Tempo"
            },
            {
                "codigo_ibge": 3147808,
                "nome": "Passa-Vinte"
            },
            {
                "codigo_ibge": 3147501,
                "nome": "Passabém"
            },
            {
                "codigo_ibge": 3147907,
                "nome": "Passos"
            },
            {
                "codigo_ibge": 3147956,
                "nome": "Patis"
            },
            {
                "codigo_ibge": 3148004,
                "nome": "Patos de Minas"
            },
            {
                "codigo_ibge": 3148103,
                "nome": "Patrocínio"
            },
            {
                "codigo_ibge": 3148202,
                "nome": "Patrocínio do Muriaé"
            },
            {
                "codigo_ibge": 3148301,
                "nome": "Paula Cândido"
            },
            {
                "codigo_ibge": 3148400,
                "nome": "Paulistas"
            },
            {
                "codigo_ibge": 3148509,
                "nome": "Pavão"
            },
            {
                "codigo_ibge": 3148608,
                "nome": "Peçanha"
            },
            {
                "codigo_ibge": 3148707,
                "nome": "Pedra Azul"
            },
            {
                "codigo_ibge": 3148756,
                "nome": "Pedra Bonita"
            },
            {
                "codigo_ibge": 3148806,
                "nome": "Pedra do Anta"
            },
            {
                "codigo_ibge": 3148905,
                "nome": "Pedra do Indaiá"
            },
            {
                "codigo_ibge": 3149002,
                "nome": "Pedra Dourada"
            },
            {
                "codigo_ibge": 3149101,
                "nome": "Pedralva"
            },
            {
                "codigo_ibge": 3149150,
                "nome": "Pedras de Maria da Cruz"
            },
            {
                "codigo_ibge": 3149200,
                "nome": "Pedrinópolis"
            },
            {
                "codigo_ibge": 3149309,
                "nome": "Pedro Leopoldo"
            },
            {
                "codigo_ibge": 3149408,
                "nome": "Pedro Teixeira"
            },
            {
                "codigo_ibge": 3149507,
                "nome": "Pequeri"
            },
            {
                "codigo_ibge": 3149606,
                "nome": "Pequi"
            },
            {
                "codigo_ibge": 3149705,
                "nome": "Perdigão"
            },
            {
                "codigo_ibge": 3149804,
                "nome": "Perdizes"
            },
            {
                "codigo_ibge": 3149903,
                "nome": "Perdões"
            },
            {
                "codigo_ibge": 3149952,
                "nome": "Periquito"
            },
            {
                "codigo_ibge": 3150000,
                "nome": "Pescador"
            },
            {
                "codigo_ibge": 3150109,
                "nome": "Piau"
            },
            {
                "codigo_ibge": 3150158,
                "nome": "Piedade de Caratinga"
            },
            {
                "codigo_ibge": 3150208,
                "nome": "Piedade de Ponte Nova"
            },
            {
                "codigo_ibge": 3150307,
                "nome": "Piedade do Rio Grande"
            },
            {
                "codigo_ibge": 3150406,
                "nome": "Piedade dos Gerais"
            },
            {
                "codigo_ibge": 3150505,
                "nome": "Pimenta"
            },
            {
                "codigo_ibge": 3150539,
                "nome": "Pingo-d'Água"
            },
            {
                "codigo_ibge": 3150570,
                "nome": "Pintópolis"
            },
            {
                "codigo_ibge": 3150604,
                "nome": "Piracema"
            },
            {
                "codigo_ibge": 3150703,
                "nome": "Pirajuba"
            },
            {
                "codigo_ibge": 3150802,
                "nome": "Piranga"
            },
            {
                "codigo_ibge": 3150901,
                "nome": "Piranguçu"
            },
            {
                "codigo_ibge": 3151008,
                "nome": "Piranguinho"
            },
            {
                "codigo_ibge": 3151107,
                "nome": "Pirapetinga"
            },
            {
                "codigo_ibge": 3151206,
                "nome": "Pirapora"
            },
            {
                "codigo_ibge": 3151305,
                "nome": "Piraúba"
            },
            {
                "codigo_ibge": 3151404,
                "nome": "Pitangui"
            },
            {
                "codigo_ibge": 3151503,
                "nome": "Piumhi"
            },
            {
                "codigo_ibge": 3151602,
                "nome": "Planura"
            },
            {
                "codigo_ibge": 3151701,
                "nome": "Poço Fundo"
            },
            {
                "codigo_ibge": 3151800,
                "nome": "Poços de Caldas"
            },
            {
                "codigo_ibge": 3151909,
                "nome": "Pocrane"
            },
            {
                "codigo_ibge": 3152006,
                "nome": "Pompéu"
            },
            {
                "codigo_ibge": 3152105,
                "nome": "Ponte Nova"
            },
            {
                "codigo_ibge": 3152131,
                "nome": "Ponto Chique"
            },
            {
                "codigo_ibge": 3152170,
                "nome": "Ponto dos Volantes"
            },
            {
                "codigo_ibge": 3152204,
                "nome": "Porteirinha"
            },
            {
                "codigo_ibge": 3152303,
                "nome": "Porto Firme"
            },
            {
                "codigo_ibge": 3152402,
                "nome": "Poté"
            },
            {
                "codigo_ibge": 3152501,
                "nome": "Pouso Alegre"
            },
            {
                "codigo_ibge": 3152600,
                "nome": "Pouso Alto"
            },
            {
                "codigo_ibge": 3152709,
                "nome": "Prados"
            },
            {
                "codigo_ibge": 3152808,
                "nome": "Prata"
            },
            {
                "codigo_ibge": 3152907,
                "nome": "Pratápolis"
            },
            {
                "codigo_ibge": 3153004,
                "nome": "Pratinha"
            },
            {
                "codigo_ibge": 3153103,
                "nome": "Presidente Bernardes"
            },
            {
                "codigo_ibge": 3153202,
                "nome": "Presidente Juscelino"
            },
            {
                "codigo_ibge": 3153301,
                "nome": "Presidente Kubitschek"
            },
            {
                "codigo_ibge": 3153400,
                "nome": "Presidente Olegário"
            },
            {
                "codigo_ibge": 3153608,
                "nome": "Prudente de Morais"
            },
            {
                "codigo_ibge": 3153707,
                "nome": "Quartel Geral"
            },
            {
                "codigo_ibge": 3153806,
                "nome": "Queluzito"
            },
            {
                "codigo_ibge": 3153905,
                "nome": "Raposos"
            },
            {
                "codigo_ibge": 3154002,
                "nome": "Raul Soares"
            },
            {
                "codigo_ibge": 3154101,
                "nome": "Recreio"
            },
            {
                "codigo_ibge": 3154150,
                "nome": "Reduto"
            },
            {
                "codigo_ibge": 3154200,
                "nome": "Resende Costa"
            },
            {
                "codigo_ibge": 3154309,
                "nome": "Resplendor"
            },
            {
                "codigo_ibge": 3154408,
                "nome": "Ressaquinha"
            },
            {
                "codigo_ibge": 3154457,
                "nome": "Riachinho"
            },
            {
                "codigo_ibge": 3154507,
                "nome": "Riacho dos Machados"
            },
            {
                "codigo_ibge": 3154606,
                "nome": "Ribeirão das Neves"
            },
            {
                "codigo_ibge": 3154705,
                "nome": "Ribeirão Vermelho"
            },
            {
                "codigo_ibge": 3154804,
                "nome": "Rio Acima"
            },
            {
                "codigo_ibge": 3154903,
                "nome": "Rio Casca"
            },
            {
                "codigo_ibge": 3155108,
                "nome": "Rio do Prado"
            },
            {
                "codigo_ibge": 3155009,
                "nome": "Rio Doce"
            },
            {
                "codigo_ibge": 3155207,
                "nome": "Rio Espera"
            },
            {
                "codigo_ibge": 3155306,
                "nome": "Rio Manso"
            },
            {
                "codigo_ibge": 3155405,
                "nome": "Rio Novo"
            },
            {
                "codigo_ibge": 3155504,
                "nome": "Rio Paranaíba"
            },
            {
                "codigo_ibge": 3155603,
                "nome": "Rio Pardo de Minas"
            },
            {
                "codigo_ibge": 3155702,
                "nome": "Rio Piracicaba"
            },
            {
                "codigo_ibge": 3155801,
                "nome": "Rio Pomba"
            },
            {
                "codigo_ibge": 3155900,
                "nome": "Rio Preto"
            },
            {
                "codigo_ibge": 3156007,
                "nome": "Rio Vermelho"
            },
            {
                "codigo_ibge": 3156106,
                "nome": "Ritápolis"
            },
            {
                "codigo_ibge": 3156205,
                "nome": "Rochedo de Minas"
            },
            {
                "codigo_ibge": 3156304,
                "nome": "Rodeiro"
            },
            {
                "codigo_ibge": 3156403,
                "nome": "Romaria"
            },
            {
                "codigo_ibge": 3156452,
                "nome": "Rosário da Limeira"
            },
            {
                "codigo_ibge": 3156502,
                "nome": "Rubelita"
            },
            {
                "codigo_ibge": 3156601,
                "nome": "Rubim"
            },
            {
                "codigo_ibge": 3156700,
                "nome": "Sabará"
            },
            {
                "codigo_ibge": 3156809,
                "nome": "Sabinópolis"
            },
            {
                "codigo_ibge": 3156908,
                "nome": "Sacramento"
            },
            {
                "codigo_ibge": 3157005,
                "nome": "Salinas"
            },
            {
                "codigo_ibge": 3157104,
                "nome": "Salto da Divisa"
            },
            {
                "codigo_ibge": 3157203,
                "nome": "Santa Bárbara"
            },
            {
                "codigo_ibge": 3157252,
                "nome": "Santa Bárbara do Leste"
            },
            {
                "codigo_ibge": 3157278,
                "nome": "Santa Bárbara do Monte Verde"
            },
            {
                "codigo_ibge": 3157302,
                "nome": "Santa Bárbara do Tugúrio"
            },
            {
                "codigo_ibge": 3157336,
                "nome": "Santa Cruz de Minas"
            },
            {
                "codigo_ibge": 3157377,
                "nome": "Santa Cruz de Salinas"
            },
            {
                "codigo_ibge": 3157401,
                "nome": "Santa Cruz do Escalvado"
            },
            {
                "codigo_ibge": 3157500,
                "nome": "Santa Efigênia de Minas"
            },
            {
                "codigo_ibge": 3157609,
                "nome": "Santa Fé de Minas"
            },
            {
                "codigo_ibge": 3157658,
                "nome": "Santa Helena de Minas"
            },
            {
                "codigo_ibge": 3157708,
                "nome": "Santa Juliana"
            },
            {
                "codigo_ibge": 3157807,
                "nome": "Santa Luzia"
            },
            {
                "codigo_ibge": 3157906,
                "nome": "Santa Margarida"
            },
            {
                "codigo_ibge": 3158003,
                "nome": "Santa Maria de Itabira"
            },
            {
                "codigo_ibge": 3158102,
                "nome": "Santa Maria do Salto"
            },
            {
                "codigo_ibge": 3158201,
                "nome": "Santa Maria do Suaçuí"
            },
            {
                "codigo_ibge": 3159209,
                "nome": "Santa Rita de Caldas"
            },
            {
                "codigo_ibge": 3159407,
                "nome": "Santa Rita de Ibitipoca"
            },
            {
                "codigo_ibge": 3159308,
                "nome": "Santa Rita de Jacutinga"
            },
            {
                "codigo_ibge": 3159357,
                "nome": "Santa Rita de Minas"
            },
            {
                "codigo_ibge": 3159506,
                "nome": "Santa Rita do Itueto"
            },
            {
                "codigo_ibge": 3159605,
                "nome": "Santa Rita do Sapucaí"
            },
            {
                "codigo_ibge": 3159704,
                "nome": "Santa Rosa da Serra"
            },
            {
                "codigo_ibge": 3159803,
                "nome": "Santa Vitória"
            },
            {
                "codigo_ibge": 3158300,
                "nome": "Santana da Vargem"
            },
            {
                "codigo_ibge": 3158409,
                "nome": "Santana de Cataguases"
            },
            {
                "codigo_ibge": 3158508,
                "nome": "Santana de Pirapama"
            },
            {
                "codigo_ibge": 3158607,
                "nome": "Santana do Deserto"
            },
            {
                "codigo_ibge": 3158706,
                "nome": "Santana do Garambéu"
            },
            {
                "codigo_ibge": 3158805,
                "nome": "Santana do Jacaré"
            },
            {
                "codigo_ibge": 3158904,
                "nome": "Santana do Manhuaçu"
            },
            {
                "codigo_ibge": 3158953,
                "nome": "Santana do Paraíso"
            },
            {
                "codigo_ibge": 3159001,
                "nome": "Santana do Riacho"
            },
            {
                "codigo_ibge": 3159100,
                "nome": "Santana dos Montes"
            },
            {
                "codigo_ibge": 3159902,
                "nome": "Santo Antônio do Amparo"
            },
            {
                "codigo_ibge": 3160009,
                "nome": "Santo Antônio do Aventureiro"
            },
            {
                "codigo_ibge": 3160108,
                "nome": "Santo Antônio do Grama"
            },
            {
                "codigo_ibge": 3160207,
                "nome": "Santo Antônio do Itambé"
            },
            {
                "codigo_ibge": 3160306,
                "nome": "Santo Antônio do Jacinto"
            },
            {
                "codigo_ibge": 3160405,
                "nome": "Santo Antônio do Monte"
            },
            {
                "codigo_ibge": 3160454,
                "nome": "Santo Antônio do Retiro"
            },
            {
                "codigo_ibge": 3160504,
                "nome": "Santo Antônio do Rio Abaixo"
            },
            {
                "codigo_ibge": 3160603,
                "nome": "Santo Hipólito"
            },
            {
                "codigo_ibge": 3160702,
                "nome": "Santos Dumont"
            },
            {
                "codigo_ibge": 3160801,
                "nome": "São Bento Abade"
            },
            {
                "codigo_ibge": 3160900,
                "nome": "São Brás do Suaçuí"
            },
            {
                "codigo_ibge": 3160959,
                "nome": "São Domingos das Dores"
            },
            {
                "codigo_ibge": 3161007,
                "nome": "São Domingos do Prata"
            },
            {
                "codigo_ibge": 3161056,
                "nome": "São Félix de Minas"
            },
            {
                "codigo_ibge": 3161106,
                "nome": "São Francisco"
            },
            {
                "codigo_ibge": 3161205,
                "nome": "São Francisco de Paula"
            },
            {
                "codigo_ibge": 3161304,
                "nome": "São Francisco de Sales"
            },
            {
                "codigo_ibge": 3161403,
                "nome": "São Francisco do Glória"
            },
            {
                "codigo_ibge": 3161502,
                "nome": "São Geraldo"
            },
            {
                "codigo_ibge": 3161601,
                "nome": "São Geraldo da Piedade"
            },
            {
                "codigo_ibge": 3161650,
                "nome": "São Geraldo do Baixio"
            },
            {
                "codigo_ibge": 3161700,
                "nome": "São Gonçalo do Abaeté"
            },
            {
                "codigo_ibge": 3161809,
                "nome": "São Gonçalo do Pará"
            },
            {
                "codigo_ibge": 3161908,
                "nome": "São Gonçalo do Rio Abaixo"
            },
            {
                "codigo_ibge": 3125507,
                "nome": "São Gonçalo do Rio Preto"
            },
            {
                "codigo_ibge": 3162005,
                "nome": "São Gonçalo do Sapucaí"
            },
            {
                "codigo_ibge": 3162104,
                "nome": "São Gotardo"
            },
            {
                "codigo_ibge": 3162203,
                "nome": "São João Batista do Glória"
            },
            {
                "codigo_ibge": 3162252,
                "nome": "São João da Lagoa"
            },
            {
                "codigo_ibge": 3162302,
                "nome": "São João da Mata"
            },
            {
                "codigo_ibge": 3162401,
                "nome": "São João da Ponte"
            },
            {
                "codigo_ibge": 3162450,
                "nome": "São João das Missões"
            },
            {
                "codigo_ibge": 3162500,
                "nome": "São João del Rei"
            },
            {
                "codigo_ibge": 3162559,
                "nome": "São João do Manhuaçu"
            },
            {
                "codigo_ibge": 3162575,
                "nome": "São João do Manteninha"
            },
            {
                "codigo_ibge": 3162609,
                "nome": "São João do Oriente"
            },
            {
                "codigo_ibge": 3162658,
                "nome": "São João do Pacuí"
            },
            {
                "codigo_ibge": 3162708,
                "nome": "São João do Paraíso"
            },
            {
                "codigo_ibge": 3162807,
                "nome": "São João Evangelista"
            },
            {
                "codigo_ibge": 3162906,
                "nome": "São João Nepomuceno"
            },
            {
                "codigo_ibge": 3162922,
                "nome": "São Joaquim de Bicas"
            },
            {
                "codigo_ibge": 3162948,
                "nome": "São José da Barra"
            },
            {
                "codigo_ibge": 3162955,
                "nome": "São José da Lapa"
            },
            {
                "codigo_ibge": 3163003,
                "nome": "São José da Safira"
            },
            {
                "codigo_ibge": 3163102,
                "nome": "São José da Varginha"
            },
            {
                "codigo_ibge": 3163201,
                "nome": "São José do Alegre"
            },
            {
                "codigo_ibge": 3163300,
                "nome": "São José do Divino"
            },
            {
                "codigo_ibge": 3163409,
                "nome": "São José do Goiabal"
            },
            {
                "codigo_ibge": 3163508,
                "nome": "São José do Jacuri"
            },
            {
                "codigo_ibge": 3163607,
                "nome": "São José do Mantimento"
            },
            {
                "codigo_ibge": 3163706,
                "nome": "São Lourenço"
            },
            {
                "codigo_ibge": 3163805,
                "nome": "São Miguel do Anta"
            },
            {
                "codigo_ibge": 3163904,
                "nome": "São Pedro da União"
            },
            {
                "codigo_ibge": 3164100,
                "nome": "São Pedro do Suaçuí"
            },
            {
                "codigo_ibge": 3164001,
                "nome": "São Pedro dos Ferros"
            },
            {
                "codigo_ibge": 3164209,
                "nome": "São Romão"
            },
            {
                "codigo_ibge": 3164308,
                "nome": "São Roque de Minas"
            },
            {
                "codigo_ibge": 3164407,
                "nome": "São Sebastião da Bela Vista"
            },
            {
                "codigo_ibge": 3164431,
                "nome": "São Sebastião da Vargem Alegre"
            },
            {
                "codigo_ibge": 3164472,
                "nome": "São Sebastião do Anta"
            },
            {
                "codigo_ibge": 3164506,
                "nome": "São Sebastião do Maranhão"
            },
            {
                "codigo_ibge": 3164605,
                "nome": "São Sebastião do Oeste"
            },
            {
                "codigo_ibge": 3164704,
                "nome": "São Sebastião do Paraíso"
            },
            {
                "codigo_ibge": 3164803,
                "nome": "São Sebastião do Rio Preto"
            },
            {
                "codigo_ibge": 3164902,
                "nome": "São Sebastião do Rio Verde"
            },
            {
                "codigo_ibge": 3165206,
                "nome": "São Thomé das Letras"
            },
            {
                "codigo_ibge": 3165008,
                "nome": "São Tiago"
            },
            {
                "codigo_ibge": 3165107,
                "nome": "São Tomás de Aquino"
            },
            {
                "codigo_ibge": 3165305,
                "nome": "São Vicente de Minas"
            },
            {
                "codigo_ibge": 3165404,
                "nome": "Sapucaí-Mirim"
            },
            {
                "codigo_ibge": 3165503,
                "nome": "Sardoá"
            },
            {
                "codigo_ibge": 3165537,
                "nome": "Sarzedo"
            },
            {
                "codigo_ibge": 3165560,
                "nome": "Sem-Peixe"
            },
            {
                "codigo_ibge": 3165578,
                "nome": "Senador Amaral"
            },
            {
                "codigo_ibge": 3165602,
                "nome": "Senador Cortes"
            },
            {
                "codigo_ibge": 3165701,
                "nome": "Senador Firmino"
            },
            {
                "codigo_ibge": 3165800,
                "nome": "Senador José Bento"
            },
            {
                "codigo_ibge": 3165909,
                "nome": "Senador Modestino Gonçalves"
            },
            {
                "codigo_ibge": 3166006,
                "nome": "Senhora de Oliveira"
            },
            {
                "codigo_ibge": 3166105,
                "nome": "Senhora do Porto"
            },
            {
                "codigo_ibge": 3166204,
                "nome": "Senhora dos Remédios"
            },
            {
                "codigo_ibge": 3166303,
                "nome": "Sericita"
            },
            {
                "codigo_ibge": 3166402,
                "nome": "Seritinga"
            },
            {
                "codigo_ibge": 3166501,
                "nome": "Serra Azul de Minas"
            },
            {
                "codigo_ibge": 3166600,
                "nome": "Serra da Saudade"
            },
            {
                "codigo_ibge": 3166808,
                "nome": "Serra do Salitre"
            },
            {
                "codigo_ibge": 3166709,
                "nome": "Serra dos Aimorés"
            },
            {
                "codigo_ibge": 3166907,
                "nome": "Serrania"
            },
            {
                "codigo_ibge": 3166956,
                "nome": "Serranópolis de Minas"
            },
            {
                "codigo_ibge": 3167004,
                "nome": "Serranos"
            },
            {
                "codigo_ibge": 3167103,
                "nome": "Serro"
            },
            {
                "codigo_ibge": 3167202,
                "nome": "Sete Lagoas"
            },
            {
                "codigo_ibge": 3165552,
                "nome": "Setubinha"
            },
            {
                "codigo_ibge": 3167301,
                "nome": "Silveirânia"
            },
            {
                "codigo_ibge": 3167400,
                "nome": "Silvianópolis"
            },
            {
                "codigo_ibge": 3167509,
                "nome": "Simão Pereira"
            },
            {
                "codigo_ibge": 3167608,
                "nome": "Simonésia"
            },
            {
                "codigo_ibge": 3167707,
                "nome": "Sobrália"
            },
            {
                "codigo_ibge": 3167806,
                "nome": "Soledade de Minas"
            },
            {
                "codigo_ibge": 3167905,
                "nome": "Tabuleiro"
            },
            {
                "codigo_ibge": 3168002,
                "nome": "Taiobeiras"
            },
            {
                "codigo_ibge": 3168051,
                "nome": "Taparuba"
            },
            {
                "codigo_ibge": 3168101,
                "nome": "Tapira"
            },
            {
                "codigo_ibge": 3168200,
                "nome": "Tapiraí"
            },
            {
                "codigo_ibge": 3168309,
                "nome": "Taquaraçu de Minas"
            },
            {
                "codigo_ibge": 3168408,
                "nome": "Tarumirim"
            },
            {
                "codigo_ibge": 3168507,
                "nome": "Teixeiras"
            },
            {
                "codigo_ibge": 3168606,
                "nome": "Teófilo Otoni"
            },
            {
                "codigo_ibge": 3168705,
                "nome": "Timóteo"
            },
            {
                "codigo_ibge": 3168804,
                "nome": "Tiradentes"
            },
            {
                "codigo_ibge": 3168903,
                "nome": "Tiros"
            },
            {
                "codigo_ibge": 3169000,
                "nome": "Tocantins"
            },
            {
                "codigo_ibge": 3169059,
                "nome": "Tocos do Moji"
            },
            {
                "codigo_ibge": 3169109,
                "nome": "Toledo"
            },
            {
                "codigo_ibge": 3169208,
                "nome": "Tombos"
            },
            {
                "codigo_ibge": 3169307,
                "nome": "Três Corações"
            },
            {
                "codigo_ibge": 3169356,
                "nome": "Três Marias"
            },
            {
                "codigo_ibge": 3169406,
                "nome": "Três Pontas"
            },
            {
                "codigo_ibge": 3169505,
                "nome": "Tumiritinga"
            },
            {
                "codigo_ibge": 3169604,
                "nome": "Tupaciguara"
            },
            {
                "codigo_ibge": 3169703,
                "nome": "Turmalina"
            },
            {
                "codigo_ibge": 3169802,
                "nome": "Turvolândia"
            },
            {
                "codigo_ibge": 3169901,
                "nome": "Ubá"
            },
            {
                "codigo_ibge": 3170008,
                "nome": "Ubaí"
            },
            {
                "codigo_ibge": 3170057,
                "nome": "Ubaporanga"
            },
            {
                "codigo_ibge": 3170107,
                "nome": "Uberaba"
            },
            {
                "codigo_ibge": 3170206,
                "nome": "Uberlândia"
            },
            {
                "codigo_ibge": 3170305,
                "nome": "Umburatiba"
            },
            {
                "codigo_ibge": 3170404,
                "nome": "Unaí"
            },
            {
                "codigo_ibge": 3170438,
                "nome": "União de Minas"
            },
            {
                "codigo_ibge": 3170479,
                "nome": "Uruana de Minas"
            },
            {
                "codigo_ibge": 3170503,
                "nome": "Urucânia"
            },
            {
                "codigo_ibge": 3170529,
                "nome": "Urucuia"
            },
            {
                "codigo_ibge": 3170578,
                "nome": "Vargem Alegre"
            },
            {
                "codigo_ibge": 3170602,
                "nome": "Vargem Bonita"
            },
            {
                "codigo_ibge": 3170651,
                "nome": "Vargem Grande do Rio Pardo"
            },
            {
                "codigo_ibge": 3170701,
                "nome": "Varginha"
            },
            {
                "codigo_ibge": 3170750,
                "nome": "Varjão de Minas"
            },
            {
                "codigo_ibge": 3170800,
                "nome": "Várzea da Palma"
            },
            {
                "codigo_ibge": 3170909,
                "nome": "Varzelândia"
            },
            {
                "codigo_ibge": 3171006,
                "nome": "Vazante"
            },
            {
                "codigo_ibge": 3171030,
                "nome": "Verdelândia"
            },
            {
                "codigo_ibge": 3171071,
                "nome": "Veredinha"
            },
            {
                "codigo_ibge": 3171105,
                "nome": "Veríssimo"
            },
            {
                "codigo_ibge": 3171154,
                "nome": "Vermelho Novo"
            },
            {
                "codigo_ibge": 3171204,
                "nome": "Vespasiano"
            },
            {
                "codigo_ibge": 3171303,
                "nome": "Viçosa"
            },
            {
                "codigo_ibge": 3171402,
                "nome": "Vieiras"
            },
            {
                "codigo_ibge": 3171600,
                "nome": "Virgem da Lapa"
            },
            {
                "codigo_ibge": 3171709,
                "nome": "Virgínia"
            },
            {
                "codigo_ibge": 3171808,
                "nome": "Virginópolis"
            },
            {
                "codigo_ibge": 3171907,
                "nome": "Virgolândia"
            },
            {
                "codigo_ibge": 3172004,
                "nome": "Visconde do Rio Branco"
            },
            {
                "codigo_ibge": 3172103,
                "nome": "Volta Grande"
            },
            {
                "codigo_ibge": 3172202,
                "nome": "Wenceslau Braz"
            }
        ]
    },
    "MS": {
        "nome": "Mato Grosso do Sul",
        "municipios": [
            {
                "codigo_ibge": 5000203,
                "nome": "Água Clara"
            },
            {
                "codigo_ibge": 5000252,
                "nome": "Alcinópolis"
            },
            {
                "codigo_ibge": 5000609,
                "nome": "Amambai"
            },
            {
                "codigo_ibge": 5000708,
                "nome": "Anastácio"
            },
            {
                "codigo_ibge": 5000807,
                "nome": "Anaurilândia"
            },
            {
                "codigo_ibge": 5000856,
                "nome": "Angélica"
            },
            {
                "codigo_ibge": 5000906,
                "nome": "Antônio João"
            },
            {
                "codigo_ibge": 5001003,
                "nome": "Aparecida do Taboado"
            },
            {
                "codigo_ibge": 5001102,
                "nome": "Aquidauana"
            },
            {
                "codigo_ibge": 5001243,
                "nome": "Aral Moreira"
            },
            {
                "codigo_ibge": 5001508,
                "nome": "Bandeirantes"
            },
            {
                "codigo_ibge": 5001904,
                "nome": "Bataguassu"
            },
            {
                "codigo_ibge": 5002001,
                "nome": "Batayporã"
            },
            {
                "codigo_ibge": 5002100,
                "nome": "Bela Vista"
            },
            {
                "codigo_ibge": 5002159,
                "nome": "Bodoquena"
            },
            {
                "codigo_ibge": 5002209,
                "nome": "Bonito"
            },
            {
                "codigo_ibge": 5002308,
                "nome": "Brasilândia"
            },
            {
                "codigo_ibge": 5002407,
                "nome": "Caarapó"
            },
            {
                "codigo_ibge": 5002605,
                "nome": "Camapuã"
            },
            {
                "codigo_ibge": 5002704,
                "nome": "Campo Grande"
            },
            {
                "codigo_ibge": 5002803,
                "nome": "Caracol"
            },
            {
                "codigo_ibge": 5002902,
                "nome": "Cassilândia"
            },
            {
                "codigo_ibge": 5002951,
                "nome": "Chapadão do Sul"
            },
            {
                "codigo_ibge": 5003108,
                "nome": "Corguinho"
            },
            {
                "codigo_ibge": 5003157,
                "nome": "Coronel Sapucaia"
            },
            {
                "codigo_ibge": 5003207,
                "nome": "Corumbá"
            },
            {
                "codigo_ibge": 5003256,
                "nome": "Costa Rica"
            },
            {
                "codigo_ibge": 5003306,
                "nome": "Coxim"
            },
            {
                "codigo_ibge": 5003454,
                "nome": "Deodápolis"
            },
            {
                "codigo_ibge": 5003488,
                "nome": "Dois Irmãos do Buriti"
            },
            {
                "codigo_ibge": 5003504,
                "nome": "Douradina"
            },
            {
                "codigo_ibge": 5003702,
                "nome": "Dourados"
            },
            {
                "codigo_ibge": 5003751,
                "nome": "Eldorado"
            },
            {
                "codigo_ibge": 5003801,
                "nome": "Fátima do Sul"
            },
            {
                "codigo_ibge": 5003900,
                "nome": "Figueirão"
            },
            {
                "codigo_ibge": 5004007,
                "nome": "Glória de Dourados"
            },
            {
                "codigo_ibge": 5004106,
                "nome": "Guia Lopes da Laguna"
            },
            {
                "codigo_ibge": 5004304,
                "nome": "Iguatemi"
            },
            {
                "codigo_ibge": 5004403,
                "nome": "Inocência"
            },
            {
                "codigo_ibge": 5004502,
                "nome": "Itaporã"
            },
            {
                "codigo_ibge": 5004601,
                "nome": "Itaquiraí"
            },
            {
                "codigo_ibge": 5004700,
                "nome": "Ivinhema"
            },
            {
                "codigo_ibge": 5004809,
                "nome": "Japorã"
            },
            {
                "codigo_ibge": 5004908,
                "nome": "Jaraguari"
            },
            {
                "codigo_ibge": 5005004,
                "nome": "Jardim"
            },
            {
                "codigo_ibge": 5005103,
                "nome": "Jateí"
            },
            {
                "codigo_ibge": 5005152,
                "nome": "Juti"
            },
            {
                "codigo_ibge": 5005202,
                "nome": "Ladário"
            },
            {
                "codigo_ibge": 5005251,
                "nome": "Laguna Carapã"
            },
            {
                "codigo_ibge": 5005400,
                "nome": "Maracaju"
            },
            {
                "codigo_ibge": 5005608,
                "nome": "Miranda"
            },
            {
                "codigo_ibge": 5005681,
                "nome": "Mundo Novo"
            },
            {
                "codigo_ibge": 5005707,
                "nome": "Naviraí"
            },
            {
                "codigo_ibge": 5005806,
                "nome": "Nioaque"
            },
            {
                "codigo_ibge": 5006002,
                "nome": "Nova Alvorada do Sul"
            },
            {
                "codigo_ibge": 5006200,
                "nome": "Nova Andradina"
            },
            {
                "codigo_ibge": 5006259,
                "nome": "Novo Horizonte do Sul"
            },
            {
                "codigo_ibge": 5006275,
                "nome": "Paraíso das Águas"
            },
            {
                "codigo_ibge": 5006309,
                "nome": "Paranaíba"
            },
            {
                "codigo_ibge": 5006358,
                "nome": "Paranhos"
            },
            {
                "codigo_ibge": 5006408,
                "nome": "Pedro Gomes"
            },
            {
                "codigo_ibge": 5006606,
                "nome": "Ponta Porã"
            },
            {
                "codigo_ibge": 5006903,
                "nome": "Porto Murtinho"
            },
            {
                "codigo_ibge": 5007109,
                "nome": "Ribas do Rio Pardo"
            },
            {
                "codigo_ibge": 5007208,
                "nome": "Rio Brilhante"
            },
            {
                "codigo_ibge": 5007307,
                "nome": "Rio Negro"
            },
            {
                "codigo_ibge": 5007406,
                "nome": "Rio Verde de Mato Grosso"
            },
            {
                "codigo_ibge": 5007505,
                "nome": "Rochedo"
            },
            {
                "codigo_ibge": 5007554,
                "nome": "Santa Rita do Pardo"
            },
            {
                "codigo_ibge": 5007695,
                "nome": "São Gabriel do Oeste"
            },
            {
                "codigo_ibge": 5007802,
                "nome": "Selvíria"
            },
            {
                "codigo_ibge": 5007703,
                "nome": "Sete Quedas"
            },
            {
                "codigo_ibge": 5007901,
                "nome": "Sidrolândia"
            },
            {
                "codigo_ibge": 5007935,
                "nome": "Sonora"
            },
            {
                "codigo_ibge": 5007950,
                "nome": "Tacuru"
            },
            {
                "codigo_ibge": 5007976,
                "nome": "Taquarussu"
            },
            {
                "codigo_ibge": 5008008,
                "nome": "Terenos"
            },
            {
                "codigo_ibge": 5008305,
                "nome": "Três Lagoas"
            },
            {
                "codigo_ibge": 5008404,
                "nome": "Vicentina"
            }
        ]
    },
    "MT": {
        "nome": "Mato Grosso",
        "municipios": [
            {
                "codigo_ibge": 5100102,
                "nome": "Acorizal"
            },
            {
                "codigo_ibge": 5100201,
                "nome": "Água Boa"
            },
            {
                "codigo_ibge": 5100250,
                "nome": "Alta Floresta"
            },
            {
                "codigo_ibge": 5100300,
                "nome": "Alto Araguaia"
            },
            {
                "codigo_ibge": 5100359,
                "nome": "Alto Boa Vista"
            },
            {
                "codigo_ibge": 5100409,
                "nome": "Alto Garças"
            },
            {
                "codigo_ibge": 5100508,
                "nome": "Alto Paraguai"
            },
            {
                "codigo_ibge": 5100607,
                "nome": "Alto Taquari"
            },
            {
                "codigo_ibge": 5100805,
                "nome": "Apiacás"
            },
            {
                "codigo_ibge": 5101001,
                "nome": "Araguaiana"
            },
            {
                "codigo_ibge": 5101209,
                "nome": "Araguainha"
            },
            {
                "codigo_ibge": 5101258,
                "nome": "Araputanga"
            },
            {
                "codigo_ibge": 5101308,
                "nome": "Arenápolis"
            },
            {
                "codigo_ibge": 5101407,
                "nome": "Aripuanã"
            },
            {
                "codigo_ibge": 5101605,
                "nome": "Barão de Melgaço"
            },
            {
                "codigo_ibge": 5101704,
                "nome": "Barra do Bugres"
            },
            {
                "codigo_ibge": 5101803,
                "nome": "Barra do Garças"
            },
            {
                "codigo_ibge": 5101852,
                "nome": "Bom Jesus do Araguaia"
            },
            {
                "codigo_ibge": 5101902,
                "nome": "Brasnorte"
            },
            {
                "codigo_ibge": 5102504,
                "nome": "Cáceres"
            },
            {
                "codigo_ibge": 5102603,
                "nome": "Campinápolis"
            },
            {
                "codigo_ibge": 5102637,
                "nome": "Campo Novo do Parecis"
            },
            {
                "codigo_ibge": 5102678,
                "nome": "Campo Verde"
            },
            {
                "codigo_ibge": 5102686,
                "nome": "Campos de Júlio"
            },
            {
                "codigo_ibge": 5102694,
                "nome": "Canabrava do Norte"
            },
            {
                "codigo_ibge": 5102702,
                "nome": "Canarana"
            },
            {
                "codigo_ibge": 5102793,
                "nome": "Carlinda"
            },
            {
                "codigo_ibge": 5102850,
                "nome": "Castanheira"
            },
            {
                "codigo_ibge": 5103007,
                "nome": "Chapada dos Guimarães"
            },
            {
                "codigo_ibge": 5103056,
                "nome": "Cláudia"
            },
            {
                "codigo_ibge": 5103106,
                "nome": "Cocalinho"
            },
            {
                "codigo_ibge": 5103205,
                "nome": "Colíder"
            },
            {
                "codigo_ibge": 5103254,
                "nome": "Colniza"
            },
            {
                "codigo_ibge": 5103304,
                "nome": "Comodoro"
            },
            {
                "codigo_ibge": 5103353,
                "nome": "Confresa"
            },
            {
                "codigo_ibge": 5103361,
                "nome": "Conquista D'Oeste"
            },
            {
                "codigo_ibge": 5103379,
                "nome": "Cotriguaçu"
            },
            {
                "codigo_ibge": 5103403,
                "nome": "Cuiabá"
            },
            {
                "codigo_ibge": 5103437,
                "nome": "Curvelândia"
            },
            {
                "codigo_ibge": 5103452,
                "nome": "Denise"
            },
            {
                "codigo_ibge": 5103502,
                "nome": "Diamantino"
            },
            {
                "codigo_ibge": 5103601,
                "nome": "Dom Aquino"
            },
            {
                "codigo_ibge": 5103700,
                "nome": "Feliz Natal"
            },
            {
                "codigo_ibge": 5103809,
                "nome": "Figueirópolis D'Oeste"
            },
            {
                "codigo_ibge": 5103858,
                "nome": "Gaúcha do Norte"
            },
            {
                "codigo_ibge": 5103908,
                "nome": "General Carneiro"
            },
            {
                "codigo_ibge": 5103957,
                "nome": "Glória D'Oeste"
            },
            {
                "codigo_ibge": 5104104,
                "nome": "Guarantã do Norte"
            },
            {
                "codigo_ibge": 5104203,
                "nome": "Guiratinga"
            },
            {
                "codigo_ibge": 5104500,
                "nome": "Indiavaí"
            },
            {
                "codigo_ibge": 5104526,
                "nome": "Ipiranga do Norte"
            },
            {
                "codigo_ibge": 5104542,
                "nome": "Itanhangá"
            },
            {
                "codigo_ibge": 5104559,
                "nome": "Itaúba"
            },
            {
                "codigo_ibge": 5104609,
                "nome": "Itiquira"
            },
            {
                "codigo_ibge": 5104807,
                "nome": "Jaciara"
            },
            {
                "codigo_ibge": 5104906,
                "nome": "Jangada"
            },
            {
                "codigo_ibge": 5105002,
                "nome": "Jauru"
            },
            {
                "codigo_ibge": 5105101,
                "nome": "Juara"
            },
            {
                "codigo_ibge": 5105150,
                "nome": "Juína"
            },
            {
                "codigo_ibge": 5105176,
                "nome": "Juruena"
            },
            {
                "codigo_ibge": 5105200,
                "nome": "Juscimeira"
            },
            {
                "codigo_ibge": 5105234,
                "nome": "Lambari D'Oeste"
            },
            {
                "codigo_ibge": 5105259,
                "nome": "Lucas do Rio Verde"
            },
            {
                "codigo_ibge": 5105309,
                "nome": "Luciara"
            },
            {
                "codigo_ibge": 5105580,
                "nome": "Marcelândia"
            },
            {
                "codigo_ibge": 5105606,
                "nome": "Matupá"
            },
            {
                "codigo_ibge": 5105622,
                "nome": "Mirassol d'Oeste"
            },
            {
                "codigo_ibge": 5105903,
                "nome": "Nobres"
            },
            {
                "codigo_ibge": 5106000,
                "nome": "Nortelândia"
            },
            {
                "codigo_ibge": 5106109,
                "nome": "Nossa Senhora do Livramento"
            },
            {
                "codigo_ibge": 5106158,
                "nome": "Nova Bandeirantes"
            },
            {
                "codigo_ibge": 5106208,
                "nome": "Nova Brasilândia"
            },
            {
                "codigo_ibge": 5106216,
                "nome": "Nova Canaã do Norte"
            },
            {
                "codigo_ibge": 5108808,
                "nome": "Nova Guarita"
            },
            {
                "codigo_ibge": 5106182,
                "nome": "Nova Lacerda"
            },
            {
                "codigo_ibge": 5108857,
                "nome": "Nova Marilândia"
            },
            {
                "codigo_ibge": 5108907,
                "nome": "Nova Maringá"
            },
            {
                "codigo_ibge": 5108956,
                "nome": "Nova Monte Verde"
            },
            {
                "codigo_ibge": 5106224,
                "nome": "Nova Mutum"
            },
            {
                "codigo_ibge": 5106174,
                "nome": "Nova Nazaré"
            },
            {
                "codigo_ibge": 5106232,
                "nome": "Nova Olímpia"
            },
            {
                "codigo_ibge": 5106190,
                "nome": "Nova Santa Helena"
            },
            {
                "codigo_ibge": 5106240,
                "nome": "Nova Ubiratã"
            },
            {
                "codigo_ibge": 5106257,
                "nome": "Nova Xavantina"
            },
            {
                "codigo_ibge": 5106273,
                "nome": "Novo Horizonte do Norte"
            },
            {
                "codigo_ibge": 5106265,
                "nome": "Novo Mundo"
            },
            {
                "codigo_ibge": 5106315,
                "nome": "Novo Santo Antônio"
            },
            {
                "codigo_ibge": 5106281,
                "nome": "Novo São Joaquim"
            },
            {
                "codigo_ibge": 5106299,
                "nome": "Paranaíta"
            },
            {
                "codigo_ibge": 5106307,
                "nome": "Paranatinga"
            },
            {
                "codigo_ibge": 5106372,
                "nome": "Pedra Preta"
            },
            {
                "codigo_ibge": 5106422,
                "nome": "Peixoto de Azevedo"
            },
            {
                "codigo_ibge": 5106455,
                "nome": "Planalto da Serra"
            },
            {
                "codigo_ibge": 5106505,
                "nome": "Poconé"
            },
            {
                "codigo_ibge": 5106653,
                "nome": "Pontal do Araguaia"
            },
            {
                "codigo_ibge": 5106703,
                "nome": "Ponte Branca"
            },
            {
                "codigo_ibge": 5106752,
                "nome": "Pontes e Lacerda"
            },
            {
                "codigo_ibge": 5106778,
                "nome": "Porto Alegre do Norte"
            },
            {
                "codigo_ibge": 5106802,
                "nome": "Porto dos Gaúchos"
            },
            {
                "codigo_ibge": 5106828,
                "nome": "Porto Esperidião"
            },
            {
                "codigo_ibge": 5106851,
                "nome": "Porto Estrela"
            },
            {
                "codigo_ibge": 5107008,
                "nome": "Poxoréu"
            },
            {
                "codigo_ibge": 5107040,
                "nome": "Primavera do Leste"
            },
            {
                "codigo_ibge": 5107065,
                "nome": "Querência"
            },
            {
                "codigo_ibge": 5107156,
                "nome": "Reserva do Cabaçal"
            },
            {
                "codigo_ibge": 5107180,
                "nome": "Ribeirão Cascalheira"
            },
            {
                "codigo_ibge": 5107198,
                "nome": "Ribeirãozinho"
            },
            {
                "codigo_ibge": 5107206,
                "nome": "Rio Branco"
            },
            {
                "codigo_ibge": 5107578,
                "nome": "Rondolândia"
            },
            {
                "codigo_ibge": 5107602,
                "nome": "Rondonópolis"
            },
            {
                "codigo_ibge": 5107701,
                "nome": "Rosário Oeste"
            },
            {
                "codigo_ibge": 5107750,
                "nome": "Salto do Céu"
            },
            {
                "codigo_ibge": 5107248,
                "nome": "Santa Carmem"
            },
            {
                "codigo_ibge": 5107743,
                "nome": "Santa Cruz do Xingu"
            },
            {
                "codigo_ibge": 5107768,
                "nome": "Santa Rita do Trivelato"
            },
            {
                "codigo_ibge": 5107776,
                "nome": "Santa Terezinha"
            },
            {
                "codigo_ibge": 5107263,
                "nome": "Santo Afonso"
            },
            {
                "codigo_ibge": 5107792,
                "nome": "Santo Antônio do Leste"
            },
            {
                "codigo_ibge": 5107800,
                "nome": "Santo Antônio do Leverger"
            },
            {
                "codigo_ibge": 5107859,
                "nome": "São Félix do Araguaia"
            },
            {
                "codigo_ibge": 5107297,
                "nome": "São José do Povo"
            },
            {
                "codigo_ibge": 5107305,
                "nome": "São José do Rio Claro"
            },
            {
                "codigo_ibge": 5107354,
                "nome": "São José do Xingu"
            },
            {
                "codigo_ibge": 5107107,
                "nome": "São José dos Quatro Marcos"
            },
            {
                "codigo_ibge": 5107404,
                "nome": "São Pedro da Cipa"
            },
            {
                "codigo_ibge": 5107875,
                "nome": "Sapezal"
            },
            {
                "codigo_ibge": 5107883,
                "nome": "Serra Nova Dourada"
            },
            {
                "codigo_ibge": 5107909,
                "nome": "Sinop"
            },
            {
                "codigo_ibge": 5107925,
                "nome": "Sorriso"
            },
            {
                "codigo_ibge": 5107941,
                "nome": "Tabaporã"
            },
            {
                "codigo_ibge": 5107958,
                "nome": "Tangará da Serra"
            },
            {
                "codigo_ibge": 5108006,
                "nome": "Tapurah"
            },
            {
                "codigo_ibge": 5108055,
                "nome": "Terra Nova do Norte"
            },
            {
                "codigo_ibge": 5108105,
                "nome": "Tesouro"
            },
            {
                "codigo_ibge": 5108204,
                "nome": "Torixoréu"
            },
            {
                "codigo_ibge": 5108303,
                "nome": "União do Sul"
            },
            {
                "codigo_ibge": 5108352,
                "nome": "Vale de São Domingos"
            },
            {
                "codigo_ibge": 5108402,
                "nome": "Várzea Grande"
            },
            {
                "codigo_ibge": 5108501,
                "nome": "Vera"
            },
            {
                "codigo_ibge": 5105507,
                "nome": "Vila Bela da Santíssima Trindade"
            },
            {
                "codigo_ibge": 5108600,
                "nome": "Vila Rica"
            }
        ]
    },
    "PA": {
        "nome": "Pará",
        "municipios": [
            {
                "codigo_ibge": 1500107,
                "nome": "Abaetetuba"
            },
            {
                "codigo_ibge": 1500131,
                "nome": "Abel Figueiredo"
            },
            {
                "codigo_ibge": 1500206,
                "nome": "Acará"
            },
            {
                "codigo_ibge": 1500305,
                "nome": "Afuá"
            },
            {
                "codigo_ibge": 1500347,
                "nome": "Água Azul do Norte"
            },
            {
                "codigo_ibge": 1500404,
                "nome": "Alenquer"
            },
            {
                "codigo_ibge": 1500503,
                "nome": "Almeirim"
            },
            {
                "codigo_ibge": 1500602,
                "nome": "Altamira"
            },
            {
                "codigo_ibge": 1500701,
                "nome": "Anajás"
            },
            {
                "codigo_ibge": 1500800,
                "nome": "Ananindeua"
            },
            {
                "codigo_ibge": 1500859,
                "nome": "Anapu"
            },
            {
                "codigo_ibge": 1500909,
                "nome": "Augusto Corrêa"
            },
            {
                "codigo_ibge": 1500958,
                "nome": "Aurora do Pará"
            },
            {
                "codigo_ibge": 1501006,
                "nome": "Aveiro"
            },
            {
                "codigo_ibge": 1501105,
                "nome": "Bagre"
            },
            {
                "codigo_ibge": 1501204,
                "nome": "Baião"
            },
            {
                "codigo_ibge": 1501253,
                "nome": "Bannach"
            },
            {
                "codigo_ibge": 1501303,
                "nome": "Barcarena"
            },
            {
                "codigo_ibge": 1501402,
                "nome": "Belém"
            },
            {
                "codigo_ibge": 1501451,
                "nome": "Belterra"
            },
            {
                "codigo_ibge": 1501501,
                "nome": "Benevides"
            },
            {
                "codigo_ibge": 1501576,
                "nome": "Bom Jesus do Tocantins"
            },
            {
                "codigo_ibge": 1501600,
                "nome": "Bonito"
            },
            {
                "codigo_ibge": 1501709,
                "nome": "Bragança"
            },
            {
                "codigo_ibge": 1501725,
                "nome": "Brasil Novo"
            },
            {
                "codigo_ibge": 1501758,
                "nome": "Brejo Grande do Araguaia"
            },
            {
                "codigo_ibge": 1501782,
                "nome": "Breu Branco"
            },
            {
                "codigo_ibge": 1501808,
                "nome": "Breves"
            },
            {
                "codigo_ibge": 1501907,
                "nome": "Bujaru"
            },
            {
                "codigo_ibge": 1502004,
                "nome": "Cachoeira do Arari"
            },
            {
                "codigo_ibge": 1501956,
                "nome": "Cachoeira do Piriá"
            },
            {
                "codigo_ibge": 1502103,
                "nome": "Cametá"
            },
            {
                "codigo_ibge": 1502152,
                "nome": "Canaã dos Carajás"
            },
            {
                "codigo_ibge": 1502202,
                "nome": "Capanema"
            },
            {
                "codigo_ibge": 1502301,
                "nome": "Capitão Poço"
            },
            {
                "codigo_ibge": 1502400,
                "nome": "Castanhal"
            },
            {
                "codigo_ibge": 1502509,
                "nome": "Chaves"
            },
            {
                "codigo_ibge": 1502608,
                "nome": "Colares"
            },
            {
                "codigo_ibge": 1502707,
                "nome": "Conceição do Araguaia"
            },
            {
                "codigo_ibge": 1502756,
                "nome": "Concórdia do Pará"
            },
            {
                "codigo_ibge": 1502764,
                "nome": "Cumaru do Norte"
            },
            {
                "codigo_ibge": 1502772,
                "nome": "Curionópolis"
            },
            {
                "codigo_ibge": 1502806,
                "nome": "Curralinho"
            },
            {
                "codigo_ibge": 1502855,
                "nome": "Curuá"
            },
            {
                "codigo_ibge": 1502905,
                "nome": "Curuçá"
            },
            {
                "codigo_ibge": 1502939,
                "nome": "Dom Eliseu"
            },
            {
                "codigo_ibge": 1502954,
                "nome": "Eldorado do Carajás"
            },
            {
                "codigo_ibge": 1503002,
                "nome": "Faro"
            },
            {
                "codigo_ibge": 1503044,
                "nome": "Floresta do Araguaia"
            },
            {
                "codigo_ibge": 1503077,
                "nome": "Garrafão do Norte"
            },
            {
                "codigo_ibge": 1503093,
                "nome": "Goianésia do Pará"
            },
            {
                "codigo_ibge": 1503101,
                "nome": "Gurupá"
            },
            {
                "codigo_ibge": 1503200,
                "nome": "Igarapé-Açu"
            },
            {
                "codigo_ibge": 1503309,
                "nome": "Igarapé-Miri"
            },
            {
                "codigo_ibge": 1503408,
                "nome": "Inhangapi"
            },
            {
                "codigo_ibge": 1503457,
                "nome": "Ipixuna do Pará"
            },
            {
                "codigo_ibge": 1503507,
                "nome": "Irituia"
            },
            {
                "codigo_ibge": 1503606,
                "nome": "Itaituba"
            },
            {
                "codigo_ibge": 1503705,
                "nome": "Itupiranga"
            },
            {
                "codigo_ibge": 1503754,
                "nome": "Jacareacanga"
            },
            {
                "codigo_ibge": 1503804,
                "nome": "Jacundá"
            },
            {
                "codigo_ibge": 1503903,
                "nome": "Juruti"
            },
            {
                "codigo_ibge": 1504000,
                "nome": "Limoeiro do Ajuru"
            },
            {
                "codigo_ibge": 1504059,
                "nome": "Mãe do Rio"
            },
            {
                "codigo_ibge": 1504109,
                "nome": "Magalhães Barata"
            },
            {
                "codigo_ibge": 1504208,
                "nome": "Marabá"
            },
            {
                "codigo_ibge": 1504307,
                "nome": "Maracanã"
            },
            {
                "codigo_ibge": 1504406,
                "nome": "Marapanim"
            },
            {
                "codigo_ibge": 1504422,
                "nome": "Marituba"
            },
            {
                "codigo_ibge": 1504455,
                "nome": "Medicilândia"
            },
            {
                "codigo_ibge": 1504505,
                "nome": "Melgaço"
            },
            {
                "codigo_ibge": 1504604,
                "nome": "Mocajuba"
            },
            {
                "codigo_ibge": 1504703,
                "nome": "Moju"
            },
            {
                "codigo_ibge": 1504752,
                "nome": "Mojuí dos Campos"
            },
            {
                "codigo_ibge": 1504802,
                "nome": "Monte Alegre"
            },
            {
                "codigo_ibge": 1504901,
                "nome": "Muaná"
            },
            {
                "codigo_ibge": 1504950,
                "nome": "Nova Esperança do Piriá"
            },
            {
                "codigo_ibge": 1504976,
                "nome": "Nova Ipixuna"
            },
            {
                "codigo_ibge": 1505007,
                "nome": "Nova Timboteua"
            },
            {
                "codigo_ibge": 1505031,
                "nome": "Novo Progresso"
            },
            {
                "codigo_ibge": 1505064,
                "nome": "Novo Repartimento"
            },
            {
                "codigo_ibge": 1505106,
                "nome": "Óbidos"
            },
            {
                "codigo_ibge": 1505205,
                "nome": "Oeiras do Pará"
            },
            {
                "codigo_ibge": 1505304,
                "nome": "Oriximiná"
            },
            {
                "codigo_ibge": 1505403,
                "nome": "Ourém"
            },
            {
                "codigo_ibge": 1505437,
                "nome": "Ourilândia do Norte"
            },
            {
                "codigo_ibge": 1505486,
                "nome": "Pacajá"
            },
            {
                "codigo_ibge": 1505494,
                "nome": "Palestina do Pará"
            },
            {
                "codigo_ibge": 1505502,
                "nome": "Paragominas"
            },
            {
                "codigo_ibge": 1505536,
                "nome": "Parauapebas"
            },
            {
                "codigo_ibge": 1505551,
                "nome": "Pau d'Arco"
            },
            {
                "codigo_ibge": 1505601,
                "nome": "Peixe-Boi"
            },
            {
                "codigo_ibge": 1505635,
                "nome": "Piçarra"
            },
            {
                "codigo_ibge": 1505650,
                "nome": "Placas"
            },
            {
                "codigo_ibge": 1505700,
                "nome": "Ponta de Pedras"
            },
            {
                "codigo_ibge": 1505809,
                "nome": "Portel"
            },
            {
                "codigo_ibge": 1505908,
                "nome": "Porto de Moz"
            },
            {
                "codigo_ibge": 1506005,
                "nome": "Prainha"
            },
            {
                "codigo_ibge": 1506104,
                "nome": "Primavera"
            },
            {
                "codigo_ibge": 1506112,
                "nome": "Quatipuru"
            },
            {
                "codigo_ibge": 1506138,
                "nome": "Redenção"
            },
            {
                "codigo_ibge": 1506161,
                "nome": "Rio Maria"
            },
            {
                "codigo_ibge": 1506187,
                "nome": "Rondon do Pará"
            },
            {
                "codigo_ibge": 1506195,
                "nome": "Rurópolis"
            },
            {
                "codigo_ibge": 1506203,
                "nome": "Salinópolis"
            },
            {
                "codigo_ibge": 1506302,
                "nome": "Salvaterra"
            },
            {
                "codigo_ibge": 1506351,
                "nome": "Santa Bárbara do Pará"
            },
            {
                "codigo_ibge": 1506401,
                "nome": "Santa Cruz do Arari"
            },
            {
                "codigo_ibge": 1506500,
                "nome": "Santa Izabel do Pará"
            },
            {
                "codigo_ibge": 1506559,
                "nome": "Santa Luzia do Pará"
            },
            {
                "codigo_ibge": 1506583,
                "nome": "Santa Maria das Barreiras"
            },
            {
                "codigo_ibge": 1506609,
                "nome": "Santa Maria do Pará"
            },
            {
                "codigo_ibge": 1506708,
                "nome": "Santana do Araguaia"
            },
            {
                "codigo_ibge": 1506807,
                "nome": "Santarém"
            },
            {
                "codigo_ibge": 1506906,
                "nome": "Santarém Novo"
            },
            {
                "codigo_ibge": 1507003,
                "nome": "Santo Antônio do Tauá"
            },
            {
                "codigo_ibge": 1507102,
                "nome": "São Caetano de Odivelas"
            },
            {
                "codigo_ibge": 1507151,
                "nome": "São Domingos do Araguaia"
            },
            {
                "codigo_ibge": 1507201,
                "nome": "São Domingos do Capim"
            },
            {
                "codigo_ibge": 1507300,
                "nome": "São Félix do Xingu"
            },
            {
                "codigo_ibge": 1507409,
                "nome": "São Francisco do Pará"
            },
            {
                "codigo_ibge": 1507458,
                "nome": "São Geraldo do Araguaia"
            },
            {
                "codigo_ibge": 1507466,
                "nome": "São João da Ponta"
            },
            {
                "codigo_ibge": 1507474,
                "nome": "São João de Pirabas"
            },
            {
                "codigo_ibge": 1507508,
                "nome": "São João do Araguaia"
            },
            {
                "codigo_ibge": 1507607,
                "nome": "São Miguel do Guamá"
            },
            {
                "codigo_ibge": 1507706,
                "nome": "São Sebastião da Boa Vista"
            },
            {
                "codigo_ibge": 1507755,
                "nome": "Sapucaia"
            },
            {
                "codigo_ibge": 1507805,
                "nome": "Senador José Porfírio"
            },
            {
                "codigo_ibge": 1507904,
                "nome": "Soure"
            },
            {
                "codigo_ibge": 1507953,
                "nome": "Tailândia"
            },
            {
                "codigo_ibge": 1507961,
                "nome": "Terra Alta"
            },
            {
                "codigo_ibge": 1507979,
                "nome": "Terra Santa"
            },
            {
                "codigo_ibge": 1508001,
                "nome": "Tomé-Açu"
            },
            {
                "codigo_ibge": 1508035,
                "nome": "Tracuateua"
            },
            {
                "codigo_ibge": 1508050,
                "nome": "Trairão"
            },
            {
                "codigo_ibge": 1508084,
                "nome": "Tucumã"
            },
            {
                "codigo_ibge": 1508100,
                "nome": "Tucuruí"
            },
            {
                "codigo_ibge": 1508126,
                "nome": "Ulianópolis"
            },
            {
                "codigo_ibge": 1508159,
                "nome": "Uruará"
            },
            {
                "codigo_ibge": 1508209,
                "nome": "Vigia"
            },
            {
                "codigo_ibge": 1508308,
                "nome": "Viseu"
            },
            {
                "codigo_ibge": 1508357,
                "nome": "Vitória do Xingu"
            },
            {
                "codigo_ibge": 1508407,
                "nome": "Xinguara"
            }
        ]
    },
    "PB": {
        "nome": "Paraíba",
        "municipios": [
            {
                "codigo_ibge": 2500106,
                "nome": "Água Branca"
            },
            {
                "codigo_ibge": 2500205,
                "nome": "Aguiar"
            },
            {
                "codigo_ibge": 2500304,
                "nome": "Alagoa Grande"
            },
            {
                "codigo_ibge": 2500403,
                "nome": "Alagoa Nova"
            },
            {
                "codigo_ibge": 2500502,
                "nome": "Alagoinha"
            },
            {
                "codigo_ibge": 2500536,
                "nome": "Alcantil"
            },
            {
                "codigo_ibge": 2500577,
                "nome": "Algodão de Jandaíra"
            },
            {
                "codigo_ibge": 2500601,
                "nome": "Alhandra"
            },
            {
                "codigo_ibge": 2500734,
                "nome": "Amparo"
            },
            {
                "codigo_ibge": 2500775,
                "nome": "Aparecida"
            },
            {
                "codigo_ibge": 2500809,
                "nome": "Araçagi"
            },
            {
                "codigo_ibge": 2500908,
                "nome": "Arara"
            },
            {
                "codigo_ibge": 2501005,
                "nome": "Araruna"
            },
            {
                "codigo_ibge": 2501104,
                "nome": "Areia"
            },
            {
                "codigo_ibge": 2501153,
                "nome": "Areia de Baraúnas"
            },
            {
                "codigo_ibge": 2501203,
                "nome": "Areial"
            },
            {
                "codigo_ibge": 2501302,
                "nome": "Aroeiras"
            },
            {
                "codigo_ibge": 2501351,
                "nome": "Assunção"
            },
            {
                "codigo_ibge": 2501401,
                "nome": "Baía da Traição"
            },
            {
                "codigo_ibge": 2501500,
                "nome": "Bananeiras"
            },
            {
                "codigo_ibge": 2501534,
                "nome": "Baraúna"
            },
            {
                "codigo_ibge": 2501609,
                "nome": "Barra de Santa Rosa"
            },
            {
                "codigo_ibge": 2501575,
                "nome": "Barra de Santana"
            },
            {
                "codigo_ibge": 2501708,
                "nome": "Barra de São Miguel"
            },
            {
                "codigo_ibge": 2501807,
                "nome": "Bayeux"
            },
            {
                "codigo_ibge": 2501906,
                "nome": "Belém"
            },
            {
                "codigo_ibge": 2502003,
                "nome": "Belém do Brejo do Cruz"
            },
            {
                "codigo_ibge": 2502052,
                "nome": "Bernardino Batista"
            },
            {
                "codigo_ibge": 2502102,
                "nome": "Boa Ventura"
            },
            {
                "codigo_ibge": 2502151,
                "nome": "Boa Vista"
            },
            {
                "codigo_ibge": 2502201,
                "nome": "Bom Jesus"
            },
            {
                "codigo_ibge": 2502300,
                "nome": "Bom Sucesso"
            },
            {
                "codigo_ibge": 2502409,
                "nome": "Bonito de Santa Fé"
            },
            {
                "codigo_ibge": 2502508,
                "nome": "Boqueirão"
            },
            {
                "codigo_ibge": 2502706,
                "nome": "Borborema"
            },
            {
                "codigo_ibge": 2502805,
                "nome": "Brejo do Cruz"
            },
            {
                "codigo_ibge": 2502904,
                "nome": "Brejo dos Santos"
            },
            {
                "codigo_ibge": 2503001,
                "nome": "Caaporã"
            },
            {
                "codigo_ibge": 2503100,
                "nome": "Cabaceiras"
            },
            {
                "codigo_ibge": 2503209,
                "nome": "Cabedelo"
            },
            {
                "codigo_ibge": 2503308,
                "nome": "Cachoeira dos Índios"
            },
            {
                "codigo_ibge": 2503407,
                "nome": "Cacimba de Areia"
            },
            {
                "codigo_ibge": 2503506,
                "nome": "Cacimba de Dentro"
            },
            {
                "codigo_ibge": 2503555,
                "nome": "Cacimbas"
            },
            {
                "codigo_ibge": 2503605,
                "nome": "Caiçara"
            },
            {
                "codigo_ibge": 2503704,
                "nome": "Cajazeiras"
            },
            {
                "codigo_ibge": 2503753,
                "nome": "Cajazeirinhas"
            },
            {
                "codigo_ibge": 2503803,
                "nome": "Caldas Brandão"
            },
            {
                "codigo_ibge": 2503902,
                "nome": "Camalaú"
            },
            {
                "codigo_ibge": 2504009,
                "nome": "Campina Grande"
            },
            {
                "codigo_ibge": 2504033,
                "nome": "Capim"
            },
            {
                "codigo_ibge": 2504074,
                "nome": "Caraúbas"
            },
            {
                "codigo_ibge": 2504108,
                "nome": "Carrapateira"
            },
            {
                "codigo_ibge": 2504157,
                "nome": "Casserengue"
            },
            {
                "codigo_ibge": 2504207,
                "nome": "Catingueira"
            },
            {
                "codigo_ibge": 2504306,
                "nome": "Catolé do Rocha"
            },
            {
                "codigo_ibge": 2504355,
                "nome": "Caturité"
            },
            {
                "codigo_ibge": 2504405,
                "nome": "Conceição"
            },
            {
                "codigo_ibge": 2504504,
                "nome": "Condado"
            },
            {
                "codigo_ibge": 2504603,
                "nome": "Conde"
            },
            {
                "codigo_ibge": 2504702,
                "nome": "Congo"
            },
            {
                "codigo_ibge": 2504801,
                "nome": "Coremas"
            },
            {
                "codigo_ibge": 2504850,
                "nome": "Coxixola"
            },
            {
                "codigo_ibge": 2504900,
                "nome": "Cruz do Espírito Santo"
            },
            {
                "codigo_ibge": 2505006,
                "nome": "Cubati"
            },
            {
                "codigo_ibge": 2505105,
                "nome": "Cuité"
            },
            {
                "codigo_ibge": 2505238,
                "nome": "Cuité de Mamanguape"
            },
            {
                "codigo_ibge": 2505204,
                "nome": "Cuitegi"
            },
            {
                "codigo_ibge": 2505279,
                "nome": "Curral de Cima"
            },
            {
                "codigo_ibge": 2505303,
                "nome": "Curral Velho"
            },
            {
                "codigo_ibge": 2505352,
                "nome": "Damião"
            },
            {
                "codigo_ibge": 2505402,
                "nome": "Desterro"
            },
            {
                "codigo_ibge": 2505600,
                "nome": "Diamante"
            },
            {
                "codigo_ibge": 2505709,
                "nome": "Dona Inês"
            },
            {
                "codigo_ibge": 2505808,
                "nome": "Duas Estradas"
            },
            {
                "codigo_ibge": 2505907,
                "nome": "Emas"
            },
            {
                "codigo_ibge": 2506004,
                "nome": "Esperança"
            },
            {
                "codigo_ibge": 2506103,
                "nome": "Fagundes"
            },
            {
                "codigo_ibge": 2506202,
                "nome": "Frei Martinho"
            },
            {
                "codigo_ibge": 2506251,
                "nome": "Gado Bravo"
            },
            {
                "codigo_ibge": 2506301,
                "nome": "Guarabira"
            },
            {
                "codigo_ibge": 2506400,
                "nome": "Gurinhém"
            },
            {
                "codigo_ibge": 2506509,
                "nome": "Gurjão"
            },
            {
                "codigo_ibge": 2506608,
                "nome": "Ibiara"
            },
            {
                "codigo_ibge": 2502607,
                "nome": "Igaracy"
            },
            {
                "codigo_ibge": 2506707,
                "nome": "Imaculada"
            },
            {
                "codigo_ibge": 2506806,
                "nome": "Ingá"
            },
            {
                "codigo_ibge": 2506905,
                "nome": "Itabaiana"
            },
            {
                "codigo_ibge": 2507002,
                "nome": "Itaporanga"
            },
            {
                "codigo_ibge": 2507101,
                "nome": "Itapororoca"
            },
            {
                "codigo_ibge": 2507200,
                "nome": "Itatuba"
            },
            {
                "codigo_ibge": 2507309,
                "nome": "Jacaraú"
            },
            {
                "codigo_ibge": 2507408,
                "nome": "Jericó"
            },
            {
                "codigo_ibge": 2507507,
                "nome": "João Pessoa"
            },
            {
                "codigo_ibge": 2513653,
                "nome": "Joca Claudino"
            },
            {
                "codigo_ibge": 2507606,
                "nome": "Juarez Távora"
            },
            {
                "codigo_ibge": 2507705,
                "nome": "Juazeirinho"
            },
            {
                "codigo_ibge": 2507804,
                "nome": "Junco do Seridó"
            },
            {
                "codigo_ibge": 2507903,
                "nome": "Juripiranga"
            },
            {
                "codigo_ibge": 2508000,
                "nome": "Juru"
            },
            {
                "codigo_ibge": 2508109,
                "nome": "Lagoa"
            },
            {
                "codigo_ibge": 2508208,
                "nome": "Lagoa de Dentro"
            },
            {
                "codigo_ibge": 2508307,
                "nome": "Lagoa Seca"
            },
            {
                "codigo_ibge": 2508406,
                "nome": "Lastro"
            },
            {
                "codigo_ibge": 2508505,
                "nome": "Livramento"
            },
            {
                "codigo_ibge": 2508554,
                "nome": "Logradouro"
            },
            {
                "codigo_ibge": 2508604,
                "nome": "Lucena"
            },
            {
                "codigo_ibge": 2508703,
                "nome": "Mãe d'Água"
            },
            {
                "codigo_ibge": 2508802,
                "nome": "Malta"
            },
            {
                "codigo_ibge": 2508901,
                "nome": "Mamanguape"
            },
            {
                "codigo_ibge": 2509008,
                "nome": "Manaíra"
            },
            {
                "codigo_ibge": 2509057,
                "nome": "Marcação"
            },
            {
                "codigo_ibge": 2509107,
                "nome": "Mari"
            },
            {
                "codigo_ibge": 2509156,
                "nome": "Marizópolis"
            },
            {
                "codigo_ibge": 2509206,
                "nome": "Massaranduba"
            },
            {
                "codigo_ibge": 2509305,
                "nome": "Mataraca"
            },
            {
                "codigo_ibge": 2509339,
                "nome": "Matinhas"
            },
            {
                "codigo_ibge": 2509370,
                "nome": "Mato Grosso"
            },
            {
                "codigo_ibge": 2509396,
                "nome": "Maturéia"
            },
            {
                "codigo_ibge": 2509404,
                "nome": "Mogeiro"
            },
            {
                "codigo_ibge": 2509503,
                "nome": "Montadas"
            },
            {
                "codigo_ibge": 2509602,
                "nome": "Monte Horebe"
            },
            {
                "codigo_ibge": 2509701,
                "nome": "Monteiro"
            },
            {
                "codigo_ibge": 2509800,
                "nome": "Mulungu"
            },
            {
                "codigo_ibge": 2509909,
                "nome": "Natuba"
            },
            {
                "codigo_ibge": 2510006,
                "nome": "Nazarezinho"
            },
            {
                "codigo_ibge": 2510105,
                "nome": "Nova Floresta"
            },
            {
                "codigo_ibge": 2510204,
                "nome": "Nova Olinda"
            },
            {
                "codigo_ibge": 2510303,
                "nome": "Nova Palmeira"
            },
            {
                "codigo_ibge": 2510402,
                "nome": "Olho d'Água"
            },
            {
                "codigo_ibge": 2510501,
                "nome": "Olivedos"
            },
            {
                "codigo_ibge": 2510600,
                "nome": "Ouro Velho"
            },
            {
                "codigo_ibge": 2510659,
                "nome": "Parari"
            },
            {
                "codigo_ibge": 2510709,
                "nome": "Passagem"
            },
            {
                "codigo_ibge": 2510808,
                "nome": "Patos"
            },
            {
                "codigo_ibge": 2510907,
                "nome": "Paulista"
            },
            {
                "codigo_ibge": 2511004,
                "nome": "Pedra Branca"
            },
            {
                "codigo_ibge": 2511103,
                "nome": "Pedra Lavrada"
            },
            {
                "codigo_ibge": 2511202,
                "nome": "Pedras de Fogo"
            },
            {
                "codigo_ibge": 2512721,
                "nome": "Pedro Régis"
            },
            {
                "codigo_ibge": 2511301,
                "nome": "Piancó"
            },
            {
                "codigo_ibge": 2511400,
                "nome": "Picuí"
            },
            {
                "codigo_ibge": 2511509,
                "nome": "Pilar"
            },
            {
                "codigo_ibge": 2511608,
                "nome": "Pilões"
            },
            {
                "codigo_ibge": 2511707,
                "nome": "Pilõezinhos"
            },
            {
                "codigo_ibge": 2511806,
                "nome": "Pirpirituba"
            },
            {
                "codigo_ibge": 2511905,
                "nome": "Pitimbu"
            },
            {
                "codigo_ibge": 2512002,
                "nome": "Pocinhos"
            },
            {
                "codigo_ibge": 2512036,
                "nome": "Poço Dantas"
            },
            {
                "codigo_ibge": 2512077,
                "nome": "Poço de José de Moura"
            },
            {
                "codigo_ibge": 2512101,
                "nome": "Pombal"
            },
            {
                "codigo_ibge": 2512200,
                "nome": "Prata"
            },
            {
                "codigo_ibge": 2512309,
                "nome": "Princesa Isabel"
            },
            {
                "codigo_ibge": 2512408,
                "nome": "Puxinanã"
            },
            {
                "codigo_ibge": 2512507,
                "nome": "Queimadas"
            },
            {
                "codigo_ibge": 2512606,
                "nome": "Quixabá"
            },
            {
                "codigo_ibge": 2512705,
                "nome": "Remígio"
            },
            {
                "codigo_ibge": 2512747,
                "nome": "Riachão"
            },
            {
                "codigo_ibge": 2512754,
                "nome": "Riachão do Bacamarte"
            },
            {
                "codigo_ibge": 2512762,
                "nome": "Riachão do Poço"
            },
            {
                "codigo_ibge": 2512788,
                "nome": "Riacho de Santo Antônio"
            },
            {
                "codigo_ibge": 2512804,
                "nome": "Riacho dos Cavalos"
            },
            {
                "codigo_ibge": 2512903,
                "nome": "Rio Tinto"
            },
            {
                "codigo_ibge": 2513000,
                "nome": "Salgadinho"
            },
            {
                "codigo_ibge": 2513109,
                "nome": "Salgado de São Félix"
            },
            {
                "codigo_ibge": 2513158,
                "nome": "Santa Cecília"
            },
            {
                "codigo_ibge": 2513208,
                "nome": "Santa Cruz"
            },
            {
                "codigo_ibge": 2513307,
                "nome": "Santa Helena"
            },
            {
                "codigo_ibge": 2513356,
                "nome": "Santa Inês"
            },
            {
                "codigo_ibge": 2513406,
                "nome": "Santa Luzia"
            },
            {
                "codigo_ibge": 2513703,
                "nome": "Santa Rita"
            },
            {
                "codigo_ibge": 2513802,
                "nome": "Santa Teresinha"
            },
            {
                "codigo_ibge": 2513505,
                "nome": "Santana de Mangueira"
            },
            {
                "codigo_ibge": 2513604,
                "nome": "Santana dos Garrotes"
            },
            {
                "codigo_ibge": 2513851,
                "nome": "Santo André"
            },
            {
                "codigo_ibge": 2513927,
                "nome": "São Bentinho"
            },
            {
                "codigo_ibge": 2513901,
                "nome": "São Bento"
            },
            {
                "codigo_ibge": 2513968,
                "nome": "São Domingos"
            },
            {
                "codigo_ibge": 2513943,
                "nome": "São Domingos do Cariri"
            },
            {
                "codigo_ibge": 2513984,
                "nome": "São Francisco"
            },
            {
                "codigo_ibge": 2514008,
                "nome": "São João do Cariri"
            },
            {
                "codigo_ibge": 2500700,
                "nome": "São João do Rio do Peixe"
            },
            {
                "codigo_ibge": 2514107,
                "nome": "São João do Tigre"
            },
            {
                "codigo_ibge": 2514206,
                "nome": "São José da Lagoa Tapada"
            },
            {
                "codigo_ibge": 2514305,
                "nome": "São José de Caiana"
            },
            {
                "codigo_ibge": 2514404,
                "nome": "São José de Espinharas"
            },
            {
                "codigo_ibge": 2514503,
                "nome": "São José de Piranhas"
            },
            {
                "codigo_ibge": 2514552,
                "nome": "São José de Princesa"
            },
            {
                "codigo_ibge": 2514602,
                "nome": "São José do Bonfim"
            },
            {
                "codigo_ibge": 2514651,
                "nome": "São José do Brejo do Cruz"
            },
            {
                "codigo_ibge": 2514701,
                "nome": "São José do Sabugi"
            },
            {
                "codigo_ibge": 2514800,
                "nome": "São José dos Cordeiros"
            },
            {
                "codigo_ibge": 2514453,
                "nome": "São José dos Ramos"
            },
            {
                "codigo_ibge": 2514909,
                "nome": "São Mamede"
            },
            {
                "codigo_ibge": 2515005,
                "nome": "São Miguel de Taipu"
            },
            {
                "codigo_ibge": 2515104,
                "nome": "São Sebastião de Lagoa de Roça"
            },
            {
                "codigo_ibge": 2515203,
                "nome": "São Sebastião do Umbuzeiro"
            },
            {
                "codigo_ibge": 2515401,
                "nome": "São Vicente do Seridó"
            },
            {
                "codigo_ibge": 2515302,
                "nome": "Sapé"
            },
            {
                "codigo_ibge": 2515500,
                "nome": "Serra Branca"
            },
            {
                "codigo_ibge": 2515609,
                "nome": "Serra da Raiz"
            },
            {
                "codigo_ibge": 2515708,
                "nome": "Serra Grande"
            },
            {
                "codigo_ibge": 2515807,
                "nome": "Serra Redonda"
            },
            {
                "codigo_ibge": 2515906,
                "nome": "Serraria"
            },
            {
                "codigo_ibge": 2515930,
                "nome": "Sertãozinho"
            },
            {
                "codigo_ibge": 2515971,
                "nome": "Sobrado"
            },
            {
                "codigo_ibge": 2516003,
                "nome": "Solânea"
            },
            {
                "codigo_ibge": 2516102,
                "nome": "Soledade"
            },
            {
                "codigo_ibge": 2516151,
                "nome": "Sossêgo"
            },
            {
                "codigo_ibge": 2516201,
                "nome": "Sousa"
            },
            {
                "codigo_ibge": 2516300,
                "nome": "Sumé"
            },
            {
                "codigo_ibge": 2516409,
                "nome": "Tacima"
            },
            {
                "codigo_ibge": 2516508,
                "nome": "Taperoá"
            },
            {
                "codigo_ibge": 2516607,
                "nome": "Tavares"
            },
            {
                "codigo_ibge": 2516706,
                "nome": "Teixeira"
            },
            {
                "codigo_ibge": 2516755,
                "nome": "Tenório"
            },
            {
                "codigo_ibge": 2516805,
                "nome": "Triunfo"
            },
            {
                "codigo_ibge": 2516904,
                "nome": "Uiraúna"
            },
            {
                "codigo_ibge": 2517001,
                "nome": "Umbuzeiro"
            },
            {
                "codigo_ibge": 2517100,
                "nome": "Várzea"
            },
            {
                "codigo_ibge": 2517209,
                "nome": "Vieirópolis"
            },
            {
                "codigo_ibge": 2505501,
                "nome": "Vista Serrana"
            },
            {
                "codigo_ibge": 2517407,
                "nome": "Zabelê"
            }
        ]
    },
    "PE": {
        "nome": "Pernambuco",
        "municipios": [
            {
                "codigo_ibge": 2600054,
                "nome": "Abreu e Lima"
            },
            {
                "codigo_ibge": 2600104,
                "nome": "Afogados da Ingazeira"
            },
            {
                "codigo_ibge": 2600203,
                "nome": "Afrânio"
            },
            {
                "codigo_ibge": 2600302,
                "nome": "Agrestina"
            },
            {
                "codigo_ibge": 2600401,
                "nome": "Água Preta"
            },
            {
                "codigo_ibge": 2600500,
                "nome": "Águas Belas"
            },
            {
                "codigo_ibge": 2600609,
                "nome": "Alagoinha"
            },
            {
                "codigo_ibge": 2600708,
                "nome": "Aliança"
            },
            {
                "codigo_ibge": 2600807,
                "nome": "Altinho"
            },
            {
                "codigo_ibge": 2600906,
                "nome": "Amaraji"
            },
            {
                "codigo_ibge": 2601003,
                "nome": "Angelim"
            },
            {
                "codigo_ibge": 2601052,
                "nome": "Araçoiaba"
            },
            {
                "codigo_ibge": 2601102,
                "nome": "Araripina"
            },
            {
                "codigo_ibge": 2601201,
                "nome": "Arcoverde"
            },
            {
                "codigo_ibge": 2601300,
                "nome": "Barra de Guabiraba"
            },
            {
                "codigo_ibge": 2601409,
                "nome": "Barreiros"
            },
            {
                "codigo_ibge": 2601508,
                "nome": "Belém de Maria"
            },
            {
                "codigo_ibge": 2601607,
                "nome": "Belém do São Francisco"
            },
            {
                "codigo_ibge": 2601706,
                "nome": "Belo Jardim"
            },
            {
                "codigo_ibge": 2601805,
                "nome": "Betânia"
            },
            {
                "codigo_ibge": 2601904,
                "nome": "Bezerros"
            },
            {
                "codigo_ibge": 2602001,
                "nome": "Bodocó"
            },
            {
                "codigo_ibge": 2602100,
                "nome": "Bom Conselho"
            },
            {
                "codigo_ibge": 2602209,
                "nome": "Bom Jardim"
            },
            {
                "codigo_ibge": 2602308,
                "nome": "Bonito"
            },
            {
                "codigo_ibge": 2602407,
                "nome": "Brejão"
            },
            {
                "codigo_ibge": 2602506,
                "nome": "Brejinho"
            },
            {
                "codigo_ibge": 2602605,
                "nome": "Brejo da Madre de Deus"
            },
            {
                "codigo_ibge": 2602704,
                "nome": "Buenos Aires"
            },
            {
                "codigo_ibge": 2602803,
                "nome": "Buíque"
            },
            {
                "codigo_ibge": 2602902,
                "nome": "Cabo de Santo Agostinho"
            },
            {
                "codigo_ibge": 2603009,
                "nome": "Cabrobó"
            },
            {
                "codigo_ibge": 2603108,
                "nome": "Cachoeirinha"
            },
            {
                "codigo_ibge": 2603207,
                "nome": "Caetés"
            },
            {
                "codigo_ibge": 2603306,
                "nome": "Calçado"
            },
            {
                "codigo_ibge": 2603405,
                "nome": "Calumbi"
            },
            {
                "codigo_ibge": 2603454,
                "nome": "Camaragibe"
            },
            {
                "codigo_ibge": 2603504,
                "nome": "Camocim de São Félix"
            },
            {
                "codigo_ibge": 2603603,
                "nome": "Camutanga"
            },
            {
                "codigo_ibge": 2603702,
                "nome": "Canhotinho"
            },
            {
                "codigo_ibge": 2603801,
                "nome": "Capoeiras"
            },
            {
                "codigo_ibge": 2603900,
                "nome": "Carnaíba"
            },
            {
                "codigo_ibge": 2603926,
                "nome": "Carnaubeira da Penha"
            },
            {
                "codigo_ibge": 2604007,
                "nome": "Carpina"
            },
            {
                "codigo_ibge": 2604106,
                "nome": "Caruaru"
            },
            {
                "codigo_ibge": 2604155,
                "nome": "Casinhas"
            },
            {
                "codigo_ibge": 2604205,
                "nome": "Catende"
            },
            {
                "codigo_ibge": 2604304,
                "nome": "Cedro"
            },
            {
                "codigo_ibge": 2604403,
                "nome": "Chã de Alegria"
            },
            {
                "codigo_ibge": 2604502,
                "nome": "Chã Grande"
            },
            {
                "codigo_ibge": 2604601,
                "nome": "Condado"
            },
            {
                "codigo_ibge": 2604700,
                "nome": "Correntes"
            },
            {
                "codigo_ibge": 2604809,
                "nome": "Cortês"
            },
            {
                "codigo_ibge": 2604908,
                "nome": "Cumaru"
            },
            {
                "codigo_ibge": 2605004,
                "nome": "Cupira"
            },
            {
                "codigo_ibge": 2605103,
                "nome": "Custódia"
            },
            {
                "codigo_ibge": 2605152,
                "nome": "Dormentes"
            },
            {
                "codigo_ibge": 2605202,
                "nome": "Escada"
            },
            {
                "codigo_ibge": 2605301,
                "nome": "Exu"
            },
            {
                "codigo_ibge": 2605400,
                "nome": "Feira Nova"
            },
            {
                "codigo_ibge": 2605459,
                "nome": "Fernando de Noronha"
            },
            {
                "codigo_ibge": 2605509,
                "nome": "Ferreiros"
            },
            {
                "codigo_ibge": 2605608,
                "nome": "Flores"
            },
            {
                "codigo_ibge": 2605707,
                "nome": "Floresta"
            },
            {
                "codigo_ibge": 2605806,
                "nome": "Frei Miguelinho"
            },
            {
                "codigo_ibge": 2605905,
                "nome": "Gameleira"
            },
            {
                "codigo_ibge": 2606002,
                "nome": "Garanhuns"
            },
            {
                "codigo_ibge": 2606101,
                "nome": "Glória do Goitá"
            },
            {
                "codigo_ibge": 2606200,
                "nome": "Goiana"
            },
            {
                "codigo_ibge": 2606309,
                "nome": "Granito"
            },
            {
                "codigo_ibge": 2606408,
                "nome": "Gravatá"
            },
            {
                "codigo_ibge": 2606507,
                "nome": "Iati"
            },
            {
                "codigo_ibge": 2606606,
                "nome": "Ibimirim"
            },
            {
                "codigo_ibge": 2606705,
                "nome": "Ibirajuba"
            },
            {
                "codigo_ibge": 2606804,
                "nome": "Igarassu"
            },
            {
                "codigo_ibge": 2606903,
                "nome": "Iguaracy"
            },
            {
                "codigo_ibge": 2607604,
                "nome": "Ilha de Itamaracá"
            },
            {
                "codigo_ibge": 2607000,
                "nome": "Inajá"
            },
            {
                "codigo_ibge": 2607109,
                "nome": "Ingazeira"
            },
            {
                "codigo_ibge": 2607208,
                "nome": "Ipojuca"
            },
            {
                "codigo_ibge": 2607307,
                "nome": "Ipubi"
            },
            {
                "codigo_ibge": 2607406,
                "nome": "Itacuruba"
            },
            {
                "codigo_ibge": 2607505,
                "nome": "Itaíba"
            },
            {
                "codigo_ibge": 2607653,
                "nome": "Itambé"
            },
            {
                "codigo_ibge": 2607703,
                "nome": "Itapetim"
            },
            {
                "codigo_ibge": 2607752,
                "nome": "Itapissuma"
            },
            {
                "codigo_ibge": 2607802,
                "nome": "Itaquitinga"
            },
            {
                "codigo_ibge": 2607901,
                "nome": "Jaboatão dos Guararapes"
            },
            {
                "codigo_ibge": 2607950,
                "nome": "Jaqueira"
            },
            {
                "codigo_ibge": 2608008,
                "nome": "Jataúba"
            },
            {
                "codigo_ibge": 2608057,
                "nome": "Jatobá"
            },
            {
                "codigo_ibge": 2608107,
                "nome": "João Alfredo"
            },
            {
                "codigo_ibge": 2608206,
                "nome": "Joaquim Nabuco"
            },
            {
                "codigo_ibge": 2608255,
                "nome": "Jucati"
            },
            {
                "codigo_ibge": 2608305,
                "nome": "Jupi"
            },
            {
                "codigo_ibge": 2608404,
                "nome": "Jurema"
            },
            {
                "codigo_ibge": 2608503,
                "nome": "Lagoa de Itaenga"
            },
            {
                "codigo_ibge": 2608453,
                "nome": "Lagoa do Carro"
            },
            {
                "codigo_ibge": 2608602,
                "nome": "Lagoa do Ouro"
            },
            {
                "codigo_ibge": 2608701,
                "nome": "Lagoa dos Gatos"
            },
            {
                "codigo_ibge": 2608750,
                "nome": "Lagoa Grande"
            },
            {
                "codigo_ibge": 2608800,
                "nome": "Lajedo"
            },
            {
                "codigo_ibge": 2608909,
                "nome": "Limoeiro"
            },
            {
                "codigo_ibge": 2609006,
                "nome": "Macaparana"
            },
            {
                "codigo_ibge": 2609105,
                "nome": "Machados"
            },
            {
                "codigo_ibge": 2609154,
                "nome": "Manari"
            },
            {
                "codigo_ibge": 2609204,
                "nome": "Maraial"
            },
            {
                "codigo_ibge": 2609303,
                "nome": "Mirandiba"
            },
            {
                "codigo_ibge": 2614303,
                "nome": "Moreilândia"
            },
            {
                "codigo_ibge": 2609402,
                "nome": "Moreno"
            },
            {
                "codigo_ibge": 2609501,
                "nome": "Nazaré da Mata"
            },
            {
                "codigo_ibge": 2609600,
                "nome": "Olinda"
            },
            {
                "codigo_ibge": 2609709,
                "nome": "Orobó"
            },
            {
                "codigo_ibge": 2609808,
                "nome": "Orocó"
            },
            {
                "codigo_ibge": 2609907,
                "nome": "Ouricuri"
            },
            {
                "codigo_ibge": 2610004,
                "nome": "Palmares"
            },
            {
                "codigo_ibge": 2610103,
                "nome": "Palmeirina"
            },
            {
                "codigo_ibge": 2610202,
                "nome": "Panelas"
            },
            {
                "codigo_ibge": 2610301,
                "nome": "Paranatama"
            },
            {
                "codigo_ibge": 2610400,
                "nome": "Parnamirim"
            },
            {
                "codigo_ibge": 2610509,
                "nome": "Passira"
            },
            {
                "codigo_ibge": 2610608,
                "nome": "Paudalho"
            },
            {
                "codigo_ibge": 2610707,
                "nome": "Paulista"
            },
            {
                "codigo_ibge": 2610806,
                "nome": "Pedra"
            },
            {
                "codigo_ibge": 2610905,
                "nome": "Pesqueira"
            },
            {
                "codigo_ibge": 2611002,
                "nome": "Petrolândia"
            },
            {
                "codigo_ibge": 2611101,
                "nome": "Petrolina"
            },
            {
                "codigo_ibge": 2611200,
                "nome": "Poção"
            },
            {
                "codigo_ibge": 2611309,
                "nome": "Pombos"
            },
            {
                "codigo_ibge": 2611408,
                "nome": "Primavera"
            },
            {
                "codigo_ibge": 2611507,
                "nome": "Quipapá"
            },
            {
                "codigo_ibge": 2611533,
                "nome": "Quixaba"
            },
            {
                "codigo_ibge": 2611606,
                "nome": "Recife"
            },
            {
                "codigo_ibge": 2611705,
                "nome": "Riacho das Almas"
            },
            {
                "codigo_ibge": 2611804,
                "nome": "Ribeirão"
            },
            {
                "codigo_ibge": 2611903,
                "nome": "Rio Formoso"
            },
            {
                "codigo_ibge": 2612000,
                "nome": "Sairé"
            },
            {
                "codigo_ibge": 2612109,
                "nome": "Salgadinho"
            },
            {
                "codigo_ibge": 2612208,
                "nome": "Salgueiro"
            },
            {
                "codigo_ibge": 2612307,
                "nome": "Saloá"
            },
            {
                "codigo_ibge": 2612406,
                "nome": "Sanharó"
            },
            {
                "codigo_ibge": 2612455,
                "nome": "Santa Cruz"
            },
            {
                "codigo_ibge": 2612471,
                "nome": "Santa Cruz da Baixa Verde"
            },
            {
                "codigo_ibge": 2612505,
                "nome": "Santa Cruz do Capibaribe"
            },
            {
                "codigo_ibge": 2612554,
                "nome": "Santa Filomena"
            },
            {
                "codigo_ibge": 2612604,
                "nome": "Santa Maria da Boa Vista"
            },
            {
                "codigo_ibge": 2612703,
                "nome": "Santa Maria do Cambucá"
            },
            {
                "codigo_ibge": 2612802,
                "nome": "Santa Terezinha"
            },
            {
                "codigo_ibge": 2612901,
                "nome": "São Benedito do Sul"
            },
            {
                "codigo_ibge": 2613008,
                "nome": "São Bento do Una"
            },
            {
                "codigo_ibge": 2613107,
                "nome": "São Caetano"
            },
            {
                "codigo_ibge": 2613206,
                "nome": "São João"
            },
            {
                "codigo_ibge": 2613305,
                "nome": "São Joaquim do Monte"
            },
            {
                "codigo_ibge": 2613404,
                "nome": "São José da Coroa Grande"
            },
            {
                "codigo_ibge": 2613503,
                "nome": "São José do Belmonte"
            },
            {
                "codigo_ibge": 2613602,
                "nome": "São José do Egito"
            },
            {
                "codigo_ibge": 2613701,
                "nome": "São Lourenço da Mata"
            },
            {
                "codigo_ibge": 2613800,
                "nome": "São Vicente Ferrer"
            },
            {
                "codigo_ibge": 2613909,
                "nome": "Serra Talhada"
            },
            {
                "codigo_ibge": 2614006,
                "nome": "Serrita"
            },
            {
                "codigo_ibge": 2614105,
                "nome": "Sertânia"
            },
            {
                "codigo_ibge": 2614204,
                "nome": "Sirinhaém"
            },
            {
                "codigo_ibge": 2614402,
                "nome": "Solidão"
            },
            {
                "codigo_ibge": 2614501,
                "nome": "Surubim"
            },
            {
                "codigo_ibge": 2614600,
                "nome": "Tabira"
            },
            {
                "codigo_ibge": 2614709,
                "nome": "Tacaimbó"
            },
            {
                "codigo_ibge": 2614808,
                "nome": "Tacaratu"
            },
            {
                "codigo_ibge": 2614857,
                "nome": "Tamandaré"
            },
            {
                "codigo_ibge": 2615003,
                "nome": "Taquaritinga do Norte"
            },
            {
                "codigo_ibge": 2615102,
                "nome": "Terezinha"
            },
            {
                "codigo_ibge": 2615201,
                "nome": "Terra Nova"
            },
            {
                "codigo_ibge": 2615300,
                "nome": "Timbaúba"
            },
            {
                "codigo_ibge": 2615409,
                "nome": "Toritama"
            },
            {
                "codigo_ibge": 2615508,
                "nome": "Tracunhaém"
            },
            {
                "codigo_ibge": 2615607,
                "nome": "Trindade"
            },
            {
                "codigo_ibge": 2615706,
                "nome": "Triunfo"
            },
            {
                "codigo_ibge": 2615805,
                "nome": "Tupanatinga"
            },
            {
                "codigo_ibge": 2615904,
                "nome": "Tuparetama"
            },
            {
                "codigo_ibge": 2616001,
                "nome": "Venturosa"
            },
            {
                "codigo_ibge": 2616100,
                "nome": "Verdejante"
            },
            {
                "codigo_ibge": 2616183,
                "nome": "Vertente do Lério"
            },
            {
                "codigo_ibge": 2616209,
                "nome": "Vertentes"
            },
            {
                "codigo_ibge": 2616308,
                "nome": "Vicência"
            },
            {
                "codigo_ibge": 2616407,
                "nome": "Vitória de Santo Antão"
            },
            {
                "codigo_ibge": 2616506,
                "nome": "Xexéu"
            }
        ]
    },
    "PI": {
        "nome": "Piauí",
        "municipios": [
            {
                "codigo_ibge": 2200053,
                "nome": "Acauã"
            },
            {
                "codigo_ibge": 2200103,
                "nome": "Agricolândia"
            },
            {
                "codigo_ibge": 2200202,
                "nome": "Água Branca"
            },
            {
                "codigo_ibge": 2200251,
                "nome": "Alagoinha do Piauí"
            },
            {
                "codigo_ibge": 2200277,
                "nome": "Alegrete do Piauí"
            },
            {
                "codigo_ibge": 2200301,
                "nome": "Alto Longá"
            },
            {
                "codigo_ibge": 2200400,
                "nome": "Altos"
            },
            {
                "codigo_ibge": 2200459,
                "nome": "Alvorada do Gurguéia"
            },
            {
                "codigo_ibge": 2200509,
                "nome": "Amarante"
            },
            {
                "codigo_ibge": 2200608,
                "nome": "Angical do Piauí"
            },
            {
                "codigo_ibge": 2200707,
                "nome": "Anísio de Abreu"
            },
            {
                "codigo_ibge": 2200806,
                "nome": "Antônio Almeida"
            },
            {
                "codigo_ibge": 2200905,
                "nome": "Aroazes"
            },
            {
                "codigo_ibge": 2200954,
                "nome": "Aroeiras do Itaim"
            },
            {
                "codigo_ibge": 2201002,
                "nome": "Arraial"
            },
            {
                "codigo_ibge": 2201051,
                "nome": "Assunção do Piauí"
            },
            {
                "codigo_ibge": 2201101,
                "nome": "Avelino Lopes"
            },
            {
                "codigo_ibge": 2201150,
                "nome": "Baixa Grande do Ribeiro"
            },
            {
                "codigo_ibge": 2201176,
                "nome": "Barra D'Alcântara"
            },
            {
                "codigo_ibge": 2201200,
                "nome": "Barras"
            },
            {
                "codigo_ibge": 2201309,
                "nome": "Barreiras do Piauí"
            },
            {
                "codigo_ibge": 2201408,
                "nome": "Barro Duro"
            },
            {
                "codigo_ibge": 2201507,
                "nome": "Batalha"
            },
            {
                "codigo_ibge": 2201556,
                "nome": "Bela Vista do Piauí"
            },
            {
                "codigo_ibge": 2201572,
                "nome": "Belém do Piauí"
            },
            {
                "codigo_ibge": 2201606,
                "nome": "Beneditinos"
            },
            {
                "codigo_ibge": 2201705,
                "nome": "Bertolínia"
            },
            {
                "codigo_ibge": 2201739,
                "nome": "Betânia do Piauí"
            },
            {
                "codigo_ibge": 2201770,
                "nome": "Boa Hora"
            },
            {
                "codigo_ibge": 2201804,
                "nome": "Bocaina"
            },
            {
                "codigo_ibge": 2201903,
                "nome": "Bom Jesus"
            },
            {
                "codigo_ibge": 2201919,
                "nome": "Bom Princípio do Piauí"
            },
            {
                "codigo_ibge": 2201929,
                "nome": "Bonfim do Piauí"
            },
            {
                "codigo_ibge": 2201945,
                "nome": "Boqueirão do Piauí"
            },
            {
                "codigo_ibge": 2201960,
                "nome": "Brasileira"
            },
            {
                "codigo_ibge": 2201988,
                "nome": "Brejo do Piauí"
            },
            {
                "codigo_ibge": 2202000,
                "nome": "Buriti dos Lopes"
            },
            {
                "codigo_ibge": 2202026,
                "nome": "Buriti dos Montes"
            },
            {
                "codigo_ibge": 2202059,
                "nome": "Cabeceiras do Piauí"
            },
            {
                "codigo_ibge": 2202075,
                "nome": "Cajazeiras do Piauí"
            },
            {
                "codigo_ibge": 2202083,
                "nome": "Cajueiro da Praia"
            },
            {
                "codigo_ibge": 2202091,
                "nome": "Caldeirão Grande do Piauí"
            },
            {
                "codigo_ibge": 2202109,
                "nome": "Campinas do Piauí"
            },
            {
                "codigo_ibge": 2202117,
                "nome": "Campo Alegre do Fidalgo"
            },
            {
                "codigo_ibge": 2202133,
                "nome": "Campo Grande do Piauí"
            },
            {
                "codigo_ibge": 2202174,
                "nome": "Campo Largo do Piauí"
            },
            {
                "codigo_ibge": 2202208,
                "nome": "Campo Maior"
            },
            {
                "codigo_ibge": 2202251,
                "nome": "Canavieira"
            },
            {
                "codigo_ibge": 2202307,
                "nome": "Canto do Buriti"
            },
            {
                "codigo_ibge": 2202406,
                "nome": "Capitão de Campos"
            },
            {
                "codigo_ibge": 2202455,
                "nome": "Capitão Gervásio Oliveira"
            },
            {
                "codigo_ibge": 2202505,
                "nome": "Caracol"
            },
            {
                "codigo_ibge": 2202539,
                "nome": "Caraúbas do Piauí"
            },
            {
                "codigo_ibge": 2202554,
                "nome": "Caridade do Piauí"
            },
            {
                "codigo_ibge": 2202604,
                "nome": "Castelo do Piauí"
            },
            {
                "codigo_ibge": 2202653,
                "nome": "Caxingó"
            },
            {
                "codigo_ibge": 2202703,
                "nome": "Cocal"
            },
            {
                "codigo_ibge": 2202711,
                "nome": "Cocal de Telha"
            },
            {
                "codigo_ibge": 2202729,
                "nome": "Cocal dos Alves"
            },
            {
                "codigo_ibge": 2202737,
                "nome": "Coivaras"
            },
            {
                "codigo_ibge": 2202752,
                "nome": "Colônia do Gurguéia"
            },
            {
                "codigo_ibge": 2202778,
                "nome": "Colônia do Piauí"
            },
            {
                "codigo_ibge": 2202802,
                "nome": "Conceição do Canindé"
            },
            {
                "codigo_ibge": 2202851,
                "nome": "Coronel José Dias"
            },
            {
                "codigo_ibge": 2202901,
                "nome": "Corrente"
            },
            {
                "codigo_ibge": 2203008,
                "nome": "Cristalândia do Piauí"
            },
            {
                "codigo_ibge": 2203107,
                "nome": "Cristino Castro"
            },
            {
                "codigo_ibge": 2203206,
                "nome": "Curimatá"
            },
            {
                "codigo_ibge": 2203230,
                "nome": "Currais"
            },
            {
                "codigo_ibge": 2203271,
                "nome": "Curral Novo do Piauí"
            },
            {
                "codigo_ibge": 2203255,
                "nome": "Curralinhos"
            },
            {
                "codigo_ibge": 2203305,
                "nome": "Demerval Lobão"
            },
            {
                "codigo_ibge": 2203354,
                "nome": "Dirceu Arcoverde"
            },
            {
                "codigo_ibge": 2203404,
                "nome": "Dom Expedito Lopes"
            },
            {
                "codigo_ibge": 2203453,
                "nome": "Dom Inocêncio"
            },
            {
                "codigo_ibge": 2203420,
                "nome": "Domingos Mourão"
            },
            {
                "codigo_ibge": 2203503,
                "nome": "Elesbão Veloso"
            },
            {
                "codigo_ibge": 2203602,
                "nome": "Eliseu Martins"
            },
            {
                "codigo_ibge": 2203701,
                "nome": "Esperantina"
            },
            {
                "codigo_ibge": 2203750,
                "nome": "Fartura do Piauí"
            },
            {
                "codigo_ibge": 2203800,
                "nome": "Flores do Piauí"
            },
            {
                "codigo_ibge": 2203859,
                "nome": "Floresta do Piauí"
            },
            {
                "codigo_ibge": 2203909,
                "nome": "Floriano"
            },
            {
                "codigo_ibge": 2204006,
                "nome": "Francinópolis"
            },
            {
                "codigo_ibge": 2204105,
                "nome": "Francisco Ayres"
            },
            {
                "codigo_ibge": 2204154,
                "nome": "Francisco Macedo"
            },
            {
                "codigo_ibge": 2204204,
                "nome": "Francisco Santos"
            },
            {
                "codigo_ibge": 2204303,
                "nome": "Fronteiras"
            },
            {
                "codigo_ibge": 2204352,
                "nome": "Geminiano"
            },
            {
                "codigo_ibge": 2204402,
                "nome": "Gilbués"
            },
            {
                "codigo_ibge": 2204501,
                "nome": "Guadalupe"
            },
            {
                "codigo_ibge": 2204550,
                "nome": "Guaribas"
            },
            {
                "codigo_ibge": 2204600,
                "nome": "Hugo Napoleão"
            },
            {
                "codigo_ibge": 2204659,
                "nome": "Ilha Grande"
            },
            {
                "codigo_ibge": 2204709,
                "nome": "Inhuma"
            },
            {
                "codigo_ibge": 2204808,
                "nome": "Ipiranga do Piauí"
            },
            {
                "codigo_ibge": 2204907,
                "nome": "Isaías Coelho"
            },
            {
                "codigo_ibge": 2205003,
                "nome": "Itainópolis"
            },
            {
                "codigo_ibge": 2205102,
                "nome": "Itaueira"
            },
            {
                "codigo_ibge": 2205151,
                "nome": "Jacobina do Piauí"
            },
            {
                "codigo_ibge": 2205201,
                "nome": "Jaicós"
            },
            {
                "codigo_ibge": 2205250,
                "nome": "Jardim do Mulato"
            },
            {
                "codigo_ibge": 2205276,
                "nome": "Jatobá do Piauí"
            },
            {
                "codigo_ibge": 2205300,
                "nome": "Jerumenha"
            },
            {
                "codigo_ibge": 2205359,
                "nome": "João Costa"
            },
            {
                "codigo_ibge": 2205409,
                "nome": "Joaquim Pires"
            },
            {
                "codigo_ibge": 2205458,
                "nome": "Joca Marques"
            },
            {
                "codigo_ibge": 2205508,
                "nome": "José de Freitas"
            },
            {
                "codigo_ibge": 2205516,
                "nome": "Juazeiro do Piauí"
            },
            {
                "codigo_ibge": 2205524,
                "nome": "Júlio Borges"
            },
            {
                "codigo_ibge": 2205532,
                "nome": "Jurema"
            },
            {
                "codigo_ibge": 2205557,
                "nome": "Lagoa Alegre"
            },
            {
                "codigo_ibge": 2205573,
                "nome": "Lagoa de São Francisco"
            },
            {
                "codigo_ibge": 2205565,
                "nome": "Lagoa do Barro do Piauí"
            },
            {
                "codigo_ibge": 2205581,
                "nome": "Lagoa do Piauí"
            },
            {
                "codigo_ibge": 2205599,
                "nome": "Lagoa do Sítio"
            },
            {
                "codigo_ibge": 2205540,
                "nome": "Lagoinha do Piauí"
            },
            {
                "codigo_ibge": 2205607,
                "nome": "Landri Sales"
            },
            {
                "codigo_ibge": 2205706,
                "nome": "Luís Correia"
            },
            {
                "codigo_ibge": 2205805,
                "nome": "Luzilândia"
            },
            {
                "codigo_ibge": 2205854,
                "nome": "Madeiro"
            },
            {
                "codigo_ibge": 2205904,
                "nome": "Manoel Emídio"
            },
            {
                "codigo_ibge": 2205953,
                "nome": "Marcolândia"
            },
            {
                "codigo_ibge": 2206001,
                "nome": "Marcos Parente"
            },
            {
                "codigo_ibge": 2206050,
                "nome": "Massapê do Piauí"
            },
            {
                "codigo_ibge": 2206100,
                "nome": "Matias Olímpio"
            },
            {
                "codigo_ibge": 2206209,
                "nome": "Miguel Alves"
            },
            {
                "codigo_ibge": 2206308,
                "nome": "Miguel Leão"
            },
            {
                "codigo_ibge": 2206357,
                "nome": "Milton Brandão"
            },
            {
                "codigo_ibge": 2206407,
                "nome": "Monsenhor Gil"
            },
            {
                "codigo_ibge": 2206506,
                "nome": "Monsenhor Hipólito"
            },
            {
                "codigo_ibge": 2206605,
                "nome": "Monte Alegre do Piauí"
            },
            {
                "codigo_ibge": 2206654,
                "nome": "Morro Cabeça no Tempo"
            },
            {
                "codigo_ibge": 2206670,
                "nome": "Morro do Chapéu do Piauí"
            },
            {
                "codigo_ibge": 2206696,
                "nome": "Murici dos Portelas"
            },
            {
                "codigo_ibge": 2206704,
                "nome": "Nazaré do Piauí"
            },
            {
                "codigo_ibge": 2206720,
                "nome": "Nazária"
            },
            {
                "codigo_ibge": 2206753,
                "nome": "Nossa Senhora de Nazaré"
            },
            {
                "codigo_ibge": 2206803,
                "nome": "Nossa Senhora dos Remédios"
            },
            {
                "codigo_ibge": 2207959,
                "nome": "Nova Santa Rita"
            },
            {
                "codigo_ibge": 2206902,
                "nome": "Novo Oriente do Piauí"
            },
            {
                "codigo_ibge": 2206951,
                "nome": "Novo Santo Antônio"
            },
            {
                "codigo_ibge": 2207009,
                "nome": "Oeiras"
            },
            {
                "codigo_ibge": 2207108,
                "nome": "Olho D'Água do Piauí"
            },
            {
                "codigo_ibge": 2207207,
                "nome": "Padre Marcos"
            },
            {
                "codigo_ibge": 2207306,
                "nome": "Paes Landim"
            },
            {
                "codigo_ibge": 2207355,
                "nome": "Pajeú do Piauí"
            },
            {
                "codigo_ibge": 2207405,
                "nome": "Palmeira do Piauí"
            },
            {
                "codigo_ibge": 2207504,
                "nome": "Palmeirais"
            },
            {
                "codigo_ibge": 2207553,
                "nome": "Paquetá"
            },
            {
                "codigo_ibge": 2207603,
                "nome": "Parnaguá"
            },
            {
                "codigo_ibge": 2207702,
                "nome": "Parnaíba"
            },
            {
                "codigo_ibge": 2207751,
                "nome": "Passagem Franca do Piauí"
            },
            {
                "codigo_ibge": 2207777,
                "nome": "Patos do Piauí"
            },
            {
                "codigo_ibge": 2207793,
                "nome": "Pau D'Arco do Piauí"
            },
            {
                "codigo_ibge": 2207801,
                "nome": "Paulistana"
            },
            {
                "codigo_ibge": 2207850,
                "nome": "Pavussu"
            },
            {
                "codigo_ibge": 2207900,
                "nome": "Pedro II"
            },
            {
                "codigo_ibge": 2207934,
                "nome": "Pedro Laurentino"
            },
            {
                "codigo_ibge": 2208007,
                "nome": "Picos"
            },
            {
                "codigo_ibge": 2208106,
                "nome": "Pimenteiras"
            },
            {
                "codigo_ibge": 2208205,
                "nome": "Pio IX"
            },
            {
                "codigo_ibge": 2208304,
                "nome": "Piracuruca"
            },
            {
                "codigo_ibge": 2208403,
                "nome": "Piripiri"
            },
            {
                "codigo_ibge": 2208502,
                "nome": "Porto"
            },
            {
                "codigo_ibge": 2208551,
                "nome": "Porto Alegre do Piauí"
            },
            {
                "codigo_ibge": 2208601,
                "nome": "Prata do Piauí"
            },
            {
                "codigo_ibge": 2208650,
                "nome": "Queimada Nova"
            },
            {
                "codigo_ibge": 2208700,
                "nome": "Redenção do Gurguéia"
            },
            {
                "codigo_ibge": 2208809,
                "nome": "Regeneração"
            },
            {
                "codigo_ibge": 2208858,
                "nome": "Riacho Frio"
            },
            {
                "codigo_ibge": 2208874,
                "nome": "Ribeira do Piauí"
            },
            {
                "codigo_ibge": 2208908,
                "nome": "Ribeiro Gonçalves"
            },
            {
                "codigo_ibge": 2209005,
                "nome": "Rio Grande do Piauí"
            },
            {
                "codigo_ibge": 2209104,
                "nome": "Santa Cruz do Piauí"
            },
            {
                "codigo_ibge": 2209153,
                "nome": "Santa Cruz dos Milagres"
            },
            {
                "codigo_ibge": 2209203,
                "nome": "Santa Filomena"
            },
            {
                "codigo_ibge": 2209302,
                "nome": "Santa Luz"
            },
            {
                "codigo_ibge": 2209377,
                "nome": "Santa Rosa do Piauí"
            },
            {
                "codigo_ibge": 2209351,
                "nome": "Santana do Piauí"
            },
            {
                "codigo_ibge": 2209401,
                "nome": "Santo Antônio de Lisboa"
            },
            {
                "codigo_ibge": 2209450,
                "nome": "Santo Antônio dos Milagres"
            },
            {
                "codigo_ibge": 2209500,
                "nome": "Santo Inácio do Piauí"
            },
            {
                "codigo_ibge": 2209559,
                "nome": "São Braz do Piauí"
            },
            {
                "codigo_ibge": 2209609,
                "nome": "São Félix do Piauí"
            },
            {
                "codigo_ibge": 2209658,
                "nome": "São Francisco de Assis do Piauí"
            },
            {
                "codigo_ibge": 2209708,
                "nome": "São Francisco do Piauí"
            },
            {
                "codigo_ibge": 2209757,
                "nome": "São Gonçalo do Gurguéia"
            },
            {
                "codigo_ibge": 2209807,
                "nome": "São Gonçalo do Piauí"
            },
            {
                "codigo_ibge": 2209856,
                "nome": "São João da Canabrava"
            },
            {
                "codigo_ibge": 2209872,
                "nome": "São João da Fronteira"
            },
            {
                "codigo_ibge": 2209906,
                "nome": "São João da Serra"
            },
            {
                "codigo_ibge": 2209955,
                "nome": "São João da Varjota"
            },
            {
                "codigo_ibge": 2209971,
                "nome": "São João do Arraial"
            },
            {
                "codigo_ibge": 2210003,
                "nome": "São João do Piauí"
            },
            {
                "codigo_ibge": 2210052,
                "nome": "São José do Divino"
            },
            {
                "codigo_ibge": 2210102,
                "nome": "São José do Peixe"
            },
            {
                "codigo_ibge": 2210201,
                "nome": "São José do Piauí"
            },
            {
                "codigo_ibge": 2210300,
                "nome": "São Julião"
            },
            {
                "codigo_ibge": 2210359,
                "nome": "São Lourenço do Piauí"
            },
            {
                "codigo_ibge": 2210375,
                "nome": "São Luis do Piauí"
            },
            {
                "codigo_ibge": 2210383,
                "nome": "São Miguel da Baixa Grande"
            },
            {
                "codigo_ibge": 2210391,
                "nome": "São Miguel do Fidalgo"
            },
            {
                "codigo_ibge": 2210409,
                "nome": "São Miguel do Tapuio"
            },
            {
                "codigo_ibge": 2210508,
                "nome": "São Pedro do Piauí"
            },
            {
                "codigo_ibge": 2210607,
                "nome": "São Raimundo Nonato"
            },
            {
                "codigo_ibge": 2210623,
                "nome": "Sebastião Barros"
            },
            {
                "codigo_ibge": 2210631,
                "nome": "Sebastião Leal"
            },
            {
                "codigo_ibge": 2210656,
                "nome": "Sigefredo Pacheco"
            },
            {
                "codigo_ibge": 2210706,
                "nome": "Simões"
            },
            {
                "codigo_ibge": 2210805,
                "nome": "Simplício Mendes"
            },
            {
                "codigo_ibge": 2210904,
                "nome": "Socorro do Piauí"
            },
            {
                "codigo_ibge": 2210938,
                "nome": "Sussuapara"
            },
            {
                "codigo_ibge": 2210953,
                "nome": "Tamboril do Piauí"
            },
            {
                "codigo_ibge": 2210979,
                "nome": "Tanque do Piauí"
            },
            {
                "codigo_ibge": 2211001,
                "nome": "Teresina"
            },
            {
                "codigo_ibge": 2211100,
                "nome": "União"
            },
            {
                "codigo_ibge": 2211209,
                "nome": "Uruçuí"
            },
            {
                "codigo_ibge": 2211308,
                "nome": "Valença do Piauí"
            },
            {
                "codigo_ibge": 2211357,
                "nome": "Várzea Branca"
            },
            {
                "codigo_ibge": 2211407,
                "nome": "Várzea Grande"
            },
            {
                "codigo_ibge": 2211506,
                "nome": "Vera Mendes"
            },
            {
                "codigo_ibge": 2211605,
                "nome": "Vila Nova do Piauí"
            },
            {
                "codigo_ibge": 2211704,
                "nome": "Wall Ferraz"
            }
        ]
    },
    "PR": {
        "nome": "Paraná",
        "municipios": [
            {
                "codigo_ibge": 4100103,
                "nome": "Abatiá"
            },
            {
                "codigo_ibge": 4100202,
                "nome": "Adrianópolis"
            },
            {
                "codigo_ibge": 4100301,
                "nome": "Agudos do Sul"
            },
            {
                "codigo_ibge": 4100400,
                "nome": "Almirante Tamandaré"
            },
            {
                "codigo_ibge": 4100459,
                "nome": "Altamira do Paraná"
            },
            {
                "codigo_ibge": 4128625,
                "nome": "Alto Paraíso"
            },
            {
                "codigo_ibge": 4100608,
                "nome": "Alto Paraná"
            },
            {
                "codigo_ibge": 4100707,
                "nome": "Alto Piquiri"
            },
            {
                "codigo_ibge": 4100509,
                "nome": "Altônia"
            },
            {
                "codigo_ibge": 4100806,
                "nome": "Alvorada do Sul"
            },
            {
                "codigo_ibge": 4100905,
                "nome": "Amaporã"
            },
            {
                "codigo_ibge": 4101002,
                "nome": "Ampére"
            },
            {
                "codigo_ibge": 4101051,
                "nome": "Anahy"
            },
            {
                "codigo_ibge": 4101101,
                "nome": "Andirá"
            },
            {
                "codigo_ibge": 4101150,
                "nome": "Ângulo"
            },
            {
                "codigo_ibge": 4101200,
                "nome": "Antonina"
            },
            {
                "codigo_ibge": 4101309,
                "nome": "Antônio Olinto"
            },
            {
                "codigo_ibge": 4101408,
                "nome": "Apucarana"
            },
            {
                "codigo_ibge": 4101507,
                "nome": "Arapongas"
            },
            {
                "codigo_ibge": 4101606,
                "nome": "Arapoti"
            },
            {
                "codigo_ibge": 4101655,
                "nome": "Arapuã"
            },
            {
                "codigo_ibge": 4101705,
                "nome": "Araruna"
            },
            {
                "codigo_ibge": 4101804,
                "nome": "Araucária"
            },
            {
                "codigo_ibge": 4101853,
                "nome": "Ariranha do Ivaí"
            },
            {
                "codigo_ibge": 4101903,
                "nome": "Assaí"
            },
            {
                "codigo_ibge": 4102000,
                "nome": "Assis Chateaubriand"
            },
            {
                "codigo_ibge": 4102109,
                "nome": "Astorga"
            },
            {
                "codigo_ibge": 4102208,
                "nome": "Atalaia"
            },
            {
                "codigo_ibge": 4102307,
                "nome": "Balsa Nova"
            },
            {
                "codigo_ibge": 4102406,
                "nome": "Bandeirantes"
            },
            {
                "codigo_ibge": 4102505,
                "nome": "Barbosa Ferraz"
            },
            {
                "codigo_ibge": 4102703,
                "nome": "Barra do Jacaré"
            },
            {
                "codigo_ibge": 4102604,
                "nome": "Barracão"
            },
            {
                "codigo_ibge": 4102752,
                "nome": "Bela Vista da Caroba"
            },
            {
                "codigo_ibge": 4102802,
                "nome": "Bela Vista do Paraíso"
            },
            {
                "codigo_ibge": 4102901,
                "nome": "Bituruna"
            },
            {
                "codigo_ibge": 4103008,
                "nome": "Boa Esperança"
            },
            {
                "codigo_ibge": 4103024,
                "nome": "Boa Esperança do Iguaçu"
            },
            {
                "codigo_ibge": 4103040,
                "nome": "Boa Ventura de São Roque"
            },
            {
                "codigo_ibge": 4103057,
                "nome": "Boa Vista da Aparecida"
            },
            {
                "codigo_ibge": 4103107,
                "nome": "Bocaiúva do Sul"
            },
            {
                "codigo_ibge": 4103156,
                "nome": "Bom Jesus do Sul"
            },
            {
                "codigo_ibge": 4103206,
                "nome": "Bom Sucesso"
            },
            {
                "codigo_ibge": 4103222,
                "nome": "Bom Sucesso do Sul"
            },
            {
                "codigo_ibge": 4103305,
                "nome": "Borrazópolis"
            },
            {
                "codigo_ibge": 4103354,
                "nome": "Braganey"
            },
            {
                "codigo_ibge": 4103370,
                "nome": "Brasilândia do Sul"
            },
            {
                "codigo_ibge": 4103404,
                "nome": "Cafeara"
            },
            {
                "codigo_ibge": 4103453,
                "nome": "Cafelândia"
            },
            {
                "codigo_ibge": 4103479,
                "nome": "Cafezal do Sul"
            },
            {
                "codigo_ibge": 4103503,
                "nome": "Califórnia"
            },
            {
                "codigo_ibge": 4103602,
                "nome": "Cambará"
            },
            {
                "codigo_ibge": 4103701,
                "nome": "Cambé"
            },
            {
                "codigo_ibge": 4103800,
                "nome": "Cambira"
            },
            {
                "codigo_ibge": 4103909,
                "nome": "Campina da Lagoa"
            },
            {
                "codigo_ibge": 4103958,
                "nome": "Campina do Simão"
            },
            {
                "codigo_ibge": 4104006,
                "nome": "Campina Grande do Sul"
            },
            {
                "codigo_ibge": 4104055,
                "nome": "Campo Bonito"
            },
            {
                "codigo_ibge": 4104105,
                "nome": "Campo do Tenente"
            },
            {
                "codigo_ibge": 4104204,
                "nome": "Campo Largo"
            },
            {
                "codigo_ibge": 4104253,
                "nome": "Campo Magro"
            },
            {
                "codigo_ibge": 4104303,
                "nome": "Campo Mourão"
            },
            {
                "codigo_ibge": 4104402,
                "nome": "Cândido de Abreu"
            },
            {
                "codigo_ibge": 4104428,
                "nome": "Candói"
            },
            {
                "codigo_ibge": 4104451,
                "nome": "Cantagalo"
            },
            {
                "codigo_ibge": 4104501,
                "nome": "Capanema"
            },
            {
                "codigo_ibge": 4104600,
                "nome": "Capitão Leônidas Marques"
            },
            {
                "codigo_ibge": 4104659,
                "nome": "Carambeí"
            },
            {
                "codigo_ibge": 4104709,
                "nome": "Carlópolis"
            },
            {
                "codigo_ibge": 4104808,
                "nome": "Cascavel"
            },
            {
                "codigo_ibge": 4104907,
                "nome": "Castro"
            },
            {
                "codigo_ibge": 4105003,
                "nome": "Catanduvas"
            },
            {
                "codigo_ibge": 4105102,
                "nome": "Centenário do Sul"
            },
            {
                "codigo_ibge": 4105201,
                "nome": "Cerro Azul"
            },
            {
                "codigo_ibge": 4105300,
                "nome": "Céu Azul"
            },
            {
                "codigo_ibge": 4105409,
                "nome": "Chopinzinho"
            },
            {
                "codigo_ibge": 4105508,
                "nome": "Cianorte"
            },
            {
                "codigo_ibge": 4105607,
                "nome": "Cidade Gaúcha"
            },
            {
                "codigo_ibge": 4105706,
                "nome": "Clevelândia"
            },
            {
                "codigo_ibge": 4105805,
                "nome": "Colombo"
            },
            {
                "codigo_ibge": 4105904,
                "nome": "Colorado"
            },
            {
                "codigo_ibge": 4106001,
                "nome": "Congonhinhas"
            },
            {
                "codigo_ibge": 4106100,
                "nome": "Conselheiro Mairinck"
            },
            {
                "codigo_ibge": 4106209,
                "nome": "Contenda"
            },
            {
                "codigo_ibge": 4106308,
                "nome": "Corbélia"
            },
            {
                "codigo_ibge": 4106407,
                "nome": "Cornélio Procópio"
            },
            {
                "codigo_ibge": 4106456,
                "nome": "Coronel Domingos Soares"
            },
            {
                "codigo_ibge": 4106506,
                "nome": "Coronel Vivida"
            },
            {
                "codigo_ibge": 4106555,
                "nome": "Corumbataí do Sul"
            },
            {
                "codigo_ibge": 4106803,
                "nome": "Cruz Machado"
            },
            {
                "codigo_ibge": 4106571,
                "nome": "Cruzeiro do Iguaçu"
            },
            {
                "codigo_ibge": 4106605,
                "nome": "Cruzeiro do Oeste"
            },
            {
                "codigo_ibge": 4106704,
                "nome": "Cruzeiro do Sul"
            },
            {
                "codigo_ibge": 4106852,
                "nome": "Cruzmaltina"
            },
            {
                "codigo_ibge": 4106902,
                "nome": "Curitiba"
            },
            {
                "codigo_ibge": 4107009,
                "nome": "Curiúva"
            },
            {
                "codigo_ibge": 4107157,
                "nome": "Diamante D'Oeste"
            },
            {
                "codigo_ibge": 4107108,
                "nome": "Diamante do Norte"
            },
            {
                "codigo_ibge": 4107124,
                "nome": "Diamante do Sul"
            },
            {
                "codigo_ibge": 4107207,
                "nome": "Dois Vizinhos"
            },
            {
                "codigo_ibge": 4107256,
                "nome": "Douradina"
            },
            {
                "codigo_ibge": 4107306,
                "nome": "Doutor Camargo"
            },
            {
                "codigo_ibge": 4128633,
                "nome": "Doutor Ulysses"
            },
            {
                "codigo_ibge": 4107405,
                "nome": "Enéas Marques"
            },
            {
                "codigo_ibge": 4107504,
                "nome": "Engenheiro Beltrão"
            },
            {
                "codigo_ibge": 4107538,
                "nome": "Entre Rios do Oeste"
            },
            {
                "codigo_ibge": 4107520,
                "nome": "Esperança Nova"
            },
            {
                "codigo_ibge": 4107546,
                "nome": "Espigão Alto do Iguaçu"
            },
            {
                "codigo_ibge": 4107553,
                "nome": "Farol"
            },
            {
                "codigo_ibge": 4107603,
                "nome": "Faxinal"
            },
            {
                "codigo_ibge": 4107652,
                "nome": "Fazenda Rio Grande"
            },
            {
                "codigo_ibge": 4107702,
                "nome": "Fênix"
            },
            {
                "codigo_ibge": 4107736,
                "nome": "Fernandes Pinheiro"
            },
            {
                "codigo_ibge": 4107751,
                "nome": "Figueira"
            },
            {
                "codigo_ibge": 4107850,
                "nome": "Flor da Serra do Sul"
            },
            {
                "codigo_ibge": 4107801,
                "nome": "Floraí"
            },
            {
                "codigo_ibge": 4107900,
                "nome": "Floresta"
            },
            {
                "codigo_ibge": 4108007,
                "nome": "Florestópolis"
            },
            {
                "codigo_ibge": 4108106,
                "nome": "Flórida"
            },
            {
                "codigo_ibge": 4108205,
                "nome": "Formosa do Oeste"
            },
            {
                "codigo_ibge": 4108304,
                "nome": "Foz do Iguaçu"
            },
            {
                "codigo_ibge": 4108452,
                "nome": "Foz do Jordão"
            },
            {
                "codigo_ibge": 4108320,
                "nome": "Francisco Alves"
            },
            {
                "codigo_ibge": 4108403,
                "nome": "Francisco Beltrão"
            },
            {
                "codigo_ibge": 4108502,
                "nome": "General Carneiro"
            },
            {
                "codigo_ibge": 4108551,
                "nome": "Godoy Moreira"
            },
            {
                "codigo_ibge": 4108601,
                "nome": "Goioerê"
            },
            {
                "codigo_ibge": 4108650,
                "nome": "Goioxim"
            },
            {
                "codigo_ibge": 4108700,
                "nome": "Grandes Rios"
            },
            {
                "codigo_ibge": 4108809,
                "nome": "Guaíra"
            },
            {
                "codigo_ibge": 4108908,
                "nome": "Guairaçá"
            },
            {
                "codigo_ibge": 4108957,
                "nome": "Guamiranga"
            },
            {
                "codigo_ibge": 4109005,
                "nome": "Guapirama"
            },
            {
                "codigo_ibge": 4109104,
                "nome": "Guaporema"
            },
            {
                "codigo_ibge": 4109203,
                "nome": "Guaraci"
            },
            {
                "codigo_ibge": 4109302,
                "nome": "Guaraniaçu"
            },
            {
                "codigo_ibge": 4109401,
                "nome": "Guarapuava"
            },
            {
                "codigo_ibge": 4109500,
                "nome": "Guaraqueçaba"
            },
            {
                "codigo_ibge": 4109609,
                "nome": "Guaratuba"
            },
            {
                "codigo_ibge": 4109658,
                "nome": "Honório Serpa"
            },
            {
                "codigo_ibge": 4109708,
                "nome": "Ibaiti"
            },
            {
                "codigo_ibge": 4109757,
                "nome": "Ibema"
            },
            {
                "codigo_ibge": 4109807,
                "nome": "Ibiporã"
            },
            {
                "codigo_ibge": 4109906,
                "nome": "Icaraíma"
            },
            {
                "codigo_ibge": 4110003,
                "nome": "Iguaraçu"
            },
            {
                "codigo_ibge": 4110052,
                "nome": "Iguatu"
            },
            {
                "codigo_ibge": 4110078,
                "nome": "Imbaú"
            },
            {
                "codigo_ibge": 4110102,
                "nome": "Imbituva"
            },
            {
                "codigo_ibge": 4110201,
                "nome": "Inácio Martins"
            },
            {
                "codigo_ibge": 4110300,
                "nome": "Inajá"
            },
            {
                "codigo_ibge": 4110409,
                "nome": "Indianópolis"
            },
            {
                "codigo_ibge": 4110508,
                "nome": "Ipiranga"
            },
            {
                "codigo_ibge": 4110607,
                "nome": "Iporã"
            },
            {
                "codigo_ibge": 4110656,
                "nome": "Iracema do Oeste"
            },
            {
                "codigo_ibge": 4110706,
                "nome": "Irati"
            },
            {
                "codigo_ibge": 4110805,
                "nome": "Iretama"
            },
            {
                "codigo_ibge": 4110904,
                "nome": "Itaguajé"
            },
            {
                "codigo_ibge": 4110953,
                "nome": "Itaipulândia"
            },
            {
                "codigo_ibge": 4111001,
                "nome": "Itambaracá"
            },
            {
                "codigo_ibge": 4111100,
                "nome": "Itambé"
            },
            {
                "codigo_ibge": 4111209,
                "nome": "Itapejara d'Oeste"
            },
            {
                "codigo_ibge": 4111258,
                "nome": "Itaperuçu"
            },
            {
                "codigo_ibge": 4111308,
                "nome": "Itaúna do Sul"
            },
            {
                "codigo_ibge": 4111407,
                "nome": "Ivaí"
            },
            {
                "codigo_ibge": 4111506,
                "nome": "Ivaiporã"
            },
            {
                "codigo_ibge": 4111555,
                "nome": "Ivaté"
            },
            {
                "codigo_ibge": 4111605,
                "nome": "Ivatuba"
            },
            {
                "codigo_ibge": 4111704,
                "nome": "Jaboti"
            },
            {
                "codigo_ibge": 4111803,
                "nome": "Jacarezinho"
            },
            {
                "codigo_ibge": 4111902,
                "nome": "Jaguapitã"
            },
            {
                "codigo_ibge": 4112009,
                "nome": "Jaguariaíva"
            },
            {
                "codigo_ibge": 4112108,
                "nome": "Jandaia do Sul"
            },
            {
                "codigo_ibge": 4112207,
                "nome": "Janiópolis"
            },
            {
                "codigo_ibge": 4112306,
                "nome": "Japira"
            },
            {
                "codigo_ibge": 4112405,
                "nome": "Japurá"
            },
            {
                "codigo_ibge": 4112504,
                "nome": "Jardim Alegre"
            },
            {
                "codigo_ibge": 4112603,
                "nome": "Jardim Olinda"
            },
            {
                "codigo_ibge": 4112702,
                "nome": "Jataizinho"
            },
            {
                "codigo_ibge": 4112751,
                "nome": "Jesuítas"
            },
            {
                "codigo_ibge": 4112801,
                "nome": "Joaquim Távora"
            },
            {
                "codigo_ibge": 4112900,
                "nome": "Jundiaí do Sul"
            },
            {
                "codigo_ibge": 4112959,
                "nome": "Juranda"
            },
            {
                "codigo_ibge": 4113007,
                "nome": "Jussara"
            },
            {
                "codigo_ibge": 4113106,
                "nome": "Kaloré"
            },
            {
                "codigo_ibge": 4113205,
                "nome": "Lapa"
            },
            {
                "codigo_ibge": 4113254,
                "nome": "Laranjal"
            },
            {
                "codigo_ibge": 4113304,
                "nome": "Laranjeiras do Sul"
            },
            {
                "codigo_ibge": 4113403,
                "nome": "Leópolis"
            },
            {
                "codigo_ibge": 4113429,
                "nome": "Lidianópolis"
            },
            {
                "codigo_ibge": 4113452,
                "nome": "Lindoeste"
            },
            {
                "codigo_ibge": 4113502,
                "nome": "Loanda"
            },
            {
                "codigo_ibge": 4113601,
                "nome": "Lobato"
            },
            {
                "codigo_ibge": 4113700,
                "nome": "Londrina"
            },
            {
                "codigo_ibge": 4113734,
                "nome": "Luiziana"
            },
            {
                "codigo_ibge": 4113759,
                "nome": "Lunardelli"
            },
            {
                "codigo_ibge": 4113809,
                "nome": "Lupionópolis"
            },
            {
                "codigo_ibge": 4113908,
                "nome": "Mallet"
            },
            {
                "codigo_ibge": 4114005,
                "nome": "Mamborê"
            },
            {
                "codigo_ibge": 4114104,
                "nome": "Mandaguaçu"
            },
            {
                "codigo_ibge": 4114203,
                "nome": "Mandaguari"
            },
            {
                "codigo_ibge": 4114302,
                "nome": "Mandirituba"
            },
            {
                "codigo_ibge": 4114351,
                "nome": "Manfrinópolis"
            },
            {
                "codigo_ibge": 4114401,
                "nome": "Mangueirinha"
            },
            {
                "codigo_ibge": 4114500,
                "nome": "Manoel Ribas"
            },
            {
                "codigo_ibge": 4114609,
                "nome": "Marechal Cândido Rondon"
            },
            {
                "codigo_ibge": 4114708,
                "nome": "Maria Helena"
            },
            {
                "codigo_ibge": 4114807,
                "nome": "Marialva"
            },
            {
                "codigo_ibge": 4114906,
                "nome": "Marilândia do Sul"
            },
            {
                "codigo_ibge": 4115002,
                "nome": "Marilena"
            },
            {
                "codigo_ibge": 4115101,
                "nome": "Mariluz"
            },
            {
                "codigo_ibge": 4115200,
                "nome": "Maringá"
            },
            {
                "codigo_ibge": 4115309,
                "nome": "Mariópolis"
            },
            {
                "codigo_ibge": 4115358,
                "nome": "Maripá"
            },
            {
                "codigo_ibge": 4115408,
                "nome": "Marmeleiro"
            },
            {
                "codigo_ibge": 4115457,
                "nome": "Marquinho"
            },
            {
                "codigo_ibge": 4115507,
                "nome": "Marumbi"
            },
            {
                "codigo_ibge": 4115606,
                "nome": "Matelândia"
            },
            {
                "codigo_ibge": 4115705,
                "nome": "Matinhos"
            },
            {
                "codigo_ibge": 4115739,
                "nome": "Mato Rico"
            },
            {
                "codigo_ibge": 4115754,
                "nome": "Mauá da Serra"
            },
            {
                "codigo_ibge": 4115804,
                "nome": "Medianeira"
            },
            {
                "codigo_ibge": 4115853,
                "nome": "Mercedes"
            },
            {
                "codigo_ibge": 4115903,
                "nome": "Mirador"
            },
            {
                "codigo_ibge": 4116000,
                "nome": "Miraselva"
            },
            {
                "codigo_ibge": 4116059,
                "nome": "Missal"
            },
            {
                "codigo_ibge": 4116109,
                "nome": "Moreira Sales"
            },
            {
                "codigo_ibge": 4116208,
                "nome": "Morretes"
            },
            {
                "codigo_ibge": 4116307,
                "nome": "Munhoz de Melo"
            },
            {
                "codigo_ibge": 4116406,
                "nome": "Nossa Senhora das Graças"
            },
            {
                "codigo_ibge": 4116505,
                "nome": "Nova Aliança do Ivaí"
            },
            {
                "codigo_ibge": 4116604,
                "nome": "Nova América da Colina"
            },
            {
                "codigo_ibge": 4116703,
                "nome": "Nova Aurora"
            },
            {
                "codigo_ibge": 4116802,
                "nome": "Nova Cantu"
            },
            {
                "codigo_ibge": 4116901,
                "nome": "Nova Esperança"
            },
            {
                "codigo_ibge": 4116950,
                "nome": "Nova Esperança do Sudoeste"
            },
            {
                "codigo_ibge": 4117008,
                "nome": "Nova Fátima"
            },
            {
                "codigo_ibge": 4117057,
                "nome": "Nova Laranjeiras"
            },
            {
                "codigo_ibge": 4117107,
                "nome": "Nova Londrina"
            },
            {
                "codigo_ibge": 4117206,
                "nome": "Nova Olímpia"
            },
            {
                "codigo_ibge": 4117255,
                "nome": "Nova Prata do Iguaçu"
            },
            {
                "codigo_ibge": 4117214,
                "nome": "Nova Santa Bárbara"
            },
            {
                "codigo_ibge": 4117222,
                "nome": "Nova Santa Rosa"
            },
            {
                "codigo_ibge": 4117271,
                "nome": "Nova Tebas"
            },
            {
                "codigo_ibge": 4117297,
                "nome": "Novo Itacolomi"
            },
            {
                "codigo_ibge": 4117305,
                "nome": "Ortigueira"
            },
            {
                "codigo_ibge": 4117404,
                "nome": "Ourizona"
            },
            {
                "codigo_ibge": 4117453,
                "nome": "Ouro Verde do Oeste"
            },
            {
                "codigo_ibge": 4117503,
                "nome": "Paiçandu"
            },
            {
                "codigo_ibge": 4117602,
                "nome": "Palmas"
            },
            {
                "codigo_ibge": 4117701,
                "nome": "Palmeira"
            },
            {
                "codigo_ibge": 4117800,
                "nome": "Palmital"
            },
            {
                "codigo_ibge": 4117909,
                "nome": "Palotina"
            },
            {
                "codigo_ibge": 4118006,
                "nome": "Paraíso do Norte"
            },
            {
                "codigo_ibge": 4118105,
                "nome": "Paranacity"
            },
            {
                "codigo_ibge": 4118204,
                "nome": "Paranaguá"
            },
            {
                "codigo_ibge": 4118303,
                "nome": "Paranapoema"
            },
            {
                "codigo_ibge": 4118402,
                "nome": "Paranavaí"
            },
            {
                "codigo_ibge": 4118451,
                "nome": "Pato Bragado"
            },
            {
                "codigo_ibge": 4118501,
                "nome": "Pato Branco"
            },
            {
                "codigo_ibge": 4118600,
                "nome": "Paula Freitas"
            },
            {
                "codigo_ibge": 4118709,
                "nome": "Paulo Frontin"
            },
            {
                "codigo_ibge": 4118808,
                "nome": "Peabiru"
            },
            {
                "codigo_ibge": 4118857,
                "nome": "Perobal"
            },
            {
                "codigo_ibge": 4118907,
                "nome": "Pérola"
            },
            {
                "codigo_ibge": 4119004,
                "nome": "Pérola d'Oeste"
            },
            {
                "codigo_ibge": 4119103,
                "nome": "Piên"
            },
            {
                "codigo_ibge": 4119152,
                "nome": "Pinhais"
            },
            {
                "codigo_ibge": 4119251,
                "nome": "Pinhal de São Bento"
            },
            {
                "codigo_ibge": 4119202,
                "nome": "Pinhalão"
            },
            {
                "codigo_ibge": 4119301,
                "nome": "Pinhão"
            },
            {
                "codigo_ibge": 4119400,
                "nome": "Piraí do Sul"
            },
            {
                "codigo_ibge": 4119509,
                "nome": "Piraquara"
            },
            {
                "codigo_ibge": 4119608,
                "nome": "Pitanga"
            },
            {
                "codigo_ibge": 4119657,
                "nome": "Pitangueiras"
            },
            {
                "codigo_ibge": 4119707,
                "nome": "Planaltina do Paraná"
            },
            {
                "codigo_ibge": 4119806,
                "nome": "Planalto"
            },
            {
                "codigo_ibge": 4119905,
                "nome": "Ponta Grossa"
            },
            {
                "codigo_ibge": 4119954,
                "nome": "Pontal do Paraná"
            },
            {
                "codigo_ibge": 4120002,
                "nome": "Porecatu"
            },
            {
                "codigo_ibge": 4120101,
                "nome": "Porto Amazonas"
            },
            {
                "codigo_ibge": 4120150,
                "nome": "Porto Barreiro"
            },
            {
                "codigo_ibge": 4120200,
                "nome": "Porto Rico"
            },
            {
                "codigo_ibge": 4120309,
                "nome": "Porto Vitória"
            },
            {
                "codigo_ibge": 4120333,
                "nome": "Prado Ferreira"
            },
            {
                "codigo_ibge": 4120358,
                "nome": "Pranchita"
            },
            {
                "codigo_ibge": 4120408,
                "nome": "Presidente Castelo Branco"
            },
            {
                "codigo_ibge": 4120507,
                "nome": "Primeiro de Maio"
            },
            {
                "codigo_ibge": 4120606,
                "nome": "Prudentópolis"
            },
            {
                "codigo_ibge": 4120655,
                "nome": "Quarto Centenário"
            },
            {
                "codigo_ibge": 4120705,
                "nome": "Quatiguá"
            },
            {
                "codigo_ibge": 4120804,
                "nome": "Quatro Barras"
            },
            {
                "codigo_ibge": 4120853,
                "nome": "Quatro Pontes"
            },
            {
                "codigo_ibge": 4120903,
                "nome": "Quedas do Iguaçu"
            },
            {
                "codigo_ibge": 4121000,
                "nome": "Querência do Norte"
            },
            {
                "codigo_ibge": 4121109,
                "nome": "Quinta do Sol"
            },
            {
                "codigo_ibge": 4121208,
                "nome": "Quitandinha"
            },
            {
                "codigo_ibge": 4121257,
                "nome": "Ramilândia"
            },
            {
                "codigo_ibge": 4121307,
                "nome": "Rancho Alegre"
            },
            {
                "codigo_ibge": 4121356,
                "nome": "Rancho Alegre D'Oeste"
            },
            {
                "codigo_ibge": 4121406,
                "nome": "Realeza"
            },
            {
                "codigo_ibge": 4121505,
                "nome": "Rebouças"
            },
            {
                "codigo_ibge": 4121604,
                "nome": "Renascença"
            },
            {
                "codigo_ibge": 4121703,
                "nome": "Reserva"
            },
            {
                "codigo_ibge": 4121752,
                "nome": "Reserva do Iguaçu"
            },
            {
                "codigo_ibge": 4121802,
                "nome": "Ribeirão Claro"
            },
            {
                "codigo_ibge": 4121901,
                "nome": "Ribeirão do Pinhal"
            },
            {
                "codigo_ibge": 4122008,
                "nome": "Rio Azul"
            },
            {
                "codigo_ibge": 4122107,
                "nome": "Rio Bom"
            },
            {
                "codigo_ibge": 4122156,
                "nome": "Rio Bonito do Iguaçu"
            },
            {
                "codigo_ibge": 4122172,
                "nome": "Rio Branco do Ivaí"
            },
            {
                "codigo_ibge": 4122206,
                "nome": "Rio Branco do Sul"
            },
            {
                "codigo_ibge": 4122305,
                "nome": "Rio Negro"
            },
            {
                "codigo_ibge": 4122404,
                "nome": "Rolândia"
            },
            {
                "codigo_ibge": 4122503,
                "nome": "Roncador"
            },
            {
                "codigo_ibge": 4122602,
                "nome": "Rondon"
            },
            {
                "codigo_ibge": 4122651,
                "nome": "Rosário do Ivaí"
            },
            {
                "codigo_ibge": 4122701,
                "nome": "Sabáudia"
            },
            {
                "codigo_ibge": 4122800,
                "nome": "Salgado Filho"
            },
            {
                "codigo_ibge": 4122909,
                "nome": "Salto do Itararé"
            },
            {
                "codigo_ibge": 4123006,
                "nome": "Salto do Lontra"
            },
            {
                "codigo_ibge": 4123105,
                "nome": "Santa Amélia"
            },
            {
                "codigo_ibge": 4123204,
                "nome": "Santa Cecília do Pavão"
            },
            {
                "codigo_ibge": 4123303,
                "nome": "Santa Cruz de Monte Castelo"
            },
            {
                "codigo_ibge": 4123402,
                "nome": "Santa Fé"
            },
            {
                "codigo_ibge": 4123501,
                "nome": "Santa Helena"
            },
            {
                "codigo_ibge": 4123600,
                "nome": "Santa Inês"
            },
            {
                "codigo_ibge": 4123709,
                "nome": "Santa Isabel do Ivaí"
            },
            {
                "codigo_ibge": 4123808,
                "nome": "Santa Izabel do Oeste"
            },
            {
                "codigo_ibge": 4123824,
                "nome": "Santa Lúcia"
            },
            {
                "codigo_ibge": 4123857,
                "nome": "Santa Maria do Oeste"
            },
            {
                "codigo_ibge": 4123907,
                "nome": "Santa Mariana"
            },
            {
                "codigo_ibge": 4123956,
                "nome": "Santa Mônica"
            },
            {
                "codigo_ibge": 4124020,
                "nome": "Santa Tereza do Oeste"
            },
            {
                "codigo_ibge": 4124053,
                "nome": "Santa Terezinha de Itaipu"
            },
            {
                "codigo_ibge": 4124004,
                "nome": "Santana do Itararé"
            },
            {
                "codigo_ibge": 4124103,
                "nome": "Santo Antônio da Platina"
            },
            {
                "codigo_ibge": 4124202,
                "nome": "Santo Antônio do Caiuá"
            },
            {
                "codigo_ibge": 4124301,
                "nome": "Santo Antônio do Paraíso"
            },
            {
                "codigo_ibge": 4124400,
                "nome": "Santo Antônio do Sudoeste"
            },
            {
                "codigo_ibge": 4124509,
                "nome": "Santo Inácio"
            },
            {
                "codigo_ibge": 4124608,
                "nome": "São Carlos do Ivaí"
            },
            {
                "codigo_ibge": 4124707,
                "nome": "São Jerônimo da Serra"
            },
            {
                "codigo_ibge": 4124806,
                "nome": "São João"
            },
            {
                "codigo_ibge": 4124905,
                "nome": "São João do Caiuá"
            },
            {
                "codigo_ibge": 4125001,
                "nome": "São João do Ivaí"
            },
            {
                "codigo_ibge": 4125100,
                "nome": "São João do Triunfo"
            },
            {
                "codigo_ibge": 4125209,
                "nome": "São Jorge d'Oeste"
            },
            {
                "codigo_ibge": 4125308,
                "nome": "São Jorge do Ivaí"
            },
            {
                "codigo_ibge": 4125357,
                "nome": "São Jorge do Patrocínio"
            },
            {
                "codigo_ibge": 4125407,
                "nome": "São José da Boa Vista"
            },
            {
                "codigo_ibge": 4125456,
                "nome": "São José das Palmeiras"
            },
            {
                "codigo_ibge": 4125506,
                "nome": "São José dos Pinhais"
            },
            {
                "codigo_ibge": 4125555,
                "nome": "São Manoel do Paraná"
            },
            {
                "codigo_ibge": 4125605,
                "nome": "São Mateus do Sul"
            },
            {
                "codigo_ibge": 4125704,
                "nome": "São Miguel do Iguaçu"
            },
            {
                "codigo_ibge": 4125753,
                "nome": "São Pedro do Iguaçu"
            },
            {
                "codigo_ibge": 4125803,
                "nome": "São Pedro do Ivaí"
            },
            {
                "codigo_ibge": 4125902,
                "nome": "São Pedro do Paraná"
            },
            {
                "codigo_ibge": 4126009,
                "nome": "São Sebastião da Amoreira"
            },
            {
                "codigo_ibge": 4126108,
                "nome": "São Tomé"
            },
            {
                "codigo_ibge": 4126207,
                "nome": "Sapopema"
            },
            {
                "codigo_ibge": 4126256,
                "nome": "Sarandi"
            },
            {
                "codigo_ibge": 4126272,
                "nome": "Saudade do Iguaçu"
            },
            {
                "codigo_ibge": 4126306,
                "nome": "Sengés"
            },
            {
                "codigo_ibge": 4126355,
                "nome": "Serranópolis do Iguaçu"
            },
            {
                "codigo_ibge": 4126405,
                "nome": "Sertaneja"
            },
            {
                "codigo_ibge": 4126504,
                "nome": "Sertanópolis"
            },
            {
                "codigo_ibge": 4126603,
                "nome": "Siqueira Campos"
            },
            {
                "codigo_ibge": 4126652,
                "nome": "Sulina"
            },
            {
                "codigo_ibge": 4126678,
                "nome": "Tamarana"
            },
            {
                "codigo_ibge": 4126702,
                "nome": "Tamboara"
            },
            {
                "codigo_ibge": 4126801,
                "nome": "Tapejara"
            },
            {
                "codigo_ibge": 4126900,
                "nome": "Tapira"
            },
            {
                "codigo_ibge": 4127007,
                "nome": "Teixeira Soares"
            },
            {
                "codigo_ibge": 4127106,
                "nome": "Telêmaco Borba"
            },
            {
                "codigo_ibge": 4127205,
                "nome": "Terra Boa"
            },
            {
                "codigo_ibge": 4127304,
                "nome": "Terra Rica"
            },
            {
                "codigo_ibge": 4127403,
                "nome": "Terra Roxa"
            },
            {
                "codigo_ibge": 4127502,
                "nome": "Tibagi"
            },
            {
                "codigo_ibge": 4127601,
                "nome": "Tijucas do Sul"
            },
            {
                "codigo_ibge": 4127700,
                "nome": "Toledo"
            },
            {
                "codigo_ibge": 4127809,
                "nome": "Tomazina"
            },
            {
                "codigo_ibge": 4127858,
                "nome": "Três Barras do Paraná"
            },
            {
                "codigo_ibge": 4127882,
                "nome": "Tunas do Paraná"
            },
            {
                "codigo_ibge": 4127908,
                "nome": "Tuneiras do Oeste"
            },
            {
                "codigo_ibge": 4127957,
                "nome": "Tupãssi"
            },
            {
                "codigo_ibge": 4127965,
                "nome": "Turvo"
            },
            {
                "codigo_ibge": 4128005,
                "nome": "Ubiratã"
            },
            {
                "codigo_ibge": 4128104,
                "nome": "Umuarama"
            },
            {
                "codigo_ibge": 4128203,
                "nome": "União da Vitória"
            },
            {
                "codigo_ibge": 4128302,
                "nome": "Uniflor"
            },
            {
                "codigo_ibge": 4128401,
                "nome": "Uraí"
            },
            {
                "codigo_ibge": 4128534,
                "nome": "Ventania"
            },
            {
                "codigo_ibge": 4128559,
                "nome": "Vera Cruz do Oeste"
            },
            {
                "codigo_ibge": 4128609,
                "nome": "Verê"
            },
            {
                "codigo_ibge": 4128658,
                "nome": "Virmond"
            },
            {
                "codigo_ibge": 4128708,
                "nome": "Vitorino"
            },
            {
                "codigo_ibge": 4128500,
                "nome": "Wenceslau Braz"
            },
            {
                "codigo_ibge": 4128807,
                "nome": "Xambrê"
            }
        ]
    },
    "RJ": {
        "nome": "Rio de Janeiro",
        "municipios": [
            {
                "codigo_ibge": 3300100,
                "nome": "Angra dos Reis"
            },
            {
                "codigo_ibge": 3300159,
                "nome": "Aperibé"
            },
            {
                "codigo_ibge": 3300209,
                "nome": "Araruama"
            },
            {
                "codigo_ibge": 3300225,
                "nome": "Areal"
            },
            {
                "codigo_ibge": 3300233,
                "nome": "Armação dos Búzios"
            },
            {
                "codigo_ibge": 3300258,
                "nome": "Arraial do Cabo"
            },
            {
                "codigo_ibge": 3300308,
                "nome": "Barra do Piraí"
            },
            {
                "codigo_ibge": 3300407,
                "nome": "Barra Mansa"
            },
            {
                "codigo_ibge": 3300456,
                "nome": "Belford Roxo"
            },
            {
                "codigo_ibge": 3300506,
                "nome": "Bom Jardim"
            },
            {
                "codigo_ibge": 3300605,
                "nome": "Bom Jesus do Itabapoana"
            },
            {
                "codigo_ibge": 3300704,
                "nome": "Cabo Frio"
            },
            {
                "codigo_ibge": 3300803,
                "nome": "Cachoeiras de Macacu"
            },
            {
                "codigo_ibge": 3300902,
                "nome": "Cambuci"
            },
            {
                "codigo_ibge": 3301009,
                "nome": "Campos dos Goytacazes"
            },
            {
                "codigo_ibge": 3301108,
                "nome": "Cantagalo"
            },
            {
                "codigo_ibge": 3300936,
                "nome": "Carapebus"
            },
            {
                "codigo_ibge": 3301157,
                "nome": "Cardoso Moreira"
            },
            {
                "codigo_ibge": 3301207,
                "nome": "Carmo"
            },
            {
                "codigo_ibge": 3301306,
                "nome": "Casimiro de Abreu"
            },
            {
                "codigo_ibge": 3300951,
                "nome": "Comendador Levy Gasparian"
            },
            {
                "codigo_ibge": 3301405,
                "nome": "Conceição de Macabu"
            },
            {
                "codigo_ibge": 3301504,
                "nome": "Cordeiro"
            },
            {
                "codigo_ibge": 3301603,
                "nome": "Duas Barras"
            },
            {
                "codigo_ibge": 3301702,
                "nome": "Duque de Caxias"
            },
            {
                "codigo_ibge": 3301801,
                "nome": "Engenheiro Paulo de Frontin"
            },
            {
                "codigo_ibge": 3301850,
                "nome": "Guapimirim"
            },
            {
                "codigo_ibge": 3301876,
                "nome": "Iguaba Grande"
            },
            {
                "codigo_ibge": 3301900,
                "nome": "Itaboraí"
            },
            {
                "codigo_ibge": 3302007,
                "nome": "Itaguaí"
            },
            {
                "codigo_ibge": 3302056,
                "nome": "Italva"
            },
            {
                "codigo_ibge": 3302106,
                "nome": "Itaocara"
            },
            {
                "codigo_ibge": 3302205,
                "nome": "Itaperuna"
            },
            {
                "codigo_ibge": 3302254,
                "nome": "Itatiaia"
            },
            {
                "codigo_ibge": 3302270,
                "nome": "Japeri"
            },
            {
                "codigo_ibge": 3302304,
                "nome": "Laje do Muriaé"
            },
            {
                "codigo_ibge": 3302403,
                "nome": "Macaé"
            },
            {
                "codigo_ibge": 3302452,
                "nome": "Macuco"
            },
            {
                "codigo_ibge": 3302502,
                "nome": "Magé"
            },
            {
                "codigo_ibge": 3302601,
                "nome": "Mangaratiba"
            },
            {
                "codigo_ibge": 3302700,
                "nome": "Maricá"
            },
            {
                "codigo_ibge": 3302809,
                "nome": "Mendes"
            },
            {
                "codigo_ibge": 3302858,
                "nome": "Mesquita"
            },
            {
                "codigo_ibge": 3302908,
                "nome": "Miguel Pereira"
            },
            {
                "codigo_ibge": 3303005,
                "nome": "Miracema"
            },
            {
                "codigo_ibge": 3303104,
                "nome": "Natividade"
            },
            {
                "codigo_ibge": 3303203,
                "nome": "Nilópolis"
            },
            {
                "codigo_ibge": 3303302,
                "nome": "Niterói"
            },
            {
                "codigo_ibge": 3303401,
                "nome": "Nova Friburgo"
            },
            {
                "codigo_ibge": 3303500,
                "nome": "Nova Iguaçu"
            },
            {
                "codigo_ibge": 3303609,
                "nome": "Paracambi"
            },
            {
                "codigo_ibge": 3303708,
                "nome": "Paraíba do Sul"
            },
            {
                "codigo_ibge": 3303807,
                "nome": "Paraty"
            },
            {
                "codigo_ibge": 3303856,
                "nome": "Paty do Alferes"
            },
            {
                "codigo_ibge": 3303906,
                "nome": "Petrópolis"
            },
            {
                "codigo_ibge": 3303955,
                "nome": "Pinheiral"
            },
            {
                "codigo_ibge": 3304003,
                "nome": "Piraí"
            },
            {
                "codigo_ibge": 3304102,
                "nome": "Porciúncula"
            },
            {
                "codigo_ibge": 3304110,
                "nome": "Porto Real"
            },
            {
                "codigo_ibge": 3304128,
                "nome": "Quatis"
            },
            {
                "codigo_ibge": 3304144,
                "nome": "Queimados"
            },
            {
                "codigo_ibge": 3304151,
                "nome": "Quissamã"
            },
            {
                "codigo_ibge": 3304201,
                "nome": "Resende"
            },
            {
                "codigo_ibge": 3304300,
                "nome": "Rio Bonito"
            },
            {
                "codigo_ibge": 3304409,
                "nome": "Rio Claro"
            },
            {
                "codigo_ibge": 3304508,
                "nome": "Rio das Flores"
            },
            {
                "codigo_ibge": 3304524,
                "nome": "Rio das Ostras"
            },
            {
                "codigo_ibge": 3304557,
                "nome": "Rio de Janeiro"
            },
            {
                "codigo_ibge": 3304607,
                "nome": "Santa Maria Madalena"
            },
            {
                "codigo_ibge": 3304706,
                "nome": "Santo Antônio de Pádua"
            },
            {
                "codigo_ibge": 3304805,
                "nome": "São Fidélis"
            },
            {
                "codigo_ibge": 3304755,
                "nome": "São Francisco de Itabapoana"
            },
            {
                "codigo_ibge": 3304904,
                "nome": "São Gonçalo"
            },
            {
                "codigo_ibge": 3305000,
                "nome": "São João da Barra"
            },
            {
                "codigo_ibge": 3305109,
                "nome": "São João de Meriti"
            },
            {
                "codigo_ibge": 3305133,
                "nome": "São José de Ubá"
            },
            {
                "codigo_ibge": 3305158,
                "nome": "São José do Vale do Rio Preto"
            },
            {
                "codigo_ibge": 3305208,
                "nome": "São Pedro da Aldeia"
            },
            {
                "codigo_ibge": 3305307,
                "nome": "São Sebastião do Alto"
            },
            {
                "codigo_ibge": 3305406,
                "nome": "Sapucaia"
            },
            {
                "codigo_ibge": 3305505,
                "nome": "Saquarema"
            },
            {
                "codigo_ibge": 3305554,
                "nome": "Seropédica"
            },
            {
                "codigo_ibge": 3305604,
                "nome": "Silva Jardim"
            },
            {
                "codigo_ibge": 3305703,
                "nome": "Sumidouro"
            },
            {
                "codigo_ibge": 3305752,
                "nome": "Tanguá"
            },
            {
                "codigo_ibge": 3305802,
                "nome": "Teresópolis"
            },
            {
                "codigo_ibge": 3305901,
                "nome": "Trajano de Moraes"
            },
            {
                "codigo_ibge": 3306008,
                "nome": "Três Rios"
            },
            {
                "codigo_ibge": 3306107,
                "nome": "Valença"
            },
            {
                "codigo_ibge": 3306156,
                "nome": "Varre-Sai"
            },
            {
                "codigo_ibge": 3306206,
                "nome": "Vassouras"
            },
            {
                "codigo_ibge": 3306305,
                "nome": "Volta Redonda"
            }
        ]
    },
    "RN": {
        "nome": "Rio Grande do Norte",
        "municipios": [
            {
                "codigo_ibge": 2400109,
                "nome": "Acari"
            },
            {
                "codigo_ibge": 2400208,
                "nome": "Açu"
            },
            {
                "codigo_ibge": 2400307,
                "nome": "Afonso Bezerra"
            },
            {
                "codigo_ibge": 2400406,
                "nome": "Água Nova"
            },
            {
                "codigo_ibge": 2400505,
                "nome": "Alexandria"
            },
            {
                "codigo_ibge": 2400604,
                "nome": "Almino Afonso"
            },
            {
                "codigo_ibge": 2400703,
                "nome": "Alto do Rodrigues"
            },
            {
                "codigo_ibge": 2400802,
                "nome": "Angicos"
            },
            {
                "codigo_ibge": 2400901,
                "nome": "Antônio Martins"
            },
            {
                "codigo_ibge": 2401008,
                "nome": "Apodi"
            },
            {
                "codigo_ibge": 2401107,
                "nome": "Areia Branca"
            },
            {
                "codigo_ibge": 2401206,
                "nome": "Arês"
            },
            {
                "codigo_ibge": 2401305,
                "nome": "Augusto Severo (Campo Grande)"
            },
            {
                "codigo_ibge": 2401404,
                "nome": "Baía Formosa"
            },
            {
                "codigo_ibge": 2401453,
                "nome": "Baraúna"
            },
            {
                "codigo_ibge": 2401503,
                "nome": "Barcelona"
            },
            {
                "codigo_ibge": 2401602,
                "nome": "Bento Fernandes"
            },
            {
                "codigo_ibge": 2401651,
                "nome": "Bodó"
            },
            {
                "codigo_ibge": 2401701,
                "nome": "Bom Jesus"
            },
            {
                "codigo_ibge": 2401800,
                "nome": "Brejinho"
            },
            {
                "codigo_ibge": 2401859,
                "nome": "Caiçara do Norte"
            },
            {
                "codigo_ibge": 2401909,
                "nome": "Caiçara do Rio do Vento"
            },
            {
                "codigo_ibge": 2402006,
                "nome": "Caicó"
            },
            {
                "codigo_ibge": 2402105,
                "nome": "Campo Redondo"
            },
            {
                "codigo_ibge": 2402204,
                "nome": "Canguaretama"
            },
            {
                "codigo_ibge": 2402303,
                "nome": "Caraúbas"
            },
            {
                "codigo_ibge": 2402402,
                "nome": "Carnaúba dos Dantas"
            },
            {
                "codigo_ibge": 2402501,
                "nome": "Carnaubais"
            },
            {
                "codigo_ibge": 2402600,
                "nome": "Ceará-Mirim"
            },
            {
                "codigo_ibge": 2402709,
                "nome": "Cerro Corá"
            },
            {
                "codigo_ibge": 2402808,
                "nome": "Coronel Ezequiel"
            },
            {
                "codigo_ibge": 2402907,
                "nome": "Coronel João Pessoa"
            },
            {
                "codigo_ibge": 2403004,
                "nome": "Cruzeta"
            },
            {
                "codigo_ibge": 2403103,
                "nome": "Currais Novos"
            },
            {
                "codigo_ibge": 2403202,
                "nome": "Doutor Severiano"
            },
            {
                "codigo_ibge": 2403301,
                "nome": "Encanto"
            },
            {
                "codigo_ibge": 2403400,
                "nome": "Equador"
            },
            {
                "codigo_ibge": 2403509,
                "nome": "Espírito Santo"
            },
            {
                "codigo_ibge": 2403608,
                "nome": "Extremoz"
            },
            {
                "codigo_ibge": 2403707,
                "nome": "Felipe Guerra"
            },
            {
                "codigo_ibge": 2403756,
                "nome": "Fernando Pedroza"
            },
            {
                "codigo_ibge": 2403806,
                "nome": "Florânia"
            },
            {
                "codigo_ibge": 2403905,
                "nome": "Francisco Dantas"
            },
            {
                "codigo_ibge": 2404002,
                "nome": "Frutuoso Gomes"
            },
            {
                "codigo_ibge": 2404101,
                "nome": "Galinhos"
            },
            {
                "codigo_ibge": 2404200,
                "nome": "Goianinha"
            },
            {
                "codigo_ibge": 2404309,
                "nome": "Governador Dix-Sept Rosado"
            },
            {
                "codigo_ibge": 2404408,
                "nome": "Grossos"
            },
            {
                "codigo_ibge": 2404507,
                "nome": "Guamaré"
            },
            {
                "codigo_ibge": 2404606,
                "nome": "Ielmo Marinho"
            },
            {
                "codigo_ibge": 2404705,
                "nome": "Ipanguaçu"
            },
            {
                "codigo_ibge": 2404804,
                "nome": "Ipueira"
            },
            {
                "codigo_ibge": 2404853,
                "nome": "Itajá"
            },
            {
                "codigo_ibge": 2404903,
                "nome": "Itaú"
            },
            {
                "codigo_ibge": 2405009,
                "nome": "Jaçanã"
            },
            {
                "codigo_ibge": 2405108,
                "nome": "Jandaíra"
            },
            {
                "codigo_ibge": 2405207,
                "nome": "Janduís"
            },
            {
                "codigo_ibge": 2405306,
                "nome": "Januário Cicco (Boa Saúde)"
            },
            {
                "codigo_ibge": 2405405,
                "nome": "Japi"
            },
            {
                "codigo_ibge": 2405504,
                "nome": "Jardim de Angicos"
            },
            {
                "codigo_ibge": 2405603,
                "nome": "Jardim de Piranhas"
            },
            {
                "codigo_ibge": 2405702,
                "nome": "Jardim do Seridó"
            },
            {
                "codigo_ibge": 2405801,
                "nome": "João Câmara"
            },
            {
                "codigo_ibge": 2405900,
                "nome": "João Dias"
            },
            {
                "codigo_ibge": 2406007,
                "nome": "José da Penha"
            },
            {
                "codigo_ibge": 2406106,
                "nome": "Jucurutu"
            },
            {
                "codigo_ibge": 2406155,
                "nome": "Jundiá"
            },
            {
                "codigo_ibge": 2406205,
                "nome": "Lagoa d'Anta"
            },
            {
                "codigo_ibge": 2406304,
                "nome": "Lagoa de Pedras"
            },
            {
                "codigo_ibge": 2406403,
                "nome": "Lagoa de Velhos"
            },
            {
                "codigo_ibge": 2406502,
                "nome": "Lagoa Nova"
            },
            {
                "codigo_ibge": 2406601,
                "nome": "Lagoa Salgada"
            },
            {
                "codigo_ibge": 2406700,
                "nome": "Lajes"
            },
            {
                "codigo_ibge": 2406809,
                "nome": "Lajes Pintadas"
            },
            {
                "codigo_ibge": 2406908,
                "nome": "Lucrécia"
            },
            {
                "codigo_ibge": 2407005,
                "nome": "Luís Gomes"
            },
            {
                "codigo_ibge": 2407104,
                "nome": "Macaíba"
            },
            {
                "codigo_ibge": 2407203,
                "nome": "Macau"
            },
            {
                "codigo_ibge": 2407252,
                "nome": "Major Sales"
            },
            {
                "codigo_ibge": 2407302,
                "nome": "Marcelino Vieira"
            },
            {
                "codigo_ibge": 2407401,
                "nome": "Martins"
            },
            {
                "codigo_ibge": 2407500,
                "nome": "Maxaranguape"
            },
            {
                "codigo_ibge": 2407609,
                "nome": "Messias Targino"
            },
            {
                "codigo_ibge": 2407708,
                "nome": "Montanhas"
            },
            {
                "codigo_ibge": 2407807,
                "nome": "Monte Alegre"
            },
            {
                "codigo_ibge": 2407906,
                "nome": "Monte das Gameleiras"
            },
            {
                "codigo_ibge": 2408003,
                "nome": "Mossoró"
            },
            {
                "codigo_ibge": 2408102,
                "nome": "Natal"
            },
            {
                "codigo_ibge": 2408201,
                "nome": "Nísia Floresta"
            },
            {
                "codigo_ibge": 2408300,
                "nome": "Nova Cruz"
            },
            {
                "codigo_ibge": 2408409,
                "nome": "Olho-d'Água do Borges"
            },
            {
                "codigo_ibge": 2408508,
                "nome": "Ouro Branco"
            },
            {
                "codigo_ibge": 2408607,
                "nome": "Paraná"
            },
            {
                "codigo_ibge": 2408706,
                "nome": "Paraú"
            },
            {
                "codigo_ibge": 2408805,
                "nome": "Parazinho"
            },
            {
                "codigo_ibge": 2408904,
                "nome": "Parelhas"
            },
            {
                "codigo_ibge": 2403251,
                "nome": "Parnamirim"
            },
            {
                "codigo_ibge": 2409100,
                "nome": "Passa e Fica"
            },
            {
                "codigo_ibge": 2409209,
                "nome": "Passagem"
            },
            {
                "codigo_ibge": 2409308,
                "nome": "Patu"
            },
            {
                "codigo_ibge": 2409407,
                "nome": "Pau dos Ferros"
            },
            {
                "codigo_ibge": 2409506,
                "nome": "Pedra Grande"
            },
            {
                "codigo_ibge": 2409605,
                "nome": "Pedra Preta"
            },
            {
                "codigo_ibge": 2409704,
                "nome": "Pedro Avelino"
            },
            {
                "codigo_ibge": 2409803,
                "nome": "Pedro Velho"
            },
            {
                "codigo_ibge": 2409902,
                "nome": "Pendências"
            },
            {
                "codigo_ibge": 2410009,
                "nome": "Pilões"
            },
            {
                "codigo_ibge": 2410108,
                "nome": "Poço Branco"
            },
            {
                "codigo_ibge": 2410207,
                "nome": "Portalegre"
            },
            {
                "codigo_ibge": 2410256,
                "nome": "Porto do Mangue"
            },
            {
                "codigo_ibge": 2410405,
                "nome": "Pureza"
            },
            {
                "codigo_ibge": 2410504,
                "nome": "Rafael Fernandes"
            },
            {
                "codigo_ibge": 2410603,
                "nome": "Rafael Godeiro"
            },
            {
                "codigo_ibge": 2410702,
                "nome": "Riacho da Cruz"
            },
            {
                "codigo_ibge": 2410801,
                "nome": "Riacho de Santana"
            },
            {
                "codigo_ibge": 2410900,
                "nome": "Riachuelo"
            },
            {
                "codigo_ibge": 2408953,
                "nome": "Rio do Fogo"
            },
            {
                "codigo_ibge": 2411007,
                "nome": "Rodolfo Fernandes"
            },
            {
                "codigo_ibge": 2411106,
                "nome": "Ruy Barbosa"
            },
            {
                "codigo_ibge": 2411205,
                "nome": "Santa Cruz"
            },
            {
                "codigo_ibge": 2409332,
                "nome": "Santa Maria"
            },
            {
                "codigo_ibge": 2411403,
                "nome": "Santana do Matos"
            },
            {
                "codigo_ibge": 2411429,
                "nome": "Santana do Seridó"
            },
            {
                "codigo_ibge": 2411502,
                "nome": "Santo Antônio"
            },
            {
                "codigo_ibge": 2411601,
                "nome": "São Bento do Norte"
            },
            {
                "codigo_ibge": 2411700,
                "nome": "São Bento do Trairí"
            },
            {
                "codigo_ibge": 2411809,
                "nome": "São Fernando"
            },
            {
                "codigo_ibge": 2411908,
                "nome": "São Francisco do Oeste"
            },
            {
                "codigo_ibge": 2412005,
                "nome": "São Gonçalo do Amarante"
            },
            {
                "codigo_ibge": 2412104,
                "nome": "São João do Sabugi"
            },
            {
                "codigo_ibge": 2412203,
                "nome": "São José de Mipibu"
            },
            {
                "codigo_ibge": 2412302,
                "nome": "São José do Campestre"
            },
            {
                "codigo_ibge": 2412401,
                "nome": "São José do Seridó"
            },
            {
                "codigo_ibge": 2412500,
                "nome": "São Miguel"
            },
            {
                "codigo_ibge": 2412559,
                "nome": "São Miguel do Gostoso"
            },
            {
                "codigo_ibge": 2412609,
                "nome": "São Paulo do Potengi"
            },
            {
                "codigo_ibge": 2412708,
                "nome": "São Pedro"
            },
            {
                "codigo_ibge": 2412807,
                "nome": "São Rafael"
            },
            {
                "codigo_ibge": 2412906,
                "nome": "São Tomé"
            },
            {
                "codigo_ibge": 2413003,
                "nome": "São Vicente"
            },
            {
                "codigo_ibge": 2413102,
                "nome": "Senador Elói de Souza"
            },
            {
                "codigo_ibge": 2413201,
                "nome": "Senador Georgino Avelino"
            },
            {
                "codigo_ibge": 2410306,
                "nome": "Serra Caiada"
            },
            {
                "codigo_ibge": 2413300,
                "nome": "Serra de São Bento"
            },
            {
                "codigo_ibge": 2413359,
                "nome": "Serra do Mel"
            },
            {
                "codigo_ibge": 2413409,
                "nome": "Serra Negra do Norte"
            },
            {
                "codigo_ibge": 2413508,
                "nome": "Serrinha"
            },
            {
                "codigo_ibge": 2413557,
                "nome": "Serrinha dos Pintos"
            },
            {
                "codigo_ibge": 2413607,
                "nome": "Severiano Melo"
            },
            {
                "codigo_ibge": 2413706,
                "nome": "Sítio Novo"
            },
            {
                "codigo_ibge": 2413805,
                "nome": "Taboleiro Grande"
            },
            {
                "codigo_ibge": 2413904,
                "nome": "Taipu"
            },
            {
                "codigo_ibge": 2414001,
                "nome": "Tangará"
            },
            {
                "codigo_ibge": 2414100,
                "nome": "Tenente Ananias"
            },
            {
                "codigo_ibge": 2414159,
                "nome": "Tenente Laurentino Cruz"
            },
            {
                "codigo_ibge": 2411056,
                "nome": "Tibau"
            },
            {
                "codigo_ibge": 2414209,
                "nome": "Tibau do Sul"
            },
            {
                "codigo_ibge": 2414308,
                "nome": "Timbaúba dos Batistas"
            },
            {
                "codigo_ibge": 2414407,
                "nome": "Touros"
            },
            {
                "codigo_ibge": 2414456,
                "nome": "Triunfo Potiguar"
            },
            {
                "codigo_ibge": 2414506,
                "nome": "Umarizal"
            },
            {
                "codigo_ibge": 2414605,
                "nome": "Upanema"
            },
            {
                "codigo_ibge": 2414704,
                "nome": "Várzea"
            },
            {
                "codigo_ibge": 2414753,
                "nome": "Venha-Ver"
            },
            {
                "codigo_ibge": 2414803,
                "nome": "Vera Cruz"
            },
            {
                "codigo_ibge": 2414902,
                "nome": "Viçosa"
            },
            {
                "codigo_ibge": 2415008,
                "nome": "Vila Flor"
            }
        ]
    },
    "RO": {
        "nome": "Rondônia",
        "municipios": [
            {
                "codigo_ibge": 1100015,
                "nome": "Alta Floresta D'Oeste"
            },
            {
                "codigo_ibge": 1100379,
                "nome": "Alto Alegre dos Parecis"
            },
            {
                "codigo_ibge": 1100403,
                "nome": "Alto Paraíso"
            },
            {
                "codigo_ibge": 1100346,
                "nome": "Alvorada D'Oeste"
            },
            {
                "codigo_ibge": 1100023,
                "nome": "Ariquemes"
            },
            {
                "codigo_ibge": 1100452,
                "nome": "Buritis"
            },
            {
                "codigo_ibge": 1100031,
                "nome": "Cabixi"
            },
            {
                "codigo_ibge": 1100601,
                "nome": "Cacaulândia"
            },
            {
                "codigo_ibge": 1100049,
                "nome": "Cacoal"
            },
            {
                "codigo_ibge": 1100700,
                "nome": "Campo Novo de Rondônia"
            },
            {
                "codigo_ibge": 1100809,
                "nome": "Candeias do Jamari"
            },
            {
                "codigo_ibge": 1100908,
                "nome": "Castanheiras"
            },
            {
                "codigo_ibge": 1100056,
                "nome": "Cerejeiras"
            },
            {
                "codigo_ibge": 1100924,
                "nome": "Chupinguaia"
            },
            {
                "codigo_ibge": 1100064,
                "nome": "Colorado do Oeste"
            },
            {
                "codigo_ibge": 1100072,
                "nome": "Corumbiara"
            },
            {
                "codigo_ibge": 1100080,
                "nome": "Costa Marques"
            },
            {
                "codigo_ibge": 1100940,
                "nome": "Cujubim"
            },
            {
                "codigo_ibge": 1100098,
                "nome": "Espigão D'Oeste"
            },
            {
                "codigo_ibge": 1101005,
                "nome": "Governador Jorge Teixeira"
            },
            {
                "codigo_ibge": 1100106,
                "nome": "Guajará-Mirim"
            },
            {
                "codigo_ibge": 1101104,
                "nome": "Itapuã do Oeste"
            },
            {
                "codigo_ibge": 1100114,
                "nome": "Jaru"
            },
            {
                "codigo_ibge": 1100122,
                "nome": "Ji-Paraná"
            },
            {
                "codigo_ibge": 1100130,
                "nome": "Machadinho D'Oeste"
            },
            {
                "codigo_ibge": 1101203,
                "nome": "Ministro Andreazza"
            },
            {
                "codigo_ibge": 1101302,
                "nome": "Mirante da Serra"
            },
            {
                "codigo_ibge": 1101401,
                "nome": "Monte Negro"
            },
            {
                "codigo_ibge": 1100148,
                "nome": "Nova Brasilândia D'Oeste"
            },
            {
                "codigo_ibge": 1100338,
                "nome": "Nova Mamoré"
            },
            {
                "codigo_ibge": 1101435,
                "nome": "Nova União"
            },
            {
                "codigo_ibge": 1100502,
                "nome": "Novo Horizonte do Oeste"
            },
            {
                "codigo_ibge": 1100155,
                "nome": "Ouro Preto do Oeste"
            },
            {
                "codigo_ibge": 1101450,
                "nome": "Parecis"
            },
            {
                "codigo_ibge": 1100189,
                "nome": "Pimenta Bueno"
            },
            {
                "codigo_ibge": 1101468,
                "nome": "Pimenteiras do Oeste"
            },
            {
                "codigo_ibge": 1100205,
                "nome": "Porto Velho"
            },
            {
                "codigo_ibge": 1100254,
                "nome": "Presidente Médici"
            },
            {
                "codigo_ibge": 1101476,
                "nome": "Primavera de Rondônia"
            },
            {
                "codigo_ibge": 1100262,
                "nome": "Rio Crespo"
            },
            {
                "codigo_ibge": 1100288,
                "nome": "Rolim de Moura"
            },
            {
                "codigo_ibge": 1100296,
                "nome": "Santa Luzia D'Oeste"
            },
            {
                "codigo_ibge": 1101484,
                "nome": "São Felipe D'Oeste"
            },
            {
                "codigo_ibge": 1101492,
                "nome": "São Francisco do Guaporé"
            },
            {
                "codigo_ibge": 1100320,
                "nome": "São Miguel do Guaporé"
            },
            {
                "codigo_ibge": 1101500,
                "nome": "Seringueiras"
            },
            {
                "codigo_ibge": 1101559,
                "nome": "Teixeirópolis"
            },
            {
                "codigo_ibge": 1101609,
                "nome": "Theobroma"
            },
            {
                "codigo_ibge": 1101708,
                "nome": "Urupá"
            },
            {
                "codigo_ibge": 1101757,
                "nome": "Vale do Anari"
            },
            {
                "codigo_ibge": 1101807,
                "nome": "Vale do Paraíso"
            },
            {
                "codigo_ibge": 1100304,
                "nome": "Vilhena"
            }
        ]
    },
    "RR": {
        "nome": "Roraima",
        "municipios": [
            {
                "codigo_ibge": 1400050,
                "nome": "Alto Alegre"
            },
            {
                "codigo_ibge": 1400027,
                "nome": "Amajari"
            },
            {
                "codigo_ibge": 1400100,
                "nome": "Boa Vista"
            },
            {
                "codigo_ibge": 1400159,
                "nome": "Bonfim"
            },
            {
                "codigo_ibge": 1400175,
                "nome": "Cantá"
            },
            {
                "codigo_ibge": 1400209,
                "nome": "Caracaraí"
            },
            {
                "codigo_ibge": 1400233,
                "nome": "Caroebe"
            },
            {
                "codigo_ibge": 1400282,
                "nome": "Iracema"
            },
            {
                "codigo_ibge": 1400308,
                "nome": "Mucajaí"
            },
            {
                "codigo_ibge": 1400407,
                "nome": "Normandia"
            },
            {
                "codigo_ibge": 1400456,
                "nome": "Pacaraima"
            },
            {
                "codigo_ibge": 1400472,
                "nome": "Rorainópolis"
            },
            {
                "codigo_ibge": 1400506,
                "nome": "São João da Baliza"
            },
            {
                "codigo_ibge": 1400605,
                "nome": "São Luiz"
            },
            {
                "codigo_ibge": 1400704,
                "nome": "Uiramutã"
            }
        ]
    },
    "RS": {
        "nome": "Rio Grande do Sul",
        "municipios": [
            {
                "codigo_ibge": 4300034,
                "nome": "Aceguá"
            },
            {
                "codigo_ibge": 4300059,
                "nome": "Água Santa"
            },
            {
                "codigo_ibge": 4300109,
                "nome": "Agudo"
            },
            {
                "codigo_ibge": 4300208,
                "nome": "Ajuricaba"
            },
            {
                "codigo_ibge": 4300307,
                "nome": "Alecrim"
            },
            {
                "codigo_ibge": 4300406,
                "nome": "Alegrete"
            },
            {
                "codigo_ibge": 4300455,
                "nome": "Alegria"
            },
            {
                "codigo_ibge": 4300471,
                "nome": "Almirante Tamandaré do Sul"
            },
            {
                "codigo_ibge": 4300505,
                "nome": "Alpestre"
            },
            {
                "codigo_ibge": 4300554,
                "nome": "Alto Alegre"
            },
            {
                "codigo_ibge": 4300570,
                "nome": "Alto Feliz"
            },
            {
                "codigo_ibge": 4300604,
                "nome": "Alvorada"
            },
            {
                "codigo_ibge": 4300638,
                "nome": "Amaral Ferrador"
            },
            {
                "codigo_ibge": 4300646,
                "nome": "Ametista do Sul"
            },
            {
                "codigo_ibge": 4300661,
                "nome": "André da Rocha"
            },
            {
                "codigo_ibge": 4300703,
                "nome": "Anta Gorda"
            },
            {
                "codigo_ibge": 4300802,
                "nome": "Antônio Prado"
            },
            {
                "codigo_ibge": 4300851,
                "nome": "Arambaré"
            },
            {
                "codigo_ibge": 4300877,
                "nome": "Araricá"
            },
            {
                "codigo_ibge": 4300901,
                "nome": "Aratiba"
            },
            {
                "codigo_ibge": 4301008,
                "nome": "Arroio do Meio"
            },
            {
                "codigo_ibge": 4301073,
                "nome": "Arroio do Padre"
            },
            {
                "codigo_ibge": 4301057,
                "nome": "Arroio do Sal"
            },
            {
                "codigo_ibge": 4301206,
                "nome": "Arroio do Tigre"
            },
            {
                "codigo_ibge": 4301107,
                "nome": "Arroio dos Ratos"
            },
            {
                "codigo_ibge": 4301305,
                "nome": "Arroio Grande"
            },
            {
                "codigo_ibge": 4301404,
                "nome": "Arvorezinha"
            },
            {
                "codigo_ibge": 4301503,
                "nome": "Augusto Pestana"
            },
            {
                "codigo_ibge": 4301552,
                "nome": "Áurea"
            },
            {
                "codigo_ibge": 4301602,
                "nome": "Bagé"
            },
            {
                "codigo_ibge": 4301636,
                "nome": "Balneário Pinhal"
            },
            {
                "codigo_ibge": 4301651,
                "nome": "Barão"
            },
            {
                "codigo_ibge": 4301701,
                "nome": "Barão de Cotegipe"
            },
            {
                "codigo_ibge": 4301750,
                "nome": "Barão do Triunfo"
            },
            {
                "codigo_ibge": 4301859,
                "nome": "Barra do Guarita"
            },
            {
                "codigo_ibge": 4301875,
                "nome": "Barra do Quaraí"
            },
            {
                "codigo_ibge": 4301909,
                "nome": "Barra do Ribeiro"
            },
            {
                "codigo_ibge": 4301925,
                "nome": "Barra do Rio Azul"
            },
            {
                "codigo_ibge": 4301958,
                "nome": "Barra Funda"
            },
            {
                "codigo_ibge": 4301800,
                "nome": "Barracão"
            },
            {
                "codigo_ibge": 4302006,
                "nome": "Barros Cassal"
            },
            {
                "codigo_ibge": 4302055,
                "nome": "Benjamin Constant do Sul"
            },
            {
                "codigo_ibge": 4302105,
                "nome": "Bento Gonçalves"
            },
            {
                "codigo_ibge": 4302154,
                "nome": "Boa Vista das Missões"
            },
            {
                "codigo_ibge": 4302204,
                "nome": "Boa Vista do Buricá"
            },
            {
                "codigo_ibge": 4302220,
                "nome": "Boa Vista do Cadeado"
            },
            {
                "codigo_ibge": 4302238,
                "nome": "Boa Vista do Incra"
            },
            {
                "codigo_ibge": 4302253,
                "nome": "Boa Vista do Sul"
            },
            {
                "codigo_ibge": 4302303,
                "nome": "Bom Jesus"
            },
            {
                "codigo_ibge": 4302352,
                "nome": "Bom Princípio"
            },
            {
                "codigo_ibge": 4302378,
                "nome": "Bom Progresso"
            },
            {
                "codigo_ibge": 4302402,
                "nome": "Bom Retiro do Sul"
            },
            {
                "codigo_ibge": 4302451,
                "nome": "Boqueirão do Leão"
            },
            {
                "codigo_ibge": 4302501,
                "nome": "Bossoroca"
            },
            {
                "codigo_ibge": 4302584,
                "nome": "Bozano"
            },
            {
                "codigo_ibge": 4302600,
                "nome": "Braga"
            },
            {
                "codigo_ibge": 4302659,
                "nome": "Brochier"
            },
            {
                "codigo_ibge": 4302709,
                "nome": "Butiá"
            },
            {
                "codigo_ibge": 4302808,
                "nome": "Caçapava do Sul"
            },
            {
                "codigo_ibge": 4302907,
                "nome": "Cacequi"
            },
            {
                "codigo_ibge": 4303004,
                "nome": "Cachoeira do Sul"
            },
            {
                "codigo_ibge": 4303103,
                "nome": "Cachoeirinha"
            },
            {
                "codigo_ibge": 4303202,
                "nome": "Cacique Doble"
            },
            {
                "codigo_ibge": 4303301,
                "nome": "Caibaté"
            },
            {
                "codigo_ibge": 4303400,
                "nome": "Caiçara"
            },
            {
                "codigo_ibge": 4303509,
                "nome": "Camaquã"
            },
            {
                "codigo_ibge": 4303558,
                "nome": "Camargo"
            },
            {
                "codigo_ibge": 4303608,
                "nome": "Cambará do Sul"
            },
            {
                "codigo_ibge": 4303673,
                "nome": "Campestre da Serra"
            },
            {
                "codigo_ibge": 4303707,
                "nome": "Campina das Missões"
            },
            {
                "codigo_ibge": 4303806,
                "nome": "Campinas do Sul"
            },
            {
                "codigo_ibge": 4303905,
                "nome": "Campo Bom"
            },
            {
                "codigo_ibge": 4304002,
                "nome": "Campo Novo"
            },
            {
                "codigo_ibge": 4304101,
                "nome": "Campos Borges"
            },
            {
                "codigo_ibge": 4304200,
                "nome": "Candelária"
            },
            {
                "codigo_ibge": 4304309,
                "nome": "Cândido Godói"
            },
            {
                "codigo_ibge": 4304358,
                "nome": "Candiota"
            },
            {
                "codigo_ibge": 4304408,
                "nome": "Canela"
            },
            {
                "codigo_ibge": 4304507,
                "nome": "Canguçu"
            },
            {
                "codigo_ibge": 4304606,
                "nome": "Canoas"
            },
            {
                "codigo_ibge": 4304614,
                "nome": "Canudos do Vale"
            },
            {
                "codigo_ibge": 4304622,
                "nome": "Capão Bonito do Sul"
            },
            {
                "codigo_ibge": 4304630,
                "nome": "Capão da Canoa"
            },
            {
                "codigo_ibge": 4304655,
                "nome": "Capão do Cipó"
            },
            {
                "codigo_ibge": 4304663,
                "nome": "Capão do Leão"
            },
            {
                "codigo_ibge": 4304689,
                "nome": "Capela de Santana"
            },
            {
                "codigo_ibge": 4304697,
                "nome": "Capitão"
            },
            {
                "codigo_ibge": 4304671,
                "nome": "Capivari do Sul"
            },
            {
                "codigo_ibge": 4304713,
                "nome": "Caraá"
            },
            {
                "codigo_ibge": 4304705,
                "nome": "Carazinho"
            },
            {
                "codigo_ibge": 4304804,
                "nome": "Carlos Barbosa"
            },
            {
                "codigo_ibge": 4304853,
                "nome": "Carlos Gomes"
            },
            {
                "codigo_ibge": 4304903,
                "nome": "Casca"
            },
            {
                "codigo_ibge": 4304952,
                "nome": "Caseiros"
            },
            {
                "codigo_ibge": 4305009,
                "nome": "Catuípe"
            },
            {
                "codigo_ibge": 4305108,
                "nome": "Caxias do Sul"
            },
            {
                "codigo_ibge": 4305116,
                "nome": "Centenário"
            },
            {
                "codigo_ibge": 4305124,
                "nome": "Cerrito"
            },
            {
                "codigo_ibge": 4305132,
                "nome": "Cerro Branco"
            },
            {
                "codigo_ibge": 4305157,
                "nome": "Cerro Grande"
            },
            {
                "codigo_ibge": 4305173,
                "nome": "Cerro Grande do Sul"
            },
            {
                "codigo_ibge": 4305207,
                "nome": "Cerro Largo"
            },
            {
                "codigo_ibge": 4305306,
                "nome": "Chapada"
            },
            {
                "codigo_ibge": 4305355,
                "nome": "Charqueadas"
            },
            {
                "codigo_ibge": 4305371,
                "nome": "Charrua"
            },
            {
                "codigo_ibge": 4305405,
                "nome": "Chiapetta"
            },
            {
                "codigo_ibge": 4305439,
                "nome": "Chuí"
            },
            {
                "codigo_ibge": 4305447,
                "nome": "Chuvisca"
            },
            {
                "codigo_ibge": 4305454,
                "nome": "Cidreira"
            },
            {
                "codigo_ibge": 4305504,
                "nome": "Ciríaco"
            },
            {
                "codigo_ibge": 4305587,
                "nome": "Colinas"
            },
            {
                "codigo_ibge": 4305603,
                "nome": "Colorado"
            },
            {
                "codigo_ibge": 4305702,
                "nome": "Condor"
            },
            {
                "codigo_ibge": 4305801,
                "nome": "Constantina"
            },
            {
                "codigo_ibge": 4305835,
                "nome": "Coqueiro Baixo"
            },
            {
                "codigo_ibge": 4305850,
                "nome": "Coqueiros do Sul"
            },
            {
                "codigo_ibge": 4305871,
                "nome": "Coronel Barros"
            },
            {
                "codigo_ibge": 4305900,
                "nome": "Coronel Bicaco"
            },
            {
                "codigo_ibge": 4305934,
                "nome": "Coronel Pilar"
            },
            {
                "codigo_ibge": 4305959,
                "nome": "Cotiporã"
            },
            {
                "codigo_ibge": 4305975,
                "nome": "Coxilha"
            },
            {
                "codigo_ibge": 4306007,
                "nome": "Crissiumal"
            },
            {
                "codigo_ibge": 4306056,
                "nome": "Cristal"
            },
            {
                "codigo_ibge": 4306072,
                "nome": "Cristal do Sul"
            },
            {
                "codigo_ibge": 4306106,
                "nome": "Cruz Alta"
            },
            {
                "codigo_ibge": 4306130,
                "nome": "Cruzaltense"
            },
            {
                "codigo_ibge": 4306205,
                "nome": "Cruzeiro do Sul"
            },
            {
                "codigo_ibge": 4306304,
                "nome": "David Canabarro"
            },
            {
                "codigo_ibge": 4306320,
                "nome": "Derrubadas"
            },
            {
                "codigo_ibge": 4306353,
                "nome": "Dezesseis de Novembro"
            },
            {
                "codigo_ibge": 4306379,
                "nome": "Dilermando de Aguiar"
            },
            {
                "codigo_ibge": 4306403,
                "nome": "Dois Irmãos"
            },
            {
                "codigo_ibge": 4306429,
                "nome": "Dois Irmãos das Missões"
            },
            {
                "codigo_ibge": 4306452,
                "nome": "Dois Lajeados"
            },
            {
                "codigo_ibge": 4306502,
                "nome": "Dom Feliciano"
            },
            {
                "codigo_ibge": 4306601,
                "nome": "Dom Pedrito"
            },
            {
                "codigo_ibge": 4306551,
                "nome": "Dom Pedro de Alcântara"
            },
            {
                "codigo_ibge": 4306700,
                "nome": "Dona Francisca"
            },
            {
                "codigo_ibge": 4306734,
                "nome": "Doutor Maurício Cardoso"
            },
            {
                "codigo_ibge": 4306759,
                "nome": "Doutor Ricardo"
            },
            {
                "codigo_ibge": 4306767,
                "nome": "Eldorado do Sul"
            },
            {
                "codigo_ibge": 4306809,
                "nome": "Encantado"
            },
            {
                "codigo_ibge": 4306908,
                "nome": "Encruzilhada do Sul"
            },
            {
                "codigo_ibge": 4306924,
                "nome": "Engenho Velho"
            },
            {
                "codigo_ibge": 4306957,
                "nome": "Entre Rios do Sul"
            },
            {
                "codigo_ibge": 4306932,
                "nome": "Entre-Ijuís"
            },
            {
                "codigo_ibge": 4306973,
                "nome": "Erebango"
            },
            {
                "codigo_ibge": 4307005,
                "nome": "Erechim"
            },
            {
                "codigo_ibge": 4307054,
                "nome": "Ernestina"
            },
            {
                "codigo_ibge": 4307203,
                "nome": "Erval Grande"
            },
            {
                "codigo_ibge": 4307302,
                "nome": "Erval Seco"
            },
            {
                "codigo_ibge": 4307401,
                "nome": "Esmeralda"
            },
            {
                "codigo_ibge": 4307450,
                "nome": "Esperança do Sul"
            },
            {
                "codigo_ibge": 4307500,
                "nome": "Espumoso"
            },
            {
                "codigo_ibge": 4307559,
                "nome": "Estação"
            },
            {
                "codigo_ibge": 4307609,
                "nome": "Estância Velha"
            },
            {
                "codigo_ibge": 4307708,
                "nome": "Esteio"
            },
            {
                "codigo_ibge": 4307807,
                "nome": "Estrela"
            },
            {
                "codigo_ibge": 4307815,
                "nome": "Estrela Velha"
            },
            {
                "codigo_ibge": 4307831,
                "nome": "Eugênio de Castro"
            },
            {
                "codigo_ibge": 4307864,
                "nome": "Fagundes Varela"
            },
            {
                "codigo_ibge": 4307906,
                "nome": "Farroupilha"
            },
            {
                "codigo_ibge": 4308003,
                "nome": "Faxinal do Soturno"
            },
            {
                "codigo_ibge": 4308052,
                "nome": "Faxinalzinho"
            },
            {
                "codigo_ibge": 4308078,
                "nome": "Fazenda Vilanova"
            },
            {
                "codigo_ibge": 4308102,
                "nome": "Feliz"
            },
            {
                "codigo_ibge": 4308201,
                "nome": "Flores da Cunha"
            },
            {
                "codigo_ibge": 4308250,
                "nome": "Floriano Peixoto"
            },
            {
                "codigo_ibge": 4308300,
                "nome": "Fontoura Xavier"
            },
            {
                "codigo_ibge": 4308409,
                "nome": "Formigueiro"
            },
            {
                "codigo_ibge": 4308433,
                "nome": "Forquetinha"
            },
            {
                "codigo_ibge": 4308458,
                "nome": "Fortaleza dos Valos"
            },
            {
                "codigo_ibge": 4308508,
                "nome": "Frederico Westphalen"
            },
            {
                "codigo_ibge": 4308607,
                "nome": "Garibaldi"
            },
            {
                "codigo_ibge": 4308656,
                "nome": "Garruchos"
            },
            {
                "codigo_ibge": 4308706,
                "nome": "Gaurama"
            },
            {
                "codigo_ibge": 4308805,
                "nome": "General Câmara"
            },
            {
                "codigo_ibge": 4308854,
                "nome": "Gentil"
            },
            {
                "codigo_ibge": 4308904,
                "nome": "Getúlio Vargas"
            },
            {
                "codigo_ibge": 4309001,
                "nome": "Giruá"
            },
            {
                "codigo_ibge": 4309050,
                "nome": "Glorinha"
            },
            {
                "codigo_ibge": 4309100,
                "nome": "Gramado"
            },
            {
                "codigo_ibge": 4309126,
                "nome": "Gramado dos Loureiros"
            },
            {
                "codigo_ibge": 4309159,
                "nome": "Gramado Xavier"
            },
            {
                "codigo_ibge": 4309209,
                "nome": "Gravataí"
            },
            {
                "codigo_ibge": 4309258,
                "nome": "Guabiju"
            },
            {
                "codigo_ibge": 4309308,
                "nome": "Guaíba"
            },
            {
                "codigo_ibge": 4309407,
                "nome": "Guaporé"
            },
            {
                "codigo_ibge": 4309506,
                "nome": "Guarani das Missões"
            },
            {
                "codigo_ibge": 4309555,
                "nome": "Harmonia"
            },
            {
                "codigo_ibge": 4307104,
                "nome": "Herval"
            },
            {
                "codigo_ibge": 4309571,
                "nome": "Herveiras"
            },
            {
                "codigo_ibge": 4309605,
                "nome": "Horizontina"
            },
            {
                "codigo_ibge": 4309654,
                "nome": "Hulha Negra"
            },
            {
                "codigo_ibge": 4309704,
                "nome": "Humaitá"
            },
            {
                "codigo_ibge": 4309753,
                "nome": "Ibarama"
            },
            {
                "codigo_ibge": 4309803,
                "nome": "Ibiaçá"
            },
            {
                "codigo_ibge": 4309902,
                "nome": "Ibiraiaras"
            },
            {
                "codigo_ibge": 4309951,
                "nome": "Ibirapuitã"
            },
            {
                "codigo_ibge": 4310009,
                "nome": "Ibirubá"
            },
            {
                "codigo_ibge": 4310108,
                "nome": "Igrejinha"
            },
            {
                "codigo_ibge": 4310207,
                "nome": "Ijuí"
            },
            {
                "codigo_ibge": 4310306,
                "nome": "Ilópolis"
            },
            {
                "codigo_ibge": 4310330,
                "nome": "Imbé"
            },
            {
                "codigo_ibge": 4310363,
                "nome": "Imigrante"
            },
            {
                "codigo_ibge": 4310405,
                "nome": "Independência"
            },
            {
                "codigo_ibge": 4310413,
                "nome": "Inhacorá"
            },
            {
                "codigo_ibge": 4310439,
                "nome": "Ipê"
            },
            {
                "codigo_ibge": 4310462,
                "nome": "Ipiranga do Sul"
            },
            {
                "codigo_ibge": 4310504,
                "nome": "Iraí"
            },
            {
                "codigo_ibge": 4310538,
                "nome": "Itaara"
            },
            {
                "codigo_ibge": 4310553,
                "nome": "Itacurubi"
            },
            {
                "codigo_ibge": 4310579,
                "nome": "Itapuca"
            },
            {
                "codigo_ibge": 4310603,
                "nome": "Itaqui"
            },
            {
                "codigo_ibge": 4310652,
                "nome": "Itati"
            },
            {
                "codigo_ibge": 4310702,
                "nome": "Itatiba do Sul"
            },
            {
                "codigo_ibge": 4310751,
                "nome": "Ivorá"
            },
            {
                "codigo_ibge": 4310801,
                "nome": "Ivoti"
            },
            {
                "codigo_ibge": 4310850,
                "nome": "Jaboticaba"
            },
            {
                "codigo_ibge": 4310876,
                "nome": "Jacuizinho"
            },
            {
                "codigo_ibge": 4310900,
                "nome": "Jacutinga"
            },
            {
                "codigo_ibge": 4311007,
                "nome": "Jaguarão"
            },
            {
                "codigo_ibge": 4311106,
                "nome": "Jaguari"
            },
            {
                "codigo_ibge": 4311122,
                "nome": "Jaquirana"
            },
            {
                "codigo_ibge": 4311130,
                "nome": "Jari"
            },
            {
                "codigo_ibge": 4311155,
                "nome": "Jóia"
            },
            {
                "codigo_ibge": 4311205,
                "nome": "Júlio de Castilhos"
            },
            {
                "codigo_ibge": 4311239,
                "nome": "Lagoa Bonita do Sul"
            },
            {
                "codigo_ibge": 4311270,
                "nome": "Lagoa dos Três Cantos"
            },
            {
                "codigo_ibge": 4311304,
                "nome": "Lagoa Vermelha"
            },
            {
                "codigo_ibge": 4311254,
                "nome": "Lagoão"
            },
            {
                "codigo_ibge": 4311403,
                "nome": "Lajeado"
            },
            {
                "codigo_ibge": 4311429,
                "nome": "Lajeado do Bugre"
            },
            {
                "codigo_ibge": 4311502,
                "nome": "Lavras do Sul"
            },
            {
                "codigo_ibge": 4311601,
                "nome": "Liberato Salzano"
            },
            {
                "codigo_ibge": 4311627,
                "nome": "Lindolfo Collor"
            },
            {
                "codigo_ibge": 4311643,
                "nome": "Linha Nova"
            },
            {
                "codigo_ibge": 4311718,
                "nome": "Maçambará"
            },
            {
                "codigo_ibge": 4311700,
                "nome": "Machadinho"
            },
            {
                "codigo_ibge": 4311734,
                "nome": "Mampituba"
            },
            {
                "codigo_ibge": 4311759,
                "nome": "Manoel Viana"
            },
            {
                "codigo_ibge": 4311775,
                "nome": "Maquiné"
            },
            {
                "codigo_ibge": 4311791,
                "nome": "Maratá"
            },
            {
                "codigo_ibge": 4311809,
                "nome": "Marau"
            },
            {
                "codigo_ibge": 4311908,
                "nome": "Marcelino Ramos"
            },
            {
                "codigo_ibge": 4311981,
                "nome": "Mariana Pimentel"
            },
            {
                "codigo_ibge": 4312005,
                "nome": "Mariano Moro"
            },
            {
                "codigo_ibge": 4312054,
                "nome": "Marques de Souza"
            },
            {
                "codigo_ibge": 4312104,
                "nome": "Mata"
            },
            {
                "codigo_ibge": 4312138,
                "nome": "Mato Castelhano"
            },
            {
                "codigo_ibge": 4312153,
                "nome": "Mato Leitão"
            },
            {
                "codigo_ibge": 4312179,
                "nome": "Mato Queimado"
            },
            {
                "codigo_ibge": 4312203,
                "nome": "Maximiliano de Almeida"
            },
            {
                "codigo_ibge": 4312252,
                "nome": "Minas do Leão"
            },
            {
                "codigo_ibge": 4312302,
                "nome": "Miraguaí"
            },
            {
                "codigo_ibge": 4312351,
                "nome": "Montauri"
            },
            {
                "codigo_ibge": 4312377,
                "nome": "Monte Alegre dos Campos"
            },
            {
                "codigo_ibge": 4312385,
                "nome": "Monte Belo do Sul"
            },
            {
                "codigo_ibge": 4312401,
                "nome": "Montenegro"
            },
            {
                "codigo_ibge": 4312427,
                "nome": "Mormaço"
            },
            {
                "codigo_ibge": 4312443,
                "nome": "Morrinhos do Sul"
            },
            {
                "codigo_ibge": 4312450,
                "nome": "Morro Redondo"
            },
            {
                "codigo_ibge": 4312476,
                "nome": "Morro Reuter"
            },
            {
                "codigo_ibge": 4312500,
                "nome": "Mostardas"
            },
            {
                "codigo_ibge": 4312609,
                "nome": "Muçum"
            },
            {
                "codigo_ibge": 4312617,
                "nome": "Muitos Capões"
            },
            {
                "codigo_ibge": 4312625,
                "nome": "Muliterno"
            },
            {
                "codigo_ibge": 4312658,
                "nome": "Não-Me-Toque"
            },
            {
                "codigo_ibge": 4312674,
                "nome": "Nicolau Vergueiro"
            },
            {
                "codigo_ibge": 4312708,
                "nome": "Nonoai"
            },
            {
                "codigo_ibge": 4312757,
                "nome": "Nova Alvorada"
            },
            {
                "codigo_ibge": 4312807,
                "nome": "Nova Araçá"
            },
            {
                "codigo_ibge": 4312906,
                "nome": "Nova Bassano"
            },
            {
                "codigo_ibge": 4312955,
                "nome": "Nova Boa Vista"
            },
            {
                "codigo_ibge": 4313003,
                "nome": "Nova Bréscia"
            },
            {
                "codigo_ibge": 4313011,
                "nome": "Nova Candelária"
            },
            {
                "codigo_ibge": 4313037,
                "nome": "Nova Esperança do Sul"
            },
            {
                "codigo_ibge": 4313060,
                "nome": "Nova Hartz"
            },
            {
                "codigo_ibge": 4313086,
                "nome": "Nova Pádua"
            },
            {
                "codigo_ibge": 4313102,
                "nome": "Nova Palma"
            },
            {
                "codigo_ibge": 4313201,
                "nome": "Nova Petrópolis"
            },
            {
                "codigo_ibge": 4313300,
                "nome": "Nova Prata"
            },
            {
                "codigo_ibge": 4313334,
                "nome": "Nova Ramada"
            },
            {
                "codigo_ibge": 4313359,
                "nome": "Nova Roma do Sul"
            },
            {
                "codigo_ibge": 4313375,
                "nome": "Nova Santa Rita"
            },
            {
                "codigo_ibge": 4313490,
                "nome": "Novo Barreiro"
            },
            {
                "codigo_ibge": 4313391,
                "nome": "Novo Cabrais"
            },
            {
                "codigo_ibge": 4313409,
                "nome": "Novo Hamburgo"
            },
            {
                "codigo_ibge": 4313425,
                "nome": "Novo Machado"
            },
            {
                "codigo_ibge": 4313441,
                "nome": "Novo Tiradentes"
            },
            {
                "codigo_ibge": 4313466,
                "nome": "Novo Xingu"
            },
            {
                "codigo_ibge": 4313508,
                "nome": "Osório"
            },
            {
                "codigo_ibge": 4313607,
                "nome": "Paim Filho"
            },
            {
                "codigo_ibge": 4313656,
                "nome": "Palmares do Sul"
            },
            {
                "codigo_ibge": 4313706,
                "nome": "Palmeira das Missões"
            },
            {
                "codigo_ibge": 4313805,
                "nome": "Palmitinho"
            },
            {
                "codigo_ibge": 4313904,
                "nome": "Panambi"
            },
            {
                "codigo_ibge": 4313953,
                "nome": "Pantano Grande"
            },
            {
                "codigo_ibge": 4314001,
                "nome": "Paraí"
            },
            {
                "codigo_ibge": 4314027,
                "nome": "Paraíso do Sul"
            },
            {
                "codigo_ibge": 4314035,
                "nome": "Pareci Novo"
            },
            {
                "codigo_ibge": 4314050,
                "nome": "Parobé"
            },
            {
                "codigo_ibge": 4314068,
                "nome": "Passa Sete"
            },
            {
                "codigo_ibge": 4314076,
                "nome": "Passo do Sobrado"
            },
            {
                "codigo_ibge": 4314100,
                "nome": "Passo Fundo"
            },
            {
                "codigo_ibge": 4314134,
                "nome": "Paulo Bento"
            },
            {
                "codigo_ibge": 4314159,
                "nome": "Paverama"
            },
            {
                "codigo_ibge": 4314175,
                "nome": "Pedras Altas"
            },
            {
                "codigo_ibge": 4314209,
                "nome": "Pedro Osório"
            },
            {
                "codigo_ibge": 4314308,
                "nome": "Pejuçara"
            },
            {
                "codigo_ibge": 4314407,
                "nome": "Pelotas"
            },
            {
                "codigo_ibge": 4314423,
                "nome": "Picada Café"
            },
            {
                "codigo_ibge": 4314456,
                "nome": "Pinhal"
            },
            {
                "codigo_ibge": 4314464,
                "nome": "Pinhal da Serra"
            },
            {
                "codigo_ibge": 4314472,
                "nome": "Pinhal Grande"
            },
            {
                "codigo_ibge": 4314498,
                "nome": "Pinheirinho do Vale"
            },
            {
                "codigo_ibge": 4314506,
                "nome": "Pinheiro Machado"
            },
            {
                "codigo_ibge": 4314548,
                "nome": "Pinto Bandeira"
            },
            {
                "codigo_ibge": 4314555,
                "nome": "Pirapó"
            },
            {
                "codigo_ibge": 4314605,
                "nome": "Piratini"
            },
            {
                "codigo_ibge": 4314704,
                "nome": "Planalto"
            },
            {
                "codigo_ibge": 4314753,
                "nome": "Poço das Antas"
            },
            {
                "codigo_ibge": 4314779,
                "nome": "Pontão"
            },
            {
                "codigo_ibge": 4314787,
                "nome": "Ponte Preta"
            },
            {
                "codigo_ibge": 4314803,
                "nome": "Portão"
            },
            {
                "codigo_ibge": 4314902,
                "nome": "Porto Alegre"
            },
            {
                "codigo_ibge": 4315008,
                "nome": "Porto Lucena"
            },
            {
                "codigo_ibge": 4315057,
                "nome": "Porto Mauá"
            },
            {
                "codigo_ibge": 4315073,
                "nome": "Porto Vera Cruz"
            },
            {
                "codigo_ibge": 4315107,
                "nome": "Porto Xavier"
            },
            {
                "codigo_ibge": 4315131,
                "nome": "Pouso Novo"
            },
            {
                "codigo_ibge": 4315149,
                "nome": "Presidente Lucena"
            },
            {
                "codigo_ibge": 4315156,
                "nome": "Progresso"
            },
            {
                "codigo_ibge": 4315172,
                "nome": "Protásio Alves"
            },
            {
                "codigo_ibge": 4315206,
                "nome": "Putinga"
            },
            {
                "codigo_ibge": 4315305,
                "nome": "Quaraí"
            },
            {
                "codigo_ibge": 4315313,
                "nome": "Quatro Irmãos"
            },
            {
                "codigo_ibge": 4315321,
                "nome": "Quevedos"
            },
            {
                "codigo_ibge": 4315354,
                "nome": "Quinze de Novembro"
            },
            {
                "codigo_ibge": 4315404,
                "nome": "Redentora"
            },
            {
                "codigo_ibge": 4315453,
                "nome": "Relvado"
            },
            {
                "codigo_ibge": 4315503,
                "nome": "Restinga Sêca"
            },
            {
                "codigo_ibge": 4315552,
                "nome": "Rio dos Índios"
            },
            {
                "codigo_ibge": 4315602,
                "nome": "Rio Grande"
            },
            {
                "codigo_ibge": 4315701,
                "nome": "Rio Pardo"
            },
            {
                "codigo_ibge": 4315750,
                "nome": "Riozinho"
            },
            {
                "codigo_ibge": 4315800,
                "nome": "Roca Sales"
            },
            {
                "codigo_ibge": 4315909,
                "nome": "Rodeio Bonito"
            },
            {
                "codigo_ibge": 4315958,
                "nome": "Rolador"
            },
            {
                "codigo_ibge": 4316006,
                "nome": "Rolante"
            },
            {
                "codigo_ibge": 4316105,
                "nome": "Ronda Alta"
            },
            {
                "codigo_ibge": 4316204,
                "nome": "Rondinha"
            },
            {
                "codigo_ibge": 4316303,
                "nome": "Roque Gonzales"
            },
            {
                "codigo_ibge": 4316402,
                "nome": "Rosário do Sul"
            },
            {
                "codigo_ibge": 4316428,
                "nome": "Sagrada Família"
            },
            {
                "codigo_ibge": 4316436,
                "nome": "Saldanha Marinho"
            },
            {
                "codigo_ibge": 4316451,
                "nome": "Salto do Jacuí"
            },
            {
                "codigo_ibge": 4316477,
                "nome": "Salvador das Missões"
            },
            {
                "codigo_ibge": 4316501,
                "nome": "Salvador do Sul"
            },
            {
                "codigo_ibge": 4316600,
                "nome": "Sananduva"
            },
            {
                "codigo_ibge": 4317103,
                "nome": "Sant'Ana do Livramento"
            },
            {
                "codigo_ibge": 4316709,
                "nome": "Santa Bárbara do Sul"
            },
            {
                "codigo_ibge": 4316733,
                "nome": "Santa Cecília do Sul"
            },
            {
                "codigo_ibge": 4316758,
                "nome": "Santa Clara do Sul"
            },
            {
                "codigo_ibge": 4316808,
                "nome": "Santa Cruz do Sul"
            },
            {
                "codigo_ibge": 4316972,
                "nome": "Santa Margarida do Sul"
            },
            {
                "codigo_ibge": 4316907,
                "nome": "Santa Maria"
            },
            {
                "codigo_ibge": 4316956,
                "nome": "Santa Maria do Herval"
            },
            {
                "codigo_ibge": 4317202,
                "nome": "Santa Rosa"
            },
            {
                "codigo_ibge": 4317251,
                "nome": "Santa Tereza"
            },
            {
                "codigo_ibge": 4317301,
                "nome": "Santa Vitória do Palmar"
            },
            {
                "codigo_ibge": 4317004,
                "nome": "Santana da Boa Vista"
            },
            {
                "codigo_ibge": 4317400,
                "nome": "Santiago"
            },
            {
                "codigo_ibge": 4317509,
                "nome": "Santo Ângelo"
            },
            {
                "codigo_ibge": 4317608,
                "nome": "Santo Antônio da Patrulha"
            },
            {
                "codigo_ibge": 4317707,
                "nome": "Santo Antônio das Missões"
            },
            {
                "codigo_ibge": 4317558,
                "nome": "Santo Antônio do Palma"
            },
            {
                "codigo_ibge": 4317756,
                "nome": "Santo Antônio do Planalto"
            },
            {
                "codigo_ibge": 4317806,
                "nome": "Santo Augusto"
            },
            {
                "codigo_ibge": 4317905,
                "nome": "Santo Cristo"
            },
            {
                "codigo_ibge": 4317954,
                "nome": "Santo Expedito do Sul"
            },
            {
                "codigo_ibge": 4318002,
                "nome": "São Borja"
            },
            {
                "codigo_ibge": 4318051,
                "nome": "São Domingos do Sul"
            },
            {
                "codigo_ibge": 4318101,
                "nome": "São Francisco de Assis"
            },
            {
                "codigo_ibge": 4318200,
                "nome": "São Francisco de Paula"
            },
            {
                "codigo_ibge": 4318309,
                "nome": "São Gabriel"
            },
            {
                "codigo_ibge": 4318408,
                "nome": "São Jerônimo"
            },
            {
                "codigo_ibge": 4318424,
                "nome": "São João da Urtiga"
            },
            {
                "codigo_ibge": 4318432,
                "nome": "São João do Polêsine"
            },
            {
                "codigo_ibge": 4318440,
                "nome": "São Jorge"
            },
            {
                "codigo_ibge": 4318457,
                "nome": "São José das Missões"
            },
            {
                "codigo_ibge": 4318465,
                "nome": "São José do Herval"
            },
            {
                "codigo_ibge": 4318481,
                "nome": "São José do Hortêncio"
            },
            {
                "codigo_ibge": 4318499,
                "nome": "São José do Inhacorá"
            },
            {
                "codigo_ibge": 4318507,
                "nome": "São José do Norte"
            },
            {
                "codigo_ibge": 4318606,
                "nome": "São José do Ouro"
            },
            {
                "codigo_ibge": 4318614,
                "nome": "São José do Sul"
            },
            {
                "codigo_ibge": 4318622,
                "nome": "São José dos Ausentes"
            },
            {
                "codigo_ibge": 4318705,
                "nome": "São Leopoldo"
            },
            {
                "codigo_ibge": 4318804,
                "nome": "São Lourenço do Sul"
            },
            {
                "codigo_ibge": 4318903,
                "nome": "São Luiz Gonzaga"
            },
            {
                "codigo_ibge": 4319000,
                "nome": "São Marcos"
            },
            {
                "codigo_ibge": 4319109,
                "nome": "São Martinho"
            },
            {
                "codigo_ibge": 4319125,
                "nome": "São Martinho da Serra"
            },
            {
                "codigo_ibge": 4319158,
                "nome": "São Miguel das Missões"
            },
            {
                "codigo_ibge": 4319208,
                "nome": "São Nicolau"
            },
            {
                "codigo_ibge": 4319307,
                "nome": "São Paulo das Missões"
            },
            {
                "codigo_ibge": 4319356,
                "nome": "São Pedro da Serra"
            },
            {
                "codigo_ibge": 4319364,
                "nome": "São Pedro das Missões"
            },
            {
                "codigo_ibge": 4319372,
                "nome": "São Pedro do Butiá"
            },
            {
                "codigo_ibge": 4319406,
                "nome": "São Pedro do Sul"
            },
            {
                "codigo_ibge": 4319505,
                "nome": "São Sebastião do Caí"
            },
            {
                "codigo_ibge": 4319604,
                "nome": "São Sepé"
            },
            {
                "codigo_ibge": 4319703,
                "nome": "São Valentim"
            },
            {
                "codigo_ibge": 4319711,
                "nome": "São Valentim do Sul"
            },
            {
                "codigo_ibge": 4319737,
                "nome": "São Valério do Sul"
            },
            {
                "codigo_ibge": 4319752,
                "nome": "São Vendelino"
            },
            {
                "codigo_ibge": 4319802,
                "nome": "São Vicente do Sul"
            },
            {
                "codigo_ibge": 4319901,
                "nome": "Sapiranga"
            },
            {
                "codigo_ibge": 4320008,
                "nome": "Sapucaia do Sul"
            },
            {
                "codigo_ibge": 4320107,
                "nome": "Sarandi"
            },
            {
                "codigo_ibge": 4320206,
                "nome": "Seberi"
            },
            {
                "codigo_ibge": 4320230,
                "nome": "Sede Nova"
            },
            {
                "codigo_ibge": 4320263,
                "nome": "Segredo"
            },
            {
                "codigo_ibge": 4320305,
                "nome": "Selbach"
            },
            {
                "codigo_ibge": 4320321,
                "nome": "Senador Salgado Filho"
            },
            {
                "codigo_ibge": 4320354,
                "nome": "Sentinela do Sul"
            },
            {
                "codigo_ibge": 4320404,
                "nome": "Serafina Corrêa"
            },
            {
                "codigo_ibge": 4320453,
                "nome": "Sério"
            },
            {
                "codigo_ibge": 4320503,
                "nome": "Sertão"
            },
            {
                "codigo_ibge": 4320552,
                "nome": "Sertão Santana"
            },
            {
                "codigo_ibge": 4320578,
                "nome": "Sete de Setembro"
            },
            {
                "codigo_ibge": 4320602,
                "nome": "Severiano de Almeida"
            },
            {
                "codigo_ibge": 4320651,
                "nome": "Silveira Martins"
            },
            {
                "codigo_ibge": 4320677,
                "nome": "Sinimbu"
            },
            {
                "codigo_ibge": 4320701,
                "nome": "Sobradinho"
            },
            {
                "codigo_ibge": 4320800,
                "nome": "Soledade"
            },
            {
                "codigo_ibge": 4320859,
                "nome": "Tabaí"
            },
            {
                "codigo_ibge": 4320909,
                "nome": "Tapejara"
            },
            {
                "codigo_ibge": 4321006,
                "nome": "Tapera"
            },
            {
                "codigo_ibge": 4321105,
                "nome": "Tapes"
            },
            {
                "codigo_ibge": 4321204,
                "nome": "Taquara"
            },
            {
                "codigo_ibge": 4321303,
                "nome": "Taquari"
            },
            {
                "codigo_ibge": 4321329,
                "nome": "Taquaruçu do Sul"
            },
            {
                "codigo_ibge": 4321352,
                "nome": "Tavares"
            },
            {
                "codigo_ibge": 4321402,
                "nome": "Tenente Portela"
            },
            {
                "codigo_ibge": 4321436,
                "nome": "Terra de Areia"
            },
            {
                "codigo_ibge": 4321451,
                "nome": "Teutônia"
            },
            {
                "codigo_ibge": 4321469,
                "nome": "Tio Hugo"
            },
            {
                "codigo_ibge": 4321477,
                "nome": "Tiradentes do Sul"
            },
            {
                "codigo_ibge": 4321493,
                "nome": "Toropi"
            },
            {
                "codigo_ibge": 4321501,
                "nome": "Torres"
            },
            {
                "codigo_ibge": 4321600,
                "nome": "Tramandaí"
            },
            {
                "codigo_ibge": 4321626,
                "nome": "Travesseiro"
            },
            {
                "codigo_ibge": 4321634,
                "nome": "Três Arroios"
            },
            {
                "codigo_ibge": 4321667,
                "nome": "Três Cachoeiras"
            },
            {
                "codigo_ibge": 4321709,
                "nome": "Três Coroas"
            },
            {
                "codigo_ibge": 4321808,
                "nome": "Três de Maio"
            },
            {
                "codigo_ibge": 4321832,
                "nome": "Três Forquilhas"
            },
            {
                "codigo_ibge": 4321857,
                "nome": "Três Palmeiras"
            },
            {
                "codigo_ibge": 4321907,
                "nome": "Três Passos"
            },
            {
                "codigo_ibge": 4321956,
                "nome": "Trindade do Sul"
            },
            {
                "codigo_ibge": 4322004,
                "nome": "Triunfo"
            },
            {
                "codigo_ibge": 4322103,
                "nome": "Tucunduva"
            },
            {
                "codigo_ibge": 4322152,
                "nome": "Tunas"
            },
            {
                "codigo_ibge": 4322186,
                "nome": "Tupanci do Sul"
            },
            {
                "codigo_ibge": 4322202,
                "nome": "Tupanciretã"
            },
            {
                "codigo_ibge": 4322251,
                "nome": "Tupandi"
            },
            {
                "codigo_ibge": 4322301,
                "nome": "Tuparendi"
            },
            {
                "codigo_ibge": 4322327,
                "nome": "Turuçu"
            },
            {
                "codigo_ibge": 4322343,
                "nome": "Ubiretama"
            },
            {
                "codigo_ibge": 4322350,
                "nome": "União da Serra"
            },
            {
                "codigo_ibge": 4322376,
                "nome": "Unistalda"
            },
            {
                "codigo_ibge": 4322400,
                "nome": "Uruguaiana"
            },
            {
                "codigo_ibge": 4322509,
                "nome": "Vacaria"
            },
            {
                "codigo_ibge": 4322533,
                "nome": "Vale do Sol"
            },
            {
                "codigo_ibge": 4322541,
                "nome": "Vale Real"
            },
            {
                "codigo_ibge": 4322525,
                "nome": "Vale Verde"
            },
            {
                "codigo_ibge": 4322558,
                "nome": "Vanini"
            },
            {
                "codigo_ibge": 4322608,
                "nome": "Venâncio Aires"
            },
            {
                "codigo_ibge": 4322707,
                "nome": "Vera Cruz"
            },
            {
                "codigo_ibge": 4322806,
                "nome": "Veranópolis"
            },
            {
                "codigo_ibge": 4322855,
                "nome": "Vespasiano Corrêa"
            },
            {
                "codigo_ibge": 4322905,
                "nome": "Viadutos"
            },
            {
                "codigo_ibge": 4323002,
                "nome": "Viamão"
            },
            {
                "codigo_ibge": 4323101,
                "nome": "Vicente Dutra"
            },
            {
                "codigo_ibge": 4323200,
                "nome": "Victor Graeff"
            },
            {
                "codigo_ibge": 4323309,
                "nome": "Vila Flores"
            },
            {
                "codigo_ibge": 4323358,
                "nome": "Vila Lângaro"
            },
            {
                "codigo_ibge": 4323408,
                "nome": "Vila Maria"
            },
            {
                "codigo_ibge": 4323457,
                "nome": "Vila Nova do Sul"
            },
            {
                "codigo_ibge": 4323507,
                "nome": "Vista Alegre"
            },
            {
                "codigo_ibge": 4323606,
                "nome": "Vista Alegre do Prata"
            },
            {
                "codigo_ibge": 4323705,
                "nome": "Vista Gaúcha"
            },
            {
                "codigo_ibge": 4323754,
                "nome": "Vitória das Missões"
            },
            {
                "codigo_ibge": 4323770,
                "nome": "Westfália"
            },
            {
                "codigo_ibge": 4323804,
                "nome": "Xangri-lá"
            }
        ]
    },
    "SC": {
        "nome": "Santa Catarina",
        "municipios": [
            {
                "codigo_ibge": 4200051,
                "nome": "Abdon Batista"
            },
            {
                "codigo_ibge": 4200101,
                "nome": "Abelardo Luz"
            },
            {
                "codigo_ibge": 4200200,
                "nome": "Agrolândia"
            },
            {
                "codigo_ibge": 4200309,
                "nome": "Agronômica"
            },
            {
                "codigo_ibge": 4200408,
                "nome": "Água Doce"
            },
            {
                "codigo_ibge": 4200507,
                "nome": "Águas de Chapecó"
            },
            {
                "codigo_ibge": 4200556,
                "nome": "Águas Frias"
            },
            {
                "codigo_ibge": 4200606,
                "nome": "Águas Mornas"
            },
            {
                "codigo_ibge": 4200705,
                "nome": "Alfredo Wagner"
            },
            {
                "codigo_ibge": 4200754,
                "nome": "Alto Bela Vista"
            },
            {
                "codigo_ibge": 4200804,
                "nome": "Anchieta"
            },
            {
                "codigo_ibge": 4200903,
                "nome": "Angelina"
            },
            {
                "codigo_ibge": 4201000,
                "nome": "Anita Garibaldi"
            },
            {
                "codigo_ibge": 4201109,
                "nome": "Anitápolis"
            },
            {
                "codigo_ibge": 4201208,
                "nome": "Antônio Carlos"
            },
            {
                "codigo_ibge": 4201257,
                "nome": "Apiúna"
            },
            {
                "codigo_ibge": 4201273,
                "nome": "Arabutã"
            },
            {
                "codigo_ibge": 4201307,
                "nome": "Araquari"
            },
            {
                "codigo_ibge": 4201406,
                "nome": "Araranguá"
            },
            {
                "codigo_ibge": 4201505,
                "nome": "Armazém"
            },
            {
                "codigo_ibge": 4201604,
                "nome": "Arroio Trinta"
            },
            {
                "codigo_ibge": 4201653,
                "nome": "Arvoredo"
            },
            {
                "codigo_ibge": 4201703,
                "nome": "Ascurra"
            },
            {
                "codigo_ibge": 4201802,
                "nome": "Atalanta"
            },
            {
                "codigo_ibge": 4201901,
                "nome": "Aurora"
            },
            {
                "codigo_ibge": 4201950,
                "nome": "Balneário Arroio do Silva"
            },
            {
                "codigo_ibge": 4202057,
                "nome": "Balneário Barra do Sul"
            },
            {
                "codigo_ibge": 4202008,
                "nome": "Balneário Camboriú"
            },
            {
                "codigo_ibge": 4202073,
                "nome": "Balneário Gaivota"
            },
            {
                "codigo_ibge": 4212809,
                "nome": "Balneário Piçarras"
            },
            {
                "codigo_ibge": 4220000,
                "nome": "Balneário Rincão"
            },
            {
                "codigo_ibge": 4202081,
                "nome": "Bandeirante"
            },
            {
                "codigo_ibge": 4202099,
                "nome": "Barra Bonita"
            },
            {
                "codigo_ibge": 4202107,
                "nome": "Barra Velha"
            },
            {
                "codigo_ibge": 4202131,
                "nome": "Bela Vista do Toldo"
            },
            {
                "codigo_ibge": 4202156,
                "nome": "Belmonte"
            },
            {
                "codigo_ibge": 4202206,
                "nome": "Benedito Novo"
            },
            {
                "codigo_ibge": 4202305,
                "nome": "Biguaçu"
            },
            {
                "codigo_ibge": 4202404,
                "nome": "Blumenau"
            },
            {
                "codigo_ibge": 4202438,
                "nome": "Bocaina do Sul"
            },
            {
                "codigo_ibge": 4202503,
                "nome": "Bom Jardim da Serra"
            },
            {
                "codigo_ibge": 4202537,
                "nome": "Bom Jesus"
            },
            {
                "codigo_ibge": 4202578,
                "nome": "Bom Jesus do Oeste"
            },
            {
                "codigo_ibge": 4202602,
                "nome": "Bom Retiro"
            },
            {
                "codigo_ibge": 4202453,
                "nome": "Bombinhas"
            },
            {
                "codigo_ibge": 4202701,
                "nome": "Botuverá"
            },
            {
                "codigo_ibge": 4202800,
                "nome": "Braço do Norte"
            },
            {
                "codigo_ibge": 4202859,
                "nome": "Braço do Trombudo"
            },
            {
                "codigo_ibge": 4202875,
                "nome": "Brunópolis"
            },
            {
                "codigo_ibge": 4202909,
                "nome": "Brusque"
            },
            {
                "codigo_ibge": 4203006,
                "nome": "Caçador"
            },
            {
                "codigo_ibge": 4203105,
                "nome": "Caibi"
            },
            {
                "codigo_ibge": 4203154,
                "nome": "Calmon"
            },
            {
                "codigo_ibge": 4203204,
                "nome": "Camboriú"
            },
            {
                "codigo_ibge": 4203303,
                "nome": "Campo Alegre"
            },
            {
                "codigo_ibge": 4203402,
                "nome": "Campo Belo do Sul"
            },
            {
                "codigo_ibge": 4203501,
                "nome": "Campo Erê"
            },
            {
                "codigo_ibge": 4203600,
                "nome": "Campos Novos"
            },
            {
                "codigo_ibge": 4203709,
                "nome": "Canelinha"
            },
            {
                "codigo_ibge": 4203808,
                "nome": "Canoinhas"
            },
            {
                "codigo_ibge": 4203253,
                "nome": "Capão Alto"
            },
            {
                "codigo_ibge": 4203907,
                "nome": "Capinzal"
            },
            {
                "codigo_ibge": 4203956,
                "nome": "Capivari de Baixo"
            },
            {
                "codigo_ibge": 4204004,
                "nome": "Catanduvas"
            },
            {
                "codigo_ibge": 4204103,
                "nome": "Caxambu do Sul"
            },
            {
                "codigo_ibge": 4204152,
                "nome": "Celso Ramos"
            },
            {
                "codigo_ibge": 4204178,
                "nome": "Cerro Negro"
            },
            {
                "codigo_ibge": 4204194,
                "nome": "Chapadão do Lageado"
            },
            {
                "codigo_ibge": 4204202,
                "nome": "Chapecó"
            },
            {
                "codigo_ibge": 4204251,
                "nome": "Cocal do Sul"
            },
            {
                "codigo_ibge": 4204301,
                "nome": "Concórdia"
            },
            {
                "codigo_ibge": 4204350,
                "nome": "Cordilheira Alta"
            },
            {
                "codigo_ibge": 4204400,
                "nome": "Coronel Freitas"
            },
            {
                "codigo_ibge": 4204459,
                "nome": "Coronel Martins"
            },
            {
                "codigo_ibge": 4204558,
                "nome": "Correia Pinto"
            },
            {
                "codigo_ibge": 4204509,
                "nome": "Corupá"
            },
            {
                "codigo_ibge": 4204608,
                "nome": "Criciúma"
            },
            {
                "codigo_ibge": 4204707,
                "nome": "Cunha Porã"
            },
            {
                "codigo_ibge": 4204756,
                "nome": "Cunhataí"
            },
            {
                "codigo_ibge": 4204806,
                "nome": "Curitibanos"
            },
            {
                "codigo_ibge": 4204905,
                "nome": "Descanso"
            },
            {
                "codigo_ibge": 4205001,
                "nome": "Dionísio Cerqueira"
            },
            {
                "codigo_ibge": 4205100,
                "nome": "Dona Emma"
            },
            {
                "codigo_ibge": 4205159,
                "nome": "Doutor Pedrinho"
            },
            {
                "codigo_ibge": 4205175,
                "nome": "Entre Rios"
            },
            {
                "codigo_ibge": 4205191,
                "nome": "Ermo"
            },
            {
                "codigo_ibge": 4205209,
                "nome": "Erval Velho"
            },
            {
                "codigo_ibge": 4205308,
                "nome": "Faxinal dos Guedes"
            },
            {
                "codigo_ibge": 4205357,
                "nome": "Flor do Sertão"
            },
            {
                "codigo_ibge": 4205407,
                "nome": "Florianópolis"
            },
            {
                "codigo_ibge": 4205431,
                "nome": "Formosa do Sul"
            },
            {
                "codigo_ibge": 4205456,
                "nome": "Forquilhinha"
            },
            {
                "codigo_ibge": 4205506,
                "nome": "Fraiburgo"
            },
            {
                "codigo_ibge": 4205555,
                "nome": "Frei Rogério"
            },
            {
                "codigo_ibge": 4205605,
                "nome": "Galvão"
            },
            {
                "codigo_ibge": 4205704,
                "nome": "Garopaba"
            },
            {
                "codigo_ibge": 4205803,
                "nome": "Garuva"
            },
            {
                "codigo_ibge": 4205902,
                "nome": "Gaspar"
            },
            {
                "codigo_ibge": 4206009,
                "nome": "Governador Celso Ramos"
            },
            {
                "codigo_ibge": 4206108,
                "nome": "Grão Pará"
            },
            {
                "codigo_ibge": 4206207,
                "nome": "Gravatal"
            },
            {
                "codigo_ibge": 4206306,
                "nome": "Guabiruba"
            },
            {
                "codigo_ibge": 4206405,
                "nome": "Guaraciaba"
            },
            {
                "codigo_ibge": 4206504,
                "nome": "Guaramirim"
            },
            {
                "codigo_ibge": 4206603,
                "nome": "Guarujá do Sul"
            },
            {
                "codigo_ibge": 4206652,
                "nome": "Guatambú"
            },
            {
                "codigo_ibge": 4206702,
                "nome": "Herval d'Oeste"
            },
            {
                "codigo_ibge": 4206751,
                "nome": "Ibiam"
            },
            {
                "codigo_ibge": 4206801,
                "nome": "Ibicaré"
            },
            {
                "codigo_ibge": 4206900,
                "nome": "Ibirama"
            },
            {
                "codigo_ibge": 4207007,
                "nome": "Içara"
            },
            {
                "codigo_ibge": 4207106,
                "nome": "Ilhota"
            },
            {
                "codigo_ibge": 4207205,
                "nome": "Imaruí"
            },
            {
                "codigo_ibge": 4207304,
                "nome": "Imbituba"
            },
            {
                "codigo_ibge": 4207403,
                "nome": "Imbuia"
            },
            {
                "codigo_ibge": 4207502,
                "nome": "Indaial"
            },
            {
                "codigo_ibge": 4207577,
                "nome": "Iomerê"
            },
            {
                "codigo_ibge": 4207601,
                "nome": "Ipira"
            },
            {
                "codigo_ibge": 4207650,
                "nome": "Iporã do Oeste"
            },
            {
                "codigo_ibge": 4207684,
                "nome": "Ipuaçu"
            },
            {
                "codigo_ibge": 4207700,
                "nome": "Ipumirim"
            },
            {
                "codigo_ibge": 4207759,
                "nome": "Iraceminha"
            },
            {
                "codigo_ibge": 4207809,
                "nome": "Irani"
            },
            {
                "codigo_ibge": 4207858,
                "nome": "Irati"
            },
            {
                "codigo_ibge": 4207908,
                "nome": "Irineópolis"
            },
            {
                "codigo_ibge": 4208005,
                "nome": "Itá"
            },
            {
                "codigo_ibge": 4208104,
                "nome": "Itaiópolis"
            },
            {
                "codigo_ibge": 4208203,
                "nome": "Itajaí"
            },
            {
                "codigo_ibge": 4208302,
                "nome": "Itapema"
            },
            {
                "codigo_ibge": 4208401,
                "nome": "Itapiranga"
            },
            {
                "codigo_ibge": 4208450,
                "nome": "Itapoá"
            },
            {
                "codigo_ibge": 4208500,
                "nome": "Ituporanga"
            },
            {
                "codigo_ibge": 4208609,
                "nome": "Jaborá"
            },
            {
                "codigo_ibge": 4208708,
                "nome": "Jacinto Machado"
            },
            {
                "codigo_ibge": 4208807,
                "nome": "Jaguaruna"
            },
            {
                "codigo_ibge": 4208906,
                "nome": "Jaraguá do Sul"
            },
            {
                "codigo_ibge": 4208955,
                "nome": "Jardinópolis"
            },
            {
                "codigo_ibge": 4209003,
                "nome": "Joaçaba"
            },
            {
                "codigo_ibge": 4209102,
                "nome": "Joinville"
            },
            {
                "codigo_ibge": 4209151,
                "nome": "José Boiteux"
            },
            {
                "codigo_ibge": 4209177,
                "nome": "Jupiá"
            },
            {
                "codigo_ibge": 4209201,
                "nome": "Lacerdópolis"
            },
            {
                "codigo_ibge": 4209300,
                "nome": "Lages"
            },
            {
                "codigo_ibge": 4209409,
                "nome": "Laguna"
            },
            {
                "codigo_ibge": 4209458,
                "nome": "Lajeado Grande"
            },
            {
                "codigo_ibge": 4209508,
                "nome": "Laurentino"
            },
            {
                "codigo_ibge": 4209607,
                "nome": "Lauro Muller"
            },
            {
                "codigo_ibge": 4209706,
                "nome": "Lebon Régis"
            },
            {
                "codigo_ibge": 4209805,
                "nome": "Leoberto Leal"
            },
            {
                "codigo_ibge": 4209854,
                "nome": "Lindóia do Sul"
            },
            {
                "codigo_ibge": 4209904,
                "nome": "Lontras"
            },
            {
                "codigo_ibge": 4210001,
                "nome": "Luiz Alves"
            },
            {
                "codigo_ibge": 4210035,
                "nome": "Luzerna"
            },
            {
                "codigo_ibge": 4210050,
                "nome": "Macieira"
            },
            {
                "codigo_ibge": 4210100,
                "nome": "Mafra"
            },
            {
                "codigo_ibge": 4210209,
                "nome": "Major Gercino"
            },
            {
                "codigo_ibge": 4210308,
                "nome": "Major Vieira"
            },
            {
                "codigo_ibge": 4210407,
                "nome": "Maracajá"
            },
            {
                "codigo_ibge": 4210506,
                "nome": "Maravilha"
            },
            {
                "codigo_ibge": 4210555,
                "nome": "Marema"
            },
            {
                "codigo_ibge": 4210605,
                "nome": "Massaranduba"
            },
            {
                "codigo_ibge": 4210704,
                "nome": "Matos Costa"
            },
            {
                "codigo_ibge": 4210803,
                "nome": "Meleiro"
            },
            {
                "codigo_ibge": 4210852,
                "nome": "Mirim Doce"
            },
            {
                "codigo_ibge": 4210902,
                "nome": "Modelo"
            },
            {
                "codigo_ibge": 4211009,
                "nome": "Mondaí"
            },
            {
                "codigo_ibge": 4211058,
                "nome": "Monte Carlo"
            },
            {
                "codigo_ibge": 4211108,
                "nome": "Monte Castelo"
            },
            {
                "codigo_ibge": 4211207,
                "nome": "Morro da Fumaça"
            },
            {
                "codigo_ibge": 4211256,
                "nome": "Morro Grande"
            },
            {
                "codigo_ibge": 4211306,
                "nome": "Navegantes"
            },
            {
                "codigo_ibge": 4211405,
                "nome": "Nova Erechim"
            },
            {
                "codigo_ibge": 4211454,
                "nome": "Nova Itaberaba"
            },
            {
                "codigo_ibge": 4211504,
                "nome": "Nova Trento"
            },
            {
                "codigo_ibge": 4211603,
                "nome": "Nova Veneza"
            },
            {
                "codigo_ibge": 4211652,
                "nome": "Novo Horizonte"
            },
            {
                "codigo_ibge": 4211702,
                "nome": "Orleans"
            },
            {
                "codigo_ibge": 4211751,
                "nome": "Otacílio Costa"
            },
            {
                "codigo_ibge": 4211801,
                "nome": "Ouro"
            },
            {
                "codigo_ibge": 4211850,
                "nome": "Ouro Verde"
            },
            {
                "codigo_ibge": 4211876,
                "nome": "Paial"
            },
            {
                "codigo_ibge": 4211892,
                "nome": "Painel"
            },
            {
                "codigo_ibge": 4211900,
                "nome": "Palhoça"
            },
            {
                "codigo_ibge": 4212007,
                "nome": "Palma Sola"
            },
            {
                "codigo_ibge": 4212056,
                "nome": "Palmeira"
            },
            {
                "codigo_ibge": 4212106,
                "nome": "Palmitos"
            },
            {
                "codigo_ibge": 4212205,
                "nome": "Papanduva"
            },
            {
                "codigo_ibge": 4212239,
                "nome": "Paraíso"
            },
            {
                "codigo_ibge": 4212254,
                "nome": "Passo de Torres"
            },
            {
                "codigo_ibge": 4212270,
                "nome": "Passos Maia"
            },
            {
                "codigo_ibge": 4212304,
                "nome": "Paulo Lopes"
            },
            {
                "codigo_ibge": 4212403,
                "nome": "Pedras Grandes"
            },
            {
                "codigo_ibge": 4212502,
                "nome": "Penha"
            },
            {
                "codigo_ibge": 4212601,
                "nome": "Peritiba"
            },
            {
                "codigo_ibge": 4212650,
                "nome": "Pescaria Brava"
            },
            {
                "codigo_ibge": 4212700,
                "nome": "Petrolândia"
            },
            {
                "codigo_ibge": 4212908,
                "nome": "Pinhalzinho"
            },
            {
                "codigo_ibge": 4213005,
                "nome": "Pinheiro Preto"
            },
            {
                "codigo_ibge": 4213104,
                "nome": "Piratuba"
            },
            {
                "codigo_ibge": 4213153,
                "nome": "Planalto Alegre"
            },
            {
                "codigo_ibge": 4213203,
                "nome": "Pomerode"
            },
            {
                "codigo_ibge": 4213302,
                "nome": "Ponte Alta"
            },
            {
                "codigo_ibge": 4213351,
                "nome": "Ponte Alta do Norte"
            },
            {
                "codigo_ibge": 4213401,
                "nome": "Ponte Serrada"
            },
            {
                "codigo_ibge": 4213500,
                "nome": "Porto Belo"
            },
            {
                "codigo_ibge": 4213609,
                "nome": "Porto União"
            },
            {
                "codigo_ibge": 4213708,
                "nome": "Pouso Redondo"
            },
            {
                "codigo_ibge": 4213807,
                "nome": "Praia Grande"
            },
            {
                "codigo_ibge": 4213906,
                "nome": "Presidente Castello Branco"
            },
            {
                "codigo_ibge": 4214003,
                "nome": "Presidente Getúlio"
            },
            {
                "codigo_ibge": 4214102,
                "nome": "Presidente Nereu"
            },
            {
                "codigo_ibge": 4214151,
                "nome": "Princesa"
            },
            {
                "codigo_ibge": 4214201,
                "nome": "Quilombo"
            },
            {
                "codigo_ibge": 4214300,
                "nome": "Rancho Queimado"
            },
            {
                "codigo_ibge": 4214409,
                "nome": "Rio das Antas"
            },
            {
                "codigo_ibge": 4214508,
                "nome": "Rio do Campo"
            },
            {
                "codigo_ibge": 4214607,
                "nome": "Rio do Oeste"
            },
            {
                "codigo_ibge": 4214805,
                "nome": "Rio do Sul"
            },
            {
                "codigo_ibge": 4214706,
                "nome": "Rio dos Cedros"
            },
            {
                "codigo_ibge": 4214904,
                "nome": "Rio Fortuna"
            },
            {
                "codigo_ibge": 4215000,
                "nome": "Rio Negrinho"
            },
            {
                "codigo_ibge": 4215059,
                "nome": "Rio Rufino"
            },
            {
                "codigo_ibge": 4215075,
                "nome": "Riqueza"
            },
            {
                "codigo_ibge": 4215109,
                "nome": "Rodeio"
            },
            {
                "codigo_ibge": 4215208,
                "nome": "Romelândia"
            },
            {
                "codigo_ibge": 4215307,
                "nome": "Salete"
            },
            {
                "codigo_ibge": 4215356,
                "nome": "Saltinho"
            },
            {
                "codigo_ibge": 4215406,
                "nome": "Salto Veloso"
            },
            {
                "codigo_ibge": 4215455,
                "nome": "Sangão"
            },
            {
                "codigo_ibge": 4215505,
                "nome": "Santa Cecília"
            },
            {
                "codigo_ibge": 4215554,
                "nome": "Santa Helena"
            },
            {
                "codigo_ibge": 4215604,
                "nome": "Santa Rosa de Lima"
            },
            {
                "codigo_ibge": 4215653,
                "nome": "Santa Rosa do Sul"
            },
            {
                "codigo_ibge": 4215679,
                "nome": "Santa Terezinha"
            },
            {
                "codigo_ibge": 4215687,
                "nome": "Santa Terezinha do Progresso"
            },
            {
                "codigo_ibge": 4215695,
                "nome": "Santiago do Sul"
            },
            {
                "codigo_ibge": 4215703,
                "nome": "Santo Amaro da Imperatriz"
            },
            {
                "codigo_ibge": 4215802,
                "nome": "São Bento do Sul"
            },
            {
                "codigo_ibge": 4215752,
                "nome": "São Bernardino"
            },
            {
                "codigo_ibge": 4215901,
                "nome": "São Bonifácio"
            },
            {
                "codigo_ibge": 4216008,
                "nome": "São Carlos"
            },
            {
                "codigo_ibge": 4216057,
                "nome": "São Cristovão do Sul"
            },
            {
                "codigo_ibge": 4216107,
                "nome": "São Domingos"
            },
            {
                "codigo_ibge": 4216206,
                "nome": "São Francisco do Sul"
            },
            {
                "codigo_ibge": 4216305,
                "nome": "São João Batista"
            },
            {
                "codigo_ibge": 4216354,
                "nome": "São João do Itaperiú"
            },
            {
                "codigo_ibge": 4216255,
                "nome": "São João do Oeste"
            },
            {
                "codigo_ibge": 4216404,
                "nome": "São João do Sul"
            },
            {
                "codigo_ibge": 4216503,
                "nome": "São Joaquim"
            },
            {
                "codigo_ibge": 4216602,
                "nome": "São José"
            },
            {
                "codigo_ibge": 4216701,
                "nome": "São José do Cedro"
            },
            {
                "codigo_ibge": 4216800,
                "nome": "São José do Cerrito"
            },
            {
                "codigo_ibge": 4216909,
                "nome": "São Lourenço do Oeste"
            },
            {
                "codigo_ibge": 4217006,
                "nome": "São Ludgero"
            },
            {
                "codigo_ibge": 4217105,
                "nome": "São Martinho"
            },
            {
                "codigo_ibge": 4217154,
                "nome": "São Miguel da Boa Vista"
            },
            {
                "codigo_ibge": 4217204,
                "nome": "São Miguel do Oeste"
            },
            {
                "codigo_ibge": 4217253,
                "nome": "São Pedro de Alcântara"
            },
            {
                "codigo_ibge": 4217303,
                "nome": "Saudades"
            },
            {
                "codigo_ibge": 4217402,
                "nome": "Schroeder"
            },
            {
                "codigo_ibge": 4217501,
                "nome": "Seara"
            },
            {
                "codigo_ibge": 4217550,
                "nome": "Serra Alta"
            },
            {
                "codigo_ibge": 4217600,
                "nome": "Siderópolis"
            },
            {
                "codigo_ibge": 4217709,
                "nome": "Sombrio"
            },
            {
                "codigo_ibge": 4217758,
                "nome": "Sul Brasil"
            },
            {
                "codigo_ibge": 4217808,
                "nome": "Taió"
            },
            {
                "codigo_ibge": 4217907,
                "nome": "Tangará"
            },
            {
                "codigo_ibge": 4217956,
                "nome": "Tigrinhos"
            },
            {
                "codigo_ibge": 4218004,
                "nome": "Tijucas"
            },
            {
                "codigo_ibge": 4218103,
                "nome": "Timbé do Sul"
            },
            {
                "codigo_ibge": 4218202,
                "nome": "Timbó"
            },
            {
                "codigo_ibge": 4218251,
                "nome": "Timbó Grande"
            },
            {
                "codigo_ibge": 4218301,
                "nome": "Três Barras"
            },
            {
                "codigo_ibge": 4218350,
                "nome": "Treviso"
            },
            {
                "codigo_ibge": 4218400,
                "nome": "Treze de Maio"
            },
            {
                "codigo_ibge": 4218509,
                "nome": "Treze Tílias"
            },
            {
                "codigo_ibge": 4218608,
                "nome": "Trombudo Central"
            },
            {
                "codigo_ibge": 4218707,
                "nome": "Tubarão"
            },
            {
                "codigo_ibge": 4218756,
                "nome": "Tunápolis"
            },
            {
                "codigo_ibge": 4218806,
                "nome": "Turvo"
            },
            {
                "codigo_ibge": 4218855,
                "nome": "União do Oeste"
            },
            {
                "codigo_ibge": 4218905,
                "nome": "Urubici"
            },
            {
                "codigo_ibge": 4218954,
                "nome": "Urupema"
            },
            {
                "codigo_ibge": 4219002,
                "nome": "Urussanga"
            },
            {
                "codigo_ibge": 4219101,
                "nome": "Vargeão"
            },
            {
                "codigo_ibge": 4219150,
                "nome": "Vargem"
            },
            {
                "codigo_ibge": 4219176,
                "nome": "Vargem Bonita"
            },
            {
                "codigo_ibge": 4219200,
                "nome": "Vidal Ramos"
            },
            {
                "codigo_ibge": 4219309,
                "nome": "Videira"
            },
            {
                "codigo_ibge": 4219358,
                "nome": "Vitor Meireles"
            },
            {
                "codigo_ibge": 4219408,
                "nome": "Witmarsum"
            },
            {
                "codigo_ibge": 4219507,
                "nome": "Xanxerê"
            },
            {
                "codigo_ibge": 4219606,
                "nome": "Xavantina"
            },
            {
                "codigo_ibge": 4219705,
                "nome": "Xaxim"
            },
            {
                "codigo_ibge": 4219853,
                "nome": "Zortéa"
            }
        ]
    },
    "SE": {
        "nome": "Sergipe",
        "municipios": [
            {
                "codigo_ibge": 2800100,
                "nome": "Amparo de São Francisco"
            },
            {
                "codigo_ibge": 2800209,
                "nome": "Aquidabã"
            },
            {
                "codigo_ibge": 2800308,
                "nome": "Aracaju"
            },
            {
                "codigo_ibge": 2800407,
                "nome": "Arauá"
            },
            {
                "codigo_ibge": 2800506,
                "nome": "Areia Branca"
            },
            {
                "codigo_ibge": 2800605,
                "nome": "Barra dos Coqueiros"
            },
            {
                "codigo_ibge": 2800670,
                "nome": "Boquim"
            },
            {
                "codigo_ibge": 2800704,
                "nome": "Brejo Grande"
            },
            {
                "codigo_ibge": 2801009,
                "nome": "Campo do Brito"
            },
            {
                "codigo_ibge": 2801108,
                "nome": "Canhoba"
            },
            {
                "codigo_ibge": 2801207,
                "nome": "Canindé de São Francisco"
            },
            {
                "codigo_ibge": 2801306,
                "nome": "Capela"
            },
            {
                "codigo_ibge": 2801405,
                "nome": "Carira"
            },
            {
                "codigo_ibge": 2801504,
                "nome": "Carmópolis"
            },
            {
                "codigo_ibge": 2801603,
                "nome": "Cedro de São João"
            },
            {
                "codigo_ibge": 2801702,
                "nome": "Cristinápolis"
            },
            {
                "codigo_ibge": 2801900,
                "nome": "Cumbe"
            },
            {
                "codigo_ibge": 2802007,
                "nome": "Divina Pastora"
            },
            {
                "codigo_ibge": 2802106,
                "nome": "Estância"
            },
            {
                "codigo_ibge": 2802205,
                "nome": "Feira Nova"
            },
            {
                "codigo_ibge": 2802304,
                "nome": "Frei Paulo"
            },
            {
                "codigo_ibge": 2802403,
                "nome": "Gararu"
            },
            {
                "codigo_ibge": 2802502,
                "nome": "General Maynard"
            },
            {
                "codigo_ibge": 2802601,
                "nome": "Gracho Cardoso"
            },
            {
                "codigo_ibge": 2802700,
                "nome": "Ilha das Flores"
            },
            {
                "codigo_ibge": 2802809,
                "nome": "Indiaroba"
            },
            {
                "codigo_ibge": 2802908,
                "nome": "Itabaiana"
            },
            {
                "codigo_ibge": 2803005,
                "nome": "Itabaianinha"
            },
            {
                "codigo_ibge": 2803104,
                "nome": "Itabi"
            },
            {
                "codigo_ibge": 2803203,
                "nome": "Itaporanga d'Ajuda"
            },
            {
                "codigo_ibge": 2803302,
                "nome": "Japaratuba"
            },
            {
                "codigo_ibge": 2803401,
                "nome": "Japoatã"
            },
            {
                "codigo_ibge": 2803500,
                "nome": "Lagarto"
            },
            {
                "codigo_ibge": 2803609,
                "nome": "Laranjeiras"
            },
            {
                "codigo_ibge": 2803708,
                "nome": "Macambira"
            },
            {
                "codigo_ibge": 2803807,
                "nome": "Malhada dos Bois"
            },
            {
                "codigo_ibge": 2803906,
                "nome": "Malhador"
            },
            {
                "codigo_ibge": 2804003,
                "nome": "Maruim"
            },
            {
                "codigo_ibge": 2804102,
                "nome": "Moita Bonita"
            },
            {
                "codigo_ibge": 2804201,
                "nome": "Monte Alegre de Sergipe"
            },
            {
                "codigo_ibge": 2804300,
                "nome": "Muribeca"
            },
            {
                "codigo_ibge": 2804409,
                "nome": "Neópolis"
            },
            {
                "codigo_ibge": 2804458,
                "nome": "Nossa Senhora Aparecida"
            },
            {
                "codigo_ibge": 2804508,
                "nome": "Nossa Senhora da Glória"
            },
            {
                "codigo_ibge": 2804607,
                "nome": "Nossa Senhora das Dores"
            },
            {
                "codigo_ibge": 2804706,
                "nome": "Nossa Senhora de Lourdes"
            },
            {
                "codigo_ibge": 2804805,
                "nome": "Nossa Senhora do Socorro"
            },
            {
                "codigo_ibge": 2804904,
                "nome": "Pacatuba"
            },
            {
                "codigo_ibge": 2805000,
                "nome": "Pedra Mole"
            },
            {
                "codigo_ibge": 2805109,
                "nome": "Pedrinhas"
            },
            {
                "codigo_ibge": 2805208,
                "nome": "Pinhão"
            },
            {
                "codigo_ibge": 2805307,
                "nome": "Pirambu"
            },
            {
                "codigo_ibge": 2805406,
                "nome": "Poço Redondo"
            },
            {
                "codigo_ibge": 2805505,
                "nome": "Poço Verde"
            },
            {
                "codigo_ibge": 2805604,
                "nome": "Porto da Folha"
            },
            {
                "codigo_ibge": 2805703,
                "nome": "Propriá"
            },
            {
                "codigo_ibge": 2805802,
                "nome": "Riachão do Dantas"
            },
            {
                "codigo_ibge": 2805901,
                "nome": "Riachuelo"
            },
            {
                "codigo_ibge": 2806008,
                "nome": "Ribeirópolis"
            },
            {
                "codigo_ibge": 2806107,
                "nome": "Rosário do Catete"
            },
            {
                "codigo_ibge": 2806206,
                "nome": "Salgado"
            },
            {
                "codigo_ibge": 2806305,
                "nome": "Santa Luzia do Itanhy"
            },
            {
                "codigo_ibge": 2806503,
                "nome": "Santa Rosa de Lima"
            },
            {
                "codigo_ibge": 2806404,
                "nome": "Santana do São Francisco"
            },
            {
                "codigo_ibge": 2806602,
                "nome": "Santo Amaro das Brotas"
            },
            {
                "codigo_ibge": 2806701,
                "nome": "São Cristóvão"
            },
            {
                "codigo_ibge": 2806800,
                "nome": "São Domingos"
            },
            {
                "codigo_ibge": 2806909,
                "nome": "São Francisco"
            },
            {
                "codigo_ibge": 2807006,
                "nome": "São Miguel do Aleixo"
            },
            {
                "codigo_ibge": 2807105,
                "nome": "Simão Dias"
            },
            {
                "codigo_ibge": 2807204,
                "nome": "Siriri"
            },
            {
                "codigo_ibge": 2807303,
                "nome": "Telha"
            },
            {
                "codigo_ibge": 2807402,
                "nome": "Tobias Barreto"
            },
            {
                "codigo_ibge": 2807501,
                "nome": "Tomar do Geru"
            },
            {
                "codigo_ibge": 2807600,
                "nome": "Umbaúba"
            }
        ]
    },
    "SP": {
        "nome": "São Paulo",
        "municipios": [
            {
                "codigo_ibge": 3500105,
                "nome": "Adamantina"
            },
            {
                "codigo_ibge": 3500204,
                "nome": "Adolfo"
            },
            {
                "codigo_ibge": 3500303,
                "nome": "Aguaí"
            },
            {
                "codigo_ibge": 3500402,
                "nome": "Águas da Prata"
            },
            {
                "codigo_ibge": 3500501,
                "nome": "Águas de Lindóia"
            },
            {
                "codigo_ibge": 3500550,
                "nome": "Águas de Santa Bárbara"
            },
            {
                "codigo_ibge": 3500600,
                "nome": "Águas de São Pedro"
            },
            {
                "codigo_ibge": 3500709,
                "nome": "Agudos"
            },
            {
                "codigo_ibge": 3500758,
                "nome": "Alambari"
            },
            {
                "codigo_ibge": 3500808,
                "nome": "Alfredo Marcondes"
            },
            {
                "codigo_ibge": 3500907,
                "nome": "Altair"
            },
            {
                "codigo_ibge": 3501004,
                "nome": "Altinópolis"
            },
            {
                "codigo_ibge": 3501103,
                "nome": "Alto Alegre"
            },
            {
                "codigo_ibge": 3501152,
                "nome": "Alumínio"
            },
            {
                "codigo_ibge": 3501202,
                "nome": "Álvares Florence"
            },
            {
                "codigo_ibge": 3501301,
                "nome": "Álvares Machado"
            },
            {
                "codigo_ibge": 3501400,
                "nome": "Álvaro de Carvalho"
            },
            {
                "codigo_ibge": 3501509,
                "nome": "Alvinlândia"
            },
            {
                "codigo_ibge": 3501608,
                "nome": "Americana"
            },
            {
                "codigo_ibge": 3501707,
                "nome": "Américo Brasiliense"
            },
            {
                "codigo_ibge": 3501806,
                "nome": "Américo de Campos"
            },
            {
                "codigo_ibge": 3501905,
                "nome": "Amparo"
            },
            {
                "codigo_ibge": 3502002,
                "nome": "Analândia"
            },
            {
                "codigo_ibge": 3502101,
                "nome": "Andradina"
            },
            {
                "codigo_ibge": 3502200,
                "nome": "Angatuba"
            },
            {
                "codigo_ibge": 3502309,
                "nome": "Anhembi"
            },
            {
                "codigo_ibge": 3502408,
                "nome": "Anhumas"
            },
            {
                "codigo_ibge": 3502507,
                "nome": "Aparecida"
            },
            {
                "codigo_ibge": 3502606,
                "nome": "Aparecida d'Oeste"
            },
            {
                "codigo_ibge": 3502705,
                "nome": "Apiaí"
            },
            {
                "codigo_ibge": 3502754,
                "nome": "Araçariguama"
            },
            {
                "codigo_ibge": 3502804,
                "nome": "Araçatuba"
            },
            {
                "codigo_ibge": 3502903,
                "nome": "Araçoiaba da Serra"
            },
            {
                "codigo_ibge": 3503000,
                "nome": "Aramina"
            },
            {
                "codigo_ibge": 3503109,
                "nome": "Arandu"
            },
            {
                "codigo_ibge": 3503158,
                "nome": "Arapeí"
            },
            {
                "codigo_ibge": 3503208,
                "nome": "Araraquara"
            },
            {
                "codigo_ibge": 3503307,
                "nome": "Araras"
            },
            {
                "codigo_ibge": 3503356,
                "nome": "Arco-Íris"
            },
            {
                "codigo_ibge": 3503406,
                "nome": "Arealva"
            },
            {
                "codigo_ibge": 3503505,
                "nome": "Areias"
            },
            {
                "codigo_ibge": 3503604,
                "nome": "Areiópolis"
            },
            {
                "codigo_ibge": 3503703,
                "nome": "Ariranha"
            },
            {
                "codigo_ibge": 3503802,
                "nome": "Artur Nogueira"
            },
            {
                "codigo_ibge": 3503901,
                "nome": "Arujá"
            },
            {
                "codigo_ibge": 3503950,
                "nome": "Aspásia"
            },
            {
                "codigo_ibge": 3504008,
                "nome": "Assis"
            },
            {
                "codigo_ibge": 3504107,
                "nome": "Atibaia"
            },
            {
                "codigo_ibge": 3504206,
                "nome": "Auriflama"
            },
            {
                "codigo_ibge": 3504305,
                "nome": "Avaí"
            },
            {
                "codigo_ibge": 3504404,
                "nome": "Avanhandava"
            },
            {
                "codigo_ibge": 3504503,
                "nome": "Avaré"
            },
            {
                "codigo_ibge": 3504602,
                "nome": "Bady Bassitt"
            },
            {
                "codigo_ibge": 3504701,
                "nome": "Balbinos"
            },
            {
                "codigo_ibge": 3504800,
                "nome": "Bálsamo"
            },
            {
                "codigo_ibge": 3504909,
                "nome": "Bananal"
            },
            {
                "codigo_ibge": 3505005,
                "nome": "Barão de Antonina"
            },
            {
                "codigo_ibge": 3505104,
                "nome": "Barbosa"
            },
            {
                "codigo_ibge": 3505203,
                "nome": "Bariri"
            },
            {
                "codigo_ibge": 3505302,
                "nome": "Barra Bonita"
            },
            {
                "codigo_ibge": 3505351,
                "nome": "Barra do Chapéu"
            },
            {
                "codigo_ibge": 3505401,
                "nome": "Barra do Turvo"
            },
            {
                "codigo_ibge": 3505500,
                "nome": "Barretos"
            },
            {
                "codigo_ibge": 3505609,
                "nome": "Barrinha"
            },
            {
                "codigo_ibge": 3505708,
                "nome": "Barueri"
            },
            {
                "codigo_ibge": 3505807,
                "nome": "Bastos"
            },
            {
                "codigo_ibge": 3505906,
                "nome": "Batatais"
            },
            {
                "codigo_ibge": 3506003,
                "nome": "Bauru"
            },
            {
                "codigo_ibge": 3506102,
                "nome": "Bebedouro"
            },
            {
                "codigo_ibge": 3506201,
                "nome": "Bento de Abreu"
            },
            {
                "codigo_ibge": 3506300,
                "nome": "Bernardino de Campos"
            },
            {
                "codigo_ibge": 3506359,
                "nome": "Bertioga"
            },
            {
                "codigo_ibge": 3506409,
                "nome": "Bilac"
            },
            {
                "codigo_ibge": 3506508,
                "nome": "Birigui"
            },
            {
                "codigo_ibge": 3506607,
                "nome": "Biritiba-Mirim"
            },
            {
                "codigo_ibge": 3506706,
                "nome": "Boa Esperança do Sul"
            },
            {
                "codigo_ibge": 3506805,
                "nome": "Bocaina"
            },
            {
                "codigo_ibge": 3506904,
                "nome": "Bofete"
            },
            {
                "codigo_ibge": 3507001,
                "nome": "Boituva"
            },
            {
                "codigo_ibge": 3507100,
                "nome": "Bom Jesus dos Perdões"
            },
            {
                "codigo_ibge": 3507159,
                "nome": "Bom Sucesso de Itararé"
            },
            {
                "codigo_ibge": 3507209,
                "nome": "Borá"
            },
            {
                "codigo_ibge": 3507308,
                "nome": "Boracéia"
            },
            {
                "codigo_ibge": 3507407,
                "nome": "Borborema"
            },
            {
                "codigo_ibge": 3507456,
                "nome": "Borebi"
            },
            {
                "codigo_ibge": 3507506,
                "nome": "Botucatu"
            },
            {
                "codigo_ibge": 3507605,
                "nome": "Bragança Paulista"
            },
            {
                "codigo_ibge": 3507704,
                "nome": "Braúna"
            },
            {
                "codigo_ibge": 3507753,
                "nome": "Brejo Alegre"
            },
            {
                "codigo_ibge": 3507803,
                "nome": "Brodowski"
            },
            {
                "codigo_ibge": 3507902,
                "nome": "Brotas"
            },
            {
                "codigo_ibge": 3508009,
                "nome": "Buri"
            },
            {
                "codigo_ibge": 3508108,
                "nome": "Buritama"
            },
            {
                "codigo_ibge": 3508207,
                "nome": "Buritizal"
            },
            {
                "codigo_ibge": 3508306,
                "nome": "Cabrália Paulista"
            },
            {
                "codigo_ibge": 3508405,
                "nome": "Cabreúva"
            },
            {
                "codigo_ibge": 3508504,
                "nome": "Caçapava"
            },
            {
                "codigo_ibge": 3508603,
                "nome": "Cachoeira Paulista"
            },
            {
                "codigo_ibge": 3508702,
                "nome": "Caconde"
            },
            {
                "codigo_ibge": 3508801,
                "nome": "Cafelândia"
            },
            {
                "codigo_ibge": 3508900,
                "nome": "Caiabu"
            },
            {
                "codigo_ibge": 3509007,
                "nome": "Caieiras"
            },
            {
                "codigo_ibge": 3509106,
                "nome": "Caiuá"
            },
            {
                "codigo_ibge": 3509205,
                "nome": "Cajamar"
            },
            {
                "codigo_ibge": 3509254,
                "nome": "Cajati"
            },
            {
                "codigo_ibge": 3509304,
                "nome": "Cajobi"
            },
            {
                "codigo_ibge": 3509403,
                "nome": "Cajuru"
            },
            {
                "codigo_ibge": 3509452,
                "nome": "Campina do Monte Alegre"
            },
            {
                "codigo_ibge": 3509502,
                "nome": "Campinas"
            },
            {
                "codigo_ibge": 3509601,
                "nome": "Campo Limpo Paulista"
            },
            {
                "codigo_ibge": 3509700,
                "nome": "Campos do Jordão"
            },
            {
                "codigo_ibge": 3509809,
                "nome": "Campos Novos Paulista"
            },
            {
                "codigo_ibge": 3509908,
                "nome": "Cananéia"
            },
            {
                "codigo_ibge": 3509957,
                "nome": "Canas"
            },
            {
                "codigo_ibge": 3510005,
                "nome": "Cândido Mota"
            },
            {
                "codigo_ibge": 3510104,
                "nome": "Cândido Rodrigues"
            },
            {
                "codigo_ibge": 3510153,
                "nome": "Canitar"
            },
            {
                "codigo_ibge": 3510203,
                "nome": "Capão Bonito"
            },
            {
                "codigo_ibge": 3510302,
                "nome": "Capela do Alto"
            },
            {
                "codigo_ibge": 3510401,
                "nome": "Capivari"
            },
            {
                "codigo_ibge": 3510500,
                "nome": "Caraguatatuba"
            },
            {
                "codigo_ibge": 3510609,
                "nome": "Carapicuíba"
            },
            {
                "codigo_ibge": 3510708,
                "nome": "Cardoso"
            },
            {
                "codigo_ibge": 3510807,
                "nome": "Casa Branca"
            },
            {
                "codigo_ibge": 3510906,
                "nome": "Cássia dos Coqueiros"
            },
            {
                "codigo_ibge": 3511003,
                "nome": "Castilho"
            },
            {
                "codigo_ibge": 3511102,
                "nome": "Catanduva"
            },
            {
                "codigo_ibge": 3511201,
                "nome": "Catiguá"
            },
            {
                "codigo_ibge": 3511300,
                "nome": "Cedral"
            },
            {
                "codigo_ibge": 3511409,
                "nome": "Cerqueira César"
            },
            {
                "codigo_ibge": 3511508,
                "nome": "Cerquilho"
            },
            {
                "codigo_ibge": 3511607,
                "nome": "Cesário Lange"
            },
            {
                "codigo_ibge": 3511706,
                "nome": "Charqueada"
            },
            {
                "codigo_ibge": 3557204,
                "nome": "Chavantes"
            },
            {
                "codigo_ibge": 3511904,
                "nome": "Clementina"
            },
            {
                "codigo_ibge": 3512001,
                "nome": "Colina"
            },
            {
                "codigo_ibge": 3512100,
                "nome": "Colômbia"
            },
            {
                "codigo_ibge": 3512209,
                "nome": "Conchal"
            },
            {
                "codigo_ibge": 3512308,
                "nome": "Conchas"
            },
            {
                "codigo_ibge": 3512407,
                "nome": "Cordeirópolis"
            },
            {
                "codigo_ibge": 3512506,
                "nome": "Coroados"
            },
            {
                "codigo_ibge": 3512605,
                "nome": "Coronel Macedo"
            },
            {
                "codigo_ibge": 3512704,
                "nome": "Corumbataí"
            },
            {
                "codigo_ibge": 3512803,
                "nome": "Cosmópolis"
            },
            {
                "codigo_ibge": 3512902,
                "nome": "Cosmorama"
            },
            {
                "codigo_ibge": 3513009,
                "nome": "Cotia"
            },
            {
                "codigo_ibge": 3513108,
                "nome": "Cravinhos"
            },
            {
                "codigo_ibge": 3513207,
                "nome": "Cristais Paulista"
            },
            {
                "codigo_ibge": 3513306,
                "nome": "Cruzália"
            },
            {
                "codigo_ibge": 3513405,
                "nome": "Cruzeiro"
            },
            {
                "codigo_ibge": 3513504,
                "nome": "Cubatão"
            },
            {
                "codigo_ibge": 3513603,
                "nome": "Cunha"
            },
            {
                "codigo_ibge": 3513702,
                "nome": "Descalvado"
            },
            {
                "codigo_ibge": 3513801,
                "nome": "Diadema"
            },
            {
                "codigo_ibge": 3513850,
                "nome": "Dirce Reis"
            },
            {
                "codigo_ibge": 3513900,
                "nome": "Divinolândia"
            },
            {
                "codigo_ibge": 3514007,
                "nome": "Dobrada"
            },
            {
                "codigo_ibge": 3514106,
                "nome": "Dois Córregos"
            },
            {
                "codigo_ibge": 3514205,
                "nome": "Dolcinópolis"
            },
            {
                "codigo_ibge": 3514304,
                "nome": "Dourado"
            },
            {
                "codigo_ibge": 3514403,
                "nome": "Dracena"
            },
            {
                "codigo_ibge": 3514502,
                "nome": "Duartina"
            },
            {
                "codigo_ibge": 3514601,
                "nome": "Dumont"
            },
            {
                "codigo_ibge": 3514700,
                "nome": "Echaporã"
            },
            {
                "codigo_ibge": 3514809,
                "nome": "Eldorado"
            },
            {
                "codigo_ibge": 3514908,
                "nome": "Elias Fausto"
            },
            {
                "codigo_ibge": 3514924,
                "nome": "Elisiário"
            },
            {
                "codigo_ibge": 3514957,
                "nome": "Embaúba"
            },
            {
                "codigo_ibge": 3515004,
                "nome": "Embu das Artes"
            },
            {
                "codigo_ibge": 3515103,
                "nome": "Embu-Guaçu"
            },
            {
                "codigo_ibge": 3515129,
                "nome": "Emilianópolis"
            },
            {
                "codigo_ibge": 3515152,
                "nome": "Engenheiro Coelho"
            },
            {
                "codigo_ibge": 3515186,
                "nome": "Espírito Santo do Pinhal"
            },
            {
                "codigo_ibge": 3515194,
                "nome": "Espírito Santo do Turvo"
            },
            {
                "codigo_ibge": 3557303,
                "nome": "Estiva Gerbi"
            },
            {
                "codigo_ibge": 3515202,
                "nome": "Estrela d'Oeste"
            },
            {
                "codigo_ibge": 3515301,
                "nome": "Estrela do Norte"
            },
            {
                "codigo_ibge": 3515350,
                "nome": "Euclides da Cunha Paulista"
            },
            {
                "codigo_ibge": 3515400,
                "nome": "Fartura"
            },
            {
                "codigo_ibge": 3515608,
                "nome": "Fernando Prestes"
            },
            {
                "codigo_ibge": 3515509,
                "nome": "Fernandópolis"
            },
            {
                "codigo_ibge": 3515657,
                "nome": "Fernão"
            },
            {
                "codigo_ibge": 3515707,
                "nome": "Ferraz de Vasconcelos"
            },
            {
                "codigo_ibge": 3515806,
                "nome": "Flora Rica"
            },
            {
                "codigo_ibge": 3515905,
                "nome": "Floreal"
            },
            {
                "codigo_ibge": 3516002,
                "nome": "Flórida Paulista"
            },
            {
                "codigo_ibge": 3516101,
                "nome": "Florínia"
            },
            {
                "codigo_ibge": 3516200,
                "nome": "Franca"
            },
            {
                "codigo_ibge": 3516309,
                "nome": "Francisco Morato"
            },
            {
                "codigo_ibge": 3516408,
                "nome": "Franco da Rocha"
            },
            {
                "codigo_ibge": 3516507,
                "nome": "Gabriel Monteiro"
            },
            {
                "codigo_ibge": 3516606,
                "nome": "Gália"
            },
            {
                "codigo_ibge": 3516705,
                "nome": "Garça"
            },
            {
                "codigo_ibge": 3516804,
                "nome": "Gastão Vidigal"
            },
            {
                "codigo_ibge": 3516853,
                "nome": "Gavião Peixoto"
            },
            {
                "codigo_ibge": 3516903,
                "nome": "General Salgado"
            },
            {
                "codigo_ibge": 3517000,
                "nome": "Getulina"
            },
            {
                "codigo_ibge": 3517109,
                "nome": "Glicério"
            },
            {
                "codigo_ibge": 3517208,
                "nome": "Guaiçara"
            },
            {
                "codigo_ibge": 3517307,
                "nome": "Guaimbê"
            },
            {
                "codigo_ibge": 3517406,
                "nome": "Guaíra"
            },
            {
                "codigo_ibge": 3517505,
                "nome": "Guapiaçu"
            },
            {
                "codigo_ibge": 3517604,
                "nome": "Guapiara"
            },
            {
                "codigo_ibge": 3517703,
                "nome": "Guará"
            },
            {
                "codigo_ibge": 3517802,
                "nome": "Guaraçaí"
            },
            {
                "codigo_ibge": 3517901,
                "nome": "Guaraci"
            },
            {
                "codigo_ibge": 3518008,
                "nome": "Guarani d'Oeste"
            },
            {
                "codigo_ibge": 3518107,
                "nome": "Guarantã"
            },
            {
                "codigo_ibge": 3518206,
                "nome": "Guararapes"
            },
            {
                "codigo_ibge": 3518305,
                "nome": "Guararema"
            },
            {
                "codigo_ibge": 3518404,
                "nome": "Guaratinguetá"
            },
            {
                "codigo_ibge": 3518503,
                "nome": "Guareí"
            },
            {
                "codigo_ibge": 3518602,
                "nome": "Guariba"
            },
            {
                "codigo_ibge": 3518701,
                "nome": "Guarujá"
            },
            {
                "codigo_ibge": 3518800,
                "nome": "Guarulhos"
            },
            {
                "codigo_ibge": 3518859,
                "nome": "Guatapará"
            },
            {
                "codigo_ibge": 3518909,
                "nome": "Guzolândia"
            },
            {
                "codigo_ibge": 3519006,
                "nome": "Herculândia"
            },
            {
                "codigo_ibge": 3519055,
                "nome": "Holambra"
            },
            {
                "codigo_ibge": 3519071,
                "nome": "Hortolândia"
            },
            {
                "codigo_ibge": 3519105,
                "nome": "Iacanga"
            },
            {
                "codigo_ibge": 3519204,
                "nome": "Iacri"
            },
            {
                "codigo_ibge": 3519253,
                "nome": "Iaras"
            },
            {
                "codigo_ibge": 3519303,
                "nome": "Ibaté"
            },
            {
                "codigo_ibge": 3519402,
                "nome": "Ibirá"
            },
            {
                "codigo_ibge": 3519501,
                "nome": "Ibirarema"
            },
            {
                "codigo_ibge": 3519600,
                "nome": "Ibitinga"
            },
            {
                "codigo_ibge": 3519709,
                "nome": "Ibiúna"
            },
            {
                "codigo_ibge": 3519808,
                "nome": "Icém"
            },
            {
                "codigo_ibge": 3519907,
                "nome": "Iepê"
            },
            {
                "codigo_ibge": 3520004,
                "nome": "Igaraçu do Tietê"
            },
            {
                "codigo_ibge": 3520103,
                "nome": "Igarapava"
            },
            {
                "codigo_ibge": 3520202,
                "nome": "Igaratá"
            },
            {
                "codigo_ibge": 3520301,
                "nome": "Iguape"
            },
            {
                "codigo_ibge": 3520426,
                "nome": "Ilha Comprida"
            },
            {
                "codigo_ibge": 3520442,
                "nome": "Ilha Solteira"
            },
            {
                "codigo_ibge": 3520400,
                "nome": "Ilhabela"
            },
            {
                "codigo_ibge": 3520509,
                "nome": "Indaiatuba"
            },
            {
                "codigo_ibge": 3520608,
                "nome": "Indiana"
            },
            {
                "codigo_ibge": 3520707,
                "nome": "Indiaporã"
            },
            {
                "codigo_ibge": 3520806,
                "nome": "Inúbia Paulista"
            },
            {
                "codigo_ibge": 3520905,
                "nome": "Ipaussu"
            },
            {
                "codigo_ibge": 3521002,
                "nome": "Iperó"
            },
            {
                "codigo_ibge": 3521101,
                "nome": "Ipeúna"
            },
            {
                "codigo_ibge": 3521150,
                "nome": "Ipiguá"
            },
            {
                "codigo_ibge": 3521200,
                "nome": "Iporanga"
            },
            {
                "codigo_ibge": 3521309,
                "nome": "Ipuã"
            },
            {
                "codigo_ibge": 3521408,
                "nome": "Iracemápolis"
            },
            {
                "codigo_ibge": 3521507,
                "nome": "Irapuã"
            },
            {
                "codigo_ibge": 3521606,
                "nome": "Irapuru"
            },
            {
                "codigo_ibge": 3521705,
                "nome": "Itaberá"
            },
            {
                "codigo_ibge": 3521804,
                "nome": "Itaí"
            },
            {
                "codigo_ibge": 3521903,
                "nome": "Itajobi"
            },
            {
                "codigo_ibge": 3522000,
                "nome": "Itaju"
            },
            {
                "codigo_ibge": 3522109,
                "nome": "Itanhaém"
            },
            {
                "codigo_ibge": 3522158,
                "nome": "Itaóca"
            },
            {
                "codigo_ibge": 3522208,
                "nome": "Itapecerica da Serra"
            },
            {
                "codigo_ibge": 3522307,
                "nome": "Itapetininga"
            },
            {
                "codigo_ibge": 3522406,
                "nome": "Itapeva"
            },
            {
                "codigo_ibge": 3522505,
                "nome": "Itapevi"
            },
            {
                "codigo_ibge": 3522604,
                "nome": "Itapira"
            },
            {
                "codigo_ibge": 3522653,
                "nome": "Itapirapuã Paulista"
            },
            {
                "codigo_ibge": 3522703,
                "nome": "Itápolis"
            },
            {
                "codigo_ibge": 3522802,
                "nome": "Itaporanga"
            },
            {
                "codigo_ibge": 3522901,
                "nome": "Itapuí"
            },
            {
                "codigo_ibge": 3523008,
                "nome": "Itapura"
            },
            {
                "codigo_ibge": 3523107,
                "nome": "Itaquaquecetuba"
            },
            {
                "codigo_ibge": 3523206,
                "nome": "Itararé"
            },
            {
                "codigo_ibge": 3523305,
                "nome": "Itariri"
            },
            {
                "codigo_ibge": 3523404,
                "nome": "Itatiba"
            },
            {
                "codigo_ibge": 3523503,
                "nome": "Itatinga"
            },
            {
                "codigo_ibge": 3523602,
                "nome": "Itirapina"
            },
            {
                "codigo_ibge": 3523701,
                "nome": "Itirapuã"
            },
            {
                "codigo_ibge": 3523800,
                "nome": "Itobi"
            },
            {
                "codigo_ibge": 3523909,
                "nome": "Itu"
            },
            {
                "codigo_ibge": 3524006,
                "nome": "Itupeva"
            },
            {
                "codigo_ibge": 3524105,
                "nome": "Ituverava"
            },
            {
                "codigo_ibge": 3524204,
                "nome": "Jaborandi"
            },
            {
                "codigo_ibge": 3524303,
                "nome": "Jaboticabal"
            },
            {
                "codigo_ibge": 3524402,
                "nome": "Jacareí"
            },
            {
                "codigo_ibge": 3524501,
                "nome": "Jaci"
            },
            {
                "codigo_ibge": 3524600,
                "nome": "Jacupiranga"
            },
            {
                "codigo_ibge": 3524709,
                "nome": "Jaguariúna"
            },
            {
                "codigo_ibge": 3524808,
                "nome": "Jales"
            },
            {
                "codigo_ibge": 3524907,
                "nome": "Jambeiro"
            },
            {
                "codigo_ibge": 3525003,
                "nome": "Jandira"
            },
            {
                "codigo_ibge": 3525102,
                "nome": "Jardinópolis"
            },
            {
                "codigo_ibge": 3525201,
                "nome": "Jarinu"
            },
            {
                "codigo_ibge": 3525300,
                "nome": "Jaú"
            },
            {
                "codigo_ibge": 3525409,
                "nome": "Jeriquara"
            },
            {
                "codigo_ibge": 3525508,
                "nome": "Joanópolis"
            },
            {
                "codigo_ibge": 3525607,
                "nome": "João Ramalho"
            },
            {
                "codigo_ibge": 3525706,
                "nome": "José Bonifácio"
            },
            {
                "codigo_ibge": 3525805,
                "nome": "Júlio Mesquita"
            },
            {
                "codigo_ibge": 3525854,
                "nome": "Jumirim"
            },
            {
                "codigo_ibge": 3525904,
                "nome": "Jundiaí"
            },
            {
                "codigo_ibge": 3526001,
                "nome": "Junqueirópolis"
            },
            {
                "codigo_ibge": 3526100,
                "nome": "Juquiá"
            },
            {
                "codigo_ibge": 3526209,
                "nome": "Juquitiba"
            },
            {
                "codigo_ibge": 3526308,
                "nome": "Lagoinha"
            },
            {
                "codigo_ibge": 3526407,
                "nome": "Laranjal Paulista"
            },
            {
                "codigo_ibge": 3526506,
                "nome": "Lavínia"
            },
            {
                "codigo_ibge": 3526605,
                "nome": "Lavrinhas"
            },
            {
                "codigo_ibge": 3526704,
                "nome": "Leme"
            },
            {
                "codigo_ibge": 3526803,
                "nome": "Lençóis Paulista"
            },
            {
                "codigo_ibge": 3526902,
                "nome": "Limeira"
            },
            {
                "codigo_ibge": 3527009,
                "nome": "Lindóia"
            },
            {
                "codigo_ibge": 3527108,
                "nome": "Lins"
            },
            {
                "codigo_ibge": 3527207,
                "nome": "Lorena"
            },
            {
                "codigo_ibge": 3527256,
                "nome": "Lourdes"
            },
            {
                "codigo_ibge": 3527306,
                "nome": "Louveira"
            },
            {
                "codigo_ibge": 3527405,
                "nome": "Lucélia"
            },
            {
                "codigo_ibge": 3527504,
                "nome": "Lucianópolis"
            },
            {
                "codigo_ibge": 3527603,
                "nome": "Luís Antônio"
            },
            {
                "codigo_ibge": 3527702,
                "nome": "Luiziânia"
            },
            {
                "codigo_ibge": 3527801,
                "nome": "Lupércio"
            },
            {
                "codigo_ibge": 3527900,
                "nome": "Lutécia"
            },
            {
                "codigo_ibge": 3528007,
                "nome": "Macatuba"
            },
            {
                "codigo_ibge": 3528106,
                "nome": "Macaubal"
            },
            {
                "codigo_ibge": 3528205,
                "nome": "Macedônia"
            },
            {
                "codigo_ibge": 3528304,
                "nome": "Magda"
            },
            {
                "codigo_ibge": 3528403,
                "nome": "Mairinque"
            },
            {
                "codigo_ibge": 3528502,
                "nome": "Mairiporã"
            },
            {
                "codigo_ibge": 3528601,
                "nome": "Manduri"
            },
            {
                "codigo_ibge": 3528700,
                "nome": "Marabá Paulista"
            },
            {
                "codigo_ibge": 3528809,
                "nome": "Maracaí"
            },
            {
                "codigo_ibge": 3528858,
                "nome": "Marapoama"
            },
            {
                "codigo_ibge": 3528908,
                "nome": "Mariápolis"
            },
            {
                "codigo_ibge": 3529005,
                "nome": "Marília"
            },
            {
                "codigo_ibge": 3529104,
                "nome": "Marinópolis"
            },
            {
                "codigo_ibge": 3529203,
                "nome": "Martinópolis"
            },
            {
                "codigo_ibge": 3529302,
                "nome": "Matão"
            },
            {
                "codigo_ibge": 3529401,
                "nome": "Mauá"
            },
            {
                "codigo_ibge": 3529500,
                "nome": "Mendonça"
            },
            {
                "codigo_ibge": 3529609,
                "nome": "Meridiano"
            },
            {
                "codigo_ibge": 3529658,
                "nome": "Mesópolis"
            },
            {
                "codigo_ibge": 3529708,
                "nome": "Miguelópolis"
            },
            {
                "codigo_ibge": 3529807,
                "nome": "Mineiros do Tietê"
            },
            {
                "codigo_ibge": 3530003,
                "nome": "Mira Estrela"
            },
            {
                "codigo_ibge": 3529906,
                "nome": "Miracatu"
            },
            {
                "codigo_ibge": 3530102,
                "nome": "Mirandópolis"
            },
            {
                "codigo_ibge": 3530201,
                "nome": "Mirante do Paranapanema"
            },
            {
                "codigo_ibge": 3530300,
                "nome": "Mirassol"
            },
            {
                "codigo_ibge": 3530409,
                "nome": "Mirassolândia"
            },
            {
                "codigo_ibge": 3530508,
                "nome": "Mococa"
            },
            {
                "codigo_ibge": 3530607,
                "nome": "Mogi das Cruzes"
            },
            {
                "codigo_ibge": 3530706,
                "nome": "Mogi Guaçu"
            },
            {
                "codigo_ibge": 3530805,
                "nome": "Mogi Mirim"
            },
            {
                "codigo_ibge": 3530904,
                "nome": "Mombuca"
            },
            {
                "codigo_ibge": 3531001,
                "nome": "Monções"
            },
            {
                "codigo_ibge": 3531100,
                "nome": "Mongaguá"
            },
            {
                "codigo_ibge": 3531209,
                "nome": "Monte Alegre do Sul"
            },
            {
                "codigo_ibge": 3531308,
                "nome": "Monte Alto"
            },
            {
                "codigo_ibge": 3531407,
                "nome": "Monte Aprazível"
            },
            {
                "codigo_ibge": 3531506,
                "nome": "Monte Azul Paulista"
            },
            {
                "codigo_ibge": 3531605,
                "nome": "Monte Castelo"
            },
            {
                "codigo_ibge": 3531803,
                "nome": "Monte Mor"
            },
            {
                "codigo_ibge": 3531704,
                "nome": "Monteiro Lobato"
            },
            {
                "codigo_ibge": 3531902,
                "nome": "Morro Agudo"
            },
            {
                "codigo_ibge": 3532009,
                "nome": "Morungaba"
            },
            {
                "codigo_ibge": 3532058,
                "nome": "Motuca"
            },
            {
                "codigo_ibge": 3532108,
                "nome": "Murutinga do Sul"
            },
            {
                "codigo_ibge": 3532157,
                "nome": "Nantes"
            },
            {
                "codigo_ibge": 3532207,
                "nome": "Narandiba"
            },
            {
                "codigo_ibge": 3532306,
                "nome": "Natividade da Serra"
            },
            {
                "codigo_ibge": 3532405,
                "nome": "Nazaré Paulista"
            },
            {
                "codigo_ibge": 3532504,
                "nome": "Neves Paulista"
            },
            {
                "codigo_ibge": 3532603,
                "nome": "Nhandeara"
            },
            {
                "codigo_ibge": 3532702,
                "nome": "Nipoã"
            },
            {
                "codigo_ibge": 3532801,
                "nome": "Nova Aliança"
            },
            {
                "codigo_ibge": 3532827,
                "nome": "Nova Campina"
            },
            {
                "codigo_ibge": 3532843,
                "nome": "Nova Canaã Paulista"
            },
            {
                "codigo_ibge": 3532868,
                "nome": "Nova Castilho"
            },
            {
                "codigo_ibge": 3532900,
                "nome": "Nova Europa"
            },
            {
                "codigo_ibge": 3533007,
                "nome": "Nova Granada"
            },
            {
                "codigo_ibge": 3533106,
                "nome": "Nova Guataporanga"
            },
            {
                "codigo_ibge": 3533205,
                "nome": "Nova Independência"
            },
            {
                "codigo_ibge": 3533304,
                "nome": "Nova Luzitânia"
            },
            {
                "codigo_ibge": 3533403,
                "nome": "Nova Odessa"
            },
            {
                "codigo_ibge": 3533254,
                "nome": "Novais"
            },
            {
                "codigo_ibge": 3533502,
                "nome": "Novo Horizonte"
            },
            {
                "codigo_ibge": 3533601,
                "nome": "Nuporanga"
            },
            {
                "codigo_ibge": 3533700,
                "nome": "Ocauçu"
            },
            {
                "codigo_ibge": 3533809,
                "nome": "Óleo"
            },
            {
                "codigo_ibge": 3533908,
                "nome": "Olímpia"
            },
            {
                "codigo_ibge": 3534005,
                "nome": "Onda Verde"
            },
            {
                "codigo_ibge": 3534104,
                "nome": "Oriente"
            },
            {
                "codigo_ibge": 3534203,
                "nome": "Orindiúva"
            },
            {
                "codigo_ibge": 3534302,
                "nome": "Orlândia"
            },
            {
                "codigo_ibge": 3534401,
                "nome": "Osasco"
            },
            {
                "codigo_ibge": 3534500,
                "nome": "Oscar Bressane"
            },
            {
                "codigo_ibge": 3534609,
                "nome": "Osvaldo Cruz"
            },
            {
                "codigo_ibge": 3534708,
                "nome": "Ourinhos"
            },
            {
                "codigo_ibge": 3534807,
                "nome": "Ouro Verde"
            },
            {
                "codigo_ibge": 3534757,
                "nome": "Ouroeste"
            },
            {
                "codigo_ibge": 3534906,
                "nome": "Pacaembu"
            },
            {
                "codigo_ibge": 3535002,
                "nome": "Palestina"
            },
            {
                "codigo_ibge": 3535101,
                "nome": "Palmares Paulista"
            },
            {
                "codigo_ibge": 3535200,
                "nome": "Palmeira d'Oeste"
            },
            {
                "codigo_ibge": 3535309,
                "nome": "Palmital"
            },
            {
                "codigo_ibge": 3535408,
                "nome": "Panorama"
            },
            {
                "codigo_ibge": 3535507,
                "nome": "Paraguaçu Paulista"
            },
            {
                "codigo_ibge": 3535606,
                "nome": "Paraibuna"
            },
            {
                "codigo_ibge": 3535705,
                "nome": "Paraíso"
            },
            {
                "codigo_ibge": 3535804,
                "nome": "Paranapanema"
            },
            {
                "codigo_ibge": 3535903,
                "nome": "Paranapuã"
            },
            {
                "codigo_ibge": 3536000,
                "nome": "Parapuã"
            },
            {
                "codigo_ibge": 3536109,
                "nome": "Pardinho"
            },
            {
                "codigo_ibge": 3536208,
                "nome": "Pariquera-Açu"
            },
            {
                "codigo_ibge": 3536257,
                "nome": "Parisi"
            },
            {
                "codigo_ibge": 3536307,
                "nome": "Patrocínio Paulista"
            },
            {
                "codigo_ibge": 3536406,
                "nome": "Paulicéia"
            },
            {
                "codigo_ibge": 3536505,
                "nome": "Paulínia"
            },
            {
                "codigo_ibge": 3536570,
                "nome": "Paulistânia"
            },
            {
                "codigo_ibge": 3536604,
                "nome": "Paulo de Faria"
            },
            {
                "codigo_ibge": 3536703,
                "nome": "Pederneiras"
            },
            {
                "codigo_ibge": 3536802,
                "nome": "Pedra Bela"
            },
            {
                "codigo_ibge": 3536901,
                "nome": "Pedranópolis"
            },
            {
                "codigo_ibge": 3537008,
                "nome": "Pedregulho"
            },
            {
                "codigo_ibge": 3537107,
                "nome": "Pedreira"
            },
            {
                "codigo_ibge": 3537156,
                "nome": "Pedrinhas Paulista"
            },
            {
                "codigo_ibge": 3537206,
                "nome": "Pedro de Toledo"
            },
            {
                "codigo_ibge": 3537305,
                "nome": "Penápolis"
            },
            {
                "codigo_ibge": 3537404,
                "nome": "Pereira Barreto"
            },
            {
                "codigo_ibge": 3537503,
                "nome": "Pereiras"
            },
            {
                "codigo_ibge": 3537602,
                "nome": "Peruíbe"
            },
            {
                "codigo_ibge": 3537701,
                "nome": "Piacatu"
            },
            {
                "codigo_ibge": 3537800,
                "nome": "Piedade"
            },
            {
                "codigo_ibge": 3537909,
                "nome": "Pilar do Sul"
            },
            {
                "codigo_ibge": 3538006,
                "nome": "Pindamonhangaba"
            },
            {
                "codigo_ibge": 3538105,
                "nome": "Pindorama"
            },
            {
                "codigo_ibge": 3538204,
                "nome": "Pinhalzinho"
            },
            {
                "codigo_ibge": 3538303,
                "nome": "Piquerobi"
            },
            {
                "codigo_ibge": 3538501,
                "nome": "Piquete"
            },
            {
                "codigo_ibge": 3538600,
                "nome": "Piracaia"
            },
            {
                "codigo_ibge": 3538709,
                "nome": "Piracicaba"
            },
            {
                "codigo_ibge": 3538808,
                "nome": "Piraju"
            },
            {
                "codigo_ibge": 3538907,
                "nome": "Pirajuí"
            },
            {
                "codigo_ibge": 3539004,
                "nome": "Pirangi"
            },
            {
                "codigo_ibge": 3539103,
                "nome": "Pirapora do Bom Jesus"
            },
            {
                "codigo_ibge": 3539202,
                "nome": "Pirapozinho"
            },
            {
                "codigo_ibge": 3539301,
                "nome": "Pirassununga"
            },
            {
                "codigo_ibge": 3539400,
                "nome": "Piratininga"
            },
            {
                "codigo_ibge": 3539509,
                "nome": "Pitangueiras"
            },
            {
                "codigo_ibge": 3539608,
                "nome": "Planalto"
            },
            {
                "codigo_ibge": 3539707,
                "nome": "Platina"
            },
            {
                "codigo_ibge": 3539806,
                "nome": "Poá"
            },
            {
                "codigo_ibge": 3539905,
                "nome": "Poloni"
            },
            {
                "codigo_ibge": 3540002,
                "nome": "Pompéia"
            },
            {
                "codigo_ibge": 3540101,
                "nome": "Pongaí"
            },
            {
                "codigo_ibge": 3540200,
                "nome": "Pontal"
            },
            {
                "codigo_ibge": 3540259,
                "nome": "Pontalinda"
            },
            {
                "codigo_ibge": 3540309,
                "nome": "Pontes Gestal"
            },
            {
                "codigo_ibge": 3540408,
                "nome": "Populina"
            },
            {
                "codigo_ibge": 3540507,
                "nome": "Porangaba"
            },
            {
                "codigo_ibge": 3540606,
                "nome": "Porto Feliz"
            },
            {
                "codigo_ibge": 3540705,
                "nome": "Porto Ferreira"
            },
            {
                "codigo_ibge": 3540754,
                "nome": "Potim"
            },
            {
                "codigo_ibge": 3540804,
                "nome": "Potirendaba"
            },
            {
                "codigo_ibge": 3540853,
                "nome": "Pracinha"
            },
            {
                "codigo_ibge": 3540903,
                "nome": "Pradópolis"
            },
            {
                "codigo_ibge": 3541000,
                "nome": "Praia Grande"
            },
            {
                "codigo_ibge": 3541059,
                "nome": "Pratânia"
            },
            {
                "codigo_ibge": 3541109,
                "nome": "Presidente Alves"
            },
            {
                "codigo_ibge": 3541208,
                "nome": "Presidente Bernardes"
            },
            {
                "codigo_ibge": 3541307,
                "nome": "Presidente Epitácio"
            },
            {
                "codigo_ibge": 3541406,
                "nome": "Presidente Prudente"
            },
            {
                "codigo_ibge": 3541505,
                "nome": "Presidente Venceslau"
            },
            {
                "codigo_ibge": 3541604,
                "nome": "Promissão"
            },
            {
                "codigo_ibge": 3541653,
                "nome": "Quadra"
            },
            {
                "codigo_ibge": 3541703,
                "nome": "Quatá"
            },
            {
                "codigo_ibge": 3541802,
                "nome": "Queiroz"
            },
            {
                "codigo_ibge": 3541901,
                "nome": "Queluz"
            },
            {
                "codigo_ibge": 3542008,
                "nome": "Quintana"
            },
            {
                "codigo_ibge": 3542107,
                "nome": "Rafard"
            },
            {
                "codigo_ibge": 3542206,
                "nome": "Rancharia"
            },
            {
                "codigo_ibge": 3542305,
                "nome": "Redenção da Serra"
            },
            {
                "codigo_ibge": 3542404,
                "nome": "Regente Feijó"
            },
            {
                "codigo_ibge": 3542503,
                "nome": "Reginópolis"
            },
            {
                "codigo_ibge": 3542602,
                "nome": "Registro"
            },
            {
                "codigo_ibge": 3542701,
                "nome": "Restinga"
            },
            {
                "codigo_ibge": 3542800,
                "nome": "Ribeira"
            },
            {
                "codigo_ibge": 3542909,
                "nome": "Ribeirão Bonito"
            },
            {
                "codigo_ibge": 3543006,
                "nome": "Ribeirão Branco"
            },
            {
                "codigo_ibge": 3543105,
                "nome": "Ribeirão Corrente"
            },
            {
                "codigo_ibge": 3543204,
                "nome": "Ribeirão do Sul"
            },
            {
                "codigo_ibge": 3543238,
                "nome": "Ribeirão dos Índios"
            },
            {
                "codigo_ibge": 3543253,
                "nome": "Ribeirão Grande"
            },
            {
                "codigo_ibge": 3543303,
                "nome": "Ribeirão Pires"
            },
            {
                "codigo_ibge": 3543402,
                "nome": "Ribeirão Preto"
            },
            {
                "codigo_ibge": 3543600,
                "nome": "Rifaina"
            },
            {
                "codigo_ibge": 3543709,
                "nome": "Rincão"
            },
            {
                "codigo_ibge": 3543808,
                "nome": "Rinópolis"
            },
            {
                "codigo_ibge": 3543907,
                "nome": "Rio Claro"
            },
            {
                "codigo_ibge": 3544004,
                "nome": "Rio das Pedras"
            },
            {
                "codigo_ibge": 3544103,
                "nome": "Rio Grande da Serra"
            },
            {
                "codigo_ibge": 3544202,
                "nome": "Riolândia"
            },
            {
                "codigo_ibge": 3543501,
                "nome": "Riversul"
            },
            {
                "codigo_ibge": 3544251,
                "nome": "Rosana"
            },
            {
                "codigo_ibge": 3544301,
                "nome": "Roseira"
            },
            {
                "codigo_ibge": 3544400,
                "nome": "Rubiácea"
            },
            {
                "codigo_ibge": 3544509,
                "nome": "Rubinéia"
            },
            {
                "codigo_ibge": 3544608,
                "nome": "Sabino"
            },
            {
                "codigo_ibge": 3544707,
                "nome": "Sagres"
            },
            {
                "codigo_ibge": 3544806,
                "nome": "Sales"
            },
            {
                "codigo_ibge": 3544905,
                "nome": "Sales Oliveira"
            },
            {
                "codigo_ibge": 3545001,
                "nome": "Salesópolis"
            },
            {
                "codigo_ibge": 3545100,
                "nome": "Salmourão"
            },
            {
                "codigo_ibge": 3545159,
                "nome": "Saltinho"
            },
            {
                "codigo_ibge": 3545209,
                "nome": "Salto"
            },
            {
                "codigo_ibge": 3545308,
                "nome": "Salto de Pirapora"
            },
            {
                "codigo_ibge": 3545407,
                "nome": "Salto Grande"
            },
            {
                "codigo_ibge": 3545506,
                "nome": "Sandovalina"
            },
            {
                "codigo_ibge": 3545605,
                "nome": "Santa Adélia"
            },
            {
                "codigo_ibge": 3545704,
                "nome": "Santa Albertina"
            },
            {
                "codigo_ibge": 3545803,
                "nome": "Santa Bárbara d'Oeste"
            },
            {
                "codigo_ibge": 3546009,
                "nome": "Santa Branca"
            },
            {
                "codigo_ibge": 3546108,
                "nome": "Santa Clara d'Oeste"
            },
            {
                "codigo_ibge": 3546207,
                "nome": "Santa Cruz da Conceição"
            },
            {
                "codigo_ibge": 3546256,
                "nome": "Santa Cruz da Esperança"
            },
            {
                "codigo_ibge": 3546306,
                "nome": "Santa Cruz das Palmeiras"
            },
            {
                "codigo_ibge": 3546405,
                "nome": "Santa Cruz do Rio Pardo"
            },
            {
                "codigo_ibge": 3546504,
                "nome": "Santa Ernestina"
            },
            {
                "codigo_ibge": 3546603,
                "nome": "Santa Fé do Sul"
            },
            {
                "codigo_ibge": 3546702,
                "nome": "Santa Gertrudes"
            },
            {
                "codigo_ibge": 3546801,
                "nome": "Santa Isabel"
            },
            {
                "codigo_ibge": 3546900,
                "nome": "Santa Lúcia"
            },
            {
                "codigo_ibge": 3547007,
                "nome": "Santa Maria da Serra"
            },
            {
                "codigo_ibge": 3547106,
                "nome": "Santa Mercedes"
            },
            {
                "codigo_ibge": 3547403,
                "nome": "Santa Rita d'Oeste"
            },
            {
                "codigo_ibge": 3547502,
                "nome": "Santa Rita do Passa Quatro"
            },
            {
                "codigo_ibge": 3547601,
                "nome": "Santa Rosa de Viterbo"
            },
            {
                "codigo_ibge": 3547650,
                "nome": "Santa Salete"
            },
            {
                "codigo_ibge": 3547205,
                "nome": "Santana da Ponte Pensa"
            },
            {
                "codigo_ibge": 3547304,
                "nome": "Santana de Parnaíba"
            },
            {
                "codigo_ibge": 3547700,
                "nome": "Santo Anastácio"
            },
            {
                "codigo_ibge": 3547809,
                "nome": "Santo André"
            },
            {
                "codigo_ibge": 3547908,
                "nome": "Santo Antônio da Alegria"
            },
            {
                "codigo_ibge": 3548005,
                "nome": "Santo Antônio de Posse"
            },
            {
                "codigo_ibge": 3548054,
                "nome": "Santo Antônio do Aracanguá"
            },
            {
                "codigo_ibge": 3548104,
                "nome": "Santo Antônio do Jardim"
            },
            {
                "codigo_ibge": 3548203,
                "nome": "Santo Antônio do Pinhal"
            },
            {
                "codigo_ibge": 3548302,
                "nome": "Santo Expedito"
            },
            {
                "codigo_ibge": 3548401,
                "nome": "Santópolis do Aguapeí"
            },
            {
                "codigo_ibge": 3548500,
                "nome": "Santos"
            },
            {
                "codigo_ibge": 3548609,
                "nome": "São Bento do Sapucaí"
            },
            {
                "codigo_ibge": 3548708,
                "nome": "São Bernardo do Campo"
            },
            {
                "codigo_ibge": 3548807,
                "nome": "São Caetano do Sul"
            },
            {
                "codigo_ibge": 3548906,
                "nome": "São Carlos"
            },
            {
                "codigo_ibge": 3549003,
                "nome": "São Francisco"
            },
            {
                "codigo_ibge": 3549102,
                "nome": "São João da Boa Vista"
            },
            {
                "codigo_ibge": 3549201,
                "nome": "São João das Duas Pontes"
            },
            {
                "codigo_ibge": 3549250,
                "nome": "São João de Iracema"
            },
            {
                "codigo_ibge": 3549300,
                "nome": "São João do Pau d'Alho"
            },
            {
                "codigo_ibge": 3549409,
                "nome": "São Joaquim da Barra"
            },
            {
                "codigo_ibge": 3549508,
                "nome": "São José da Bela Vista"
            },
            {
                "codigo_ibge": 3549607,
                "nome": "São José do Barreiro"
            },
            {
                "codigo_ibge": 3549706,
                "nome": "São José do Rio Pardo"
            },
            {
                "codigo_ibge": 3549805,
                "nome": "São José do Rio Preto"
            },
            {
                "codigo_ibge": 3549904,
                "nome": "São José dos Campos"
            },
            {
                "codigo_ibge": 3549953,
                "nome": "São Lourenço da Serra"
            },
            {
                "codigo_ibge": 3550001,
                "nome": "São Luiz do Paraitinga"
            },
            {
                "codigo_ibge": 3550100,
                "nome": "São Manuel"
            },
            {
                "codigo_ibge": 3550209,
                "nome": "São Miguel Arcanjo"
            },
            {
                "codigo_ibge": 3550308,
                "nome": "São Paulo"
            },
            {
                "codigo_ibge": 3550407,
                "nome": "São Pedro"
            },
            {
                "codigo_ibge": 3550506,
                "nome": "São Pedro do Turvo"
            },
            {
                "codigo_ibge": 3550605,
                "nome": "São Roque"
            },
            {
                "codigo_ibge": 3550704,
                "nome": "São Sebastião"
            },
            {
                "codigo_ibge": 3550803,
                "nome": "São Sebastião da Grama"
            },
            {
                "codigo_ibge": 3550902,
                "nome": "São Simão"
            },
            {
                "codigo_ibge": 3551009,
                "nome": "São Vicente"
            },
            {
                "codigo_ibge": 3551108,
                "nome": "Sarapuí"
            },
            {
                "codigo_ibge": 3551207,
                "nome": "Sarutaiá"
            },
            {
                "codigo_ibge": 3551306,
                "nome": "Sebastianópolis do Sul"
            },
            {
                "codigo_ibge": 3551405,
                "nome": "Serra Azul"
            },
            {
                "codigo_ibge": 3551603,
                "nome": "Serra Negra"
            },
            {
                "codigo_ibge": 3551504,
                "nome": "Serrana"
            },
            {
                "codigo_ibge": 3551702,
                "nome": "Sertãozinho"
            },
            {
                "codigo_ibge": 3551801,
                "nome": "Sete Barras"
            },
            {
                "codigo_ibge": 3551900,
                "nome": "Severínia"
            },
            {
                "codigo_ibge": 3552007,
                "nome": "Silveiras"
            },
            {
                "codigo_ibge": 3552106,
                "nome": "Socorro"
            },
            {
                "codigo_ibge": 3552205,
                "nome": "Sorocaba"
            },
            {
                "codigo_ibge": 3552304,
                "nome": "Sud Mennucci"
            },
            {
                "codigo_ibge": 3552403,
                "nome": "Sumaré"
            },
            {
                "codigo_ibge": 3552551,
                "nome": "Suzanápolis"
            },
            {
                "codigo_ibge": 3552502,
                "nome": "Suzano"
            },
            {
                "codigo_ibge": 3552601,
                "nome": "Tabapuã"
            },
            {
                "codigo_ibge": 3552700,
                "nome": "Tabatinga"
            },
            {
                "codigo_ibge": 3552809,
                "nome": "Taboão da Serra"
            },
            {
                "codigo_ibge": 3552908,
                "nome": "Taciba"
            },
            {
                "codigo_ibge": 3553005,
                "nome": "Taguaí"
            },
            {
                "codigo_ibge": 3553104,
                "nome": "Taiaçu"
            },
            {
                "codigo_ibge": 3553203,
                "nome": "Taiúva"
            },
            {
                "codigo_ibge": 3553302,
                "nome": "Tambaú"
            },
            {
                "codigo_ibge": 3553401,
                "nome": "Tanabi"
            },
            {
                "codigo_ibge": 3553500,
                "nome": "Tapiraí"
            },
            {
                "codigo_ibge": 3553609,
                "nome": "Tapiratiba"
            },
            {
                "codigo_ibge": 3553658,
                "nome": "Taquaral"
            },
            {
                "codigo_ibge": 3553708,
                "nome": "Taquaritinga"
            },
            {
                "codigo_ibge": 3553807,
                "nome": "Taquarituba"
            },
            {
                "codigo_ibge": 3553856,
                "nome": "Taquarivaí"
            },
            {
                "codigo_ibge": 3553906,
                "nome": "Tarabai"
            },
            {
                "codigo_ibge": 3553955,
                "nome": "Tarumã"
            },
            {
                "codigo_ibge": 3554003,
                "nome": "Tatuí"
            },
            {
                "codigo_ibge": 3554102,
                "nome": "Taubaté"
            },
            {
                "codigo_ibge": 3554201,
                "nome": "Tejupá"
            },
            {
                "codigo_ibge": 3554300,
                "nome": "Teodoro Sampaio"
            },
            {
                "codigo_ibge": 3554409,
                "nome": "Terra Roxa"
            },
            {
                "codigo_ibge": 3554508,
                "nome": "Tietê"
            },
            {
                "codigo_ibge": 3554607,
                "nome": "Timburi"
            },
            {
                "codigo_ibge": 3554656,
                "nome": "Torre de Pedra"
            },
            {
                "codigo_ibge": 3554706,
                "nome": "Torrinha"
            },
            {
                "codigo_ibge": 3554755,
                "nome": "Trabiju"
            },
            {
                "codigo_ibge": 3554805,
                "nome": "Tremembé"
            },
            {
                "codigo_ibge": 3554904,
                "nome": "Três Fronteiras"
            },
            {
                "codigo_ibge": 3554953,
                "nome": "Tuiuti"
            },
            {
                "codigo_ibge": 3555000,
                "nome": "Tupã"
            },
            {
                "codigo_ibge": 3555109,
                "nome": "Tupi Paulista"
            },
            {
                "codigo_ibge": 3555208,
                "nome": "Turiúba"
            },
            {
                "codigo_ibge": 3555307,
                "nome": "Turmalina"
            },
            {
                "codigo_ibge": 3555356,
                "nome": "Ubarana"
            },
            {
                "codigo_ibge": 3555406,
                "nome": "Ubatuba"
            },
            {
                "codigo_ibge": 3555505,
                "nome": "Ubirajara"
            },
            {
                "codigo_ibge": 3555604,
                "nome": "Uchoa"
            },
            {
                "codigo_ibge": 3555703,
                "nome": "União Paulista"
            },
            {
                "codigo_ibge": 3555802,
                "nome": "Urânia"
            },
            {
                "codigo_ibge": 3555901,
                "nome": "Uru"
            },
            {
                "codigo_ibge": 3556008,
                "nome": "Urupês"
            },
            {
                "codigo_ibge": 3556107,
                "nome": "Valentim Gentil"
            },
            {
                "codigo_ibge": 3556206,
                "nome": "Valinhos"
            },
            {
                "codigo_ibge": 3556305,
                "nome": "Valparaíso"
            },
            {
                "codigo_ibge": 3556354,
                "nome": "Vargem"
            },
            {
                "codigo_ibge": 3556404,
                "nome": "Vargem Grande do Sul"
            },
            {
                "codigo_ibge": 3556453,
                "nome": "Vargem Grande Paulista"
            },
            {
                "codigo_ibge": 3556503,
                "nome": "Várzea Paulista"
            },
            {
                "codigo_ibge": 3556602,
                "nome": "Vera Cruz"
            },
            {
                "codigo_ibge": 3556701,
                "nome": "Vinhedo"
            },
            {
                "codigo_ibge": 3556800,
                "nome": "Viradouro"
            },
            {
                "codigo_ibge": 3556909,
                "nome": "Vista Alegre do Alto"
            },
            {
                "codigo_ibge": 3556958,
                "nome": "Vitória Brasil"
            },
            {
                "codigo_ibge": 3557006,
                "nome": "Votorantim"
            },
            {
                "codigo_ibge": 3557105,
                "nome": "Votuporanga"
            },
            {
                "codigo_ibge": 3557154,
                "nome": "Zacarias"
            }
        ]
    },
    "TO": {
        "nome": "Tocantins",
        "municipios": [
            {
                "codigo_ibge": 1700251,
                "nome": "Abreulândia"
            },
            {
                "codigo_ibge": 1700301,
                "nome": "Aguiarnópolis"
            },
            {
                "codigo_ibge": 1700350,
                "nome": "Aliança do Tocantins"
            },
            {
                "codigo_ibge": 1700400,
                "nome": "Almas"
            },
            {
                "codigo_ibge": 1700707,
                "nome": "Alvorada"
            },
            {
                "codigo_ibge": 1701002,
                "nome": "Ananás"
            },
            {
                "codigo_ibge": 1701051,
                "nome": "Angico"
            },
            {
                "codigo_ibge": 1701101,
                "nome": "Aparecida do Rio Negro"
            },
            {
                "codigo_ibge": 1701309,
                "nome": "Aragominas"
            },
            {
                "codigo_ibge": 1701903,
                "nome": "Araguacema"
            },
            {
                "codigo_ibge": 1702000,
                "nome": "Araguaçu"
            },
            {
                "codigo_ibge": 1702109,
                "nome": "Araguaína"
            },
            {
                "codigo_ibge": 1702158,
                "nome": "Araguanã"
            },
            {
                "codigo_ibge": 1702208,
                "nome": "Araguatins"
            },
            {
                "codigo_ibge": 1702307,
                "nome": "Arapoema"
            },
            {
                "codigo_ibge": 1702406,
                "nome": "Arraias"
            },
            {
                "codigo_ibge": 1702554,
                "nome": "Augustinópolis"
            },
            {
                "codigo_ibge": 1702703,
                "nome": "Aurora do Tocantins"
            },
            {
                "codigo_ibge": 1702901,
                "nome": "Axixá do Tocantins"
            },
            {
                "codigo_ibge": 1703008,
                "nome": "Babaçulândia"
            },
            {
                "codigo_ibge": 1703057,
                "nome": "Bandeirantes do Tocantins"
            },
            {
                "codigo_ibge": 1703073,
                "nome": "Barra do Ouro"
            },
            {
                "codigo_ibge": 1703107,
                "nome": "Barrolândia"
            },
            {
                "codigo_ibge": 1703206,
                "nome": "Bernardo Sayão"
            },
            {
                "codigo_ibge": 1703305,
                "nome": "Bom Jesus do Tocantins"
            },
            {
                "codigo_ibge": 1703602,
                "nome": "Brasilândia do Tocantins"
            },
            {
                "codigo_ibge": 1703701,
                "nome": "Brejinho de Nazaré"
            },
            {
                "codigo_ibge": 1703800,
                "nome": "Buriti do Tocantins"
            },
            {
                "codigo_ibge": 1703826,
                "nome": "Cachoeirinha"
            },
            {
                "codigo_ibge": 1703842,
                "nome": "Campos Lindos"
            },
            {
                "codigo_ibge": 1703867,
                "nome": "Cariri do Tocantins"
            },
            {
                "codigo_ibge": 1703883,
                "nome": "Carmolândia"
            },
            {
                "codigo_ibge": 1703891,
                "nome": "Carrasco Bonito"
            },
            {
                "codigo_ibge": 1703909,
                "nome": "Caseara"
            },
            {
                "codigo_ibge": 1704105,
                "nome": "Centenário"
            },
            {
                "codigo_ibge": 1705102,
                "nome": "Chapada da Natividade"
            },
            {
                "codigo_ibge": 1704600,
                "nome": "Chapada de Areia"
            },
            {
                "codigo_ibge": 1705508,
                "nome": "Colinas do Tocantins"
            },
            {
                "codigo_ibge": 1716703,
                "nome": "Colméia"
            },
            {
                "codigo_ibge": 1705557,
                "nome": "Combinado"
            },
            {
                "codigo_ibge": 1705607,
                "nome": "Conceição do Tocantins"
            },
            {
                "codigo_ibge": 1706001,
                "nome": "Couto Magalhães"
            },
            {
                "codigo_ibge": 1706100,
                "nome": "Cristalândia"
            },
            {
                "codigo_ibge": 1706258,
                "nome": "Crixás do Tocantins"
            },
            {
                "codigo_ibge": 1706506,
                "nome": "Darcinópolis"
            },
            {
                "codigo_ibge": 1707009,
                "nome": "Dianópolis"
            },
            {
                "codigo_ibge": 1707108,
                "nome": "Divinópolis do Tocantins"
            },
            {
                "codigo_ibge": 1707207,
                "nome": "Dois Irmãos do Tocantins"
            },
            {
                "codigo_ibge": 1707306,
                "nome": "Dueré"
            },
            {
                "codigo_ibge": 1707405,
                "nome": "Esperantina"
            },
            {
                "codigo_ibge": 1707553,
                "nome": "Fátima"
            },
            {
                "codigo_ibge": 1707652,
                "nome": "Figueirópolis"
            },
            {
                "codigo_ibge": 1707702,
                "nome": "Filadélfia"
            },
            {
                "codigo_ibge": 1708205,
                "nome": "Formoso do Araguaia"
            },
            {
                "codigo_ibge": 1708254,
                "nome": "Fortaleza do Tabocão"
            },
            {
                "codigo_ibge": 1708304,
                "nome": "Goianorte"
            },
            {
                "codigo_ibge": 1709005,
                "nome": "Goiatins"
            },
            {
                "codigo_ibge": 1709302,
                "nome": "Guaraí"
            },
            {
                "codigo_ibge": 1709500,
                "nome": "Gurupi"
            },
            {
                "codigo_ibge": 1709807,
                "nome": "Ipueiras"
            },
            {
                "codigo_ibge": 1710508,
                "nome": "Itacajá"
            },
            {
                "codigo_ibge": 1710706,
                "nome": "Itaguatins"
            },
            {
                "codigo_ibge": 1710904,
                "nome": "Itapiratins"
            },
            {
                "codigo_ibge": 1711100,
                "nome": "Itaporã do Tocantins"
            },
            {
                "codigo_ibge": 1711506,
                "nome": "Jaú do Tocantins"
            },
            {
                "codigo_ibge": 1711803,
                "nome": "Juarina"
            },
            {
                "codigo_ibge": 1711902,
                "nome": "Lagoa da Confusão"
            },
            {
                "codigo_ibge": 1711951,
                "nome": "Lagoa do Tocantins"
            },
            {
                "codigo_ibge": 1712009,
                "nome": "Lajeado"
            },
            {
                "codigo_ibge": 1712157,
                "nome": "Lavandeira"
            },
            {
                "codigo_ibge": 1712405,
                "nome": "Lizarda"
            },
            {
                "codigo_ibge": 1712454,
                "nome": "Luzinópolis"
            },
            {
                "codigo_ibge": 1712504,
                "nome": "Marianópolis do Tocantins"
            },
            {
                "codigo_ibge": 1712702,
                "nome": "Mateiros"
            },
            {
                "codigo_ibge": 1712801,
                "nome": "Maurilândia do Tocantins"
            },
            {
                "codigo_ibge": 1713205,
                "nome": "Miracema do Tocantins"
            },
            {
                "codigo_ibge": 1713304,
                "nome": "Miranorte"
            },
            {
                "codigo_ibge": 1713601,
                "nome": "Monte do Carmo"
            },
            {
                "codigo_ibge": 1713700,
                "nome": "Monte Santo do Tocantins"
            },
            {
                "codigo_ibge": 1713957,
                "nome": "Muricilândia"
            },
            {
                "codigo_ibge": 1714203,
                "nome": "Natividade"
            },
            {
                "codigo_ibge": 1714302,
                "nome": "Nazaré"
            },
            {
                "codigo_ibge": 1714880,
                "nome": "Nova Olinda"
            },
            {
                "codigo_ibge": 1715002,
                "nome": "Nova Rosalândia"
            },
            {
                "codigo_ibge": 1715101,
                "nome": "Novo Acordo"
            },
            {
                "codigo_ibge": 1715150,
                "nome": "Novo Alegre"
            },
            {
                "codigo_ibge": 1715259,
                "nome": "Novo Jardim"
            },
            {
                "codigo_ibge": 1715507,
                "nome": "Oliveira de Fátima"
            },
            {
                "codigo_ibge": 1721000,
                "nome": "Palmas"
            },
            {
                "codigo_ibge": 1715705,
                "nome": "Palmeirante"
            },
            {
                "codigo_ibge": 1713809,
                "nome": "Palmeiras do Tocantins"
            },
            {
                "codigo_ibge": 1715754,
                "nome": "Palmeirópolis"
            },
            {
                "codigo_ibge": 1716109,
                "nome": "Paraíso do Tocantins"
            },
            {
                "codigo_ibge": 1716208,
                "nome": "Paranã"
            },
            {
                "codigo_ibge": 1716307,
                "nome": "Pau D'Arco"
            },
            {
                "codigo_ibge": 1716505,
                "nome": "Pedro Afonso"
            },
            {
                "codigo_ibge": 1716604,
                "nome": "Peixe"
            },
            {
                "codigo_ibge": 1716653,
                "nome": "Pequizeiro"
            },
            {
                "codigo_ibge": 1717008,
                "nome": "Pindorama do Tocantins"
            },
            {
                "codigo_ibge": 1717206,
                "nome": "Piraquê"
            },
            {
                "codigo_ibge": 1717503,
                "nome": "Pium"
            },
            {
                "codigo_ibge": 1717800,
                "nome": "Ponte Alta do Bom Jesus"
            },
            {
                "codigo_ibge": 1717909,
                "nome": "Ponte Alta do Tocantins"
            },
            {
                "codigo_ibge": 1718006,
                "nome": "Porto Alegre do Tocantins"
            },
            {
                "codigo_ibge": 1718204,
                "nome": "Porto Nacional"
            },
            {
                "codigo_ibge": 1718303,
                "nome": "Praia Norte"
            },
            {
                "codigo_ibge": 1718402,
                "nome": "Presidente Kennedy"
            },
            {
                "codigo_ibge": 1718451,
                "nome": "Pugmil"
            },
            {
                "codigo_ibge": 1718501,
                "nome": "Recursolândia"
            },
            {
                "codigo_ibge": 1718550,
                "nome": "Riachinho"
            },
            {
                "codigo_ibge": 1718659,
                "nome": "Rio da Conceição"
            },
            {
                "codigo_ibge": 1718709,
                "nome": "Rio dos Bois"
            },
            {
                "codigo_ibge": 1718758,
                "nome": "Rio Sono"
            },
            {
                "codigo_ibge": 1718808,
                "nome": "Sampaio"
            },
            {
                "codigo_ibge": 1718840,
                "nome": "Sandolândia"
            },
            {
                "codigo_ibge": 1718865,
                "nome": "Santa Fé do Araguaia"
            },
            {
                "codigo_ibge": 1718881,
                "nome": "Santa Maria do Tocantins"
            },
            {
                "codigo_ibge": 1718899,
                "nome": "Santa Rita do Tocantins"
            },
            {
                "codigo_ibge": 1718907,
                "nome": "Santa Rosa do Tocantins"
            },
            {
                "codigo_ibge": 1719004,
                "nome": "Santa Tereza do Tocantins"
            },
            {
                "codigo_ibge": 1720002,
                "nome": "Santa Terezinha do Tocantins"
            },
            {
                "codigo_ibge": 1720101,
                "nome": "São Bento do Tocantins"
            },
            {
                "codigo_ibge": 1720150,
                "nome": "São Félix do Tocantins"
            },
            {
                "codigo_ibge": 1720200,
                "nome": "São Miguel do Tocantins"
            },
            {
                "codigo_ibge": 1720259,
                "nome": "São Salvador do Tocantins"
            },
            {
                "codigo_ibge": 1720309,
                "nome": "São Sebastião do Tocantins"
            },
            {
                "codigo_ibge": 1720499,
                "nome": "São Valério"
            },
            {
                "codigo_ibge": 1720655,
                "nome": "Silvanópolis"
            },
            {
                "codigo_ibge": 1720804,
                "nome": "Sítio Novo do Tocantins"
            },
            {
                "codigo_ibge": 1720853,
                "nome": "Sucupira"
            },
            {
                "codigo_ibge": 1720903,
                "nome": "Taguatinga"
            },
            {
                "codigo_ibge": 1720937,
                "nome": "Taipas do Tocantins"
            },
            {
                "codigo_ibge": 1720978,
                "nome": "Talismã"
            },
            {
                "codigo_ibge": 1721109,
                "nome": "Tocantínia"
            },
            {
                "codigo_ibge": 1721208,
                "nome": "Tocantinópolis"
            },
            {
                "codigo_ibge": 1721257,
                "nome": "Tupirama"
            },
            {
                "codigo_ibge": 1721307,
                "nome": "Tupiratins"
            },
            {
                "codigo_ibge": 1722081,
                "nome": "Wanderlândia"
            },
            {
                "codigo_ibge": 1722107,
                "nome": "Xambioá"
            }
        ]
    }
};

for (let uf in ufs) {
    let municipios = ufs[uf].municipios;
    ufs[uf].municipioCodes = {};
 
    // Itera pelos municípios de cada UF e adiciona ao mapa
    municipios.forEach(municipio => {
        ufs[uf].municipioCodes[municipio.nome] = municipio.codigo_ibge;
    });
}
 
export default ufs;